var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../../node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});

// ../../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});

// ../../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../../node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});

// ../../../node_modules/lodash/now.js
var require_now = __commonJS({
  "../../../node_modules/lodash/now.js"(exports, module) {
    "use strict";
    var root = require_root();
    var now = function() {
      return root.Date.now();
    };
    module.exports = now;
  }
});

// ../../../node_modules/lodash/_trimmedEndIndex.js
var require_trimmedEndIndex = __commonJS({
  "../../../node_modules/lodash/_trimmedEndIndex.js"(exports, module) {
    "use strict";
    var reWhitespace = /\s/;
    function trimmedEndIndex(string) {
      var index3 = string.length;
      while (index3-- && reWhitespace.test(string.charAt(index3))) {
      }
      return index3;
    }
    module.exports = trimmedEndIndex;
  }
});

// ../../../node_modules/lodash/_baseTrim.js
var require_baseTrim = __commonJS({
  "../../../node_modules/lodash/_baseTrim.js"(exports, module) {
    "use strict";
    var trimmedEndIndex = require_trimmedEndIndex();
    var reTrimStart = /^\s+/;
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    module.exports = baseTrim;
  }
});

// ../../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../../node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});

// ../../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../../node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e2) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});

// ../../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../../node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});

// ../../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});

// ../../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../../node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});

// ../../../node_modules/lodash/isSymbol.js
var require_isSymbol = __commonJS({
  "../../../node_modules/lodash/isSymbol.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});

// ../../../node_modules/lodash/toNumber.js
var require_toNumber = __commonJS({
  "../../../node_modules/lodash/toNumber.js"(exports, module) {
    "use strict";
    var baseTrim = require_baseTrim();
    var isObject = require_isObject();
    var isSymbol = require_isSymbol();
    var NAN = 0 / 0;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsOctal = /^0o[0-7]+$/i;
    var freeParseInt = parseInt;
    function toNumber(value) {
      if (typeof value == "number") {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = isObject(other) ? other + "" : other;
      }
      if (typeof value != "string") {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }
    module.exports = toNumber;
  }
});

// ../../../node_modules/lodash/debounce.js
var require_debounce = __commonJS({
  "../../../node_modules/lodash/debounce.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var now = require_now();
    var toNumber = require_toNumber();
    var FUNC_ERROR_TEXT = "Expected a function";
    var nativeMax = Math.max;
    var nativeMin = Math.min;
    function debounce2(func, wait, options) {
      var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = void 0;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        lastInvokeTime = time;
        timerId = setTimeout(timerExpired, wait);
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = void 0;
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = void 0;
        return result;
      }
      function cancel() {
        if (timerId !== void 0) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = void 0;
      }
      function flush() {
        return timerId === void 0 ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === void 0) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === void 0) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }
    module.exports = debounce2;
  }
});

// ../../../node_modules/lodash/throttle.js
var require_throttle = __commonJS({
  "../../../node_modules/lodash/throttle.js"(exports, module) {
    "use strict";
    var debounce2 = require_debounce();
    var isObject = require_isObject();
    var FUNC_ERROR_TEXT = "Expected a function";
    function throttle(func, wait, options) {
      var leading = true, trailing = true;
      if (typeof func != "function") {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
      }
      return debounce2(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
      });
    }
    module.exports = throttle;
  }
});

// ../../../node_modules/lodash/_arrayMap.js
var require_arrayMap = __commonJS({
  "../../../node_modules/lodash/_arrayMap.js"(exports, module) {
    "use strict";
    function arrayMap(array, iteratee) {
      var index3 = -1, length = array == null ? 0 : array.length, result = Array(length);
      while (++index3 < length) {
        result[index3] = iteratee(array[index3], index3, array);
      }
      return result;
    }
    module.exports = arrayMap;
  }
});

// ../../../node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../../node_modules/lodash/isArray.js"(exports, module) {
    "use strict";
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});

// ../../../node_modules/lodash/_baseToString.js
var require_baseToString = __commonJS({
  "../../../node_modules/lodash/_baseToString.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var arrayMap = require_arrayMap();
    var isArray = require_isArray();
    var isSymbol = require_isSymbol();
    var INFINITY = 1 / 0;
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") {
        return value;
      }
      if (isArray(value)) {
        return arrayMap(value, baseToString) + "";
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : "";
      }
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module.exports = baseToString;
  }
});

// ../../../node_modules/lodash/toString.js
var require_toString = __commonJS({
  "../../../node_modules/lodash/toString.js"(exports, module) {
    "use strict";
    var baseToString = require_baseToString();
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    module.exports = toString;
  }
});

// ../../../node_modules/lodash/_baseSlice.js
var require_baseSlice = __commonJS({
  "../../../node_modules/lodash/_baseSlice.js"(exports, module) {
    "use strict";
    function baseSlice(array, start, end) {
      var index3 = -1, length = array.length;
      if (start < 0) {
        start = -start > length ? 0 : length + start;
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : end - start >>> 0;
      start >>>= 0;
      var result = Array(length);
      while (++index3 < length) {
        result[index3] = array[index3 + start];
      }
      return result;
    }
    module.exports = baseSlice;
  }
});

// ../../../node_modules/lodash/_castSlice.js
var require_castSlice = __commonJS({
  "../../../node_modules/lodash/_castSlice.js"(exports, module) {
    "use strict";
    var baseSlice = require_baseSlice();
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === void 0 ? length : end;
      return !start && end >= length ? array : baseSlice(array, start, end);
    }
    module.exports = castSlice;
  }
});

// ../../../node_modules/lodash/_hasUnicode.js
var require_hasUnicode = __commonJS({
  "../../../node_modules/lodash/_hasUnicode.js"(exports, module) {
    "use strict";
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsZWJ = "\\u200d";
    var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    module.exports = hasUnicode;
  }
});

// ../../../node_modules/lodash/_asciiToArray.js
var require_asciiToArray = __commonJS({
  "../../../node_modules/lodash/_asciiToArray.js"(exports, module) {
    "use strict";
    function asciiToArray(string) {
      return string.split("");
    }
    module.exports = asciiToArray;
  }
});

// ../../../node_modules/lodash/_unicodeToArray.js
var require_unicodeToArray = __commonJS({
  "../../../node_modules/lodash/_unicodeToArray.js"(exports, module) {
    "use strict";
    var rsAstralRange = "\\ud800-\\udfff";
    var rsComboMarksRange = "\\u0300-\\u036f";
    var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
    var rsComboSymbolsRange = "\\u20d0-\\u20ff";
    var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
    var rsVarRange = "\\ufe0e\\ufe0f";
    var rsAstral = "[" + rsAstralRange + "]";
    var rsCombo = "[" + rsComboRange + "]";
    var rsFitz = "\\ud83c[\\udffb-\\udfff]";
    var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
    var rsNonAstral = "[^" + rsAstralRange + "]";
    var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
    var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
    var rsZWJ = "\\u200d";
    var reOptMod = rsModifier + "?";
    var rsOptVar = "[" + rsVarRange + "]?";
    var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
    var rsSeq = rsOptVar + reOptMod + rsOptJoin;
    var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
    var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    module.exports = unicodeToArray;
  }
});

// ../../../node_modules/lodash/_stringToArray.js
var require_stringToArray = __commonJS({
  "../../../node_modules/lodash/_stringToArray.js"(exports, module) {
    "use strict";
    var asciiToArray = require_asciiToArray();
    var hasUnicode = require_hasUnicode();
    var unicodeToArray = require_unicodeToArray();
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    module.exports = stringToArray;
  }
});

// ../../../node_modules/lodash/_createCaseFirst.js
var require_createCaseFirst = __commonJS({
  "../../../node_modules/lodash/_createCaseFirst.js"(exports, module) {
    "use strict";
    var castSlice = require_castSlice();
    var hasUnicode = require_hasUnicode();
    var stringToArray = require_stringToArray();
    var toString = require_toString();
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
      };
    }
    module.exports = createCaseFirst;
  }
});

// ../../../node_modules/lodash/upperFirst.js
var require_upperFirst = __commonJS({
  "../../../node_modules/lodash/upperFirst.js"(exports, module) {
    "use strict";
    var createCaseFirst = require_createCaseFirst();
    var upperFirst = createCaseFirst("toUpperCase");
    module.exports = upperFirst;
  }
});

// ../../../node_modules/lodash/capitalize.js
var require_capitalize = __commonJS({
  "../../../node_modules/lodash/capitalize.js"(exports, module) {
    "use strict";
    var toString = require_toString();
    var upperFirst = require_upperFirst();
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }
    module.exports = capitalize;
  }
});

// ../../../node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "../../../node_modules/lodash/_listCacheClear.js"(exports, module) {
    "use strict";
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module.exports = listCacheClear;
  }
});

// ../../../node_modules/lodash/eq.js
var require_eq = __commonJS({
  "../../../node_modules/lodash/eq.js"(exports, module) {
    "use strict";
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module.exports = eq;
  }
});

// ../../../node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "../../../node_modules/lodash/_assocIndexOf.js"(exports, module) {
    "use strict";
    var eq = require_eq();
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module.exports = assocIndexOf;
  }
});

// ../../../node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "../../../node_modules/lodash/_listCacheDelete.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key) {
      var data = this.__data__, index3 = assocIndexOf(data, key);
      if (index3 < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index3 == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index3, 1);
      }
      --this.size;
      return true;
    }
    module.exports = listCacheDelete;
  }
});

// ../../../node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "../../../node_modules/lodash/_listCacheGet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key) {
      var data = this.__data__, index3 = assocIndexOf(data, key);
      return index3 < 0 ? void 0 : data[index3][1];
    }
    module.exports = listCacheGet;
  }
});

// ../../../node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "../../../node_modules/lodash/_listCacheHas.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module.exports = listCacheHas;
  }
});

// ../../../node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "../../../node_modules/lodash/_listCacheSet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key, value) {
      var data = this.__data__, index3 = assocIndexOf(data, key);
      if (index3 < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index3][1] = value;
      }
      return this;
    }
    module.exports = listCacheSet;
  }
});

// ../../../node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "../../../node_modules/lodash/_ListCache.js"(exports, module) {
    "use strict";
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index3 = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index3 < length) {
        var entry = entries[index3];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module.exports = ListCache;
  }
});

// ../../../node_modules/lodash/_stackClear.js
var require_stackClear = __commonJS({
  "../../../node_modules/lodash/_stackClear.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module.exports = stackClear;
  }
});

// ../../../node_modules/lodash/_stackDelete.js
var require_stackDelete = __commonJS({
  "../../../node_modules/lodash/_stackDelete.js"(exports, module) {
    "use strict";
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    module.exports = stackDelete;
  }
});

// ../../../node_modules/lodash/_stackGet.js
var require_stackGet = __commonJS({
  "../../../node_modules/lodash/_stackGet.js"(exports, module) {
    "use strict";
    function stackGet(key) {
      return this.__data__.get(key);
    }
    module.exports = stackGet;
  }
});

// ../../../node_modules/lodash/_stackHas.js
var require_stackHas = __commonJS({
  "../../../node_modules/lodash/_stackHas.js"(exports, module) {
    "use strict";
    function stackHas(key) {
      return this.__data__.has(key);
    }
    module.exports = stackHas;
  }
});

// ../../../node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "../../../node_modules/lodash/isFunction.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObject = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;
  }
});

// ../../../node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "../../../node_modules/lodash/_coreJsData.js"(exports, module) {
    "use strict";
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module.exports = coreJsData;
  }
});

// ../../../node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "../../../node_modules/lodash/_isMasked.js"(exports, module) {
    "use strict";
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;
  }
});

// ../../../node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "../../../node_modules/lodash/_toSource.js"(exports, module) {
    "use strict";
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e2) {
        }
        try {
          return func + "";
        } catch (e2) {
        }
      }
      return "";
    }
    module.exports = toSource;
  }
});

// ../../../node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "../../../node_modules/lodash/_baseIsNative.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;
  }
});

// ../../../node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "../../../node_modules/lodash/_getValue.js"(exports, module) {
    "use strict";
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    module.exports = getValue;
  }
});

// ../../../node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "../../../node_modules/lodash/_getNative.js"(exports, module) {
    "use strict";
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    module.exports = getNative;
  }
});

// ../../../node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "../../../node_modules/lodash/_Map.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Map2 = getNative(root, "Map");
    module.exports = Map2;
  }
});

// ../../../node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "../../../node_modules/lodash/_nativeCreate.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module.exports = nativeCreate;
  }
});

// ../../../node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "../../../node_modules/lodash/_hashClear.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module.exports = hashClear;
  }
});

// ../../../node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "../../../node_modules/lodash/_hashDelete.js"(exports, module) {
    "use strict";
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = hashDelete;
  }
});

// ../../../node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "../../../node_modules/lodash/_hashGet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    module.exports = hashGet;
  }
});

// ../../../node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "../../../node_modules/lodash/_hashHas.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    module.exports = hashHas;
  }
});

// ../../../node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "../../../node_modules/lodash/_hashSet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module.exports = hashSet;
  }
});

// ../../../node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "../../../node_modules/lodash/_Hash.js"(exports, module) {
    "use strict";
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index3 = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index3 < length) {
        var entry = entries[index3];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module.exports = Hash;
  }
});

// ../../../node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "../../../node_modules/lodash/_mapCacheClear.js"(exports, module) {
    "use strict";
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    module.exports = mapCacheClear;
  }
});

// ../../../node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "../../../node_modules/lodash/_isKeyable.js"(exports, module) {
    "use strict";
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module.exports = isKeyable;
  }
});

// ../../../node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "../../../node_modules/lodash/_getMapData.js"(exports, module) {
    "use strict";
    var isKeyable = require_isKeyable();
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    module.exports = getMapData;
  }
});

// ../../../node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "../../../node_modules/lodash/_mapCacheDelete.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = mapCacheDelete;
  }
});

// ../../../node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "../../../node_modules/lodash/_mapCacheGet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module.exports = mapCacheGet;
  }
});

// ../../../node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "../../../node_modules/lodash/_mapCacheHas.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module.exports = mapCacheHas;
  }
});

// ../../../node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "../../../node_modules/lodash/_mapCacheSet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size4 = data.size;
      data.set(key, value);
      this.size += data.size == size4 ? 0 : 1;
      return this;
    }
    module.exports = mapCacheSet;
  }
});

// ../../../node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "../../../node_modules/lodash/_MapCache.js"(exports, module) {
    "use strict";
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index3 = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index3 < length) {
        var entry = entries[index3];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module.exports = MapCache;
  }
});

// ../../../node_modules/lodash/_stackSet.js
var require_stackSet = __commonJS({
  "../../../node_modules/lodash/_stackSet.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    var MapCache = require_MapCache();
    var LARGE_ARRAY_SIZE = 200;
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    module.exports = stackSet;
  }
});

// ../../../node_modules/lodash/_Stack.js
var require_Stack = __commonJS({
  "../../../node_modules/lodash/_Stack.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var stackClear = require_stackClear();
    var stackDelete = require_stackDelete();
    var stackGet = require_stackGet();
    var stackHas = require_stackHas();
    var stackSet = require_stackSet();
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module.exports = Stack;
  }
});

// ../../../node_modules/lodash/_defineProperty.js
var require_defineProperty = __commonJS({
  "../../../node_modules/lodash/_defineProperty.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e2) {
      }
    }();
    module.exports = defineProperty;
  }
});

// ../../../node_modules/lodash/_baseAssignValue.js
var require_baseAssignValue = __commonJS({
  "../../../node_modules/lodash/_baseAssignValue.js"(exports, module) {
    "use strict";
    var defineProperty = require_defineProperty();
    function baseAssignValue(object, key, value) {
      if (key == "__proto__" && defineProperty) {
        defineProperty(object, key, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key] = value;
      }
    }
    module.exports = baseAssignValue;
  }
});

// ../../../node_modules/lodash/_assignMergeValue.js
var require_assignMergeValue = __commonJS({
  "../../../node_modules/lodash/_assignMergeValue.js"(exports, module) {
    "use strict";
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    function assignMergeValue(object, key, value) {
      if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignMergeValue;
  }
});

// ../../../node_modules/lodash/_createBaseFor.js
var require_createBaseFor = __commonJS({
  "../../../node_modules/lodash/_createBaseFor.js"(exports, module) {
    "use strict";
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index3 = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index3];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    module.exports = createBaseFor;
  }
});

// ../../../node_modules/lodash/_baseFor.js
var require_baseFor = __commonJS({
  "../../../node_modules/lodash/_baseFor.js"(exports, module) {
    "use strict";
    var createBaseFor = require_createBaseFor();
    var baseFor = createBaseFor();
    module.exports = baseFor;
  }
});

// ../../../node_modules/lodash/_cloneBuffer.js
var require_cloneBuffer = __commonJS({
  "../../../node_modules/lodash/_cloneBuffer.js"(exports, module) {
    "use strict";
    var root = require_root();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    module.exports = cloneBuffer;
  }
});

// ../../../node_modules/lodash/_Uint8Array.js
var require_Uint8Array = __commonJS({
  "../../../node_modules/lodash/_Uint8Array.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Uint8Array2 = root.Uint8Array;
    module.exports = Uint8Array2;
  }
});

// ../../../node_modules/lodash/_cloneArrayBuffer.js
var require_cloneArrayBuffer = __commonJS({
  "../../../node_modules/lodash/_cloneArrayBuffer.js"(exports, module) {
    "use strict";
    var Uint8Array2 = require_Uint8Array();
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
      return result;
    }
    module.exports = cloneArrayBuffer;
  }
});

// ../../../node_modules/lodash/_cloneTypedArray.js
var require_cloneTypedArray = __commonJS({
  "../../../node_modules/lodash/_cloneTypedArray.js"(exports, module) {
    "use strict";
    var cloneArrayBuffer = require_cloneArrayBuffer();
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    module.exports = cloneTypedArray;
  }
});

// ../../../node_modules/lodash/_copyArray.js
var require_copyArray = __commonJS({
  "../../../node_modules/lodash/_copyArray.js"(exports, module) {
    "use strict";
    function copyArray(source, array) {
      var index3 = -1, length = source.length;
      array || (array = Array(length));
      while (++index3 < length) {
        array[index3] = source[index3];
      }
      return array;
    }
    module.exports = copyArray;
  }
});

// ../../../node_modules/lodash/_baseCreate.js
var require_baseCreate = __commonJS({
  "../../../node_modules/lodash/_baseCreate.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var objectCreate = Object.create;
    var baseCreate = /* @__PURE__ */ function() {
      function object() {
      }
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    }();
    module.exports = baseCreate;
  }
});

// ../../../node_modules/lodash/_overArg.js
var require_overArg = __commonJS({
  "../../../node_modules/lodash/_overArg.js"(exports, module) {
    "use strict";
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    module.exports = overArg;
  }
});

// ../../../node_modules/lodash/_getPrototype.js
var require_getPrototype = __commonJS({
  "../../../node_modules/lodash/_getPrototype.js"(exports, module) {
    "use strict";
    var overArg = require_overArg();
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    module.exports = getPrototype;
  }
});

// ../../../node_modules/lodash/_isPrototype.js
var require_isPrototype = __commonJS({
  "../../../node_modules/lodash/_isPrototype.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    module.exports = isPrototype;
  }
});

// ../../../node_modules/lodash/_initCloneObject.js
var require_initCloneObject = __commonJS({
  "../../../node_modules/lodash/_initCloneObject.js"(exports, module) {
    "use strict";
    var baseCreate = require_baseCreate();
    var getPrototype = require_getPrototype();
    var isPrototype = require_isPrototype();
    function initCloneObject(object) {
      return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    module.exports = initCloneObject;
  }
});

// ../../../node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "../../../node_modules/lodash/_baseIsArguments.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;
  }
});

// ../../../node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "../../../node_modules/lodash/isArguments.js"(exports, module) {
    "use strict";
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module.exports = isArguments;
  }
});

// ../../../node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "../../../node_modules/lodash/isLength.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;
  }
});

// ../../../node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "../../../node_modules/lodash/isArrayLike.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module.exports = isArrayLike;
  }
});

// ../../../node_modules/lodash/isArrayLikeObject.js
var require_isArrayLikeObject = __commonJS({
  "../../../node_modules/lodash/isArrayLikeObject.js"(exports, module) {
    "use strict";
    var isArrayLike = require_isArrayLike();
    var isObjectLike = require_isObjectLike();
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    module.exports = isArrayLikeObject;
  }
});

// ../../../node_modules/lodash/stubFalse.js
var require_stubFalse = __commonJS({
  "../../../node_modules/lodash/stubFalse.js"(exports, module) {
    "use strict";
    function stubFalse() {
      return false;
    }
    module.exports = stubFalse;
  }
});

// ../../../node_modules/lodash/isBuffer.js
var require_isBuffer = __commonJS({
  "../../../node_modules/lodash/isBuffer.js"(exports, module) {
    "use strict";
    var root = require_root();
    var stubFalse = require_stubFalse();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
  }
});

// ../../../node_modules/lodash/isPlainObject.js
var require_isPlainObject = __commonJS({
  "../../../node_modules/lodash/isPlainObject.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var getPrototype = require_getPrototype();
    var isObjectLike = require_isObjectLike();
    var objectTag = "[object Object]";
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectCtorString = funcToString.call(Object);
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    module.exports = isPlainObject;
  }
});

// ../../../node_modules/lodash/_baseIsTypedArray.js
var require_baseIsTypedArray = __commonJS({
  "../../../node_modules/lodash/_baseIsTypedArray.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isLength = require_isLength();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    module.exports = baseIsTypedArray;
  }
});

// ../../../node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "../../../node_modules/lodash/_baseUnary.js"(exports, module) {
    "use strict";
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module.exports = baseUnary;
  }
});

// ../../../node_modules/lodash/_nodeUtil.js
var require_nodeUtil = __commonJS({
  "../../../node_modules/lodash/_nodeUtil.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e2) {
      }
    }();
    module.exports = nodeUtil;
  }
});

// ../../../node_modules/lodash/isTypedArray.js
var require_isTypedArray = __commonJS({
  "../../../node_modules/lodash/isTypedArray.js"(exports, module) {
    "use strict";
    var baseIsTypedArray = require_baseIsTypedArray();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module.exports = isTypedArray;
  }
});

// ../../../node_modules/lodash/_safeGet.js
var require_safeGet = __commonJS({
  "../../../node_modules/lodash/_safeGet.js"(exports, module) {
    "use strict";
    function safeGet(object, key) {
      if (key === "constructor" && typeof object[key] === "function") {
        return;
      }
      if (key == "__proto__") {
        return;
      }
      return object[key];
    }
    module.exports = safeGet;
  }
});

// ../../../node_modules/lodash/_assignValue.js
var require_assignValue = __commonJS({
  "../../../node_modules/lodash/_assignValue.js"(exports, module) {
    "use strict";
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignValue;
  }
});

// ../../../node_modules/lodash/_copyObject.js
var require_copyObject = __commonJS({
  "../../../node_modules/lodash/_copyObject.js"(exports, module) {
    "use strict";
    var assignValue = require_assignValue();
    var baseAssignValue = require_baseAssignValue();
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index3 = -1, length = props.length;
      while (++index3 < length) {
        var key = props[index3];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    module.exports = copyObject;
  }
});

// ../../../node_modules/lodash/_baseTimes.js
var require_baseTimes = __commonJS({
  "../../../node_modules/lodash/_baseTimes.js"(exports, module) {
    "use strict";
    function baseTimes(n2, iteratee) {
      var index3 = -1, result = Array(n2);
      while (++index3 < n2) {
        result[index3] = iteratee(index3);
      }
      return result;
    }
    module.exports = baseTimes;
  }
});

// ../../../node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "../../../node_modules/lodash/_isIndex.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    module.exports = isIndex;
  }
});

// ../../../node_modules/lodash/_arrayLikeKeys.js
var require_arrayLikeKeys = __commonJS({
  "../../../node_modules/lodash/_arrayLikeKeys.js"(exports, module) {
    "use strict";
    var baseTimes = require_baseTimes();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isIndex = require_isIndex();
    var isTypedArray = require_isTypedArray();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = arrayLikeKeys;
  }
});

// ../../../node_modules/lodash/_nativeKeysIn.js
var require_nativeKeysIn = __commonJS({
  "../../../node_modules/lodash/_nativeKeysIn.js"(exports, module) {
    "use strict";
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = nativeKeysIn;
  }
});

// ../../../node_modules/lodash/_baseKeysIn.js
var require_baseKeysIn = __commonJS({
  "../../../node_modules/lodash/_baseKeysIn.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var isPrototype = require_isPrototype();
    var nativeKeysIn = require_nativeKeysIn();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object), result = [];
      for (var key in object) {
        if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeysIn;
  }
});

// ../../../node_modules/lodash/keysIn.js
var require_keysIn = __commonJS({
  "../../../node_modules/lodash/keysIn.js"(exports, module) {
    "use strict";
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeysIn = require_baseKeysIn();
    var isArrayLike = require_isArrayLike();
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    module.exports = keysIn;
  }
});

// ../../../node_modules/lodash/toPlainObject.js
var require_toPlainObject = __commonJS({
  "../../../node_modules/lodash/toPlainObject.js"(exports, module) {
    "use strict";
    var copyObject = require_copyObject();
    var keysIn = require_keysIn();
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    module.exports = toPlainObject;
  }
});

// ../../../node_modules/lodash/_baseMergeDeep.js
var require_baseMergeDeep = __commonJS({
  "../../../node_modules/lodash/_baseMergeDeep.js"(exports, module) {
    "use strict";
    var assignMergeValue = require_assignMergeValue();
    var cloneBuffer = require_cloneBuffer();
    var cloneTypedArray = require_cloneTypedArray();
    var copyArray = require_copyArray();
    var initCloneObject = require_initCloneObject();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isArrayLikeObject = require_isArrayLikeObject();
    var isBuffer = require_isBuffer();
    var isFunction = require_isFunction();
    var isObject = require_isObject();
    var isPlainObject = require_isPlainObject();
    var isTypedArray = require_isTypedArray();
    var safeGet = require_safeGet();
    var toPlainObject = require_toPlainObject();
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
      var isCommon = newValue === void 0;
      if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }
    module.exports = baseMergeDeep;
  }
});

// ../../../node_modules/lodash/_baseMerge.js
var require_baseMerge = __commonJS({
  "../../../node_modules/lodash/_baseMerge.js"(exports, module) {
    "use strict";
    var Stack = require_Stack();
    var assignMergeValue = require_assignMergeValue();
    var baseFor = require_baseFor();
    var baseMergeDeep = require_baseMergeDeep();
    var isObject = require_isObject();
    var keysIn = require_keysIn();
    var safeGet = require_safeGet();
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack());
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
          if (newValue === void 0) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    module.exports = baseMerge;
  }
});

// ../../../node_modules/lodash/identity.js
var require_identity = __commonJS({
  "../../../node_modules/lodash/identity.js"(exports, module) {
    "use strict";
    function identity(value) {
      return value;
    }
    module.exports = identity;
  }
});

// ../../../node_modules/lodash/_apply.js
var require_apply = __commonJS({
  "../../../node_modules/lodash/_apply.js"(exports, module) {
    "use strict";
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module.exports = apply;
  }
});

// ../../../node_modules/lodash/_overRest.js
var require_overRest = __commonJS({
  "../../../node_modules/lodash/_overRest.js"(exports, module) {
    "use strict";
    var apply = require_apply();
    var nativeMax = Math.max;
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index3 = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index3 < length) {
          array[index3] = args[start + index3];
        }
        index3 = -1;
        var otherArgs = Array(start + 1);
        while (++index3 < start) {
          otherArgs[index3] = args[index3];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    module.exports = overRest;
  }
});

// ../../../node_modules/lodash/constant.js
var require_constant = __commonJS({
  "../../../node_modules/lodash/constant.js"(exports, module) {
    "use strict";
    function constant(value) {
      return function() {
        return value;
      };
    }
    module.exports = constant;
  }
});

// ../../../node_modules/lodash/_baseSetToString.js
var require_baseSetToString = __commonJS({
  "../../../node_modules/lodash/_baseSetToString.js"(exports, module) {
    "use strict";
    var constant = require_constant();
    var defineProperty = require_defineProperty();
    var identity = require_identity();
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    module.exports = baseSetToString;
  }
});

// ../../../node_modules/lodash/_shortOut.js
var require_shortOut = __commonJS({
  "../../../node_modules/lodash/_shortOut.js"(exports, module) {
    "use strict";
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
      var count2 = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count2 >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count2 = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    module.exports = shortOut;
  }
});

// ../../../node_modules/lodash/_setToString.js
var require_setToString = __commonJS({
  "../../../node_modules/lodash/_setToString.js"(exports, module) {
    "use strict";
    var baseSetToString = require_baseSetToString();
    var shortOut = require_shortOut();
    var setToString = shortOut(baseSetToString);
    module.exports = setToString;
  }
});

// ../../../node_modules/lodash/_baseRest.js
var require_baseRest = __commonJS({
  "../../../node_modules/lodash/_baseRest.js"(exports, module) {
    "use strict";
    var identity = require_identity();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    module.exports = baseRest;
  }
});

// ../../../node_modules/lodash/_isIterateeCall.js
var require_isIterateeCall = __commonJS({
  "../../../node_modules/lodash/_isIterateeCall.js"(exports, module) {
    "use strict";
    var eq = require_eq();
    var isArrayLike = require_isArrayLike();
    var isIndex = require_isIndex();
    var isObject = require_isObject();
    function isIterateeCall(value, index3, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index3;
      if (type == "number" ? isArrayLike(object) && isIndex(index3, object.length) : type == "string" && index3 in object) {
        return eq(object[index3], value);
      }
      return false;
    }
    module.exports = isIterateeCall;
  }
});

// ../../../node_modules/lodash/_createAssigner.js
var require_createAssigner = __commonJS({
  "../../../node_modules/lodash/_createAssigner.js"(exports, module) {
    "use strict";
    var baseRest = require_baseRest();
    var isIterateeCall = require_isIterateeCall();
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index3 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? void 0 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index3 < length) {
          var source = sources[index3];
          if (source) {
            assigner(object, source, index3, customizer);
          }
        }
        return object;
      });
    }
    module.exports = createAssigner;
  }
});

// ../../../node_modules/lodash/merge.js
var require_merge = __commonJS({
  "../../../node_modules/lodash/merge.js"(exports, module) {
    "use strict";
    var baseMerge = require_baseMerge();
    var createAssigner = require_createAssigner();
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });
    module.exports = merge;
  }
});

// ../../../node_modules/lodash/isElement.js
var require_isElement = __commonJS({
  "../../../node_modules/lodash/isElement.js"(exports, module) {
    "use strict";
    var isObjectLike = require_isObjectLike();
    var isPlainObject = require_isPlainObject();
    function isElement3(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }
    module.exports = isElement3;
  }
});

// ../../../node_modules/lodash/_baseClamp.js
var require_baseClamp = __commonJS({
  "../../../node_modules/lodash/_baseClamp.js"(exports, module) {
    "use strict";
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== void 0) {
          number = number <= upper ? number : upper;
        }
        if (lower !== void 0) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }
    module.exports = baseClamp;
  }
});

// ../../../node_modules/lodash/clamp.js
var require_clamp = __commonJS({
  "../../../node_modules/lodash/clamp.js"(exports, module) {
    "use strict";
    var baseClamp = require_baseClamp();
    var toNumber = require_toNumber();
    function clamp2(number, lower, upper) {
      if (upper === void 0) {
        upper = lower;
        lower = void 0;
      }
      if (upper !== void 0) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== void 0) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }
    module.exports = clamp2;
  }
});

// ../../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../../node_modules/lodash/lodash.js"(exports, module) {
    "use strict";
    /**
     * @license
     * Lodash <https://lodash.com/>
     * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
     * Released under MIT license <https://lodash.com/license>
     * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
     * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
     */
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e2) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index3 = -1, length = array == null ? 0 : array.length;
        while (++index3 < length) {
          var value = array[index3];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index3 = -1, length = array == null ? 0 : array.length;
        while (++index3 < length) {
          if (iteratee(array[index3], index3, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index3 = -1, length = array == null ? 0 : array.length;
        while (++index3 < length) {
          if (!predicate(array[index3], index3, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index3 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index3 < length) {
          var value = array[index3];
          if (predicate(value, index3, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index3 = -1, length = array == null ? 0 : array.length;
        while (++index3 < length) {
          if (comparator(value, array[index3])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index3 = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index3 < length) {
          result[index3] = iteratee(array[index3], index3, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index3 = -1, length = values.length, offset4 = array.length;
        while (++index3 < length) {
          array[offset4 + index3] = values[index3];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index3 = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index3];
        }
        while (++index3 < length) {
          accumulator = iteratee(accumulator, array[index3], index3, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index3 = -1, length = array == null ? 0 : array.length;
        while (++index3 < length) {
          if (predicate(array[index3], index3, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index3 = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index3-- : ++index3 < length) {
          if (predicate(array[index3], index3, array)) {
            return index3;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index3 = fromIndex - 1, length = array.length;
        while (++index3 < length) {
          if (comparator(array[index3], value)) {
            return index3;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index3, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index3, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index3 = -1, length = array.length;
        while (++index3 < length) {
          var current = iteratee(array[index3]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n2, iteratee) {
        var index3 = -1, result = Array(n2);
        while (++index3 < n2) {
          result[index3] = iteratee(index3);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index3 = -1, length = strSymbols.length;
        while (++index3 < length && baseIndexOf(chrSymbols, strSymbols[index3], 0) > -1) {
        }
        return index3;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index3 = strSymbols.length;
        while (index3-- && baseIndexOf(chrSymbols, strSymbols[index3], 0) > -1) {
        }
        return index3;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index3 = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index3] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index3 = -1, length = array.length, resIndex = 0, result = [];
        while (++index3 < length) {
          var value = array[index3];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index3] = PLACEHOLDER;
            result[resIndex++] = index3;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index3 = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index3] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index3 = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index3] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index3 = fromIndex - 1, length = array.length;
        while (++index3 < length) {
          if (array[index3] === value) {
            return index3;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index3 = fromIndex + 1;
        while (index3--) {
          if (array[index3] === value) {
            return index3;
          }
        }
        return index3;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index3 = string.length;
        while (index3-- && reWhitespace.test(string.charAt(index3))) {
        }
        return index3;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e2) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = /* @__PURE__ */ function() {
          function object() {
          }
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index3 = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index3 += dir;
              var iterIndex = -1, value = array[index3];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index3 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index3 < length) {
            var entry = entries[index3];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index3 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index3 < length) {
            var entry = entries[index3];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index3 = assocIndexOf(data, key);
          if (index3 < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index3 == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index3, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index3 = assocIndexOf(data, key);
          return index3 < 0 ? undefined2 : data[index3][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index3 = assocIndexOf(data, key);
          if (index3 < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index3][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index3 = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index3 < length) {
            var entry = entries[index3];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size5 = data.size;
          data.set(key, value);
          this.size += data.size == size5 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index3 = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index3 < length) {
            this.add(values2[index3]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n2) {
          return shuffleSelf(copyArray(array), baseClamp(n2, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index3 = -1, length = paths.length, result2 = Array2(length), skip = object == null;
          while (++index3 < length) {
            result2[index3] = skip ? undefined2 : get(object, paths[index3]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index3 = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index3 < length) {
              var value = array[index3], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index3, collection2) {
            result2 = !!predicate(value, index3, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index3 = -1, length = array.length;
          while (++index3 < length) {
            var value = array[index3], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index3, collection2) {
            if (predicate(value, index3, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index3 = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index3 < length) {
            var value = array[index3];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index3 = 0, length = path.length;
          while (object != null && index3 < length) {
            object = object[toKey(path[index3++])];
          }
          return index3 && index3 == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index3 = -1, seen = caches[0];
          outer:
            while (++index3 < length && result2.length < maxLength) {
              var value = array[index3], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index3 = matchData.length, length = index3, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index3--) {
            var data = matchData[index3];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index3 < length) {
            data = matchData[index3];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index3 = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index3] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n2) {
          var length = array.length;
          if (!length) {
            return;
          }
          n2 += n2 < 0 ? length : 0;
          return isIndex(n2, length) ? array[n2] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index3 = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index3, "value": value };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index3 = -1, length = paths.length, result2 = {};
          while (++index3 < length) {
            var path = paths[index3], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index3 = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index3 < length) {
            var fromIndex = 0, value = values2[index3], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index3 = indexes[length];
            if (length == lastIndex || index3 !== previous) {
              var previous = index3;
              if (isIndex(index3)) {
                splice.call(array, index3, 1);
              } else {
                baseUnset(array, index3);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index3 = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index3] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n2) {
          var result2 = "";
          if (!string || n2 < 1 || n2 > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n2 % 2) {
              result2 += string;
            }
            n2 = nativeFloor(n2 / 2);
            if (n2) {
              string += string;
            }
          } while (n2);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n2) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n2, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject(object)) {
            return object;
          }
          path = castPath(path, object);
          var index3 = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index3 < length) {
            var key = toKey(path[index3]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index3 != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index3 + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index3 = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index3 < length) {
            result2[index3] = array[index3 + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index3, collection2) {
            result2 = predicate(value, index3, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index3 = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index3 < length) {
            var value = array[index3], computed = iteratee2 ? iteratee2(value) : value;
            if (!index3 || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index3 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index3 < length) {
              var value = array[index3], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index3 = fromRight ? length : -1;
          while ((fromRight ? index3-- : ++index3 < length) && predicate(array[index3], index3, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index3, fromRight ? index3 + 1 : length) : baseSlice(array, fromRight ? index3 + 1 : 0, fromRight ? length : index3);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index3 = -1, result2 = Array2(length);
          while (++index3 < length) {
            var array = arrays[index3], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index3) {
                result2[index3] = baseDifference(result2[index3] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index3 = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index3 < length) {
            var value = index3 < valsLength ? values2[index3] : undefined2;
            assignFunc(result2, props[index3], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index3 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index3 < length) {
            var result2 = compareAscending(objCriteria[index3], othCriteria[index3]);
            if (result2) {
              if (index3 >= ordersLength) {
                return result2;
              }
              var order = orders[index3];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset4 = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset4 + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset4 + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index3 = -1, length = source.length;
          array || (array = Array2(length));
          while (++index3 < length) {
            array[index3] = source[index3];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index3 = -1, length = props.length;
          while (++index3 < length) {
            var key = props[index3];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index3 = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index3 < length) {
              var source = sources[index3];
              if (source) {
                assigner(object, source, index3, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index3 = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index3-- : ++index3 < length) {
              if (iteratee2(iterable[index3], index3, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index3 = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index3];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index3 = length, placeholder = getHolder(wrapper);
            while (index3--) {
              args[index3] = arguments[index3];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index3 = findIndexFunc(collection, predicate, fromIndex);
            return index3 > -1 ? iterable[iteratee2 ? collection[index3] : index3] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index3 = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index3--) {
              var func = funcs[index3];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index3 = wrapper ? index3 : length;
            while (++index3 < length) {
              func = funcs[index3];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index4 = 0, result2 = length ? funcs[index4].apply(this, args) : value;
              while (++index4 < length) {
                result2 = funcs[index4].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index3 = length;
            while (index3--) {
              args[index3] = arguments[index3];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index3 = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index3 < arrLength) {
            var arrValue = array[index3], othValue = other[index3];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index3, other, array, stack) : customizer(arrValue, othValue, index3, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index3 = objLength;
          while (index3--) {
            var key = objProps[index3];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index3 < objLength) {
            key = objProps[index3];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e2) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index3 = -1, length = transforms.length;
          while (++index3 < length) {
            var data = transforms[index3], size5 = data.size;
            switch (data.type) {
              case "drop":
                start += size5;
                break;
              case "dropRight":
                end -= size5;
                break;
              case "take":
                end = nativeMin(end, start + size5);
                break;
              case "takeRight":
                start = nativeMax(start, end - size5);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index3 = -1, length = path.length, result2 = false;
          while (++index3 < length) {
            var key = toKey(path[index3]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index3 != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index3, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index3;
          if (type == "number" ? isArrayLike(object) && isIndex(index3, object.length) : type == "string" && index3 in object) {
            return eq(object[index3], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index3 = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index3 < length) {
              array[index3] = args[start + index3];
            }
            index3 = -1;
            var otherArgs = Array2(start + 1);
            while (++index3 < start) {
              otherArgs[index3] = args[index3];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index3 = indexes[length];
            array[length] = isIndex(index3, arrLength) ? oldArray[index3] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count2 = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count2 >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count2 = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size5) {
          var index3 = -1, length = array.length, lastIndex = length - 1;
          size5 = size5 === undefined2 ? length : size5;
          while (++index3 < size5) {
            var rand = baseRandom(index3, lastIndex), value = array[rand];
            array[rand] = array[index3];
            array[index3] = value;
          }
          array.length = size5;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e2) {
            }
            try {
              return func + "";
            } catch (e2) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size5, guard) {
          if (guard ? isIterateeCall(array, size5, guard) : size5 === undefined2) {
            size5 = 1;
          } else {
            size5 = nativeMax(toInteger(size5), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size5 < 1) {
            return [];
          }
          var index3 = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size5));
          while (index3 < length) {
            result2[resIndex++] = baseSlice(array, index3, index3 += size5);
          }
          return result2;
        }
        function compact(array) {
          var index3 = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index3 < length) {
            var value = array[index3];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index3 = length;
          while (index3--) {
            args[index3 - 1] = arguments[index3];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n2, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
          return baseSlice(array, n2 < 0 ? 0 : n2, length);
        }
        function dropRight(array, n2, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
          n2 = length - n2;
          return baseSlice(array, 0, n2 < 0 ? 0 : n2);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index3 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index3 < 0) {
            index3 = nativeMax(length + index3, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index3);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index3 = length - 1;
          if (fromIndex !== undefined2) {
            index3 = toInteger(fromIndex);
            index3 = fromIndex < 0 ? nativeMax(length + index3, 0) : nativeMin(index3, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index3, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index3 = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index3 < length) {
            var pair = pairs[index3];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index3 = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index3 < 0) {
            index3 = nativeMax(length + index3, 0);
          }
          return baseIndexOf(array, value, index3);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index3 = length;
          if (fromIndex !== undefined2) {
            index3 = toInteger(fromIndex);
            index3 = index3 < 0 ? nativeMax(length + index3, 0) : nativeMin(index3, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index3) : baseFindIndex(array, baseIsNaN, index3, true);
        }
        function nth(array, n2) {
          return array && array.length ? baseNth(array, toInteger(n2)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index3) {
            return isIndex(index3, length) ? +index3 : index3;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index3 = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index3 < length) {
            var value = array[index3];
            if (predicate(value, index3, array)) {
              result2.push(value);
              indexes.push(index3);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index3 = baseSortedIndex(array, value);
            if (index3 < length && eq(array[index3], value)) {
              return index3;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index3 = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index3], value)) {
              return index3;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n2, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
          return baseSlice(array, 0, n2 < 0 ? 0 : n2);
        }
        function takeRight(array, n2, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n2 = guard || n2 === undefined2 ? 1 : toInteger(n2);
          n2 = length - n2;
          return baseSlice(array, n2 < 0 ? 0 : n2, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index3) {
            return arrayMap(array, baseProperty(index3));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index3 = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index3] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n2, guard) {
          if (guard ? isIterateeCall(collection, n2, guard) : n2 === undefined2) {
            n2 = 1;
          } else {
            n2 = toInteger(n2);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n2);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size4(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n2, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n2 = toInteger(n2);
          return function() {
            if (--n2 < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n2, guard) {
          n2 = guard ? undefined2 : n2;
          n2 = func && n2 == null ? func.length : n2;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n2);
        }
        function before(n2, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n2 = toInteger(n2);
          return function() {
            if (--n2 > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n2 <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce2(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip4(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index3 = -1, length = nativeMin(args.length, funcsLength);
            while (++index3 < length) {
              args[index3] = transforms[index3].call(this, args[index3]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce2(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement3(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index3 = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index3 < length) {
            var source = sources[index3];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result2 = object == null ? undefined2 : baseGet(object, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index3 = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index3 < length) {
            var value = object == null ? undefined2 : object[toKey(path[index3])];
            if (value === undefined2) {
              index3 = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index3, object2) {
            return iteratee2(accumulator, value, index3, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp2(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index3) {
          word = word.toLowerCase();
          return result2 + (index3 ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index3) {
          return result2 + (index3 ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index3) {
          return result2 + (index3 ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n2, guard) {
          if (guard ? isIterateeCall(string, n2, guard) : n2 === undefined2) {
            n2 = 1;
          } else {
            n2 = toInteger(n2);
          }
          return baseRepeat(toString(string), n2);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index3) {
          return result2 + (index3 ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index3) {
          return result2 + (index3 ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index3 = 0, interpolate2 = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate2.source + "|" + (interpolate2 === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset4) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index3, offset4).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index3 = offset4 + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index3 = result2.lastIndexOf(separator);
            if (index3 > -1) {
              result2 = result2.slice(0, index3);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index3) {
          return result2 + (index3 ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e2) {
            return isError(e2) ? e2 : new Error2(e2);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index3 = -1;
            while (++index3 < length) {
              var pair = pairs[index3];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches2(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n2) {
          n2 = toInteger(n2);
          return baseRest(function(args) {
            return baseNth(args, n2);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n2, iteratee2) {
          n2 = toInteger(n2);
          if (n2 < 1 || n2 > MAX_SAFE_INTEGER) {
            return [];
          }
          var index3 = MAX_ARRAY_LENGTH, length = nativeMin(n2, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n2 -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index3 < n2) {
            iteratee2(index3);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor2 = createRound("floor");
        function max2(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min2(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round2 = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce2;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip4;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches2;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp2;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor2;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement3;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max2;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min2;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round2;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size4;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index3) {
          LazyWrapper.prototype[methodName] = function(n2) {
            n2 = n2 === undefined2 ? 1 : nativeMax(toInteger(n2), 0);
            var result2 = this.__filtered__ && !index3 ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n2, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n2, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n2) {
            return this.reverse()[methodName](n2).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index3) {
          var type = index3 + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index3) {
          var takeName = "take" + (index3 ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index3) {
          var dropName = "drop" + (index3 ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(exports);
  }
});

// ../../hooks/dist/esm/useCallbackRef.js
import { useCallback, useEffect, useRef } from "react";
var useCallbackRef = (callback) => {
  const callbackRef = useRef(callback);
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
  return useCallback((...args) => callbackRef.current?.(...args), []);
};

// ../../hooks/dist/esm/useCallbacks.js
var import_debounce = __toESM(require_debounce());
var import_throttle = __toESM(require_throttle());
import { useCallback as useCallback2 } from "react";
var getDebounceOptions = (delayOrOpts) => {
  const opts = { leading: true, trailing: true, maxWait: Infinity };
  let wait = 0;
  if (typeof delayOrOpts === "number") {
    wait = delayOrOpts;
  } else {
    const { wait: waitFromOpts, ...rest } = delayOrOpts;
    wait = waitFromOpts;
    Object.assign(opts, rest);
  }
  return { opts, wait };
};
var useDebouncedCallback = (func, waitOrOpts, deps = []) => {
  const { opts, wait } = getDebounceOptions(waitOrOpts);
  return useCallback2((0, import_debounce.default)(func, wait, opts), [wait, opts.leading, opts.trailing, opts.maxWait, ...deps]);
};

// ../../logging/dist/esm/utils/constants.js
var CSOL_ORGID = "awsm_care";
var ANALYTICS_METADATA_ATTRIBUTE = "data-rigel-analytics";

// ../../logging/dist/esm/utils/index.js
var throwError = (location2, message) => {
  throw new Error(`[RigelLogging] [${location2}] ${message}`);
};
var stringStartsWithRigel = (str) => str?.toLowerCase().startsWith("rigel") ?? false;

// ../../logging/dist/esm/hooks/useLogger.js
import { useLogger as useTemplateHelperLogger } from "@amzn/aws-marketing-experience-builder-template-helpers";

// ../../../node_modules/@amzn/aws-marketing-experience-builder-template-types/dist/esm/types/analytics-types.js
var AnalyticsEventContentType;
(function(AnalyticsEventContentType2) {
  AnalyticsEventContentType2["AWS_TV_VIDEO"] = "awsTvVideo";
  AnalyticsEventContentType2["GEN_AI_SUMMARY"] = "genAiSummary";
  AnalyticsEventContentType2["SLOT"] = "slot";
  AnalyticsEventContentType2["TEST"] = "test";
  AnalyticsEventContentType2["THUMBS_UP_DOWN"] = "thumbsUpDown";
  AnalyticsEventContentType2["VIDEO"] = "video";
})(AnalyticsEventContentType || (AnalyticsEventContentType = {}));

// ../../../node_modules/@amzn/aws-marketing-experience-builder-template-types/dist/esm/types/i18n-types.js
var SupportedLocale;
(function(SupportedLocale2) {
  SupportedLocale2["AR_SA"] = "ar-SA";
  SupportedLocale2["DE_DE"] = "de-DE";
  SupportedLocale2["EN_US"] = "en-US";
  SupportedLocale2["ES_ES"] = "es-ES";
  SupportedLocale2["FR_FR"] = "fr-FR";
  SupportedLocale2["ID_ID"] = "id-ID";
  SupportedLocale2["IT_IT"] = "it-IT";
  SupportedLocale2["JA_JP"] = "ja-JP";
  SupportedLocale2["KO_KR"] = "ko-KR";
  SupportedLocale2["PT_BR"] = "pt-BR";
  SupportedLocale2["RU_RU"] = "ru-RU";
  SupportedLocale2["TH_TH"] = "th-TH";
  SupportedLocale2["TR_TR"] = "tr-TR";
  SupportedLocale2["VI_VN"] = "vi-VN";
  SupportedLocale2["ZH_CN"] = "zh-CN";
  SupportedLocale2["ZH_TW"] = "zh-TW";
})(SupportedLocale || (SupportedLocale = {}));
var SupportedLanguagePath;
(function(SupportedLanguagePath2) {
  SupportedLanguagePath2["AR"] = "ar";
  SupportedLanguagePath2["CN"] = "cn";
  SupportedLanguagePath2["DE"] = "de";
  SupportedLanguagePath2["EN"] = "";
  SupportedLanguagePath2["ES"] = "es";
  SupportedLanguagePath2["FR"] = "fr";
  SupportedLanguagePath2["ID"] = "id";
  SupportedLanguagePath2["IT"] = "it";
  SupportedLanguagePath2["JP"] = "jp";
  SupportedLanguagePath2["KO"] = "ko";
  SupportedLanguagePath2["PT"] = "pt";
  SupportedLanguagePath2["RU"] = "ru";
  SupportedLanguagePath2["TH"] = "th";
  SupportedLanguagePath2["TR"] = "tr";
  SupportedLanguagePath2["TW"] = "tw";
  SupportedLanguagePath2["VI"] = "vi";
})(SupportedLanguagePath || (SupportedLanguagePath = {}));

// ../../../node_modules/@amzn/aws-marketing-experience-builder-template-types/dist/esm/types/template-types.js
var RenderingStrategy;
(function(RenderingStrategy2) {
  RenderingStrategy2["CSR"] = "csr";
})(RenderingStrategy || (RenderingStrategy = {}));
var Site;
(function(Site2) {
  Site2["GLOBAL"] = "Global";
  Site2["CN"] = "CN";
  Site2["BLOG"] = "Blog";
  Site2["DCA"] = "DCA";
  Site2["LCK"] = "LCK";
  Site2["TOPAZ"] = "Topaz";
})(Site || (Site = {}));
var EnvironmentStage;
(function(EnvironmentStage2) {
  EnvironmentStage2["DEV"] = "dev";
  EnvironmentStage2["ALPHA"] = "alpha";
  EnvironmentStage2["BETA"] = "beta";
  EnvironmentStage2["GAMMA"] = "gamma";
  EnvironmentStage2["PROD"] = "prod";
  EnvironmentStage2["UNKNOWN"] = "unknown";
})(EnvironmentStage || (EnvironmentStage = {}));
var TargetName;
(function(TargetName2) {
  TargetName2["LIVE"] = "Live";
  TargetName2["STAGING"] = "Staging";
  TargetName2["LOCALIZATION"] = "Localization";
  TargetName2["SANDBOX"] = "Sandbox";
})(TargetName || (TargetName = {}));
var EnvironmentRegion;
(function(EnvironmentRegion2) {
  EnvironmentRegion2["US_WEST_2"] = "us-west-2";
  EnvironmentRegion2["US_EAST_1"] = "us-east-1";
  EnvironmentRegion2["CN_NORTH_1"] = "cn-north-1";
  EnvironmentRegion2["CN_NORTHWEST_1"] = "cn-northwest-1";
  EnvironmentRegion2["UNKNOWN"] = "unknown";
})(EnvironmentRegion || (EnvironmentRegion = {}));

// ../../../node_modules/@amzn/aws-marketing-experience-builder-template-types/dist/esm/types/rendering-types.js
var ContentType;
(function(ContentType2) {
  ContentType2["EXPERIENCE_FRAGMENT"] = "xf";
  ContentType2["OFFER"] = "offer";
  ContentType2["PAGE"] = "page";
})(ContentType || (ContentType = {}));
var SlotSsrState;
(function(SlotSsrState2) {
  SlotSsrState2["PROCESSED"] = "processed";
  SlotSsrState2["UNPROCESSED"] = "unprocessed";
})(SlotSsrState || (SlotSsrState = {}));
var RenderMode;
(function(RenderMode2) {
  RenderMode2["NO_WRAPPERS"] = "noWrappers";
  RenderMode2["WITH_WRAPPERS"] = "withWrappers";
  RenderMode2["TEMPLATE_MARKUP_ONLY"] = "templateMarkupOnly";
})(RenderMode || (RenderMode = {}));
var StyleDirection;
(function(StyleDirection2) {
  StyleDirection2["LTR"] = "ltr";
  StyleDirection2["RTL"] = "rtl";
})(StyleDirection || (StyleDirection = {}));

// ../../../node_modules/@amzn/aws-marketing-experience-builder-template-types/dist/esm/types/logger-types.js
var LogLevel;
(function(LogLevel2) {
  LogLevel2["INFO"] = "info";
  LogLevel2["DEBUG"] = "debug";
  LogLevel2["WARN"] = "warn";
  LogLevel2["ERROR"] = "error";
})(LogLevel || (LogLevel = {}));
var MetricUnit;
(function(MetricUnit2) {
  MetricUnit2["NONE"] = "None";
  MetricUnit2["SECONDS"] = "Seconds";
  MetricUnit2["MILLISECONDS"] = "Milliseconds";
  MetricUnit2["BYTES"] = "Bytes";
  MetricUnit2["COUNT"] = "Count";
  MetricUnit2["PERCENT"] = "Percent";
  MetricUnit2["BYTES_PER_SECOND"] = "Bytes/Second";
  MetricUnit2["COUNT_PER_SECOND"] = "Count/Second";
})(MetricUnit || (MetricUnit = {}));

// ../../../node_modules/@amzn/aws-marketing-experience-builder-template-types/dist/esm/types/client-logger-types.js
var ClientSideMetric;
(function(ClientSideMetric2) {
  ClientSideMetric2["INVALID_EXPERIENCE_CONFIG_ERROR"] = "InvalidExperienceConfigError";
  ClientSideMetric2["RECON_REQUEST_ERROR"] = "ReConRequestError";
  ClientSideMetric2["RECON_REQUEST_SUCCESS"] = "ReConRequestSuccess";
  ClientSideMetric2["RECON_REQUEST_COMPLETE"] = "ReConRequestComplete";
  ClientSideMetric2["EXPERIENCE_NOT_FOUND_ERROR"] = "ExperienceNotFoundError";
  ClientSideMetric2["INVALID_SLOT_ERROR"] = "InvalidSlotError";
  ClientSideMetric2["RENDER_ERROR"] = "RenderError";
  ClientSideMetric2["SLOT_RENDER_SUCCESS"] = "SlotRenderSuccess";
  ClientSideMetric2["SLOT_RENDER_COMPLETE"] = "SlotRenderComplete";
  ClientSideMetric2["PAGE_RENDER_COMPLETE"] = "PageRenderComplete";
  ClientSideMetric2["INVALID_CONTENT_DATA_ERROR"] = "InvalidContentDataError";
  ClientSideMetric2["CONTENT_DATA_PARSE_ERROR"] = "ContentDataParseError";
  ClientSideMetric2["EXPERIENCE_HYDRATION_ERROR"] = "ExperienceHydrationError";
  ClientSideMetric2["EXPERIENCE_HYDRATION_SUCCESS"] = "ExperienceHydrationSuccess";
  ClientSideMetric2["EXPERIENCE_HYDRATION_TIME"] = "ExperienceHydrationTime";
  ClientSideMetric2["PAGE_HYDRATION_TIME"] = "PageHydrationTime";
  ClientSideMetric2["CDN_TEMPLATE_REQUEST_TIME"] = "CDNTemplateRequestTime";
  ClientSideMetric2["CDN_TEMPLATE_REQUEST_ERROR"] = "CDNTemplateRequestError";
  ClientSideMetric2["CDN_TEMPLATE_REQUEST_SUCCESS"] = "CDNTemplateRequestSuccess";
})(ClientSideMetric || (ClientSideMetric = {}));
var LogType;
(function(LogType2) {
  LogType2["RAW"] = "RAW";
  LogType2["AI"] = "AI";
  LogType2["LOCAL"] = "LOCAL";
})(LogType || (LogType = {}));

// ../../../node_modules/@amzn/aws-marketing-experience-builder-template-types/dist/esm/types/recon-types.js
var ReconEventType;
(function(ReconEventType2) {
  ReconEventType2["CLICK"] = "click";
  ReconEventType2["IMPRESSION"] = "impression";
  ReconEventType2["DISMISS"] = "dismiss";
  ReconEventType2["TEST"] = "test";
})(ReconEventType || (ReconEventType = {}));

// ../../logging/dist/esm/hooks/useLogger.js
import { useCallback as useCallback3, useContext, useMemo } from "react";

// ../../logging/dist/esm/LoggingProvider/LoggingContext.js
import { createContext } from "react";
var LoggingContext = createContext(void 0);

// ../../logging/dist/esm/hooks/useLogger.js
var DEFAULT_COMPONENT_NAME = "UnknownComponent";
var DEFAULT_NAMESPACE = "UnknownNamespace";
var ensurePayloadIsObject = (payload) => typeof payload === "string" ? { message: payload } : payload;
var useLogger = (options) => {
  if (stringStartsWithRigel(options.componentName)) {
    throwError("useLogger", 'The provided component name must not start with "Rigel".');
  }
  if (stringStartsWithRigel(options.namespaceOverride)) {
    throwError("useLogger", 'The provided namespace must not start with "Rigel".');
  }
  const loggingContext = useContext(LoggingContext);
  const componentName = options.componentName || DEFAULT_COMPONENT_NAME;
  const componentNamespace = options.namespaceOverride || loggingContext?.namespaceStack.join(".") || DEFAULT_NAMESPACE;
  const outerNamespace = options.namespaceOverride || loggingContext?.namespaceStack[0] || DEFAULT_NAMESPACE;
  const baseLogger = useTemplateHelperLogger({
    /**
     * @see https://code.amazon.com/packages/AWSMarketingClientSideOperationsLogLambda/blobs/2cf9754fc2d6c7502de7c745ad59e1b19ada64ab/--/src/utils/groupLogsByNamespace.ts#L11
     */
    // @ts-ignore - it will always default to Rigel even if namespace override is an empty string.
    namespace: options.csolConfig?.namespace || "Rigel",
    /**
     * This makes all Rigel logs go to us (CARE). If we want logs to go to whatever team is actually consuming the components, move the orgId option onto the LoggingProvider instead.
     */
    orgId: CSOL_ORGID
  });
  const addRigelNamespacesToPayload = useCallback3(
    (payload) => {
      return {
        ...ensurePayloadIsObject(payload),
        rigelComponentName: componentName,
        rigelRootNamespace: outerNamespace,
        rigelComponentNamespace: componentNamespace
      };
    },
    [outerNamespace, componentName, componentNamespace]
  );
  const startPerformanceMetric = useCallback3(
    (metricName) => {
      const startTime = Date.now();
      return {
        logPerformanceMetric: (payload) => {
          baseLogger.info(metricName, {
            ...addRigelNamespacesToPayload(payload),
            value: Math.floor(Date.now() - startTime),
            unit: MetricUnit.MILLISECONDS
          });
        }
      };
    },
    [baseLogger, addRigelNamespacesToPayload]
  );
  return useMemo(
    () => ({
      ...baseLogger,
      debug: (metricName, payload) => baseLogger.debug(metricName, addRigelNamespacesToPayload(payload)),
      info: (metricName, payload) => baseLogger.info(metricName, addRigelNamespacesToPayload(payload)),
      warn: (metricName, payload) => baseLogger.warn(metricName, addRigelNamespacesToPayload(payload)),
      error: (metricName, payload) => baseLogger.error(metricName, addRigelNamespacesToPayload(payload)),
      startPerformanceMetric
    }),
    [baseLogger, addRigelNamespacesToPayload, startPerformanceMetric]
  );
};

// ../../logging/dist/esm/hocs/withLogger.js
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
function withLogger(Component2, options) {
  const wrapped = forwardRef((props, ref) => {
    const logger = useLogger(options);
    return /* @__PURE__ */ jsx(Component2, { ...props, logger, ref });
  });
  wrapped.displayName = `withLogger(${Component2.displayName || Component2.name})`;
  return wrapped;
}

// ../../logging/dist/esm/LoggingErrorBoundary/LoggingErrorBoundary.js
import { Component } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var LoggingErrorBoundaryInternal = class extends Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error2, errorInfo) {
    if ("logger" in this.props) {
      const logger = this.props.logger;
      console.error(error2, errorInfo);
      logger.error("ErrorBoundary", {
        message: error2.message,
        stack: error2.stack,
        componentStack: errorInfo.componentStack
      });
    }
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsx2("p", { children: this.props.errorMessage || "An error has occured with this component." });
    }
    return this.props.children;
  }
};
var LoggingErrorBoundary = withLogger(LoggingErrorBoundaryInternal, {
  componentName: "ErrorBoundary"
});

// ../../logging/dist/esm/LoggingProvider/LoggingProvider.js
import { useContext as useContext2, useMemo as useMemo2 } from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var LoggingProvider = ({ children, namespace }) => {
  const outerContext = useContext2(LoggingContext);
  if (!outerContext && !namespace) {
    throwError("LoggingProvider", "The 'namespace' prop is required on the outer logging provider.");
  }
  if (stringStartsWithRigel(namespace)) {
    throwError(
      "LoggingProvider",
      'The provided namespace must not start with "Rigel". The Rigel prefix will be added for you.'
    );
  }
  const namespaceStack = useMemo2(() => {
    if (namespace) {
      if (outerContext?.namespaceStack) {
        return [...outerContext.namespaceStack, namespace];
      } else {
        return [namespace];
      }
    } else {
      return outerContext?.namespaceStack || [];
    }
  }, [namespace, outerContext?.namespaceStack]);
  const value = useMemo2(() => {
    return {
      namespaceStack
    };
  }, [namespaceStack]);
  return /* @__PURE__ */ jsx3(LoggingContext.Provider, { value, children: /* @__PURE__ */ jsx3(LoggingErrorBoundary, { children }) });
};

// ../../../node_modules/clsx/dist/clsx.mjs
function r(e2) {
  var t2, f, n2 = "";
  if ("string" == typeof e2 || "number" == typeof e2) n2 += e2;
  else if ("object" == typeof e2) if (Array.isArray(e2)) {
    var o2 = e2.length;
    for (t2 = 0; t2 < o2; t2++) e2[t2] && (f = r(e2[t2])) && (n2 && (n2 += " "), n2 += f);
  } else for (f in e2) e2[f] && (n2 && (n2 += " "), n2 += f);
  return n2;
}
function clsx() {
  for (var e2, t2, f = 0, n2 = "", o2 = arguments.length; f < o2; f++) (e2 = arguments[f]) && (t2 = r(e2)) && (n2 && (n2 += " "), n2 += t2);
  return n2;
}
var clsx_default = clsx;

// ../../components/dist/esm/Button/Button.js
var import_merge2 = __toESM(require_merge());
import { forwardRef as forwardRef10 } from "react";

// ../../hooks/dist/esm/useHrefProps.js
import { isLinkExternal } from "@amzn/aws-marketing-experience-builder-template-helpers";
import { useEffect as useEffect2, useState } from "react";
var VALID_HOSTS = [
  /^https:\/\/aws\.amazon\.com/,
  /^https:\/\/pages\.awscloud\.com/,
  /^https:\/\/.*\.?awsevents\.com/,
  /^https:\/\/.*\.?aws\.com/,
  /^https:\/\/.*\.?awscloudinstitute\.com/
];
var hostsRegex = new RegExp(VALID_HOSTS.map((r3) => r3.source).join("|"));
function getHrefProps(href) {
  if (!href) {
    return {};
  }
  const props = { href };
  if (isLinkExternal(href) && !href.startsWith("#")) {
    props.rel = "noopener noreferrer";
    props.target = "_blank";
  }
  return props;
}
var useHrefProps = (href) => {
  const [props, setProps] = useState(getHrefProps(href));
  useEffect2(() => {
    if (href && hostsRegex.test(href)) {
      const urlParams = new URLSearchParams(location.search);
      const url = new URL(href, location.href);
      const params = Array.from(url.searchParams.entries());
      params.map(([paramName, paramValue]) => {
        if (!paramValue) {
          const urlValue = urlParams.get(paramName);
          if (urlValue) {
            url.searchParams.set(paramName, urlValue);
          } else {
            url.searchParams.delete(paramName);
          }
        }
      });
      href = url.href;
    }
    setProps(getHrefProps(href));
  }, [href]);
  return props;
};

// ../../components/dist/esm/ButtonBase/ButtonBase.js
import { forwardRef as forwardRef3 } from "react";

// ../../utils/dist/esm/mergeRefs.js
function mergeRefs(...refs) {
  if (refs.every((ref) => ref == null)) {
    return null;
  }
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        ref.current = value;
      }
    });
  };
}

// ../../hooks/dist/esm/useMergeRefs.js
import { useMemo as useMemo3 } from "react";
function useMergeRefs(...refs) {
  return useMemo3(() => mergeRefs(...refs), refs);
}

// ../../components/dist/esm/DropShadow/DropShadow.js
import { cloneElement, forwardRef as forwardRef2 } from "react";

// ../../components/dist/esm/DropShadow/drop-shadow.module.css
var drop_shadow_default = {
  "shadow": "rgft_9e423fbb",
  "grayscale": "rgft_1b2a14d4",
  "disabled": "rgft_3ef5a62a",
  "always": "rgft_3d631df0",
  "off-hover": "rgft_b27cc003",
  "on-hover": "rgft_5962fadc",
  "elev-2": "rgft_e79955da",
  "themed": "rgft_1ed8cbde",
  "hoverable": "rgft_4df65418",
  "pressable": "rgft_e90ac70d",
  "pressed": "rgft_a4f580d2",
  "inverted": "rgft_38d8ffac"
};

// ../../components/dist/esm/DropShadow/DropShadow.js
var DropShadow = forwardRef2(
  ({
    children,
    when = "always",
    pressable = false,
    pressed = false,
    hoverable = false,
    disabled = false,
    variant = "themed",
    invertGradient = false,
    elevation = 1
  }, ref) => {
    const classes = clsx_default(drop_shadow_default.shadow, drop_shadow_default[variant], drop_shadow_default[`elev-${elevation}`], {
      [drop_shadow_default["always"]]: when === "always",
      [drop_shadow_default["on-hover"]]: when === "hover",
      [drop_shadow_default["off-hover"]]: when === "not-hover",
      [drop_shadow_default.pressable]: pressable,
      [drop_shadow_default.hoverable]: hoverable,
      [drop_shadow_default.pressed]: pressed,
      [drop_shadow_default.disabled]: disabled,
      [drop_shadow_default.inverted]: invertGradient
    });
    const refs = useMergeRefs(ref, children.ref);
    return cloneElement(children, {
      className: clsx_default(classes, children.props.className),
      ref: refs
    });
  }
);

// ../../components/dist/esm/ButtonBase/buttonbase.module.css
var buttonbase_default = {
  "button-base": "rgft_f7822e54",
  "size-s": "rgft_094d67e1",
  "primary": "rgft_303c672b",
  "secondary": "rgft_18409398",
  "tertiary": "rgft_090951dc",
  "flat": "rgft_15529d9f",
  "selected": "rgft_bb950a4e",
  "visited": "rgft_bb419678",
  "disabled": "rgft_badebaf5"
};

// ../../components/dist/esm/ButtonBase/ButtonBase.js
import { jsx as jsx4 } from "react/jsx-runtime";
var ButtonBase = forwardRef3(
  ({
    className,
    children,
    variant = "primary",
    size: size4 = "m",
    selected = false,
    visited = false,
    disabled = false,
    hovering = false,
    pressed = false,
    href,
    ...rest
  }, ref) => {
    const classes = clsx_default(
      buttonbase_default["button-base"],
      buttonbase_default[`size-${size4}`],
      {
        [buttonbase_default.disabled]: disabled,
        [buttonbase_default.visited]: visited,
        [buttonbase_default.selected]: selected,
        [buttonbase_default.primary]: variant === "primary",
        [buttonbase_default.secondary]: variant === "secondary",
        [buttonbase_default.tertiary]: variant === "tertiary",
        [buttonbase_default.flat]: variant === "flat"
      },
      className
    );
    const isAnchor = href !== void 0;
    const hrefAttrs = useHrefProps(href);
    const Tag = isAnchor ? "a" : "button";
    const props = {
      role: "button",
      tabIndex: isAnchor && disabled ? -1 : void 0,
      ...hrefAttrs,
      ...rest,
      disabled: !isAnchor && disabled,
      className: classes,
      ref
    };
    return /* @__PURE__ */ jsx4(
      DropShadow,
      {
        when: hovering ? "always" : "hover",
        pressable: true,
        disabled: variant === "tertiary",
        pressed,
        invertGradient: true,
        children: /* @__PURE__ */ jsx4(Tag, { ...props, children })
      }
    );
  }
);

// ../../utils/dist/esm/getComponentNameAttributes.js
var getComponentNameAttributes = (name) => ({
  "data-rg-n": name
});

// ../../components/dist/esm/Link/Link.js
var import_merge = __toESM(require_merge());
import { forwardRef as forwardRef9 } from "react";

// ../../components/dist/esm/Text/BodyText/BodyText.js
import { forwardRef as forwardRef6 } from "react";

// ../../components/dist/esm/Text/BaseText/BaseText.js
import { sanitizeHTML } from "@amzn/aws-marketing-experience-builder-template-helpers";
import { forwardRef as forwardRef5 } from "react";

// ../../components/dist/esm/Text/BaseText/basetext.module.css
var basetext_default = {
  "text": "rgft_8711ccd9",
  "center": "rgft_5e58a6df",
  "block": "rgft_b7ada98b",
  "monospace": "rgft_beb26dc7",
  "link-swipe": "rgft_d72bdead",
  "inline-icon": "rgft_12e1c6fa"
};

// ../../hooks/dist/esm/useIsomorphicLayoutEffect.js
import { isServer } from "@amzn/aws-marketing-experience-builder-template-helpers";
import { useEffect as useEffect3, useLayoutEffect } from "react";
var useIsomorphicLayoutEffect = isServer() ? useEffect3 : useLayoutEffect;

// ../../components/dist/esm/Text/BaseText/useIconReplacer.js
import React2, { useRef as useRef3 } from "react";
import { flushSync } from "react-dom";

// ../../components/dist/esm/Icon/Icon.js
import { forwardRef as forwardRef4 } from "react";

// ../../../node_modules/react-if/dist/react-if.esm.js
import React, { Fragment, useRef as useRef2, useState as useState2, useMemo as useMemo4, useEffect as useEffect4 } from "react";
var render = function render2(props) {
  if (typeof props.children === "function") {
    return React.createElement(Fragment, null, props.children());
  }
  return React.createElement(Fragment, null, props.children || null);
};
var getConditionResult = function getConditionResult2(condition) {
  var conditionResult = Boolean(typeof condition === "function" ? condition() : condition);
  return conditionResult;
};
var When = function When2(_ref) {
  var condition = _ref.condition, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
  var conditionResult = Boolean(getConditionResult(condition));
  return conditionResult && children ? render({
    children
  }) : null;
};

// ../../components/dist/esm/Icon/IconSVGs.js
var IconSVGs = {
  pause: { viewBox: { w: 17, h: 16 }, path: "M5.35001 2V14 M11.35 2V14", type: "stroke" },
  play: {
    viewBox: { w: 11, h: 12 },
    path: "M1.35001 1V11L9.35001 6L1.35001 1Z"
  },
  replay: {
    viewBox: { w: 14, h: 16 },
    type: "stroke",
    path: "M9.42599 11.8077C7.67599 12.4877 5.62598 12.2777 4.02598 11.0577C1.59598 9.20773 1.13598 5.75773 2.99598 3.34773C4.85598 0.937732 8.33598 0.477732 10.756 2.32773C11.916 3.20773 12.626 4.45773 12.846 5.77773 M7.70599 8.80774L10.706 11.8077L7.70599 14.8077"
  },
  plus: { viewBox: { w: 16, h: 16 }, path: "M16 9H9V16H7V9H0V7H7V0H9V7H16V9Z" },
  "plus-circle": {
    viewBox: { w: 16, h: 16 },
    path: "M8 0C3.59 0 0 3.59 0 8C0 12.41 3.59 16 8 16C12.41 16 16 12.41 16 8C16 3.59 12.41 0 8 0ZM8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C11.31 2 14 4.69 14 8C14 11.31 11.31 14 8 14ZM9 7H11V9H9V11H7V9H5V7H7V5H9V7Z"
  },
  minus: { viewBox: { w: 16, h: 2 }, path: "M16 0H0V2H16V0Z" },
  "minus-circle": {
    viewBox: { w: 16, h: 16 },
    path: "M8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0C12.41 0 16 3.59 16 8C16 12.41 12.41 16 8 16ZM8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2ZM11 7H5V9H11V7Z"
  },
  new: {
    viewBox: { w: 16, h: 16 },
    path: "M16 16H0V0H6.83V2H2V14H14V9.17H16V16ZM15 0H9.17V2H12.59L6.13 8.46L7.54 9.87L14 3.41V6.83H16V1C16 0.45 15.55 0 15 0Z"
  },
  copy: { viewBox: { w: 16, h: 16 }, path: "M16 0H3V3H0V16H13V13H16V0ZM11 14H2V5H11V14ZM14 11H13V3H5V2H14V11Z" },
  download: {
    viewBox: { w: 16, h: 16 },
    path: "M12.71 6.71L8.71 10.71C8.51 10.91 8.26 11 8 11C7.74 11 7.49 10.9 7.29 10.71L3.29 6.71L4.7 5.3L6.99 7.59V0H8.99V7.59L11.28 5.3L12.69 6.71H12.71ZM16 0H12V2H14V14H2V2H4V0H0V16H16V0Z"
  },
  "zoom-in": {
    viewBox: { w: 16, h: 16 },
    path: "M15.855 14.435L12.745 11.325C13.625 10.155 14.145 8.71502 14.145 7.14502C14.145 3.28502 11.005 0.14502 7.14502 0.14502C3.28502 0.14502 0.14502 3.28502 0.14502 7.14502C0.14502 11.005 3.28502 14.145 7.14502 14.145C8.71502 14.145 10.165 13.615 11.325 12.745L14.435 15.855L15.845 14.445L15.855 14.435ZM2.14502 7.14502C2.14502 4.38502 4.38502 2.14502 7.14502 2.14502C9.90502 2.14502 12.145 4.38502 12.145 7.14502C12.145 9.90502 9.90502 12.145 7.14502 12.145C4.38502 12.145 2.14502 9.90502 2.14502 7.14502ZM8.14502 6.14502H10.145V8.14502H8.14502V10.145H6.14502V8.14502H4.14502V6.14502H6.14502V4.14502H8.14502V6.14502Z"
  },
  "zoom-out": {
    viewBox: { w: 16, h: 16 },
    path: "M15.855 14.435L12.745 11.325C13.625 10.155 14.145 8.71502 14.145 7.14502C14.145 3.28502 11.005 0.14502 7.14502 0.14502C3.28502 0.14502 0.14502 3.28502 0.14502 7.14502C0.14502 11.005 3.28502 14.145 7.14502 14.145C8.71502 14.145 10.165 13.615 11.325 12.745L14.435 15.855L15.845 14.445L15.855 14.435ZM2.14502 7.14502C2.14502 4.38502 4.38502 2.14502 7.14502 2.14502C9.90502 2.14502 12.145 4.38502 12.145 7.14502C12.145 9.90502 9.90502 12.145 7.14502 12.145C4.38502 12.145 2.14502 9.90502 2.14502 7.14502ZM4.14502 6.14502H10.145V8.14502H4.14502V6.14502Z"
  },
  search: {
    viewBox: { w: 16, h: 16 },
    path: "M15.855 14.435L12.745 11.325C13.625 10.155 14.145 8.71502 14.145 7.14502C14.145 3.28502 11.005 0.14502 7.14502 0.14502C3.28502 0.14502 0.14502 3.28502 0.14502 7.14502C0.14502 11.005 3.28502 14.145 7.14502 14.145C8.71502 14.145 10.165 13.615 11.325 12.745L14.435 15.855L15.845 14.445L15.855 14.435ZM2.14502 7.14502C2.14502 4.38502 4.38502 2.14502 7.14502 2.14502C9.90502 2.14502 12.145 4.38502 12.145 7.14502C12.145 9.90502 9.90502 12.145 7.14502 12.145C4.38502 12.145 2.14502 9.90502 2.14502 7.14502Z"
  },
  sync: {
    viewBox: { w: 16, h: 16 },
    path: "M10 4H12.46C11.33 2.74 9.74 2 8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8H16C16 12.41 12.41 16 8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0C10.35 0 12.5 1.01 14 2.73V0H16V5C16 5.55 15.55 6 15 6H10V4Z"
  },
  filter: { viewBox: { w: 16, h: 12 }, path: "M16 2H0V0H16V2ZM13 5H3V7H13V5ZM11 10H5V12H11V10Z" },
  globe: {
    viewBox: { w: 16, h: 16 },
    path: "M8 0C3.59 0 0 3.59 0 8C0 12.41 3.59 16 8 16C12.41 16 16 12.41 16 8C16 3.59 12.41 0 8 0ZM13.19 5H11.73C11.59 4.25 11.39 3.54 11.14 2.9C11.98 3.42 12.69 4.14 13.19 5ZM14 8C14 8.34 13.96 8.67 13.91 9H11.97C11.99 8.67 12 8.33 12 8C12 7.67 11.99 7.33 11.97 7H13.91C13.97 7.33 14 7.66 14 8ZM8 14C7.51 14 6.75 12.9 6.33 11H9.68C9.25 12.9 8.49 14 8.01 14H8ZM6.04 9C6.02 8.68 6 8.35 6 8C6 7.65 6.02 7.32 6.04 7H9.95C9.97 7.32 9.99 7.65 9.99 8C9.99 8.35 9.97 8.68 9.95 9H6.04ZM2 8C2 7.66 2.04 7.33 2.09 7H4.03C4.01 7.33 4 7.67 4 8C4 8.33 4.01 8.67 4.03 9H2.09C2.03 8.67 2 8.34 2 8ZM8 2C8.49 2 9.25 3.1 9.67 5H6.32C6.75 3.1 7.51 2 7.99 2H8ZM4.86 2.9C4.61 3.54 4.41 4.25 4.27 5H2.81C3.31 4.14 4.01 3.42 4.86 2.9ZM2.81 11H4.27C4.41 11.75 4.61 12.46 4.86 13.1C4.02 12.58 3.31 11.86 2.81 11ZM11.14 13.1C11.39 12.46 11.59 11.75 11.73 11H13.19C12.69 11.86 11.99 12.58 11.14 13.1Z"
  },
  checkmark: {
    viewBox: { w: 16, h: 16 },
    path: "M7.37999 15.23C7.14999 15.23 6.91999 15.15 6.73999 15L0.73999 10L2.01999 8.46001L7.07999 12.68L13.5 0.76001L15.26 1.71001L8.25999 14.71C8.11999 14.97 7.85999 15.16 7.56999 15.22C7.50999 15.23 7.43999 15.24 7.37999 15.24V15.23Z"
  },
  settings: {
    viewBox: { w: 16, h: 16 },
    path: "M4 7.18V0H2V7.18C0.84 7.59 0 8.69 0 10C0 11.31 0.84 12.4 2 12.82V16H4V12.82C5.16 12.41 6 11.31 6 10C6 8.69 5.16 7.6 4 7.18ZM3 11C2.45 11 2 10.55 2 10C2 9.45 2.45 9 3 9C3.55 9 4 9.45 4 10C4 10.55 3.55 11 3 11ZM11 5C11 3.7 10.16 2.6 9 2.18V0H7V2.18C5.84 2.59 5 3.69 5 5C5 6.31 5.84 7.4 7 7.82V16H9V7.82C10.16 7.41 11 6.31 11 5ZM8 4C8.55 4 9 4.45 9 5C9 5.55 8.55 6 8 6C7.45 6 7 5.55 7 5C7 4.45 7.45 4 8 4ZM16 11C16 9.7 15.16 8.6 14 8.18V0H12V8.18C10.84 8.59 10 9.69 10 11C10 12.31 10.84 13.4 12 13.82V16H14V13.82C15.16 13.41 16 12.31 16 11ZM13 12C12.45 12 12 11.55 12 11C12 10.45 12.45 10 13 10C13.55 10 14 10.45 14 11C14 11.55 13.55 12 13 12Z"
  },
  "caret-right": {
    viewBox: { w: 10, h: 16 },
    path: "M2.05868 15.705L0.648682 14.295L6.93868 8.00501L0.648682 1.70501L2.05868 0.295013L9.05868 7.29501C9.44868 7.68501 9.44868 8.31501 9.05868 8.70501L2.05868 15.705Z"
  },
  "caret-left": {
    viewBox: { w: 10, h: 16 },
    path: "M7.94118 15.705L0.941182 8.70501C0.551182 8.31501 0.551182 7.68501 0.941182 7.29501L7.94118 0.295013L9.35118 1.70501L3.06118 8.00501L9.35118 14.295L7.94118 15.705Z"
  },
  "caret-up": {
    viewBox: { w: 16, h: 10 },
    path: "M14.2949 9.35625L8.00492 3.05625L1.70492 9.35625L0.294922 7.94625L7.29492 0.936253C7.68492 0.546253 8.31492 0.546253 8.70492 0.936253L15.7049 7.93625L14.2949 9.34625V9.35625Z"
  },
  "caret-down": {
    viewBox: { w: 16, h: 10 },
    path: "M8.00492 9.355C7.74492 9.355 7.49492 9.255 7.29492 9.065L0.294922 2.055L1.70492 0.645004L7.99492 6.935L14.2949 0.645004L15.7049 2.055L8.70492 9.055C8.50492 9.255 8.25492 9.345 7.99492 9.345L8.00492 9.355Z"
  },
  "arrow-up": {
    viewBox: { w: 16, h: 16 },
    path: "M8.74173 0.83L13.7417 6.33L12.2617 7.68L9.00173 4.09L9.00172 15L7.00172 15L7.00172 4.09L3.74173 7.68L2.26172 6.33L7.26172 0.83C7.45172 0.620001 7.72173 0.5 8.00173 0.5C8.28172 0.5 8.55173 0.620001 8.74173 0.83Z"
  },
  "arrow-right": {
    viewBox: { w: 16, h: 16 },
    path: "M1 7.00001H11.91L8.32 3.74001L9.67 2.26001L15.17 7.26001C15.38 7.45001 15.5 7.72001 15.5 8.00001C15.5 8.28001 15.38 8.55001 15.17 8.74001L9.67 13.74L8.32 12.26L11.91 9.00001H1V7.00001Z"
  },
  "arrow-left": {
    viewBox: { w: 16, h: 16 },
    path: "M0.83 7.26001L6.33 2.26001L7.68 3.74002L4.09 7.00002H15V9.00002H4.09L7.68 12.26L6.33 13.74L0.83 8.74002C0.62 8.55002 0.5 8.28002 0.5 8.00002C0.5 7.72002 0.62 7.45001 0.83 7.26001Z"
  },
  "arrow-down": {
    viewBox: { w: 16, h: 16 },
    path: "M7.26172 15.17L2.26172 9.67L3.74173 8.32L7.00172 11.91L7.00172 1L9.00173 1L9.00172 11.91L12.2617 8.32L13.7417 9.67L8.74173 15.17C8.55173 15.38 8.28172 15.5 8.00172 15.5C7.72172 15.5 7.45172 15.38 7.26172 15.17Z"
  },
  "sort-ascending": {
    viewBox: { w: 16, h: 16 },
    path: "M3.00029 10V4.41L1.71029 5.7L0.300293 4.29L3.30029 1.29C3.69029 0.899998 4.32029 0.899998 4.71029 1.29L7.71029 4.29L6.30029 5.7L5.01029 4.41V10H3.01029H3.00029ZM15.0003 12H3.00029V14H15.0003V12ZM15.0003 7H7.00029V9H15.0003V7ZM15.0003 2H10.0003V4H15.0003V2Z"
  },
  "sort-descending": {
    viewBox: { w: 16, h: 16 },
    path: "M0.29002 11.71L1.70002 10.3L2.99002 11.59V6.00002H4.99002V11.59L6.28002 10.3L7.69002 11.71L4.69002 14.71C4.49002 14.91 4.24002 15 3.98002 15C3.72002 15 3.47002 14.9 3.27002 14.71L0.27002 11.71H0.29002ZM15 1.96002H3.00002V3.96002H15V1.96002ZM15 7.00002H7.00002V9.00002H15V7.00002ZM15 14V12H10V14H15Z"
  },
  close: {
    viewBox: { w: 16, h: 16 },
    path: "M9.41492 8.005L15.7049 14.295L14.2949 15.705L8.00492 9.415L1.70492 15.705L0.294922 14.295L6.58492 8.005L0.294922 1.705L1.70492 0.294998L7.99492 6.585L14.2949 0.294998L15.7049 1.705L9.41492 7.995V8.005Z"
  },
  alert: {
    viewBox: { w: 16, h: 16 },
    path: "M7 5h2v4H7V5Zm0 7h2v-2H7v2Zm8.23-.62c.39.78.35 1.69-.11 2.43-.46.74-1.25 1.19-2.13 1.19H3c-.87 0-1.67-.44-2.13-1.19-.46-.75-.5-1.65-.11-2.43l5-10C6.19.53 7.04 0 8 0c.96 0 1.81.53 2.24 1.38l5 10h-.01Zm-1.79.9-5-10A.485.485 0 0 0 7.99 2c-.1 0-.32.03-.45.28l-5 10c-.11.23-.02.42.02.49s.17.24.43.24h9.99c.25 0 .38-.17.43-.24.04-.07.13-.26.02-.49h.01Z"
  },
  verify: {
    viewBox: { w: 16, h: 16 },
    path: "M8 0C3.59 0 0 3.59 0 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8Zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6Zm4.27-7.87-4.5 5.5c-.18.22-.44.35-.72.37H7c-.26 0-.52-.1-.71-.29l-2.5-2.5L5.2 7.8l1.72 1.72 3.8-4.65 1.55 1.27v-.01Z"
  },
  cancel: {
    viewBox: { w: 16, h: 16 },
    path: "M8 0C3.59 0 0 3.59 0 8C0 12.41 3.59 16 8 16C12.41 16 16 12.41 16 8C16 3.59 12.41 0 8 0ZM8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C11.31 2 14 4.69 14 8C14 11.31 11.31 14 8 14ZM11.71 5.71L9.42 8L11.71 10.29L10.3 11.7L8.01 9.41L5.72 11.7L4.31 10.29L6.6 8L4.31 5.71L5.72 4.3L8.01 6.59L10.3 4.3L11.71 5.71Z"
  },
  pending: {
    viewBox: { w: 16, h: 16 },
    path: "M8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0C12.41 0 16 3.59 16 8C16 12.41 12.41 16 8 16ZM8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2ZM6 7H4V9H6V7ZM9 7H7V9H9V7ZM12 7H10V9H12V7Z"
  },
  share: {
    viewBox: { w: 16, h: 16 },
    path: "M12.5 10C11.71 10 11 10.31 10.46 10.81L6.46 8.41C6.48 8.27 6.5 8.14 6.5 8C6.5 7.86 6.48 7.73 6.46 7.59L10.46 5.19C11 5.69 11.71 6 12.5 6C14.15 6 15.5 4.65 15.5 3C15.5 1.35 14.15 0 12.5 0C10.85 0 9.5 1.35 9.5 3C9.5 3.14 9.52 3.27 9.54 3.41L5.54 5.81C5 5.31 4.29 5 3.5 5C1.85 5 0.5 6.35 0.5 8C0.5 9.65 1.85 11 3.5 11C4.29 11 5 10.69 5.54 10.19L9.54 12.59C9.52 12.73 9.5 12.86 9.5 13C9.5 14.65 10.85 16 12.5 16C14.15 16 15.5 14.65 15.5 13C15.5 11.35 14.15 10 12.5 10ZM12.5 2C13.05 2 13.5 2.45 13.5 3C13.5 3.55 13.05 4 12.5 4C11.95 4 11.5 3.55 11.5 3C11.5 2.45 11.95 2 12.5 2ZM3.5 9C2.95 9 2.5 8.55 2.5 8C2.5 7.45 2.95 7 3.5 7C4.05 7 4.5 7.45 4.5 8C4.5 8.55 4.05 9 3.5 9ZM12.5 14C11.95 14 11.5 13.55 11.5 13C11.5 12.45 11.95 12 12.5 12C13.05 12 13.5 12.45 13.5 13C13.5 13.55 13.05 14 12.5 14Z"
  },
  calendar: {
    viewBox: { w: 16, h: 16 },
    path: "M15 2H13V0H11V2H5V0H3V2H1C0.45 2 0 2.45 0 3V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V3C16 2.45 15.55 2 15 2ZM3.15 4H14V5H2V4H3.15ZM2 14V7H14V14H2ZM3 8H5V10H3V8ZM7 8H9V10H7V8ZM11 8H13V10H11V8ZM3 11H5V13H3V11ZM7 11H9V13H7V11ZM11 11H13V13H11V11Z"
  },
  "calendar-empty": {
    viewBox: { w: 16, h: 16 },
    path: "M15 2H13V0H11V2H5V0H3V2H1C0.45 2 0 2.45 0 3V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V3C16 2.45 15.55 2 15 2ZM14 4V6H2V4H14ZM2 14V8H14V14H2Z"
  },
  menu: { viewBox: { w: 14, h: 12 }, path: "M14 2H0V0H14V2ZM14 5H0V7H14V5ZM14 10H0V12H14V10Z" },
  expand: {
    viewBox: { w: 16, h: 16 },
    path: "M14 6V3.41L9.41 8L14 12.59V10H16V15C16 15.55 15.55 16 15 16H10V14H12.59L8 9.41L3.41 14H6V16H1C0.45 16 0 15.55 0 15V10H2V12.59L6.59 8L2 3.41V6H0V1C0 0.45 0.45 0 1 0H6V2H3.41L8 6.59L12.59 2H10V0H15C15.55 0 16 0.45 16 1V6H14Z"
  },
  shrink: {
    viewBox: { w: 16, h: 16 },
    path: "M9.00492 6.00501V2.00501H11.0049V3.59501L14.2949 0.305013L15.7049 1.71501L12.4149 5.00501H14.0049V7.00501H10.0049C9.45492 7.00501 9.00492 6.55501 9.00492 6.00501ZM6.00492 9.00501H2.00492V11.005H3.59492L0.304922 14.295L1.71492 15.705L5.00492 12.415V14.005H7.00492V10.005C7.00492 9.45501 6.55492 9.00501 6.00492 9.00501ZM5.00492 3.59501L1.70492 0.295013L0.294922 1.70501L3.58492 4.99501H1.99492V6.99501H5.99492C6.54492 6.99501 6.99492 6.54501 6.99492 5.99501V2.00501H4.99492V3.59501H5.00492ZM14.0049 11.005V9.00501H10.0049C9.45492 9.00501 9.00492 9.45501 9.00492 10.005V14.005H11.0049V12.415L14.2949 15.705L15.7049 14.295L12.4149 11.005H14.0049Z"
  },
  compress: {
    viewBox: { w: 14, h: 14 },
    path: "M5 6H0V4H4V0H6V5C6 5.55 5.55 6 5 6ZM14 4H10V0H8V5C8 5.55 8.45 6 9 6H14V4ZM10 10H14V8H9C8.45 8 8 8.45 8 9V14H10V10ZM6 9C6 8.45 5.55 8 5 8H0V10H4V14H6V9Z"
  },
  fullscreen: {
    viewBox: { w: 48, h: 48 },
    path: "M7.33 2H21V6H7.33C6.59 6 6 6.6 6 7.33V21H2V7.33C2 4.39 4.39 2 7.33 2ZM46 7.33C46 4.39 43.61 2 40.67 2H27V6H40.67C41.41 6 42 6.6 42 7.33V21H46V7.33ZM46 27H42V40.67C42 41.41 41.4 42 40.67 42H27V46H40.67C43.61 46 46 43.61 46 40.67V27ZM2 40.67C2 43.61 4.39 46 7.33 46H21V42H7.33C6.59 42 6 41.4 6 40.67V27H2V40.67Z"
  },
  "exit-fullscreen": {
    viewBox: { w: 48, h: 48 },
    path: "M21 19C21 20.1 20.1 21 19 21H3V17H17V3H21V19ZM45 17H31V3H27V19C27 20.1 27.9 21 29 21H45V17ZM27 29V45H31V31H45V27H29C27.9 27 27 27.9 27 29ZM21 45V29C21 27.9 20.1 27 19 27H3V31H17V45H21Z"
  },
  volume: {
    viewBox: { w: 18, h: 14 },
    path: "M9.98999 14.0002C9.76999 14.0002 9.54999 13.9302 9.36999 13.7802L4.63999 10.0002H1.98999C1.43999 10.0002 0.98999 9.55017 0.98999 9.00017V5.00017C0.98999 4.45017 1.43999 4.00017 1.98999 4.00017H4.63999L9.36999 0.220173C9.66999 -0.0198274 10.08 -0.0698274 10.43 0.100173C10.78 0.270173 11 0.620173 11 1.00017V13.0002C11 13.3802 10.78 13.7302 10.43 13.9002C10.29 13.9702 10.14 14.0002 9.99999 14.0002H9.98999ZM2.98999 8.00017H4.98999C5.21999 8.00017 5.43999 8.08017 5.60999 8.22017L8.98999 10.9202V3.08017L5.60999 5.78017C5.42999 5.92017 5.20999 6.00017 4.98999 6.00017H2.98999V8.00017ZM13.99 4.00017H11.99V10.0002H13.99V4.00017ZM17.01 2.00017H15.01V12.0002H17.01V2.00017Z"
  },
  "awstv-volume": {
    viewBox: { w: 32, h: 32 },
    path: "M15.56 30.4995C14.65 30.4995 13.76 30.1295 13.09 29.4495L7.85 24.0095H1.5C0.67 24.0095 0 23.3395 0 22.5095V9.50953C0 8.67953 0.67 8.00953 1.5 8.00953H7.86L13.1 2.56953C14.08 1.55953 15.55 1.23953 16.85 1.76953C18.16 2.29953 19 3.53953 19 4.94953V27.0795C19 28.4895 18.16 29.7395 16.85 30.2595C16.43 30.4295 15.99 30.5095 15.56 30.5095V30.4995ZM3 20.9995H8.5C8.91 20.9995 9.3 21.1695 9.58 21.4595L15.26 27.3595C15.43 27.5295 15.61 27.5095 15.73 27.4595C15.85 27.4095 16 27.2995 16 27.0595V4.93953C16 4.69953 15.85 4.58953 15.73 4.53953C15.61 4.48953 15.43 4.46953 15.26 4.63953L9.58 10.5395C9.3 10.8295 8.91 10.9995 8.5 10.9995H3V20.9995ZM22 9.39953V12.4395C23.14 12.6995 24 13.7295 24 14.9495C24 16.1695 23.14 17.1895 22 17.4595V20.4995C24.81 20.2095 27 17.8295 27 14.9495C27 12.0695 24.81 9.68953 22 9.39953ZM22 4.56953V7.57953C25.94 8.01953 29 11.1495 29 14.9495C29 18.7495 25.94 21.8795 22 22.3195V25.3295C27.59 24.8695 32 20.3895 32 14.9495C32 9.50953 27.59 5.02953 22 4.56953Z"
  },
  "awstv-volume-mid": {
    viewBox: { w: 32, h: 32 },
    path: "M15.56 30.4995C14.65 30.4995 13.76 30.1295 13.09 29.4495L7.85 24.0095H1.5C0.67 24.0095 0 23.3395 0 22.5095V9.50953C0 8.67953 0.67 8.00953 1.5 8.00953H7.86L13.1 2.56953C14.08 1.55953 15.55 1.23953 16.85 1.76953C18.16 2.29953 19 3.53953 19 4.94953V27.0795C19 28.4895 18.16 29.7395 16.85 30.2595C16.43 30.4295 15.99 30.5095 15.56 30.5095V30.4995ZM3 20.9995H8.5C8.91 20.9995 9.3 21.1695 9.58 21.4595L15.26 27.3595C15.43 27.5295 15.61 27.5095 15.73 27.4595C15.85 27.4095 16 27.2995 16 27.0595V4.93953C16 4.69953 15.85 4.58953 15.73 4.53953C15.61 4.48953 15.43 4.46953 15.26 4.63953L9.58 10.5395C9.3 10.8295 8.91 10.9995 8.5 10.9995H3V20.9995ZM27.58 16.0795C27.58 12.9995 25.08 10.4995 22 10.4995V13.4995C23.42 13.4995 24.58 14.6595 24.58 16.0795C24.58 17.4995 23.42 18.6595 22 18.6595V21.6595C25.08 21.6595 27.58 19.1595 27.58 16.0795Z"
  },
  "awstv-volume-mute": {
    viewBox: { w: 32, h: 32 },
    path: "M16.85 1.75044C15.55 1.23044 14.07 1.54044 13.1 2.55044L7.86 7.99044H1.5C0.67 7.99044 0 8.66044 0 9.49044V22.4904C0 23.3204 0.67 23.9904 1.5 23.9904H7.86L13.1 29.4304C13.76 30.1204 14.65 30.4804 15.57 30.4804C16 30.4804 16.44 30.4004 16.86 30.2304C18.16 29.7004 19.01 28.4604 19.01 27.0504V4.94044C19.01 3.53044 18.17 2.28044 16.86 1.76044L16.85 1.75044ZM16 27.0704C16 27.3104 15.85 27.4204 15.73 27.4704C15.61 27.5204 15.43 27.5404 15.26 27.3704L9.58 21.4704C9.3 21.1804 8.91 21.0104 8.5 21.0104H3V11.0104H8.5C8.91 11.0104 9.3 10.8404 9.58 10.5504L15.26 4.65044C15.43 4.48044 15.61 4.50044 15.73 4.55044C15.85 4.60044 16 4.71044 16 4.95044V27.0804V27.0704ZM28.05 16.0004L31.99 19.9404L29.87 22.0604L25.93 18.1204L21.99 22.0604L19.87 19.9404L23.81 16.0004L19.87 12.0604L21.99 9.94044L25.93 13.8804L29.87 9.94044L31.99 12.0604L28.05 16.0004Z"
  },
  "jump-link": {
    viewBox: { w: 16, h: 12 },
    path: "M14.7088 7.85502L10.7088 11.855L9.29878 10.445L11.5888 8.15502H0.998779V0.14502H2.99878V6.14502H11.5888L9.29878 3.85502L10.7088 2.44502L14.7088 6.44502C15.0988 6.83502 15.0988 7.46502 14.7088 7.85502Z"
  },
  gear: {
    viewBox: { w: 16, h: 16 },
    path: "M9.63508 15.485H6.37508C5.86508 15.485 5.44508 15.105 5.38508 14.605L5.20508 13.075C5.20508 13.075 5.15508 13.045 5.12508 13.035C5.08508 13.015 5.04507 12.985 5.00507 12.965L3.59508 13.555C3.13508 13.745 2.59508 13.575 2.34508 13.135L0.705075 10.315C0.455075 9.875 0.565075 9.325 0.965075 9.01499L2.16508 8.10499C2.16508 8.10499 2.16508 8.02499 2.16508 7.98499C2.16508 7.94499 2.16508 7.89499 2.16508 7.85499L0.965075 6.94499C0.575075 6.64499 0.455075 6.08499 0.715075 5.65499L2.34508 2.845C2.59508 2.41499 3.13508 2.225 3.59508 2.425L4.99508 3.015C4.99508 3.015 5.06508 2.975 5.10508 2.955C5.13508 2.935 5.16507 2.925 5.19508 2.905L5.38508 1.375C5.44508 0.874995 5.87508 0.494995 6.37508 0.494995H9.63508C10.1451 0.494995 10.5651 0.874995 10.6251 1.375L10.8051 2.915C10.8051 2.915 10.8651 2.945 10.8851 2.965C10.9151 2.985 10.9451 3.005 10.9851 3.025L12.4151 2.435C12.8751 2.245 13.4151 2.42499 13.6651 2.855L15.2951 5.66499C15.5451 6.10499 15.4351 6.65499 15.0351 6.96499L13.8251 7.89499V8.00499C13.8251 8.00499 13.8251 8.08499 13.8251 8.12499L15.0251 9.045C15.4251 9.345 15.5351 9.90499 15.2851 10.335L13.6551 13.155C13.4051 13.595 12.8651 13.775 12.4051 13.575L10.9851 12.975C10.9851 12.975 10.9251 13.015 10.8951 13.035C10.8651 13.055 10.8351 13.065 10.8151 13.085L10.6351 14.625C10.5751 15.125 10.1451 15.505 9.64507 15.505L9.63508 15.485ZM7.26508 13.485H8.74508L8.88508 12.315C8.92508 11.975 9.13507 11.675 9.44508 11.525C9.58508 11.455 9.72508 11.385 9.87508 11.295C10.0251 11.205 10.1651 11.115 10.3051 11.015C10.5851 10.815 10.9551 10.775 11.2751 10.905L12.3751 11.365L13.1251 10.065L12.2051 9.365C11.9451 9.165 11.8051 8.85499 11.8151 8.535L11.8351 7.97499V7.71499C11.8351 7.64499 11.8351 7.585 11.8151 7.515C11.7651 7.165 11.9151 6.805 12.1951 6.595L13.1251 5.88499L12.3751 4.595L11.2651 5.055C10.9451 5.185 10.5851 5.14499 10.3051 4.94499C10.1751 4.85499 10.0351 4.765 9.88508 4.67499C9.73508 4.58499 9.57508 4.505 9.42508 4.425C9.12508 4.275 8.91508 3.985 8.88508 3.645L8.74508 2.475H7.25507L7.11508 3.645C7.07508 3.985 6.86508 4.275 6.56507 4.425C6.42508 4.495 6.27508 4.575 6.10508 4.67499C5.94508 4.765 5.79508 4.86499 5.66508 4.95499C5.38508 5.15499 5.02508 5.19499 4.70508 5.055L3.62508 4.60499L2.87508 5.89499L3.78508 6.58499C4.04508 6.78499 4.19508 7.095 4.17508 7.42499L4.15508 7.765C4.15508 7.845 4.15508 7.92499 4.15508 7.98499C4.15508 8.055 4.15508 8.13499 4.15508 8.22499L4.17508 8.535C4.19508 8.865 4.04508 9.18499 3.78508 9.38499L2.86508 10.075L3.61508 11.365L4.69508 10.905C5.01508 10.765 5.39507 10.815 5.67508 11.025C5.78508 11.105 5.92508 11.195 6.07508 11.275C6.25507 11.375 6.41507 11.455 6.54507 11.525C6.85507 11.675 7.05508 11.965 7.09508 12.305L7.23507 13.475L7.26508 13.485ZM8.00507 10.985C6.35507 10.985 5.00507 9.63499 5.00507 7.98499C5.00507 6.33499 6.35507 4.98499 8.00507 4.98499C9.65508 4.98499 11.0051 6.33499 11.0051 7.98499C11.0051 9.63499 9.65508 10.985 8.00507 10.985ZM8.00507 6.98499C7.45507 6.98499 7.00507 7.43499 7.00507 7.98499C7.00507 8.535 7.45507 8.98499 8.00507 8.98499C8.55508 8.98499 9.00508 8.535 9.00508 7.98499C9.00508 7.43499 8.55508 6.98499 8.00507 6.98499Z"
  },
  like: {
    viewBox: { w: 16, h: 16 },
    path: "M8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0C12.41 0 16 3.59 16 8C16 12.41 12.41 16 8 16ZM8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2ZM12.31 9.29L10.39 8.72C10.08 9.77 9.09 10.51 7.99 10.51C6.89 10.51 5.91 9.78 5.59 8.72L3.67 9.29C4.23 11.18 6.01 12.5 7.98 12.5C9.95 12.5 11.73 11.18 12.29 9.29H12.31ZM5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5C5.45 5 5 5.45 5 6ZM9 6C9 6.55 9.45 7 10 7C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6ZM8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0C12.41 0 16 3.59 16 8C16 12.41 12.41 16 8 16ZM8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2ZM12.31 9.29L10.39 8.72C10.08 9.77 9.09 10.51 7.99 10.51C6.89 10.51 5.91 9.78 5.59 8.72L3.67 9.29C4.23 11.18 6.01 12.5 7.98 12.5C9.95 12.5 11.73 11.18 12.29 9.29H12.31ZM5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5C5.45 5 5 5.45 5 6ZM9 6C9 6.55 9.45 7 10 7C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6Z"
  },
  dislike: {
    viewBox: { w: 16, h: 16 },
    path: "M8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0C12.41 0 16 3.59 16 8C16 12.41 12.41 16 8 16ZM8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2ZM12.31 11.21C11.75 9.32 9.97 8 8 8C6.03 8 4.25 9.32 3.69 11.21L5.61 11.78C5.92 10.73 6.91 9.99 8.01 9.99C9.11 9.99 10.09 10.72 10.41 11.78L12.33 11.21H12.31ZM5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5C5.45 5 5 5.45 5 6ZM9 6C9 6.55 9.45 7 10 7C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6ZM8 16C3.59 16 0 12.41 0 8C0 3.59 3.59 0 8 0C12.41 0 16 3.59 16 8C16 12.41 12.41 16 8 16ZM8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2ZM12.31 11.21C11.75 9.32 9.97 8 8 8C6.03 8 4.25 9.32 3.69 11.21L5.61 11.78C5.92 10.73 6.91 9.99 8.01 9.99C9.11 9.99 10.09 10.72 10.41 11.78L12.33 11.21H12.31ZM5 6C5 6.55 5.45 7 6 7C6.55 7 7 6.55 7 6C7 5.45 6.55 5 6 5C5.45 5 5 5.45 5 6ZM9 6C9 6.55 9.45 7 10 7C10.55 7 11 6.55 11 6C11 5.45 10.55 5 10 5C9.45 5 9 5.45 9 6Z"
  },
  success: {
    viewBox: { w: 16, h: 16 },
    path: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z M4.5 8.5L7 11L11.5 5.5",
    type: "stroke"
  },
  info: {
    viewBox: { w: 16, h: 16 },
    paths: [
      {
        path: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z M8 12V7 Z",
        type: "stroke"
      },
      {
        path: "M9 4H7V6H9V4Z",
        type: "fill"
      }
    ]
  },
  thumbsup: {
    viewBox: { w: 24, h: 22 },
    paths: [
      {
        path: "M7.625 20.0032V8.00317",
        type: "stroke"
      },
      {
        path: "M7.625 20.0031H1.625V8.00309H7.625L11.06 2.43809C12.005 1.49309 13.625 2.16809 13.625 3.50309V9.50309H15.125H19.625C20.345 9.50309 21.125 9.50309 21.125 11.0031L18.68 18.3531C18.35 19.3431 17.435 20.0031 16.4 20.0031H7.64H7.625Z",
        type: "stroke"
      }
    ]
  },
  thumbsdown: {
    viewBox: { w: 24, h: 22 },
    paths: [
      {
        path: "M8.375 14.1875L12.875 18.6875C14.375 20.1875 15.875 20.1875 15.875 18.6875V12.6875H20.375C21.095 12.6875 21.875 12.6875 21.875 11.1875L19.43 3.8375C19.1 2.8475 18.185 2.1875 17.15 2.1875H2.375V14.1875H8.375Z",
        type: "stroke"
      },
      {
        path: "M8.28564 2.45752V14.4575",
        type: "stroke"
      }
    ]
  },
  x: {
    viewBox: { w: 16, h: 16 },
    path: "M9.33905 6.77143L15.1809 0H13.7965L8.7241 5.87954L4.67275 0H0L6.12643 8.8909L0 15.9918H1.3844L6.74104 9.78279L11.0196 15.9918H15.6923L9.33871 6.77143H9.33905ZM7.44293 8.96923L6.82219 8.0839L1.88322 1.03921H4.00958L7.99539 6.7245L8.61612 7.60983L13.7972 14.9998H11.6708L7.44293 8.96957V8.96923Z",
    type: "fill"
  },
  facebook: {
    viewBox: { w: 16, h: 16 },
    path: "M15.9824 0.898245V15.0987C15.9824 15.5869 15.5869 15.9789 15.1023 15.9789H11.0328V9.7998H13.1067L13.4167 7.39089H11.0292V5.85147C11.0292 5.15303 11.2216 4.67909 12.223 4.67909H13.4987V2.52319C13.2778 2.49468 12.5223 2.42698 11.6386 2.42698C9.7998 2.42698 8.53833 3.54947 8.53833 5.61272V7.39089H6.45726V9.7998H8.53833V15.9824H0.898245C0.413612 15.9824 0.0180664 15.5869 0.0180664 15.1023V0.898245C0.0180664 0.413612 0.413612 0.0180664 0.898245 0.0180664H15.0987C15.5869 0.0180664 15.9824 0.413612 15.9824 0.898245Z",
    type: "fill"
  },
  linkedin: {
    viewBox: { w: 16, h: 16 },
    path: "M1.183.031C.53.031 0 .543 0 1.173v13.653c0 .63.53 1.141 1.183 1.141h13.635c.653 0 1.182-.51 1.182-1.141V1.173C16 .543 15.47.03 14.818.03zM4.86 6.193v7.174H2.467V6.193zm.158-2.219c0 .689-.52 1.24-1.355 1.24H3.65c-.804 0-1.323-.551-1.323-1.24 0-.704.535-1.24 1.354-1.24s1.323.536 1.339 1.24m3.561 9.393H6.186s.032-6.5 0-7.174H8.58V7.21c.319-.49.888-1.184 2.158-1.184 1.575 0 2.756 1.025 2.756 3.229v4.113H11.1V9.53c0-.965-.346-1.623-1.212-1.623-.662 0-1.056.444-1.229.872-.063.153-.079.368-.079.582z",
    type: "fill"
  },
  instagram: {
    viewBox: { w: 16, h: 16 },
    path: "M4.68673 0.0559501C3.83553 0.0961101 3.25425 0.23195 2.74609 0.43163C2.22017 0.63659 1.77441 0.91163 1.33089 1.35675C0.887373 1.80187 0.614253 2.24795 0.410733 2.77467C0.213773 3.28395 0.080333 3.86571 0.042733 4.71739C0.00513298 5.56907 -0.00318703 5.84283 0.000972972 8.01531C0.00513297 10.1878 0.014733 10.4601 0.056013 11.3135C0.096653 12.1646 0.232013 12.7457 0.431693 13.254C0.636973 13.7799 0.911693 14.2255 1.35697 14.6692C1.80225 15.1129 2.24801 15.3854 2.77601 15.5892C3.28481 15.7859 3.86673 15.9199 4.71825 15.9572C5.56977 15.9945 5.84385 16.0031 8.01569 15.999C10.1875 15.9948 10.461 15.9852 11.3143 15.9447C12.1675 15.9043 12.7456 15.7679 13.2541 15.5692C13.78 15.3635 14.2259 15.0892 14.6693 14.6438C15.1127 14.1983 15.3856 13.7519 15.589 13.2249C15.7861 12.7161 15.92 12.1342 15.957 11.2833C15.9943 10.4294 16.0031 10.1567 15.9989 7.98459C15.9947 5.81243 15.985 5.54011 15.9445 4.68699C15.904 3.83387 15.7685 3.25451 15.569 2.74587C15.3634 2.21995 15.089 1.77467 14.6439 1.33067C14.1987 0.88667 13.752 0.61387 13.2251 0.41099C12.716 0.21403 12.1344 0.0797901 11.2829 0.0429901C10.4314 0.00619009 10.1573 -0.00324991 7.98465 0.000910089C5.81201 0.00507009 5.54001 0.0143501 4.68673 0.0559501ZM4.78017 14.518C4.00017 14.4841 3.57665 14.3545 3.29441 14.246C2.92065 14.102 2.65441 13.9279 2.37313 13.6494C2.09185 13.3708 1.91905 13.1036 1.77313 12.7307C1.66353 12.4484 1.53153 12.0254 1.49505 11.2454C1.45537 10.4023 1.44705 10.1492 1.44241 8.01339C1.43777 5.87755 1.44593 5.62475 1.48289 4.78139C1.51617 4.00203 1.64657 3.57803 1.75489 3.29595C1.89889 2.92171 2.07233 2.65595 2.35153 2.37483C2.63073 2.09371 2.89713 1.92059 3.27041 1.77467C3.55233 1.66459 3.97537 1.53371 4.75505 1.49659C5.59873 1.45659 5.85153 1.44859 7.98705 1.44395C10.1226 1.43931 10.376 1.44731 11.22 1.48443C11.9994 1.51835 12.4235 1.64747 12.7053 1.75643C13.0792 1.90043 13.3453 2.07339 13.6264 2.35307C13.9075 2.63275 14.0808 2.89819 14.2267 3.27227C14.337 3.55339 14.4679 3.97627 14.5047 4.75643C14.5448 5.60011 14.5539 5.85307 14.5578 7.98843C14.5616 10.1238 14.5541 10.3774 14.5171 11.2204C14.4831 12.0004 14.3538 12.4241 14.2451 12.7067C14.1011 13.0803 13.9275 13.3467 13.6482 13.6276C13.3688 13.9086 13.1027 14.0817 12.7293 14.2276C12.4477 14.3375 12.0242 14.4687 11.2451 14.5059C10.4015 14.5455 10.1487 14.5539 8.01233 14.5585C5.87601 14.5631 5.62401 14.5545 4.78033 14.518M11.3019 3.72427C11.3022 3.91415 11.3589 4.09968 11.4646 4.25738C11.5704 4.41508 11.7206 4.53788 11.8961 4.61023C12.0717 4.68259 12.2647 4.70126 12.4509 4.66388C12.6371 4.62651 12.808 4.53476 12.942 4.40024C13.076 4.26573 13.1671 4.09449 13.2038 3.90819C13.2405 3.72188 13.2212 3.52888 13.1482 3.35359C13.0751 3.1783 12.9518 3.0286 12.7937 2.92341C12.6356 2.81823 12.4499 2.76229 12.26 2.76267C12.0055 2.76318 11.7615 2.86477 11.5819 3.04509C11.4022 3.22542 11.3015 3.46972 11.3019 3.72427ZM3.89233 8.00795C3.89681 10.2767 5.73937 12.1118 8.00769 12.1075C10.276 12.1031 12.1123 10.2607 12.108 7.99195C12.1037 5.72315 10.2607 3.88763 7.99201 3.89211C5.72337 3.89659 3.88801 5.73947 3.89233 8.00795ZM5.33329 8.00507C5.33225 7.47764 5.48763 6.96175 5.77979 6.52263C6.07194 6.08352 6.48775 5.74089 6.97462 5.53809C7.4615 5.33529 7.99759 5.28142 8.51508 5.38329C9.03258 5.48516 9.50824 5.7382 9.88193 6.11041C10.2556 6.48262 10.5105 6.95728 10.6145 7.47436C10.7184 7.99145 10.6666 8.52774 10.4658 9.01542C10.2649 9.5031 9.92391 9.92026 9.48595 10.2142C9.04799 10.508 8.53272 10.6655 8.00529 10.6665C7.65508 10.6672 7.30816 10.599 6.98433 10.4656C6.66051 10.3323 6.36612 10.1364 6.118 9.88927C5.86987 9.64213 5.67286 9.34852 5.53822 9.02523C5.40358 8.70193 5.33394 8.35528 5.33329 8.00507Z",
    type: "fill"
  },
  twitch: {
    viewBox: { w: 16, h: 16 },
    path: "M7.65385 4.17308V8.34615H6.25962V4.17308H7.65385ZM11.4808 4.17308V8.34615H10.0865V4.17308H11.4808ZM11.4808 11.4808L13.9135 9.03846V1.39423H2.43269V11.4808H5.56731V13.5673L7.65385 11.4808H11.4808ZM15.3077 0V9.74038L11.1346 13.9135H8L5.91346 16H3.82692V13.9135H0V2.77885L1.04808 0H15.3077Z",
    type: "fill"
  },
  youtube: {
    viewBox: { w: 20, h: 16 },
    path: "M19.5 2.46154C20 4.18462 20 7.87692 20 7.87692C20 7.87692 20 11.5692 19.5 13.2923C19.25 14.2769 18.5 15.0154 17.625 15.2615C15.875 15.7538 10 15.7538 10 15.7538C10 15.7538 4.125 15.7538 2.5 15.2615C1.5 15.0154 0.75 14.2769 0.5 13.2923C0 11.5692 0 7.87692 0 7.87692C0 7.87692 0 4.18462 0.5 2.46154C0.75 1.47692 1.5 0.738461 2.375 0.492308C4.125 0 10 0 10 0C10 0 15.875 0 17.5 0.492308C18.5 0.738461 19.25 1.47692 19.5 2.46154ZM8 11.3231L14 7.87692L8 4.43077V11.3231Z",
    type: "fill"
  },
  podcasts: {
    viewBox: { w: 16, h: 16 },
    path: "M9.87687 10.6414C9.87687 11.1534 9.82626 11.7399 9.72504 12.4008C9.54047 13.6809 9.37673 14.6127 9.23384 15.1962C9.10285 15.7321 8.65034 16 7.87632 16C7.10229 16 6.64979 15.7321 6.5188 15.1962C6.3759 14.6127 6.21217 13.6809 6.02759 12.4008C5.92637 11.7458 5.87576 11.1594 5.87576 10.6414C5.87576 9.6411 6.54261 9.14096 7.87632 9.14096C9.21002 9.14096 9.87687 9.6411 9.87687 10.6414ZM14.7175 6.85461C14.7175 8.28358 14.3186 9.5756 13.5207 10.7307C12.7229 11.8858 11.6809 12.7193 10.3949 13.2314C10.3472 13.2492 10.3026 13.2403 10.2609 13.2046C10.2192 13.1689 10.2014 13.1242 10.2073 13.0706C10.249 12.7848 10.2788 12.5883 10.2966 12.4812C10.3204 12.2906 10.3383 12.1507 10.3502 12.0614C10.3562 12.0078 10.383 11.9721 10.4306 11.9542C11.3773 11.472 12.1379 10.7753 12.7125 9.86437C13.287 8.95341 13.5743 7.95015 13.5743 6.85461C13.5743 5.78289 13.3034 4.79898 12.7616 3.9029C12.2198 3.00682 11.4845 2.30871 10.5556 1.80857C9.6268 1.30843 8.62355 1.08813 7.54587 1.14767C6.80757 1.18935 6.10202 1.37095 5.42921 1.69247C4.75641 2.01398 4.18035 2.43225 3.70105 2.94728C3.22175 3.4623 2.8407 4.06366 2.55788 4.75135C2.27506 5.43904 2.13663 6.15501 2.14259 6.89927C2.14854 7.99481 2.44327 8.99657 3.02676 9.90456C3.61026 10.8126 4.37535 11.5017 5.32204 11.9721C5.36372 11.99 5.39051 12.0257 5.40242 12.0793C5.42028 12.2043 5.43814 12.3383 5.456 12.4812C5.46196 12.5348 5.47684 12.6315 5.50066 12.7714C5.52448 12.9113 5.54234 13.017 5.55425 13.0885C5.5602 13.1421 5.54085 13.1867 5.49619 13.2224C5.45154 13.2582 5.4054 13.2641 5.35776 13.2403C4.47657 12.895 3.69957 12.3904 3.02676 11.7265C2.35396 11.0626 1.83744 10.2767 1.47722 9.3687C1.11701 8.46071 0.960712 7.50955 1.00834 6.51523C1.05002 5.6638 1.24651 4.84959 1.59779 4.07259C1.94908 3.29559 2.40903 2.61981 2.97764 2.04524C3.54625 1.47068 4.21608 1.0018 4.98712 0.638603C5.75817 0.275408 6.56941 0.0670166 7.42083 0.0134306C8.3973 -0.0461102 9.33654 0.0923214 10.2386 0.428724C11.1406 0.765126 11.9176 1.24294 12.5696 1.86216C13.2215 2.48138 13.7425 3.22712 14.1325 4.09938C14.5225 4.97165 14.7175 5.89006 14.7175 6.85461ZM9.29189 5.15325C9.29189 5.15325 9.38939 5.25074 9.58438 5.44574C9.77937 5.64073 9.87687 6.01509 9.87687 6.56882C9.87687 7.12254 9.68188 7.5944 9.29189 7.98439C8.9019 8.37438 8.43004 8.56937 7.87632 8.56937C7.32259 8.56937 6.85074 8.37438 6.46075 7.98439C6.07076 7.5944 5.87576 7.12254 5.87576 6.56882C5.87576 6.01509 6.07076 5.54324 6.46075 5.15325C6.85074 4.76326 7.32259 4.56826 7.87632 4.56826C8.43004 4.56826 8.9019 4.76326 9.29189 5.15325ZM12.449 6.85461C12.449 7.581 12.2897 8.26125 11.9712 8.89535C11.6527 9.52946 11.2165 10.0579 10.6628 10.4806C10.6152 10.5163 10.5675 10.5223 10.5199 10.4985C10.4723 10.4747 10.4425 10.433 10.4306 10.3734C10.3949 10.0638 10.3085 9.78995 10.1716 9.55179C10.1299 9.49225 10.1388 9.43271 10.1984 9.37317C10.5437 9.05165 10.8146 8.67357 11.0111 8.23892C11.2076 7.80428 11.3058 7.34284 11.3058 6.85461C11.3058 6.19371 11.1317 5.5864 10.7834 5.03268C10.4351 4.47895 9.96618 4.0577 9.37673 3.76893C8.78728 3.48016 8.15616 3.3715 7.48335 3.44295C6.69147 3.53226 6.00973 3.86866 5.43814 4.45216C4.86656 5.03565 4.54206 5.72334 4.46466 6.51523C4.40512 7.063 4.47508 7.58696 4.67454 8.08709C4.874 8.58723 5.16723 9.01592 5.55425 9.37317C5.61379 9.43271 5.62272 9.49225 5.58104 9.55179C5.43814 9.7959 5.35181 10.0728 5.32204 10.3824C5.31013 10.436 5.28036 10.4747 5.23273 10.4985C5.1851 10.5223 5.13746 10.5163 5.08983 10.4806C4.5242 10.04 4.08211 9.49522 3.76357 8.84623C3.44503 8.19724 3.29171 7.50062 3.30362 6.75637C3.32148 5.97639 3.5269 5.25 3.91986 4.57719C4.31283 3.90439 4.83976 3.36406 5.50066 2.95621C6.16156 2.54836 6.87902 2.32657 7.65304 2.29085C8.51042 2.24917 9.30826 2.42779 10.0466 2.82671C10.7849 3.22563 11.3698 3.78382 11.8015 4.50128C12.2332 5.21874 12.449 6.00318 12.449 6.85461Z",
    type: "fill"
  },
  email: {
    viewBox: { w: 16, h: 16 },
    path: "M14.8571 13.1432V6.28606C14.6667 6.50035 14.4613 6.69678 14.2411 6.87535C12.6458 8.10154 11.378 9.10749 10.4375 9.89321C10.1339 10.1492 9.88691 10.3486 9.69643 10.4914C9.50595 10.6343 9.24851 10.7786 8.92411 10.9245C8.5997 11.0703 8.29464 11.1432 8.00893 11.1432H8H7.99107C7.70536 11.1432 7.4003 11.0703 7.07589 10.9245C6.75149 10.7786 6.49405 10.6343 6.30357 10.4914C6.1131 10.3486 5.86607 10.1492 5.5625 9.89321C4.62202 9.10749 3.35417 8.10154 1.75893 6.87535C1.53869 6.69678 1.33333 6.50035 1.14286 6.28606V13.1432C1.14286 13.2206 1.17113 13.2876 1.22768 13.3441C1.28423 13.4006 1.35119 13.4289 1.42857 13.4289H14.5714C14.6488 13.4289 14.7158 13.4006 14.7723 13.3441C14.8289 13.2876 14.8571 13.2206 14.8571 13.1432ZM14.8571 3.75928C14.8571 3.74737 14.8571 3.71463 14.8571 3.66106C14.8571 3.60749 14.8571 3.56731 14.8571 3.54053C14.8571 3.51374 14.8557 3.47505 14.8527 3.42446C14.8497 3.37386 14.8408 3.33666 14.8259 3.31285C14.811 3.28904 14.7946 3.26225 14.7768 3.23249C14.7589 3.20273 14.7321 3.18041 14.6964 3.16553C14.6607 3.15065 14.619 3.14321 14.5714 3.14321H1.42857C1.35119 3.14321 1.28423 3.17148 1.22768 3.22803C1.17113 3.28458 1.14286 3.35154 1.14286 3.42892C1.14286 4.42892 1.58036 5.27416 2.45536 5.96463C3.60417 6.8694 4.79762 7.81285 6.03571 8.79499C6.07143 8.82475 6.1756 8.91255 6.34821 9.05838C6.52083 9.20422 6.65774 9.31583 6.75893 9.39321C6.86012 9.47059 6.99256 9.56434 7.15625 9.67446C7.31994 9.78458 7.47024 9.86642 7.60714 9.91999C7.74405 9.97356 7.87202 10.0003 7.99107 10.0003H8H8.00893C8.12798 10.0003 8.25595 9.97356 8.39286 9.91999C8.52976 9.86642 8.68006 9.78458 8.84375 9.67446C9.00744 9.56434 9.13988 9.47059 9.24107 9.39321C9.34226 9.31583 9.47917 9.20422 9.65179 9.05838C9.82441 8.91255 9.92857 8.82475 9.96429 8.79499C11.2024 7.81285 12.3958 6.8694 13.5446 5.96463C13.8661 5.70868 14.1652 5.36493 14.442 4.93338C14.7188 4.50184 14.8571 4.11047 14.8571 3.75928ZM16 3.42892V13.1432C16 13.5361 15.8601 13.8724 15.5804 14.1521C15.3006 14.4319 14.9643 14.5718 14.5714 14.5718H1.42857C1.03571 14.5718 0.699405 14.4319 0.419643 14.1521C0.139881 13.8724 0 13.5361 0 13.1432V3.42892C0 3.03606 0.139881 2.69975 0.419643 2.41999C0.699405 2.14023 1.03571 2.00035 1.42857 2.00035H14.5714C14.9643 2.00035 15.3006 2.14023 15.5804 2.41999C15.8601 2.69975 16 3.03606 16 3.42892Z",
    type: "fill"
  },
  "amazon-q": {
    viewBox: { w: 16, h: 16 },
    path: "M14.164 3.191L9.082.258C8.785.084 8.392 0 8 0c-.393 0-.785.086-1.083.258L1.837 3.19C1.24 3.535.753 4.38.753 5.066v5.868c0 .687.487 1.531 1.082 1.875l5.081 2.934c.298.172.69.257 1.083.257.392 0 .785-.086 1.082-.258l5.082-2.933c.595-.344 1.082-1.188 1.082-1.875V5.066c0-.687-.487-1.531-1.082-1.875ZM8.457 14.66c-.058.034-.22.09-.457.09-.238 0-.4-.056-.458-.09l-5.08-2.934c-.21-.121-.458-.551-.458-.792V5.066c0-.242.247-.671.457-.792L7.542 1.34c.06-.034.22-.09.458-.09.237 0 .4.056.457.09l5.082 2.934c.21.121.457.551.457.792v5.674L9.25 8v-.541a.312.312 0 0 0-.156-.27l-.938-.542a.318.318 0 0 0-.312 0l-.938.542a.313.313 0 0 0-.156.27V8.54c0 .111.06.215.156.27l.938.541a.318.318 0 0 0 .312 0l.469-.27 4.746 2.74-4.914 2.836v.002Z"
  },
  highlight: {
    viewBox: { w: 32, h: 32 },
    path: "M21 5V29H26V32H13V29H18V5H13V2H26V5H21ZM16 21H4V12H16V9H1V24H16V21ZM16 18V15H6V18H16ZM31 15H23V18H31V15Z"
  },
  chat: {
    viewBox: { w: 32, h: 32 },
    path: "M27.5 2H3.5C1.57 2 0 3.57 0 5.5V21.5C0 23.43 1.57 25 3.5 25H10V29.5C10 30.07 10.32 30.59 10.83 30.84C11.04 30.95 11.27 31 11.5 31C11.82 31 12.14 30.9 12.4 30.7L20 25H27.5C29.43 25 31 23.43 31 21.5V5.5C31 3.57 29.43 2 27.5 2ZM28 21.5C28 21.78 27.78 22 27.5 22H19.5C19.18 22 18.86 22.11 18.6 22.3L13 26.5V23.5C13 22.67 12.33 22 11.5 22H3.5C3.22 22 3 21.78 3 21.5V5.5C3 5.22 3.22 5 3.5 5H27.5C27.78 5 28 5.22 28 5.5V21.5Z"
  },
  // Move aws-logo to the global nav pattern once importing svgs is supported
  "aws-logo": {
    viewBox: { w: 109, h: 64 },
    paths: [
      {
        path: "M30.63 23.243c0 1.317.144 2.385.398 3.168.289.783.65 1.637 1.156 2.563.18.284.253.569.253.818 0 .356-.217.712-.687 1.068l-2.277 1.495c-.325.214-.65.32-.94.32-.361 0-.723-.178-1.084-.498a11.036 11.036 0 0 1-1.301-1.673 27.44 27.44 0 0 1-1.12-2.1c-2.82 3.275-6.362 4.912-10.627 4.912-3.037 0-5.458-.854-7.23-2.563-1.77-1.708-2.674-3.986-2.674-6.834 0-3.025 1.084-5.481 3.29-7.332 2.204-1.851 5.132-2.777 8.855-2.777 1.229 0 2.494.107 3.831.285 1.337.178 2.71.463 4.157.783V12.28c0-2.705-.579-4.592-1.7-5.695-1.156-1.104-3.108-1.638-5.89-1.638-1.266 0-2.567.143-3.904.463-1.338.32-2.64.712-3.904 1.21-.578.25-1.012.392-1.265.463-.253.071-.434.107-.579.107-.506 0-.759-.356-.759-1.104V4.342c0-.57.073-.996.253-1.246.181-.249.506-.498 1.012-.747 1.266-.64 2.784-1.175 4.555-1.602 1.77-.462 3.65-.676 5.638-.676 4.302 0 7.446.961 9.47 2.883 1.989 1.922 3 4.84 3 8.756v11.533h.073Zm-14.675 5.41c1.193 0 2.422-.213 3.723-.64 1.301-.428 2.458-1.21 3.434-2.279.578-.676 1.012-1.423 1.229-2.278.216-.854.361-1.886.361-3.096v-1.495a30.626 30.626 0 0 0-3.325-.605 27.649 27.649 0 0 0-3.398-.214c-2.422 0-4.193.463-5.386 1.424-1.192.96-1.77 2.313-1.77 4.093 0 1.673.433 2.919 1.337 3.773.867.89 2.132 1.317 3.795 1.317Zm29.024 3.844c-.65 0-1.084-.106-1.373-.356-.29-.213-.542-.711-.759-1.388L34.353 3.24c-.217-.712-.325-1.175-.325-1.424 0-.57.289-.89.867-.89h3.542c.687 0 1.157.107 1.41.356.29.214.506.712.723 1.388l6.072 23.564 5.639-23.564c.18-.712.398-1.174.687-1.388.289-.213.795-.356 1.445-.356h2.892c.687 0 1.157.107 1.446.356.289.214.542.712.687 1.388l5.71 23.849 6.254-23.849c.217-.712.47-1.174.723-1.388.289-.213.759-.356 1.41-.356h3.36c.58 0 .904.285.904.89 0 .178-.036.356-.072.57a4.998 4.998 0 0 1-.253.89l-8.71 27.514c-.218.712-.47 1.174-.76 1.388-.29.214-.759.356-1.374.356h-3.108c-.687 0-1.157-.107-1.446-.356-.289-.25-.542-.712-.687-1.424L55.787 7.795l-5.566 22.923c-.181.712-.398 1.174-.687 1.423-.29.25-.795.356-1.446.356H44.98Zm46.447.961c-1.88 0-3.759-.213-5.566-.64-1.807-.427-3.217-.89-4.157-1.424-.578-.32-.976-.676-1.12-.997a2.48 2.48 0 0 1-.217-.996v-1.816c0-.747.289-1.103.831-1.103.217 0 .434.035.65.107.218.07.543.213.904.356 1.23.534 2.567.96 3.976 1.245 1.446.285 2.856.427 4.302.427 2.277 0 4.048-.391 5.277-1.174 1.229-.783 1.88-1.922 1.88-3.382 0-.996-.326-1.815-.977-2.491-.65-.676-1.88-1.282-3.65-1.851l-5.241-1.602c-2.639-.818-4.59-2.029-5.784-3.63-1.192-1.566-1.807-3.31-1.807-5.162 0-1.495.325-2.811.976-3.95a9.196 9.196 0 0 1 2.603-2.92c1.084-.818 2.313-1.423 3.759-1.85C89.51.178 91.029 0 92.619 0c.795 0 1.627.035 2.422.142.831.107 1.59.25 2.35.392.722.178 1.409.356 2.06.57.65.213 1.156.426 1.518.64.506.285.867.57 1.084.89.217.284.325.676.325 1.174v1.673c0 .748-.289 1.14-.831 1.14-.289 0-.759-.143-1.374-.428-2.06-.925-4.373-1.388-6.94-1.388-2.06 0-3.686.32-4.807.997-1.12.676-1.699 1.708-1.699 3.168 0 .996.362 1.85 1.085 2.527.723.676 2.06 1.352 3.976 1.957l5.132 1.602c2.603.819 4.482 1.958 5.603 3.417 1.12 1.46 1.662 3.133 1.662 4.983 0 1.53-.325 2.92-.939 4.13-.651 1.21-1.518 2.277-2.639 3.132-1.12.89-2.458 1.53-4.012 1.993-1.627.498-3.325.747-5.169.747Z",
        type: "fill"
      },
      {
        path: "M98.254 50.76C86.363 59.408 69.085 64 54.23 64 33.41 64 14.65 56.42.481 43.82c-1.12-.997-.108-2.35 1.23-1.567 15.325 8.756 34.229 14.06 53.784 14.06 13.193 0 27.687-2.705 41.024-8.258 1.988-.89 3.687 1.282 1.735 2.705Z",
        type: "fill"
      },
      {
        path: "M103.199 45.204c-1.519-1.922-10.049-.925-13.916-.463-1.157.143-1.338-.854-.29-1.601 6.796-4.699 17.965-3.346 19.266-1.78 1.301 1.602-.362 12.6-6.723 17.868-.976.819-1.916.392-1.482-.676 1.446-3.524 4.663-11.461 3.145-13.348Z",
        type: "fill"
      },
      {
        path: "M30.63 23.243c0 1.317.144 2.385.398 3.168.289.783.65 1.637 1.156 2.563.18.284.253.569.253.818 0 .356-.217.712-.687 1.068l-2.277 1.495c-.325.214-.65.32-.94.32-.361 0-.723-.178-1.084-.498a11.03 11.03 0 0 1-1.301-1.673 27.403 27.403 0 0 1-1.12-2.1c-2.82 3.275-6.362 4.912-10.627 4.912-3.037 0-5.458-.854-7.23-2.563-1.77-1.708-2.674-3.986-2.674-6.834 0-3.025 1.084-5.481 3.29-7.332 2.204-1.851 5.132-2.777 8.855-2.777 1.229 0 2.494.107 3.831.285 1.337.178 2.71.463 4.157.783V12.28c0-2.705-.579-4.592-1.7-5.695-1.156-1.104-3.108-1.638-5.89-1.638-1.266 0-2.567.143-3.904.463-1.338.32-2.64.712-3.904 1.21-.578.25-1.012.392-1.265.463-.253.071-.434.107-.579.107-.506 0-.759-.356-.759-1.104V4.342c0-.57.073-.996.253-1.246.181-.249.506-.498 1.012-.747 1.266-.64 2.784-1.175 4.555-1.602 1.77-.462 3.65-.676 5.638-.676 4.302 0 7.446.961 9.47 2.883 1.989 1.922 3 4.84 3 8.756v11.533h.073Zm-14.675 5.41c1.193 0 2.422-.213 3.723-.64 1.301-.428 2.458-1.21 3.434-2.279.578-.676 1.012-1.423 1.229-2.278.216-.854.361-1.886.361-3.096v-1.495a30.602 30.602 0 0 0-3.325-.605 27.649 27.649 0 0 0-3.398-.214c-2.422 0-4.193.463-5.386 1.424-1.192.96-1.77 2.313-1.77 4.093 0 1.673.433 2.919 1.337 3.773.867.89 2.132 1.317 3.795 1.317Zm29.024 3.844c-.65 0-1.084-.106-1.373-.356-.29-.213-.542-.711-.759-1.388L34.353 3.24c-.217-.712-.325-1.175-.325-1.424 0-.57.289-.89.867-.89h3.542c.687 0 1.157.107 1.41.356.29.214.506.712.723 1.388l6.072 23.564 5.639-23.564c.18-.712.398-1.174.687-1.388.289-.213.795-.356 1.445-.356h2.892c.687 0 1.157.107 1.446.356.29.214.542.712.687 1.388l5.71 23.848L71.403 2.67c.217-.712.47-1.174.723-1.388.289-.213.759-.356 1.41-.356h3.36c.58 0 .904.285.904.89 0 .178-.036.356-.072.57a5.008 5.008 0 0 1-.253.89l-8.71 27.514c-.218.712-.47 1.174-.76 1.388-.29.214-.759.356-1.373.356h-3.109c-.687 0-1.157-.107-1.446-.356-.289-.25-.542-.712-.687-1.424L55.787 7.795l-5.566 22.923c-.181.712-.398 1.174-.687 1.423-.29.25-.795.356-1.446.356H44.98Zm46.447.961c-1.88 0-3.759-.213-5.566-.64-1.807-.427-3.217-.89-4.157-1.424-.578-.32-.976-.676-1.12-.997a2.48 2.48 0 0 1-.217-.996v-1.816c0-.747.289-1.103.831-1.103.217 0 .434.035.65.107.218.07.543.213.904.356 1.23.534 2.567.96 3.976 1.245 1.446.285 2.856.427 4.302.427 2.277 0 4.048-.391 5.277-1.174 1.229-.783 1.88-1.922 1.88-3.382 0-.996-.326-1.815-.977-2.491-.65-.676-1.88-1.282-3.65-1.851l-5.241-1.602c-2.639-.818-4.59-2.029-5.784-3.63-1.192-1.566-1.807-3.31-1.807-5.162 0-1.495.325-2.811.976-3.95a9.198 9.198 0 0 1 2.603-2.92c1.084-.818 2.313-1.423 3.759-1.85C89.51.178 91.029 0 92.619 0c.795 0 1.627.035 2.422.142.831.107 1.59.25 2.35.392.722.178 1.409.356 2.06.57.65.213 1.156.426 1.518.64.506.285.867.57 1.084.89.217.284.325.676.325 1.174v1.673c0 .748-.289 1.14-.831 1.14-.289 0-.759-.143-1.374-.428-2.06-.925-4.373-1.388-6.94-1.388-2.06 0-3.686.32-4.807.997-1.12.676-1.699 1.708-1.699 3.168 0 .996.362 1.85 1.085 2.527.723.676 2.06 1.352 3.976 1.957l5.132 1.602c2.603.819 4.482 1.958 5.603 3.417 1.12 1.46 1.663 3.133 1.663 4.983 0 1.53-.326 2.92-.94 4.13-.651 1.21-1.518 2.277-2.639 3.132-1.12.89-2.458 1.53-4.012 1.993-1.626.498-3.325.747-5.169.747Z",
        type: "fill"
      },
      {
        path: "M98.254 50.76C86.363 59.408 69.085 64 54.23 64 33.41 64 14.65 56.42.482 43.82c-1.12-.997-.108-2.35 1.23-1.567 15.325 8.757 34.229 14.06 53.784 14.06 13.193 0 27.687-2.705 41.024-8.258 1.988-.89 3.687 1.282 1.735 2.705Z",
        type: "fill"
      },
      {
        path: "M103.199 45.204c-1.519-1.922-10.049-.925-13.916-.463-1.157.143-1.338-.854-.29-1.601 6.796-4.699 17.965-3.346 19.266-1.78 1.301 1.602-.362 12.6-6.723 17.868-.976.819-1.916.392-1.482-.676 1.446-3.524 4.663-11.461 3.145-13.348Z",
        type: "fill"
      }
    ]
  },
  "chevron-right-inline": {
    viewBox: { w: 16, h: 16 },
    path: "M10 7.99996C10 8.25996 9.90005 8.50996 9.71005 8.70996L6.21005 12.21L4.80005 10.8L7.59005 8.00996L4.80005 5.21996L6.21005 3.80996L9.71005 7.30996C9.91005 7.50996 10 7.75996 10 8.01996V7.99996Z"
  },
  "chevron-left-inline": {
    viewBox: { w: 16, h: 16 },
    path: "M6.0002 7.99996C6.0002 8.25996 6.1002 8.50996 6.2902 8.70996L9.7902 12.21L11.2002 10.8L8.4102 8.00996L11.2002 5.21996L9.7902 3.80996L6.2902 7.30996C6.0902 7.50996 6.0002 7.75996 6.0002 8.01996V7.99996Z"
  },
  "chevron-up-inline": {
    viewBox: { w: 16, h: 16 },
    path: "M7.97994 5.8C8.23994 5.8 8.48994 5.9 8.68994 6.09L12.1899 9.59L10.7799 11L7.98994 8.21L5.19994 11L3.78994 9.59L7.28994 6.09C7.48994 5.89 7.73994 5.8 7.99994 5.8L7.97994 5.8Z"
  },
  "chevron-down-inline": {
    viewBox: { w: 16, h: 16 },
    path: "M8.00004 11C7.74004 11 7.49004 10.9 7.29004 10.71L3.79004 7.21005L5.20004 5.80005L7.99004 8.59005L10.78 5.80005L12.19 7.21005L8.69004 10.71C8.49004 10.91 8.24004 11 7.98004 11H8.00004Z"
  },
  "chevron-right": {
    viewBox: { w: 16, h: 16 },
    path: "M5.29004 13.29L10.58 8.00006L5.29004 2.71008L6.70004 1.30005L12.7 7.30005C13.09 7.69005 13.09 8.32008 12.7 8.71008L6.70004 14.7101L5.29004 13.3V13.29Z"
  },
  "chevron-left": {
    viewBox: { w: 16, h: 16 },
    path: "M10.7098 2.71002L5.41982 8.00003L10.7098 13.29L9.29982 14.7L3.29982 8.70004C2.90982 8.31004 2.90982 7.68004 3.29982 7.29004L9.29982 1.29004L10.7098 2.70004V2.71002Z"
  },
  "chevron-up": {
    viewBox: { w: 16, h: 16 },
    path: "M14.7101 10.2901L13.3001 11.7001L8.01006 6.41005L2.72006 11.7001L1.31006 10.2901L7.31006 4.29006C7.70006 3.90006 8.33006 3.90006 8.72006 4.29006L14.7201 10.2901H14.7101Z"
  },
  "chevron-down": {
    viewBox: { w: 16, h: 16 },
    path: "M14.71 5.71008L8.71004 11.7101C8.51004 11.9101 8.26004 12.0001 8.00004 12.0001C7.74004 12.0001 7.49004 11.9001 7.29004 11.7101L1.29004 5.71008L2.70004 4.30005L7.99004 9.59009L13.28 4.30005L14.69 5.71008H14.71Z"
  },
  compass: {
    viewBox: { w: 21, h: 20 },
    path: "M11.0002 19.9992C10.5902 19.9992 10.2202 19.7492 10.0702 19.3692L7.94021 14.0492L2.62021 11.9192C2.24021 11.7692 1.99021 11.3992 1.99021 10.9892C1.99021 10.5792 2.24021 10.2092 2.62021 10.0592L7.94021 7.92922L10.0702 2.60922C10.2202 2.22922 10.5902 1.97922 11.0002 1.97922C11.4102 1.97922 11.7802 2.22922 11.9302 2.60922L14.0602 7.92922L19.3802 10.0592C19.7602 10.2092 20.0102 10.5792 20.0102 10.9892C20.0102 11.3992 19.7602 11.7692 19.3802 11.9192L14.0602 14.0492L11.9302 19.3692C11.7802 19.7492 11.4102 19.9992 11.0002 19.9992ZM5.70021 10.9992L9.09021 12.3592C9.34021 12.4592 9.55021 12.6592 9.65022 12.9192L11.0102 16.3092L12.3702 12.9192C12.4702 12.6692 12.6702 12.4592 12.9302 12.3592L16.3202 10.9992L12.9302 9.63922C12.6802 9.53922 12.4702 9.33922 12.3702 9.07922L11.0102 5.68922L9.65022 9.07922C9.55021 9.32922 9.35021 9.53922 9.09021 9.63922L5.70021 10.9992ZM3.60021 6.87922C3.46021 6.87922 3.33021 6.78922 3.27021 6.65922L2.53021 4.81922L0.690214 4.07922C0.560214 4.02922 0.470215 3.89922 0.470215 3.74922C0.470215 3.59922 0.560214 3.47922 0.690214 3.41922L2.54021 2.67922L3.28021 0.839219C3.39021 0.569219 3.82021 0.569219 3.93021 0.839219L4.67021 2.67922L6.52021 3.41922C6.65021 3.46922 6.74022 3.59922 6.74022 3.74922C6.74022 3.89922 6.65021 4.01922 6.52021 4.07922L4.67021 4.81922L3.93021 6.65922C3.88021 6.78922 3.75021 6.87922 3.60021 6.87922Z"
  },
  clock: {
    viewBox: { w: 16, h: 17 },
    path: "M12 2H4V0H12V2ZM14 5.41C14.63 6.46 15 7.68 15 9C15 12.86 11.86 16 8 16C4.14 16 1 12.86 1 9C1 5.14 4.14 2 8 2C9.82 2 11.48 2.71 12.73 3.86L14.29 2.3L15.7 3.71L13.99 5.42L14 5.41ZM13 9C13 6.24 10.76 4 8 4C5.24 4 3 6.24 3 9C3 11.76 5.24 14 8 14C10.76 14 13 11.76 13 9ZM7 10H9V6H7V10Z"
  },
  pin: {
    viewBox: { w: 16, h: 16 },
    path: "M8 3C6.35 3 5 4.35 5 6s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3Zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1Zm0-7C5.69 0 3.59 1.28 2.54 3.33c-1.05 2.05-.88 4.5.46 6.38l4.19 5.86c.19.26.49.42.81.42.32 0 .63-.16.81-.42L13 9.71a6.12 6.12 0 0 0 .46-6.38A6.128 6.128 0 0 0 8 0Zm3.37 8.56L8 13.28 4.63 8.56c-.92-1.29-1.04-2.9-.31-4.31C5.05 2.84 6.42 2 8.01 2c1.59 0 2.96.84 3.69 2.25.73 1.41.61 3.02-.31 4.31h-.02Z"
  },
  person: {
    viewBox: { w: 16, h: 16 },
    path: "M4 4c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4-4 1.79-4 4Zm6 0c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2ZM3 16H1v-3c0-2.21 1.79-4 4-4h6c2.21 0 4 1.79 4 4v3h-2v-3c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v3Z"
  },
  "person-active": {
    viewBox: { w: 16, h: 16 },
    path: "M4.5 4C4.5 2.07 6.07 0.5 8 0.5C9.93 0.5 11.5 2.07 11.5 4C11.5 5.93 9.93 7.5 8 7.5C6.07 7.5 4.5 5.93 4.5 4ZM3 16H15V13C15 10.79 13.21 9 11 9H5C2.79 9 1 10.79 1 13V16H3Z"
  },
  hat: {
    viewBox: { w: 16, h: 16 },
    path: "M14.54 3.13 8.48 1.1c-.31-.1-.65-.1-.95 0L1.46 3.13C.64 3.41.12 4.14.12 5c0 .86.53 1.59 1.34 1.87l.54.18V11c0 .16.04.31.11.45C2.24 11.71 3.52 14 8 14c4.48 0 5.76-2.29 5.89-2.55.07-.14.11-.29.11-.45V7.05l.54-.18c.82-.27 1.34-1.01 1.34-1.87 0-.86-.53-1.59-1.34-1.87ZM2.09 5.03 8 3.05l5.9 1.92-5.91 1.98-5.91-1.91.01-.01ZM12 10.69c-.32.38-1.38 1.31-4 1.31s-3.69-.94-4-1.3V7.72L7.52 8.9c.15.05.32.08.48.08.16 0 .32-.03.47-.08l3.52-1.18v2.97H12Z"
  },
  "price-tag": {
    viewBox: { w: 16, h: 16 },
    path: "M8.04 15.92c-.26 0-.51-.1-.71-.29L.46 8.75c-.21-.21-.32-.52-.29-.82l.69-6.19a1 1 0 0 1 .88-.88L7.93.17c.3-.04.6.07.82.29l6.88 6.88c.39.39.39 1.02 0 1.41l-6.88 6.88c-.2.2-.45.29-.71.29ZM2.21 7.67l5.83 5.83 5.46-5.46-5.83-5.83-4.92.55-.55 4.91h.01Zm2.08-1.96A.996.996 0 1 0 5.7 4.3a.996.996 0 1 0-1.41 1.41Z"
  },
  video: {
    viewBox: { w: 16, h: 16 },
    path: "M15.45 2.11c-.34-.17-.75-.13-1.05.09L12 4v-.94c0-.55-.45-1-1-1H1c-.55 0-1 .45-1 1V13c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-1l2.4 1.8c.18.13.39.2.6.2.15 0 .31-.03.45-.11A1 1 0 0 0 16 13V3c0-.38-.21-.73-.55-.89ZM14 11l-2.4-1.8a.996.996 0 0 0-1.05-.09A1 1 0 0 0 10 10v2H2V4.06h8V6c0 .38.21.73.55.89.34.16.75.13 1.05-.09L14 5v6Z"
  },
  comment: {
    viewBox: { w: 16, h: 16 },
    path: "M6 15c-.15 0-.31-.04-.45-.11A1 1 0 0 1 5 14v-2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h12c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2h-3.67L6.6 14.8c-.18.13-.39.2-.6.2ZM2 2v8h4c.55 0 1 .45 1 1v1l2.4-1.8c.17-.13.38-.2.6-.2h4V2H2Z"
  },
  star: {
    viewBox: { w: 17, h: 16 },
    path: "m15.7 6.81-3.12 3.04.74 4.29c.06.38-.09.75-.4.98-.17.13-.38.19-.59.19-.16 0-.32-.04-.46-.11L8 13.17 4.13 15.2c-.33.18-.74.15-1.05-.08-.31-.22-.46-.6-.4-.98l.74-4.29L.3 6.81a.997.997 0 0 1 .56-1.7l4.32-.63L7.11.57c.34-.68 1.46-.68 1.79 0l1.93 3.91 4.32.63a.997.997 0 0 1 .56 1.7h-.01Z"
  },
  "star-outline": {
    viewBox: { w: 32, h: 32 },
    path: "M31.4298 12.4099C31.2498 11.8699 30.7898 11.4699 30.2198 11.3899L21.3198 10.0799L17.3498 2.02994C17.0998 1.51994 16.5798 1.18994 15.9998 1.18994C15.4198 1.18994 14.9098 1.50994 14.6498 2.02994L10.6798 10.0799L1.77975 11.3899C1.21975 11.4699 0.749751 11.8699 0.569751 12.4099C0.389751 12.9499 0.539748 13.5499 0.949748 13.9499L7.37975 20.2199L5.84975 29.0599C5.74975 29.6199 5.97975 30.1899 6.44975 30.5299C6.91975 30.8699 7.51975 30.9099 8.02975 30.6499L15.9897 26.4799L23.9497 30.6499C24.1697 30.7699 24.4098 30.8199 24.6498 30.8199C24.9598 30.8199 25.2698 30.7199 25.5298 30.5299C25.9897 30.1899 26.2197 29.6199 26.1297 29.0599L24.5998 20.2199L31.0298 13.9499C31.4398 13.5499 31.5898 12.9599 31.4098 12.4099H31.4298ZM21.9497 18.6199C21.5997 18.9599 21.4297 19.4599 21.5197 19.9499L22.6598 26.5699L16.6898 23.4399C16.4698 23.3299 16.2297 23.2699 15.9897 23.2699C15.7497 23.2699 15.5098 23.3299 15.2898 23.4399L9.31975 26.5699L10.4598 19.9499C10.5398 19.4599 10.3798 18.9699 10.0297 18.6199L5.19975 13.9199L11.8797 12.9399C12.3697 12.8699 12.7898 12.5599 13.0098 12.1199L15.9798 6.08994L18.9497 12.1199C19.1697 12.5599 19.5898 12.8699 20.0798 12.9399L26.7598 13.9199L21.9298 18.6199H21.9497Z"
  },
  hd: {
    viewBox: { w: 32, h: 32 },
    path: "M9.57 20.64H7.14V11.07H9.57V14.59H12.48V11.07H14.91V20.64H12.48V16.73H9.57V20.64ZM20.76 20.59H17.05V11.18H20.66C21.44 11.18 22.03 11.24 22.45 11.36C23.03 11.53 23.53 11.84 23.94 12.27C24.34 12.7 24.65 13.22 24.86 13.83C25.07 14.43 25.17 15.18 25.17 16.05C25.17 16.82 25.07 17.49 24.88 18.06C24.64 18.75 24.29 19.33 23.84 19.76C23.49 20.1 23.03 20.36 22.45 20.55C22.02 20.69 21.46 20.59 20.75 20.59H20.76ZM20.52 18.62C21.11 18.62 21.4 18.58 21.54 18.54C21.79 18.48 21.98 18.38 22.14 18.24C22.29 18.1 22.42 17.86 22.52 17.52C22.63 17.15 22.69 16.63 22.69 15.97C22.69 15.31 22.63 14.81 22.52 14.47C22.42 14.15 22.27 13.9 22.09 13.73C21.91 13.56 21.68 13.45 21.4 13.39C21.24 13.35 20.86 13.31 19.98 13.31H19.48V18.61H20.52V18.62ZM30 28.5C30 29.33 29.33 30 28.5 30H3.5C2.67 30 2 29.33 2 28.5V3.5C2 2.67 2.67 2 3.5 2H28.5C29.33 2 30 2.67 30 3.5V28.5ZM27 5H5V27H27V5Z"
  },
  "4k": {
    viewBox: { w: 32, h: 32 },
    path: "M28.5 30H3.5C2.67 30 2 29.33 2 28.5V3.5C2 2.67 2.67 2 3.5 2H28.5C29.33 2 30 2.67 30 3.5V28.5C30 29.33 29.33 30 28.5 30ZM5 27H27V5H5V27ZM13.27 11.13H11.51L7.54 16.94L7.5 16.99V18.77H11.19V20.58H13.26V18.77H14.38V16.85H13.26V11.13H13.27ZM9.7 16.85L11.2 14.62V16.85H9.7ZM21.18 14.91L24.79 11.17H21.78L18.39 14.86V11.17H16.17V20.59H18.39V17.75L19.63 16.49L22.04 20.6H24.88L21.19 14.92L21.18 14.91Z"
  },
  "rewind-10": {
    viewBox: { w: 32, h: 32 },
    path: "M4 31H1V16H4V31ZM11.22 31C8.89 31 7 29.11 7 26.78V20.22C7 17.89 8.89 16 11.22 16H12.78C15.11 16 17 17.89 17 20.22V26.78C17 29.11 15.11 31 12.78 31H11.22ZM11.22 28H12.78C13.45 28 14 27.45 14 26.78V20.22C14 19.55 13.45 19 12.78 19H11.22C10.55 19 10 19.55 10 20.22V26.78C10 27.45 10.55 28 11.22 28ZM17.5 2C13.47 2 9.71 3.64 7 6.5V1H4V10.5C4 11.33 4.67 12 5.5 12H15V9H8.8C10.97 6.48 14.11 5 17.5 5C23.84 5 29 10.16 29 16.5C29 21.86 25.36 26.46 20.16 27.69L20.85 30.61C27.42 29.06 32 23.26 32 16.5C32 8.51 25.5 2 17.5 2Z"
  },
  "forward-10": {
    viewBox: { w: 32, h: 32 },
    path: "M18 16V31H15V16H18ZM31 26.78C31 29.11 29.11 31 26.78 31H25.22C22.89 31 21 29.11 21 26.78V20.22C21 17.89 22.89 16 25.22 16H26.78C29.11 16 31 17.89 31 20.22V26.78ZM28 20.22C28 19.55 27.45 19 26.78 19H25.22C24.55 19 24 19.55 24 20.22V26.78C24 27.45 24.55 28 25.22 28H26.78C27.45 28 28 27.45 28 26.78V20.22ZM11.15 30.61L11.84 27.69C6.63 26.46 3 21.86 3 16.5C3 10.16 8.16 5 14.5 5C17.89 5 21.03 6.48 23.2 9H17V12H26.5C27.33 12 28 11.33 28 10.5V1H25V6.5C22.29 3.65 18.53 2 14.5 2C6.5 2 0 8.5 0 16.5C0 23.26 4.59 29.06 11.15 30.61Z"
  },
  transcript: {
    viewBox: { w: 32, h: 32 },
    path: "M30 3.5C30 2.67 29.33 2 28.5 2H3.5C2.67 2 2 2.67 2 3.5V28.5C2 29.33 2.67 30 3.5 30H28.5C29.33 30 30 29.33 30 28.5V3.5ZM27 27H5V5H27V27ZM24 11H8V8H24V11ZM24 17H8V14H24V17ZM19 23H8V20H19V23Z"
  },
  "close-caption-disabled": {
    viewBox: { w: 32, h: 32 },
    path: "M28.5 2H3.5C2.67 2 2 2.67 2 3.5V28.5C2 29.33 2.67 30 3.5 30H28.5C29.33 30 30 29.33 30 28.5V3.5C30 2.67 29.33 2 28.5 2ZM27 24.88L22.57 20.45C23.02 20.31 23.42 20.11 23.76 19.84C24.48 19.27 24.97 18.42 25.23 17.29L22.78 16.87C22.66 17.53 22.44 17.99 22.14 18.26C21.84 18.53 21.45 18.66 20.98 18.66C20.91 18.66 20.85 18.65 20.78 18.64L19.02 16.88C18.95 16.51 18.9 16.09 18.9 15.59C18.9 14.58 19.09 13.87 19.46 13.44C19.83 13.01 20.33 12.8 20.95 12.8C21.42 12.8 21.8 12.92 22.09 13.17C22.38 13.42 22.57 13.79 22.65 14.28L25.11 13.84C24.81 12.83 24.33 12.07 23.65 11.58C22.97 11.09 22.06 10.84 20.91 10.84C19.51 10.84 18.39 11.27 17.57 12.14C17.02 12.72 16.67 13.47 16.49 14.36L15.63 13.5C15.33 12.66 14.89 12.02 14.29 11.58C13.97 11.35 13.61 11.18 13.19 11.06L7.13 5H27.01V24.88H27ZM5 7.12L24.88 27H5V7.12ZM14.65 19.6C14.57 19.68 14.49 19.77 14.4 19.84C13.68 20.41 12.71 20.7 11.49 20.7C10.11 20.7 9.01 20.26 8.19 19.39C7.37 18.52 6.96 17.31 6.96 15.77C6.96 14.53 7.23 13.51 7.76 12.71L9.62 14.57C9.56 14.87 9.53 15.21 9.53 15.6C9.53 16.72 9.72 17.51 10.09 17.97C10.46 18.43 10.97 18.66 11.6 18.66C12.07 18.66 12.46 18.53 12.76 18.26C12.85 18.18 12.93 18.08 13 17.97L14.63 19.6H14.65Z"
  },
  "closed-caption": {
    viewBox: { w: 32, h: 32 },
    path: "M30 3.5C30 2.67 29.33 2 28.5 2H3.5C2.67 2 2 2.67 2 3.5V28.5C2 29.33 2.67 30 3.5 30H28.5C29.33 30 30 29.33 30 28.5V3.5ZM27 27H5V5H27V27ZM8.2 19.39C7.38 18.52 6.97 17.31 6.97 15.77C6.97 14.23 7.38 13 8.2 12.13C9.02 11.26 10.14 10.83 11.54 10.83C12.69 10.83 13.6 11.08 14.28 11.57C14.96 12.06 15.45 12.82 15.74 13.83L13.28 14.27C13.2 13.78 13.01 13.41 12.72 13.16C12.43 12.91 12.05 12.79 11.58 12.79C10.96 12.79 10.46 13 10.09 13.43C9.72 13.86 9.53 14.58 9.53 15.58C9.53 16.7 9.72 17.49 10.09 17.95C10.46 18.41 10.97 18.64 11.6 18.64C12.07 18.64 12.46 18.51 12.76 18.24C13.06 17.97 13.28 17.51 13.4 16.85L15.85 17.27C15.6 18.4 15.11 19.25 14.38 19.82C13.65 20.39 12.69 20.68 11.47 20.68C10.09 20.68 8.99 20.24 8.17 19.37L8.2 19.39ZM17.55 19.39C16.73 18.52 16.32 17.31 16.32 15.77C16.32 14.23 16.73 13 17.55 12.13C18.37 11.26 19.49 10.83 20.89 10.83C22.04 10.83 22.95 11.08 23.63 11.57C24.31 12.06 24.8 12.82 25.09 13.83L22.63 14.27C22.55 13.78 22.36 13.41 22.07 13.16C21.78 12.91 21.4 12.79 20.93 12.79C20.31 12.79 19.81 13 19.44 13.43C19.07 13.86 18.88 14.58 18.88 15.58C18.88 16.7 19.07 17.49 19.44 17.95C19.82 18.41 20.32 18.64 20.95 18.64C21.42 18.64 21.81 18.51 22.11 18.24C22.41 17.97 22.63 17.51 22.75 16.85L25.2 17.27C24.95 18.4 24.46 19.25 23.73 19.82C23.01 20.39 22.04 20.68 20.83 20.68C19.45 20.68 18.35 20.24 17.53 19.37L17.55 19.39Z"
  }
};

// ../../components/dist/esm/Icon/icon.module.css
var icon_default = {
  "icon": "rgft_a1b66739",
  "size-s": "rgft_bc1a8743",
  "size-m": "rgft_c0cbb35d",
  "size-l": "rgft_bd40fe12",
  "size-xl": "rgft_27320e58",
  "legacy-icon": "rgft_3ed66ff4",
  "size-xs": "rgft_9124b200"
};

// ../../components/dist/esm/Icon/Icon.js
import { jsx as jsx5, jsxs } from "react/jsx-runtime";
var getIconPaths = (name) => {
  const svgData = IconSVGs[name];
  if (!svgData) {
    return null;
  }
  if ("paths" in svgData) {
    return { viewBox: svgData.viewBox, paths: svgData.paths };
  } else {
    return { viewBox: svgData.viewBox, paths: [{ path: svgData.path, type: svgData.type }] };
  }
};
var Icon = forwardRef4(({ ...props }, ref) => {
  if ("name" in props) {
    return /* @__PURE__ */ jsx5(LegacyIcon, { ...props, ref });
  }
  const { className, svg, color = "default", role, title, ...rest } = props;
  let { size: size4 = "s" } = props;
  if (size4 === "xs") {
    size4 = "s";
  }
  if ("size" in svg) {
    size4 = svg.size;
  }
  const classes = clsx_default(className, icon_default.icon, icon_default[`size-${size4}`], icon_default[color]);
  const IconSvg = "svg" in svg ? svg.svg : svg[size4].svg;
  return /* @__PURE__ */ jsx5("span", { ref, className: classes, ...rest, children: /* @__PURE__ */ jsx5(IconSvg, { role, title }) });
});
var LegacyIcon = forwardRef4(
  ({ className, size: size4 = "s", role = "presentation", title, color = "default", ...props }, ref) => {
    if (!("name" in props)) {
      throw new Error("Name is required for legacy icon");
    }
    const { name, ...propsWithoutName } = props;
    const { viewBox, paths } = getIconPaths(name) || {};
    if (!viewBox || !paths) {
      return null;
    }
    const classes = clsx_default(className, icon_default.icon, icon_default["legacy-icon"], icon_default[`size-${size4}`]);
    return /* @__PURE__ */ jsx5("span", { ref, className: classes, ...propsWithoutName, children: /* @__PURE__ */ jsxs("svg", { role, xmlns: "http://www.w3.org/2000/svg", viewBox: `0 0 ${viewBox.w} ${viewBox.h}`, children: [
      paths.map(({ type = "fill", path }, i2) => {
        return /* @__PURE__ */ jsx5(
          "path",
          {
            d: path,
            ...{ [`data-${type}`]: true },
            ...{ [type]: color === "genai" ? "url(#paint0_linear_5161_1780)" : void 0 }
          },
          i2
        );
      }),
      /* @__PURE__ */ jsx5(When, { condition: color === "genai", children: /* @__PURE__ */ jsx5("defs", { children: /* @__PURE__ */ jsxs(
        "linearGradient",
        {
          id: "paint0_linear_5161_1780",
          x1: "-3.89372",
          y1: "10.2386",
          x2: "24.5044",
          y2: "10.2742",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx5("stop", { stopColor: "#A000B8" }),
            /* @__PURE__ */ jsx5("stop", { offset: "1", stopColor: "#003EFA" })
          ]
        }
      ) }) }),
      title && /* @__PURE__ */ jsx5("title", { children: title })
    ] }) });
  }
);

// ../../components/dist/esm/Icon/svg/jsx/checkmark_xl.js
import { jsx as jsx6, jsxs as jsxs2 } from "react/jsx-runtime";
var CheckmarkXl = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs2("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx6("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx6("path", { d: "M45.4599 9.35999L17.4599 39.36C17.0899 39.76 16.5698 39.99 16.0298 39.99C16.0198 39.99 16.0098 39.99 15.9998 39.99C15.4698 39.99 14.9598 39.78 14.5898 39.4L2.58984 27.4L5.41985 24.57L15.9599 35.11L42.5499 6.62L45.4698 9.35L45.4599 9.35999Z", "data-fill": true })
] });
var checkmark_xl_default = CheckmarkXl;

// ../../components/dist/esm/Icon/svg/jsx/checkmark_l.js
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var CheckmarkL = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs3("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx7("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx7("path", { d: "M31.1099 5.00999L11.1099 27.01C10.8299 27.31 10.4499 27.49 10.0399 27.5C10.0299 27.5 10.0199 27.5 9.99994 27.5C9.59994 27.5 9.21994 27.34 8.93994 27.06L0.939941 19.06L3.05994 16.94L9.94994 23.83L28.8899 2.98999L31.1099 5.00999Z", "data-fill": true })
] });
var checkmark_l_default = CheckmarkL;

// ../../components/dist/esm/Icon/svg/jsx/checkmark_m.js
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var CheckmarkM = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs4("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx8("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx8("path", { d: "M19.73 3.67996L6.73004 17.68C6.54004 17.88 6.29004 17.99 6.02004 18H6.00004C5.73004 18 5.48004 17.89 5.29004 17.71L0.290039 12.71L1.70004 11.3L5.97004 15.57L18.26 2.32996L19.73 3.68996V3.67996Z", "data-fill": true })
] });
var checkmark_m_default = CheckmarkM;

// ../../components/dist/esm/Icon/svg/jsx/checkmark_s.js
import { jsx as jsx9, jsxs as jsxs5 } from "react/jsx-runtime";
var CheckmarkS = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs5("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx9("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx9("path", { d: "M15.74 2.66996L5.74004 13.67C5.56004 13.87 5.30004 13.99 5.02004 14H5.00004C4.73004 14 4.48004 13.9 4.29004 13.71L0.290039 9.70996L1.70004 8.29996L4.96004 11.56L14.25 1.33997L15.73 2.68996L15.74 2.66996Z", "data-fill": true })
] });
var checkmark_s_default = CheckmarkS;

// ../../components/dist/esm/Icon/svg/checkmark.js
var iconCheckmark = { xl: { svg: checkmark_xl_default, size: "xl" }, l: { svg: checkmark_l_default, size: "l" }, m: { svg: checkmark_m_default, size: "m" }, s: { svg: checkmark_s_default, size: "s" }, __name: "iconCheckmark" };

// ../../components/dist/esm/Icon/svg/jsx/close_xl.js
import { jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var CloseXl = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs6("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx10("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx10("path", { d: "M2.59003 42.5901L21.18 24.0001L2.59003 5.41008L5.42003 2.58008L24.01 21.1701L42.6 2.58008L45.43 5.41008L26.84 24.0001L45.43 42.5901L42.6 45.4201L24.01 26.8301L5.42003 45.4201L2.59003 42.5901Z", "data-fill": true })
] });
var close_xl_default = CloseXl;

// ../../components/dist/esm/Icon/svg/jsx/close_l.js
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var CloseL = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs7("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx11("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx11("path", { d: "M31.0601 3.05994L18.1201 15.9999L31.0601 28.9399L28.9401 31.0599L16.0001 18.1199L3.06006 31.0599L0.940063 28.9399L13.8801 15.9999L0.940063 3.05994L3.06006 0.939941L16.0001 13.8799L28.9401 0.939941L31.0601 3.05994Z", "data-fill": true })
] });
var close_l_default = CloseL;

// ../../components/dist/esm/Icon/svg/jsx/close_m.js
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var CloseM = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs8("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx12("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx12("path", { d: "M1.29004 17.2901L8.58004 10L1.29004 2.71005L2.70004 1.30005L9.99004 8.59005L17.28 1.30005L18.69 2.71005L11.4 10L18.69 17.2901L17.28 18.7001L9.99004 11.41L2.70004 18.7001L1.29004 17.2901Z", "data-fill": true })
] });
var close_m_default = CloseM;

// ../../components/dist/esm/Icon/svg/jsx/close_s.js
import { jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var CloseS = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs9("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", role: props.role, "aria-labelledby": titleId, ...props, children: [
  title ? /* @__PURE__ */ jsx13("title", { id: titleId, children: title }) : null,
  /* @__PURE__ */ jsx13("path", { d: "M1.29004 13.2901L6.58004 8.00005L1.29004 2.71005L2.70004 1.30005L7.99004 6.59005L13.28 1.30005L14.69 2.71005L9.40004 8.00005L14.69 13.2901L13.28 14.7001L7.99004 9.41005L2.70004 14.7001L1.29004 13.2901Z", "data-fill": true })
] });
var close_s_default = CloseS;

// ../../components/dist/esm/Icon/svg/close.js
var iconClose = { xl: { svg: close_xl_default, size: "xl" }, l: { svg: close_l_default, size: "l" }, m: { svg: close_m_default, size: "m" }, s: { svg: close_s_default, size: "s" }, __name: "iconClose" };

// ../../components/dist/esm/Text/BaseText/useIconReplacer.js
import { jsx as jsx14 } from "react/jsx-runtime";
var SUPPORTED_ICONS = {
  "\u2714": iconCheckmark,
  "\u2716": iconClose
};
var iconRegex = new RegExp(`[${Object.keys(SUPPORTED_ICONS).join("")}]`, "g");
var useIconReplacer = () => {
  const ref = useRef3(null);
  useIsomorphicLayoutEffect(() => {
    const el = ref.current;
    if (!el?.innerHTML) {
      return;
    }
    (async () => {
      const iconsInHtml = el.innerHTML.match(iconRegex);
      const uniqueIcons = new Set(iconsInHtml);
      if (!uniqueIcons.size) {
        return;
      }
      const renderedIcons = {};
      for (const icon of uniqueIcons) {
        const svg = SUPPORTED_ICONS[icon];
        renderedIcons[icon] = await renderComponentToHtml(/* @__PURE__ */ jsx14(Icon, { svg: svg.s, className: basetext_default["inline-icon"] }));
      }
      const htmlWithIcons = el.innerHTML.replace(iconRegex, (match) => {
        return renderedIcons[match];
      });
      el.innerHTML = htmlWithIcons;
    })();
  }, []);
  return { ref };
};
var renderComponentToHtml = async (component) => {
  if (+React2.version.split(".")[0] <= 17) {
    const { renderToString } = await import("react-dom/server");
    return renderToString(component);
  }
  const { createRoot } = await import("react-dom/client");
  const div = document.createElement("div");
  const root = createRoot(div);
  return new Promise((resolve) => {
    setTimeout(() => {
      flushSync(() => root.render(component));
      const html = div.innerHTML;
      root.unmount();
      div.remove();
      resolve(html);
    }, 0);
  });
};

// ../../components/dist/esm/Text/BaseText/BaseText.js
import { jsx as jsx15 } from "react/jsx-runtime";
var polyRef = forwardRef5;
var BaseText = polyRef(
  ({ as: As = "span", block = false, center = false, children, innerHTML, className, monospace = false, ...props }, ref) => {
    const classes = clsx_default(
      basetext_default.text,
      {
        [basetext_default.block]: block,
        [basetext_default.center]: center,
        [basetext_default.monospace]: monospace
      },
      className
    );
    const { ref: replacerRef } = useIconReplacer();
    const refs = useMergeRefs(ref, replacerRef);
    const textProps = {
      ...props,
      className: classes,
      ref: refs
    };
    if (innerHTML) {
      return /* @__PURE__ */ jsx15(As, { ...textProps, dangerouslySetInnerHTML: { __html: sanitizeHTML(innerHTML) } });
    }
    return /* @__PURE__ */ jsx15(As, { ...textProps, children });
  }
);

// ../../components/dist/esm/Text/BaseText/utils.js
var getSizeClasses = (styles, size4, fixedSize) => {
  if (!size4 && !fixedSize) {
    return styles["size-1"];
  }
  if (fixedSize) {
    return [styles[`size-${fixedSize}`], styles.fixed];
  }
  return styles[`size-${size4}`];
};

// ../../components/dist/esm/Text/BodyText/bodytext.module.css
var bodytext_default = {
  "body": "rgft_98b54368",
  "size-1": "rgft_275611e5",
  "size-2": "rgft_007aef8b",
  "size-3": "rgft_ff19c5f9",
  "link": "rgft_2a7f98ee",
  "link-swipe": "rgft_9beb7cc5"
};

// ../../components/dist/esm/Text/BodyText/BodyText.js
import { jsx as jsx16 } from "react/jsx-runtime";
var polyRef2 = forwardRef6;
var nameAttrs = getComponentNameAttributes("BodyText");
var BodyText = polyRef2(
  ({ as: As, className, size: size4 = 1, fixedSize, link, ...props }, ref) => {
    const classes = clsx_default(bodytext_default.body, className, getSizeClasses(bodytext_default, size4, fixedSize), {
      [bodytext_default.link]: As === "a" || link
    });
    return /* @__PURE__ */ jsx16(BaseText, { as: As, className: classes, ref, ...nameAttrs, ...props });
  }
);

// ../../components/dist/esm/Text/TitleText/TitleText.js
import { forwardRef as forwardRef7 } from "react";

// ../../components/dist/esm/Text/TitleText/titletext.module.css
var titletext_default = {
  "title": "rgft_7047aa37",
  "size-1": "rgft_5cec080d",
  "size-2": "rgft_b033b5e8",
  "size-3": "rgft_b97b7b3b"
};

// ../../components/dist/esm/Text/TitleText/TitleText.js
import { jsx as jsx17 } from "react/jsx-runtime";
var polyRef3 = forwardRef7;
var nameAttrs2 = getComponentNameAttributes("TitleText");
var TitleText = polyRef3(
  ({ as: As, className, size: size4 = 1, fixedSize, ...props }, ref) => {
    const classes = clsx_default(titletext_default.title, className, getSizeClasses(titletext_default, size4, fixedSize));
    return /* @__PURE__ */ jsx17(BaseText, { as: As, className: classes, ref, ...nameAttrs2, ...props });
  }
);

// ../../components/dist/esm/Text/UtilityText/UtilityText.js
import { forwardRef as forwardRef8 } from "react";

// ../../components/dist/esm/Text/UtilityText/utilitytext.module.css
var utilitytext_default = {
  "utility": "rgft_82d7eac3",
  "size-1": "rgft_60954f49",
  "size-2": "rgft_2c9f3422",
  "size-3": "rgft_aa83ac72",
  "size-4": "rgft_1476187d"
};

// ../../components/dist/esm/Text/UtilityText/UtilityText.js
import { jsx as jsx18 } from "react/jsx-runtime";
var polyRef4 = forwardRef8;
var nameAttrs3 = getComponentNameAttributes("UtilityText");
var UtilityText = polyRef4(
  ({ as: As, className, size: size4 = 1, fixedSize, ...props }, ref) => {
    const classes = clsx_default(utilitytext_default.utility, className, getSizeClasses(utilitytext_default, size4, fixedSize));
    return /* @__PURE__ */ jsx18(BaseText, { as: As, className: classes, ref, ...nameAttrs3, ...props });
  }
);

// ../../components/dist/esm/Link/link.module.css
var link_default = {
  "link": "rgft_13008707",
  "monochrome": "rgft_3669185e"
};

// ../../components/dist/esm/Link/Link.js
import { jsx as jsx19 } from "react/jsx-runtime";
var nameAttrs4 = getComponentNameAttributes("Link");
var polyRef5 = forwardRef9;
var Link = polyRef5(
  ({
    children,
    size: size4 = 1,
    href,
    monochrome,
    tag,
    as: As = tag || "a",
    className,
    injectAnalyticsMetadata = false,
    ...rest
  }, ref) => {
    const hrefProps = useHrefProps(href);
    const classes = clsx_default(link_default.link, className, {
      [link_default.monochrome]: monochrome
    });
    const analyticsMetadata = !injectAnalyticsMetadata ? {} : {
      [ANALYTICS_METADATA_ATTRIBUTE]: JSON.stringify(
        (0, import_merge.default)(
          {
            name: "Link",
            properties: {
              monochrome,
              size: size4
            }
          },
          typeof injectAnalyticsMetadata === "object" ? injectAnalyticsMetadata : void 0
        )
      )
    };
    const linkProps = {
      ...nameAttrs4,
      ...rest,
      ...analyticsMetadata,
      children
    };
    return /* @__PURE__ */ jsx19(BodyText, { as: As, size: size4, ...hrefProps, ...linkProps, className: classes, link: true, ref });
  }
);

// ../../components/dist/esm/Button/button.module.css
var button_default = {
  "button-base": "rgft_2249face",
  "size-s": "rgft_c46055a8",
  "primary": "rgft_5e7d04ee",
  "secondary": "rgft_ed10b6fc",
  "tertiary": "rgft_69284063",
  "flat": "rgft_eec0b978",
  "selected": "rgft_335ebf96",
  "visited": "rgft_58fdaabc",
  "disabled": "rgft_f1515350",
  "button": "rgft_b78e9379",
  "full-width": "rgft_c008bb31",
  "start-icon": "rgft_d3d7facc",
  "end-icon": "rgft_208ce3b6",
  "icon-hover-only": "rgft_04e9a8ae",
  "content": "rgft_f5857abf",
  "with-start-icon": "rgft_90c47075",
  "with-end-icon": "rgft_be121009",
  "link-button": "rgft_d9725c73"
};

// ../../components/dist/esm/Button/Button.js
import { jsx as jsx20, jsxs as jsxs10 } from "react/jsx-runtime";
var Button = forwardRef10(
  ({
    className,
    children,
    variant = "primary",
    fullWidth = false,
    startIcon,
    endIcon,
    iconOnlyOnHover,
    injectAnalyticsMetadata = false,
    ...props
  }, ref) => {
    if (variant === "link" && props.href) {
      throw new Error(
        'Use the <Link> component for links. <Button variant="link"> should only be used to make a button appear as a link.'
      );
    }
    const classes = clsx_default(
      button_default.button,
      {
        [button_default["full-width"]]: fullWidth,
        [button_default["icon-hover-only"]]: iconOnlyOnHover && children,
        [button_default["with-start-icon"]]: startIcon,
        [button_default["with-end-icon"]]: endIcon
      },
      className
    );
    const analyticsMetadata = !injectAnalyticsMetadata ? {} : {
      [ANALYTICS_METADATA_ATTRIBUTE]: JSON.stringify(
        (0, import_merge2.default)(
          {
            name: "Button",
            properties: {
              variant
            }
          },
          typeof injectAnalyticsMetadata === "object" ? injectAnalyticsMetadata : void 0
        )
      )
    };
    const buttonProps = {
      ...props,
      ...analyticsMetadata
    };
    if (variant === "link") {
      return (
        // @ts-expect-error Ref type is wrong
        /* @__PURE__ */ jsx20(Link, { ...buttonProps, ref, as: "button", monochrome: true, className: clsx_default(className, button_default["link-button"]), children })
      );
    }
    return /* @__PURE__ */ jsxs10(ButtonBase, { ...buttonProps, className: classes, ref, variant, children: [
      startIcon ? /* @__PURE__ */ jsx20("span", { className: button_default["start-icon"], children: startIcon }) : null,
      children ? /* @__PURE__ */ jsx20(UtilityText, { size: 3, center: true, className: button_default.content, children }) : null,
      endIcon ? /* @__PURE__ */ jsx20("span", { className: button_default["end-icon"], children: endIcon }) : null
    ] });
  }
);

// ../../utils/dist/esm/viewportSizes.js
var allViewportSizesInOrder = ["xs", "s", "m", "l", "xl", "xxl"];

// ../../utils/dist/esm/getNearestViewportDependentValue.js
var getNearestViewportDependentValue = (size4, availableSizes) => {
  if (availableSizes[size4] !== void 0) {
    return availableSizes[size4];
  }
  const index3 = allViewportSizesInOrder.indexOf(size4);
  for (let i2 = index3; i2 >= 0; --i2) {
    const valueAtSize = availableSizes[allViewportSizesInOrder[i2]];
    if (valueAtSize !== void 0) {
      return valueAtSize;
    }
  }
  for (let i2 = index3; i2 < allViewportSizesInOrder.length; ++i2) {
    const valueAtSize = availableSizes[allViewportSizesInOrder[i2]];
    if (valueAtSize !== void 0) {
      return valueAtSize;
    }
  }
  throw new Error("No sizes were provided to select from.");
};

// ../../components/dist/esm/Grid/Col.js
import { forwardRef as forwardRef11 } from "react";

// ../../components/dist/esm/Grid/col.module.css
var col_default = {
  "col": "rgft_7ca45506",
  "col-0": "rgft_11350cba",
  "col-1": "rgft_710fa332",
  "col-2": "rgft_948c40f1",
  "col-3": "rgft_4381b023",
  "col-4": "rgft_3ae83509",
  "col-5": "rgft_1c7f9dfb",
  "col-6": "rgft_656e1ab9",
  "col-7": "rgft_d039c8b7",
  "col-8": "rgft_6e733507",
  "col-9": "rgft_cab03403",
  "col-10": "rgft_aeddd549",
  "col-11": "rgft_b99601ba",
  "col-12": "rgft_f6ca794c",
  "col-13": "rgft_d3e55935",
  "col-14": "rgft_d65fc9f2",
  "col-xs-0": "rgft_24ce2692",
  "col-xs-1": "rgft_8437e71a",
  "order-xs-1": "rgft_bf84f81d",
  "start-xs-1": "rgft_d944d056",
  "col-xs-2": "rgft_ac257e33",
  "order-xs-2": "rgft_396e46c1",
  "start-xs-2": "rgft_5729a69c",
  "col-xs-3": "rgft_82aaa13d",
  "order-xs-3": "rgft_5b145c86",
  "start-xs-3": "rgft_56455fb7",
  "col-xs-4": "rgft_0d739a41",
  "order-xs-4": "rgft_8991b21d",
  "start-xs-4": "rgft_6cac61fe",
  "col-xs-5": "rgft_6e213e06",
  "order-xs-5": "rgft_2749c256",
  "start-xs-5": "rgft_699fc82f",
  "col-xs-6": "rgft_7a361b9a",
  "order-xs-6": "rgft_153c94b4",
  "start-xs-6": "rgft_01e947b2",
  "col-xs-7": "rgft_88ac1c54",
  "order-xs-7": "rgft_004fbf93",
  "start-xs-7": "rgft_eadadad9",
  "col-xs-8": "rgft_51811dec",
  "order-xs-8": "rgft_7f10f58a",
  "start-xs-8": "rgft_7d2ffaba",
  "col-xs-9": "rgft_f4b7da83",
  "order-xs-9": "rgft_d91bb37b",
  "start-xs-9": "rgft_545082c9",
  "col-xs-10": "rgft_b54f7754",
  "order-xs-10": "rgft_efdffb84",
  "start-xs-10": "rgft_945ffb67",
  "col-xs-11": "rgft_b3628528",
  "order-xs-11": "rgft_404c11f9",
  "start-xs-11": "rgft_fad5b7f7",
  "col-xs-12": "rgft_2f390d15",
  "order-xs-12": "rgft_b69f921a",
  "start-xs-12": "rgft_a0ee2b31",
  "col-xs-13": "rgft_602a65b9",
  "order-xs-13": "rgft_dbb02d26",
  "start-xs-13": "rgft_264c0438",
  "col-xs-14": "rgft_c5641af1",
  "order-xs-14": "rgft_74c53aa8",
  "start-xs-14": "rgft_9ae4850f",
  "col-s-0": "rgft_7f4014b0",
  "col-s-1": "rgft_3108c890",
  "order-s-1": "rgft_4ddebd49",
  "start-s-1": "rgft_2e45d50a",
  "col-s-2": "rgft_a54b1c66",
  "order-s-2": "rgft_888b1771",
  "start-s-2": "rgft_cbc038c2",
  "col-s-3": "rgft_dac8d410",
  "order-s-3": "rgft_3951e8e6",
  "start-s-3": "rgft_8bc63178",
  "col-s-4": "rgft_37e5a385",
  "order-s-4": "rgft_41738568",
  "start-s-4": "rgft_5d66b8de",
  "col-s-5": "rgft_fba3685e",
  "order-s-5": "rgft_98aba763",
  "start-s-5": "rgft_ccdd5c3b",
  "col-s-6": "rgft_c79807e3",
  "order-s-6": "rgft_bcbb5ef1",
  "start-s-6": "rgft_7eccd59c",
  "col-s-7": "rgft_0a7d74e6",
  "order-s-7": "rgft_9c39f634",
  "start-s-7": "rgft_8b642ce5",
  "col-s-8": "rgft_adda8de0",
  "order-s-8": "rgft_bafad1bb",
  "start-s-8": "rgft_92e90543",
  "col-s-9": "rgft_f3c24635",
  "order-s-9": "rgft_1cd3d0ca",
  "start-s-9": "rgft_5f1352bf",
  "col-s-10": "rgft_b17ba09f",
  "order-s-10": "rgft_0e3e2d08",
  "start-s-10": "rgft_77139fbe",
  "col-s-11": "rgft_da2ef39d",
  "order-s-11": "rgft_6a8db4a0",
  "start-s-11": "rgft_7469c1fc",
  "col-s-12": "rgft_2aef2225",
  "order-s-12": "rgft_9fe8cfcc",
  "start-s-12": "rgft_ac3fed03",
  "col-s-13": "rgft_b1acdddd",
  "order-s-13": "rgft_ec14c9bb",
  "start-s-13": "rgft_6cb59637",
  "col-s-14": "rgft_a5aa7342",
  "order-s-14": "rgft_1f643c41",
  "start-s-14": "rgft_cf918396",
  "col-m-0": "rgft_cd05dc88",
  "col-m-1": "rgft_4e76427a",
  "order-m-1": "rgft_8e934938",
  "start-m-1": "rgft_8949177f",
  "col-m-2": "rgft_9c901125",
  "order-m-2": "rgft_76b3dbe9",
  "start-m-2": "rgft_e086e056",
  "col-m-3": "rgft_1e6bcbd0",
  "order-m-3": "rgft_119e05e2",
  "start-m-3": "rgft_82a1dd9f",
  "col-m-4": "rgft_b815655e",
  "order-m-4": "rgft_778c3959",
  "start-m-4": "rgft_0ba71306",
  "col-m-5": "rgft_3a5c8655",
  "order-m-5": "rgft_66e9a74f",
  "start-m-5": "rgft_776a07c0",
  "col-m-6": "rgft_387166a7",
  "order-m-6": "rgft_4954ff84",
  "start-m-6": "rgft_c41093a2",
  "col-m-7": "rgft_07fcce24",
  "order-m-7": "rgft_c0da85ec",
  "start-m-7": "rgft_346898d2",
  "col-m-8": "rgft_67470d0b",
  "order-m-8": "rgft_78177cda",
  "start-m-8": "rgft_486dad53",
  "col-m-9": "rgft_34b4c815",
  "order-m-9": "rgft_72220013",
  "start-m-9": "rgft_679b2988",
  "col-m-10": "rgft_d8b1bd61",
  "order-m-10": "rgft_5166c39f",
  "start-m-10": "rgft_fda7fd84",
  "col-m-11": "rgft_7683b75c",
  "order-m-11": "rgft_544efbb1",
  "start-m-11": "rgft_7b6a3e6b",
  "col-m-12": "rgft_90b792b3",
  "order-m-12": "rgft_fe4cf355",
  "start-m-12": "rgft_e7d09cea",
  "col-m-13": "rgft_220228ab",
  "order-m-13": "rgft_ee19f53c",
  "start-m-13": "rgft_95756889",
  "col-m-14": "rgft_f5fbd19e",
  "order-m-14": "rgft_985dae9b",
  "start-m-14": "rgft_e018deae",
  "col-l-0": "rgft_6a005420",
  "col-l-1": "rgft_daa51367",
  "order-l-1": "rgft_f445319e",
  "start-l-1": "rgft_11f8ea1f",
  "col-l-2": "rgft_8a1b076d",
  "order-l-2": "rgft_856308ca",
  "start-l-2": "rgft_1891867e",
  "col-l-3": "rgft_7f7eafcb",
  "order-l-3": "rgft_6e1cdac5",
  "start-l-3": "rgft_b54bb6ea",
  "col-l-4": "rgft_6e4a3878",
  "order-l-4": "rgft_064ffdae",
  "start-l-4": "rgft_e467a6e5",
  "col-l-5": "rgft_284304a7",
  "order-l-5": "rgft_cf6134fa",
  "start-l-5": "rgft_4210bb19",
  "col-l-6": "rgft_1cdd9d8d",
  "order-l-6": "rgft_9faf814c",
  "start-l-6": "rgft_108329ee",
  "col-l-7": "rgft_01373672",
  "order-l-7": "rgft_ff55a059",
  "start-l-7": "rgft_faa64121",
  "col-l-8": "rgft_f962cbf7",
  "order-l-8": "rgft_b32651c7",
  "start-l-8": "rgft_aaac03ab",
  "col-l-9": "rgft_4e9226ed",
  "order-l-9": "rgft_37c54216",
  "start-l-9": "rgft_0a7d8a93",
  "col-l-10": "rgft_135acb10",
  "order-l-10": "rgft_c6526e2b",
  "start-l-10": "rgft_f49d64ea",
  "col-l-11": "rgft_58492a3b",
  "order-l-11": "rgft_01493f0b",
  "start-l-11": "rgft_75224ca2",
  "col-l-12": "rgft_7b802c53",
  "order-l-12": "rgft_b171edd8",
  "start-l-12": "rgft_62d55469",
  "col-l-13": "rgft_3e874bd1",
  "order-l-13": "rgft_e46b24d1",
  "start-l-13": "rgft_80f7ec1e",
  "col-l-14": "rgft_f9da269e",
  "order-l-14": "rgft_4022fe62",
  "start-l-14": "rgft_903562a4",
  "col-xl-0": "rgft_e33d2de5",
  "col-xl-1": "rgft_e5481323",
  "order-xl-1": "rgft_fa602ce3",
  "start-xl-1": "rgft_5715f1cc",
  "col-xl-2": "rgft_bd6c4131",
  "order-xl-2": "rgft_b367677b",
  "start-xl-2": "rgft_70c34b0b",
  "col-xl-3": "rgft_afa17dc5",
  "order-xl-3": "rgft_6535eab7",
  "start-xl-3": "rgft_e8d1c5bc",
  "col-xl-4": "rgft_8f183e6d",
  "order-xl-4": "rgft_7b083cf1",
  "start-xl-4": "rgft_f59060fd",
  "col-xl-5": "rgft_96bcfc07",
  "order-xl-5": "rgft_da4dd257",
  "start-xl-5": "rgft_e672839d",
  "col-xl-6": "rgft_a80e4900",
  "order-xl-6": "rgft_38628879",
  "start-xl-6": "rgft_49c03b74",
  "col-xl-7": "rgft_68d43266",
  "order-xl-7": "rgft_758e3d49",
  "start-xl-7": "rgft_2ee1f551",
  "col-xl-8": "rgft_f72cb091",
  "order-xl-8": "rgft_b0371ea7",
  "start-xl-8": "rgft_ffad8953",
  "col-xl-9": "rgft_f6cf9812",
  "order-xl-9": "rgft_18f23821",
  "start-xl-9": "rgft_67f5b14a",
  "col-xl-10": "rgft_ac73e05c",
  "order-xl-10": "rgft_79daaed9",
  "start-xl-10": "rgft_858530d8",
  "col-xl-11": "rgft_1db6cf54",
  "order-xl-11": "rgft_93bc4c84",
  "start-xl-11": "rgft_607b086f",
  "col-xl-12": "rgft_900fec60",
  "order-xl-12": "rgft_783fd0a7",
  "start-xl-12": "rgft_1b790ce2",
  "col-xl-13": "rgft_4800e21a",
  "order-xl-13": "rgft_3c2f875f",
  "start-xl-13": "rgft_2d522ddd",
  "col-xl-14": "rgft_10ea20ba",
  "order-xl-14": "rgft_583aa736",
  "start-xl-14": "rgft_99a2a37a",
  "col-xxl-0": "rgft_ee858a24",
  "col-xxl-1": "rgft_bbecd22f",
  "order-xxl-1": "rgft_340f0d82",
  "start-xxl-1": "rgft_689ba25d",
  "col-xxl-2": "rgft_31a82faf",
  "order-xxl-2": "rgft_6059fa5d",
  "start-xxl-2": "rgft_998711f9",
  "col-xxl-3": "rgft_9618eab1",
  "order-xxl-3": "rgft_a5bc9222",
  "start-xxl-3": "rgft_4be25f55",
  "col-xxl-4": "rgft_f2d77a47",
  "order-xxl-4": "rgft_7706898c",
  "start-xxl-4": "rgft_2282cf9e",
  "col-xxl-5": "rgft_f9cd03b5",
  "order-xxl-5": "rgft_aee32259",
  "start-xxl-5": "rgft_10408b56",
  "col-xxl-6": "rgft_f36c46cb",
  "order-xxl-6": "rgft_f6c67d8e",
  "start-xxl-6": "rgft_5012951e",
  "col-xxl-7": "rgft_f30d52bf",
  "order-xxl-7": "rgft_e5c4fea3",
  "start-xxl-7": "rgft_3a15ecad",
  "col-xxl-8": "rgft_62f5ad9c",
  "order-xxl-8": "rgft_e2cb03d5",
  "start-xxl-8": "rgft_26c7d733",
  "col-xxl-9": "rgft_86571464",
  "order-xxl-9": "rgft_1c636f12",
  "start-xxl-9": "rgft_0ad14bf9",
  "col-xxl-10": "rgft_0430361f",
  "order-xxl-10": "rgft_14c44573",
  "start-xxl-10": "rgft_249c2eb0",
  "col-xxl-11": "rgft_dcd88134",
  "order-xxl-11": "rgft_f3b71005",
  "start-xxl-11": "rgft_60be6a53",
  "col-xxl-12": "rgft_47b99bc1",
  "order-xxl-12": "rgft_490a1b69",
  "start-xxl-12": "rgft_2188ab42",
  "col-xxl-13": "rgft_50e9c89b",
  "order-xxl-13": "rgft_041629db",
  "start-xxl-13": "rgft_a2347693",
  "col-xxl-14": "rgft_4d85263b",
  "order-xxl-14": "rgft_a76bd10d",
  "start-xxl-14": "rgft_d22d1dd5"
};

// ../../components/dist/esm/Grid/Col.js
import { jsx as jsx21 } from "react/jsx-runtime";
var nameAttrs5 = getComponentNameAttributes("Col");
var Col = forwardRef11(
  ({ span = 12, order, start, children, className, ...rest }, ref) => {
    const classes = [col_default.col];
    if (order) {
      const keys = Object.keys(order);
      keys.forEach((key) => {
        const orderClass = col_default[`order-${key}-${order[key]}`];
        classes.push(orderClass);
      });
    }
    if (start) {
      const keys = Object.keys(start);
      keys.forEach((key) => {
        const startClass = col_default[`start-${key}-${start[key]}`];
        classes.push(startClass);
      });
    }
    if (typeof span === "object") {
      allViewportSizesInOrder.forEach((size4) => {
        const spanClass = col_default[`col-${size4}-${getNearestViewportDependentValue(size4, span)}`];
        classes.push(spanClass);
      });
    } else {
      classes.push(col_default[`col-${span}`]);
    }
    return /* @__PURE__ */ jsx21("div", { ...nameAttrs5, ...rest, ref, className: clsx_default(classes, className), children });
  }
);

// ../../components/dist/esm/Grid/Grid.js
import { forwardRef as forwardRef12 } from "react";

// ../../components/dist/esm/Grid/grid.module.css
var grid_default = {
  "grid": "rgft_85859631",
  "equal": "rgft_f46ba445",
  "v-padding": "rgft_ad36873b",
  "h-padding": "rgft_3fcbf9c7",
  "no-padding": "rgft_bf97105f",
  "full-width": "rgft_f51223df"
};

// ../../components/dist/esm/Grid/useGridGapStyle.js
import { useMemo as useMemo5 } from "react";
var RG_GAP_VAR_PREFIX = "--rg-margin-";
var useGridGapStyle = (gridName, gap) => {
  return useMemo5(() => {
    const gapStyle = {};
    if (gap !== void 0 && gap > 0) {
      gapStyle[`--rg-${gridName}-gap`] = `var(${RG_GAP_VAR_PREFIX}${gap})`;
    }
    if (gap === 0) {
      gapStyle[`--rg-${gridName}-gap`] = "0";
    }
    return gapStyle;
  }, [gap]);
};

// ../../components/dist/esm/Grid/Grid.js
import { jsx as jsx22 } from "react/jsx-runtime";
var nameAttrs6 = getComponentNameAttributes("Grid");
var Grid = forwardRef12(
  ({ equal = false, padding = true, fullWidth, children, className, style, gap, ...rest }, ref) => {
    const classes = clsx_default(className, grid_default.grid, {
      [grid_default.equal]: equal,
      [grid_default["full-width"]]: fullWidth,
      [grid_default["no-padding"]]: padding === false,
      [grid_default["v-padding"]]: padding === "vertical",
      [grid_default["h-padding"]]: padding === "horizontal"
    });
    const gapStyle = useGridGapStyle("grid", gap ?? 3);
    return /* @__PURE__ */ jsx22("div", { ...nameAttrs6, ...rest, className: classes, style: { ...style, ...gapStyle }, ref, children });
  }
);

// ../../components/dist/esm/Grid/grid-stack.module.css
var grid_stack_default = {
  "grid-stack": "rgft_92ef7532"
};

// ../../components/dist/esm/Grid/GridStack.js
import { jsx as jsx23 } from "react/jsx-runtime";
var nameAttrs7 = getComponentNameAttributes("GridStack");
function GridStack({ children, className, style, gap, ...rest }) {
  const classes = clsx_default(className, grid_stack_default["grid-stack"]);
  const gapStyle = useGridGapStyle("gridstack", gap ?? 0);
  return /* @__PURE__ */ jsx23("div", { ...nameAttrs7, ...rest, className: classes, style: { ...gapStyle, ...style }, children });
}

// ../../components/dist/esm/ItemExpander/ItemExpander.js
import { isServer as isServer2 } from "@amzn/aws-marketing-experience-builder-template-helpers";
var import_debounce2 = __toESM(require_debounce());
var import_merge3 = __toESM(require_merge());
import { useCallback as useCallback4, useEffect as useEffect5, useRef as useRef4, useState as useState3 } from "react";

// ../../components/dist/esm/ItemExpander/item-expander.module.css
var item_expander_default = {
  "expandable-section": "rgft_52cab642",
  "expandable-section-header": "rgft_2b04aff0",
  "expandable-section-button": "rgft_689e02ae",
  "title-content": "rgft_8ac8d4db",
  "toggle-icon": "rgft_1d4b05a5",
  "active": "rgft_20b34a1c",
  "eb-header-title": "rgft_696e8b62",
  "header-component": "rgft_e5ffaede",
  "expandable-section-content": "rgft_ee6c06e6",
  "expandable-section-content-wrapper": "rgft_b8c1571b"
};

// ../../components/dist/esm/ItemExpander/ItemExpander.js
import { jsx as jsx24, jsxs as jsxs11 } from "react/jsx-runtime";
var nameAttrs8 = getComponentNameAttributes("ItemExpander");
var supportsHiddenUntilFound = isServer2() ? false : "onbeforematch" in document.body;
var ItemExpander = ({
  id,
  title,
  content,
  expanded,
  className = "",
  classes,
  maxHeight,
  onToggle,
  injectAnalyticsMetadata = false
}) => {
  const [expandedContentEl, setExpandedContentEl] = useState3(null);
  const [inTransition, setInTransition] = useState3(false);
  const renderRef = useRef4(false);
  const toggleSection = useCallback4(() => {
    onToggle(id);
  }, [id, onToggle]);
  const analyticsMetadata = !injectAnalyticsMetadata ? {} : {
    [ANALYTICS_METADATA_ATTRIBUTE]: JSON.stringify(
      (0, import_merge3.default)(
        {
          name: "ItemExpander",
          properties: {
            expanded
          }
        },
        typeof injectAnalyticsMetadata === "object" ? injectAnalyticsMetadata : void 0
      )
    )
  };
  useEffect5(() => {
    const setHeight = () => {
      if (!expandedContentEl) {
        return;
      }
      if (expanded && expandedContentEl.scrollHeight === 0) {
        setInTransition(true);
        return;
      }
      const totalMaxHeight = !expanded ? 0 : maxHeight ?? expandedContentEl.scrollHeight;
      expandedContentEl?.style.setProperty("max-height", `${totalMaxHeight}px`);
      setInTransition(false);
    };
    setHeight();
    const setHeightDebounce = (0, import_debounce2.default)(setHeight, 200);
    window.addEventListener("resize", setHeightDebounce);
    return () => window.removeEventListener("resize", setHeightDebounce);
  }, [expanded, expandedContentEl, inTransition]);
  useEffect5(() => {
    if (!supportsHiddenUntilFound && !expandedContentEl) {
      return;
    }
    const handleFound = () => {
      if (!expanded) {
        toggleSection();
      }
    };
    expandedContentEl?.addEventListener("beforematch", handleFound);
    return () => expandedContentEl?.removeEventListener("beforematch", handleFound);
  }, [expanded, toggleSection, expandedContentEl]);
  useEffect5(() => {
    if (supportsHiddenUntilFound && expandedContentEl) {
      if (expanded) {
        expandedContentEl.removeAttribute("hidden");
      } else if (!renderRef.current) {
        expandedContentEl.setAttribute("hidden", "until-found");
      }
      renderRef.current = true;
    }
  }, [expanded, expandedContentEl]);
  const handleContentClosed = useCallback4(() => {
    if (!expanded && supportsHiddenUntilFound) {
      expandedContentEl?.setAttribute("hidden", "until-found");
    }
  }, [expanded, expandedContentEl]);
  const toggleClasses = clsx_default(item_expander_default["toggle-icon"], {
    [item_expander_default["active"]]: expanded
  });
  return /* @__PURE__ */ jsxs11("div", { className: clsx_default(item_expander_default["aws-rigel"], item_expander_default["expandable-section"], classes?.itemWrapper), ...nameAttrs8, children: [
    /* @__PURE__ */ jsx24("h3", { className: clsx_default(item_expander_default["expandable-section-header"], `${className}`), children: /* @__PURE__ */ jsxs11(
      "button",
      {
        id: `${id}-trigger`,
        "aria-controls": `content-${id}`,
        "aria-expanded": expanded,
        onClick: toggleSection,
        className: item_expander_default["expandable-section-button"],
        ...analyticsMetadata,
        children: [
          /* @__PURE__ */ jsx24("span", { className: item_expander_default["title-content"], children: title }),
          /* @__PURE__ */ jsx24("span", { className: toggleClasses, "aria-hidden": true })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx24(
      "div",
      {
        ref: setExpandedContentEl,
        id: `content-${id}`,
        "aria-labelledby": `${id}-trigger`,
        className: item_expander_default["expandable-section-content"],
        onTransitionEnd: handleContentClosed,
        children: /* @__PURE__ */ jsx24("div", { className: clsx_default(item_expander_default["expandable-section-content-wrapper"], classes?.contentWrapper), children: content })
      }
    )
  ] });
};

// ../../../node_modules/@amzn/aws-brand-tokens/dist/js/variables.mjs
var TypographyBreakpointsXxl = "1600px";
var TypographyBreakpointsXl = "1280px";
var TypographyBreakpointsLg = "1024px";
var TypographyBreakpointsMd = "768px";
var TypographyBreakpointsSm = "480px";
var TypographyBreakpointsXs = "320px";

// ../../hooks/dist/esm/useBreakpoint.js
import { isServer as isServer3 } from "@amzn/aws-marketing-experience-builder-template-helpers";
import { useEffect as useEffect6, useState as useState4 } from "react";
var BREAKPOINT_NAMES = ["smallphone", "phone", "tablet", "desktop", "widescreen", "ultrawide"];
var BREAKPOINT_MAP = {
  smallphone: TypographyBreakpointsXs,
  phone: TypographyBreakpointsSm,
  tablet: TypographyBreakpointsMd,
  desktop: TypographyBreakpointsLg,
  widescreen: TypographyBreakpointsXl,
  ultrawide: TypographyBreakpointsXxl
};
var transformToInteg = (value) => parseInt(value, 10);
var DEFAULT_BREAKPOINTS = Object.fromEntries(
  BREAKPOINT_NAMES.map((name) => [name, transformToInteg(BREAKPOINT_MAP[name])])
);
var currentBreakpoint = BREAKPOINT_NAMES[0];
var watchers = /* @__PURE__ */ new Set();
var onBreakpointMatch = (breakpoint, matcher) => {
  if (matcher.matches) {
    currentBreakpoint = breakpoint;
    watchers.forEach((cb) => cb(currentBreakpoint));
  }
};
function addBreakpointWatcher(watcher) {
  watchers.add(watcher);
  return removeBreakpointWatcher.bind(null, watcher);
}
function removeBreakpointWatcher(watcher) {
  watchers.delete(watcher);
}
var getMediaQueryForBreakpoint = (breakpoint) => {
  const width = DEFAULT_BREAKPOINTS[breakpoint];
  const nextBreakpoint = BREAKPOINT_NAMES[BREAKPOINT_NAMES.indexOf(breakpoint) + 1];
  const nextWidth = DEFAULT_BREAKPOINTS[nextBreakpoint];
  return nextWidth ? `(min-width: ${width}px) and (max-width: ${nextWidth}px)` : `(min-width: ${width}px)`;
};
var BREAKPOINT_MATCHERS = BREAKPOINT_NAMES.reduce(
  (result, breakpoint) => {
    if (isServer3()) {
      return result;
    }
    const matcher = matchMedia?.(getMediaQueryForBreakpoint(breakpoint));
    if (matcher.matches) {
      currentBreakpoint = breakpoint;
    }
    const listener = () => onBreakpointMatch(breakpoint, matcher);
    matcher.addEventListener ? matcher.addEventListener("change", listener) : matcher.addListener(listener);
    result[breakpoint] = matcher;
    return result;
  },
  {}
);
var useBreakpoint = (opts) => {
  const [breakpoint, setBreakpoint] = useState4(opts?.serverBreakpoint || null);
  useEffect6(() => {
    addBreakpointWatcher(setBreakpoint);
    () => removeBreakpointWatcher(setBreakpoint);
  }, []);
  useEffect6(() => {
    setBreakpoint(currentBreakpoint);
  }, []);
  return breakpoint;
};
var useIsBreakpoint = (...breakpoints) => {
  const breakpoint = useBreakpoint();
  const [isBreakpoint, setIsBreakpoint] = useState4(null);
  useEffect6(() => {
    if (breakpoint) {
      setIsBreakpoint(breakpoints.includes(breakpoint));
    }
  }, [breakpoints, breakpoint]);
  return isBreakpoint;
};
var useIsMobile = () => {
  const breakpoint = useBreakpoint();
  const [isMobile, setIsMobile] = useState4(null);
  useEffect6(() => {
    if (breakpoint) {
      setIsMobile(breakpoint === "smallphone" || breakpoint === "phone");
    }
  }, [breakpoint]);
  return isMobile;
};

// ../../i18n/dist/esm/hooks/useLocale.js
import { useContext as useContext3 } from "react";

// ../../i18n/dist/esm/providers/I18NProvider/I18NContext.js
import { createContext as createContext2 } from "react";
var I18NContext = createContext2(
  void 0
);

// ../../i18n/dist/esm/utils/constants.js
var DEFAULT_LOCALE = "en-US";
var RTL_LANGUAGES = /* @__PURE__ */ new Set(["ar"]);
var SUPPORTED_LOCALES = /* @__PURE__ */ new Set([
  "ar-SA",
  "de-DE",
  "en-US",
  "es-ES",
  "fr-FR",
  "ja-JP",
  "id-ID",
  "it-IT",
  "ko-KR",
  "pt-BR",
  "ru-RU",
  "th-TH",
  "tr-TR",
  "vi-VN",
  "zh-CN",
  "zh-TW"
]);
var SUPPORTED_LANGUAGES = [
  {
    code: "ar-SA",
    name: "\u0639\u0631\u0628\u064A"
  },
  {
    code: "id-ID",
    name: "Bahasa Indonesia"
  },
  {
    code: "de-DE",
    name: "Deutsch"
  },
  {
    code: "en-US",
    name: "English"
  },
  {
    code: "es-ES",
    name: "Espa\xF1ol"
  },
  {
    code: "fr-FR",
    name: "Fran\xE7ais"
  },
  {
    code: "it-IT",
    name: "Italiano"
  },
  {
    code: "pt-BR",
    name: "Portugu\xEAs"
  },
  {
    code: "vi-VN",
    name: "Ti\u1EBFng Vi\u1EC7t"
  },
  {
    code: "tr-TR",
    name: "T\xFCrk\xE7e"
  },
  {
    code: "ru-RU",
    name: "\u03A1\u0443\u0441\u0441\u043A\u0438\u0439"
  },
  {
    code: "th-TH",
    name: "\u0E44\u0E17\u0E22"
  },
  {
    code: "ja-JP",
    name: "\u65E5\u672C\u8A9E"
  },
  {
    code: "ko-KR",
    name: "\uD55C\uAD6D\uC5B4"
  },
  {
    code: "zh-CN",
    name: "\u4E2D\u6587 (\u7B80\u4F53)"
  },
  {
    code: "zh-TW",
    name: "\u4E2D\u6587 (\u7E41\u9AD4)"
  }
];

// ../../i18n/dist/esm/utils/filterLanguage.js
var filterLanguageOptions = (availableLanguages) => {
  if (!availableLanguages) {
    return SUPPORTED_LANGUAGES;
  }
  const setOflanguages = new Set(availableLanguages);
  return SUPPORTED_LANGUAGES.filter((language) => setOflanguages.has(language.code));
};

// ../../i18n/dist/esm/utils/flattenTree.js
var flattenTree = (dict, prefix = "") => {
  const flatted = {};
  for (const key in dict) {
    const prefixedKey = prefix ? `${prefix}.${key}` : key;
    if (typeof dict[key] === "object") {
      const nested = flattenTree(dict[key], prefixedKey);
      for (const k in nested) {
        if (flatted[k] !== void 0) {
          throw new Error(`Duplicate key ${k} in ${prefixedKey}`);
        }
        flatted[k] = nested[k];
      }
    } else {
      flatted[prefixedKey] = dict[key];
    }
  }
  return flatted;
};
var flattenLocaleTree = (dict) => {
  const flatted = {};
  for (const phrase in dict) {
    flatted[phrase] = flattenTree(dict[phrase]);
  }
  return flatted;
};

// ../../i18n/dist/esm/utils/locales.js
var localeToLanguage = (locale) => {
  const specialCases = {
    "zh-CN": "cn",
    "zh-TW": "tw",
    "ja-JP": "jp"
  };
  return specialCases[locale] ?? locale.substring(0, 2);
};

// ../../i18n/dist/esm/utils/plurals.js
var getPlural = (count2, locale) => {
  if (typeof Intl === "object" && typeof Intl.PluralRules === "function") {
    return new Intl.PluralRules(locale).select(count2);
  }
  return count2 === 0 ? "zero" : count2 === 1 ? "one" : "other";
};

// ../../i18n/dist/esm/hooks/useLocale.js
var useLocale = () => {
  const ctx = useContext3(I18NContext);
  return ctx?.locale ?? DEFAULT_LOCALE;
};

// ../../i18n/dist/esm/hooks/useTranslate.js
import { interpolate, translate } from "@amzn/aws-marketing-experience-builder-template-helpers";
import { useCallback as useCallback5 } from "react";
var useTranslate = (translations, options) => {
  const localeOverride = options?.locale;
  const localeFromContext = useLocale();
  const locale = localeOverride ?? localeFromContext;
  const translateFunc = useCallback5(
    (translationKey, config = {}) => {
      let langKey = locale;
      const { count: count2, useFallback } = config;
      const data = config.data ?? {};
      const langObj = translations[translationKey]?.[locale];
      if (typeof langObj === "object") {
        if (count2 === void 0) {
          throw new Error(`The 'count' option is required for translating '${translationKey}' in ${locale}`);
        }
        const plural = getPlural(count2, locale);
        if (plural === "other") {
          langKey += ".many";
        } else {
          langKey += `.${plural}`;
        }
      }
      const translated = translate(translationKey, flattenLocaleTree(translations), langKey, useFallback ?? false);
      if (count2 !== void 0 && !{}.hasOwnProperty.apply(data, ["count"])) {
        data.count = count2;
      }
      return interpolate(translated, data);
    },
    [locale, translations]
  );
  return { T: translateFunc };
};

// ../../i18n/dist/esm/providers/I18NProvider/I18NProvider.js
import { useContext as useContext4, useMemo as useMemo6 } from "react";
import { Fragment as Fragment2, jsx as jsx25 } from "react/jsx-runtime";
var I18NProvider = ({ children, locale = "en-US" }) => {
  const lang = localeToLanguage(locale);
  const outerContext = useContext4(I18NContext);
  const value = useMemo6(
    () => ({
      lang,
      locale
    }),
    [lang, locale]
  );
  if (outerContext) {
    return /* @__PURE__ */ jsx25(Fragment2, { children });
  }
  return /* @__PURE__ */ jsx25("div", { "data-rg-lang": lang, "data-rg-locale": locale, lang: locale, dir: RTL_LANGUAGES.has(lang) ? "rtl" : "ltr", children: /* @__PURE__ */ jsx25(I18NContext.Provider, { value, children }) });
};

// ../../components/dist/esm/LanguageSelector/LanguageSelector.js
import { forwardRef as forwardRef26, useCallback as useCallback14, useEffect as useEffect21, useState as useState17 } from "react";

// ../../../node_modules/@floating-ui/react/dist/floating-ui.react.mjs
import * as React4 from "react";
import { useLayoutEffect as useLayoutEffect3, useEffect as useEffect9, useRef as useRef7 } from "react";

// ../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle2(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [":popover-open", ":modal"].some((selector) => {
    try {
      return element.matches(selector);
    } catch (e2) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle2(elementOrCss) : elementOrCss;
  return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || ["transform", "perspective", "filter"].some((value) => (css.willChange || "").includes(value)) || ["paint", "layout", "strict", "content"].some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function getComputedStyle2(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

// ../../../node_modules/@floating-ui/react/dist/floating-ui.react.utils.mjs
function activeElement(doc) {
  let activeElement2 = doc.activeElement;
  while (((_activeElement = activeElement2) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null) {
    var _activeElement;
    activeElement2 = activeElement2.shadowRoot.activeElement;
  }
  return activeElement2;
}
function contains(parent, child) {
  if (!parent || !child) {
    return false;
  }
  const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
  if (parent.contains(child)) {
    return true;
  }
  if (rootNode && isShadowRoot(rootNode)) {
    let next = child;
    while (next) {
      if (parent === next) {
        return true;
      }
      next = next.parentNode || next.host;
    }
  }
  return false;
}
function getPlatform() {
  const uaData = navigator.userAgentData;
  if (uaData != null && uaData.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
function getUserAgent() {
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    return uaData.brands.map((_ref) => {
      let {
        brand,
        version
      } = _ref;
      return brand + "/" + version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isVirtualClick(event) {
  if (event.mozInputSource === 0 && event.isTrusted) {
    return true;
  }
  if (isAndroid() && event.pointerType) {
    return event.type === "click" && event.buttons === 1;
  }
  return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
  if (isJSDOM()) return false;
  return !isAndroid() && event.width === 0 && event.height === 0 || isAndroid() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function isSafari() {
  return /apple/i.test(navigator.vendor);
}
function isAndroid() {
  const re = /android/i;
  return re.test(getPlatform()) || re.test(getUserAgent());
}
function isMac() {
  return getPlatform().toLowerCase().startsWith("mac") && !navigator.maxTouchPoints;
}
function isJSDOM() {
  return getUserAgent().includes("jsdom/");
}
function isMouseLikePointerType(pointerType, strict) {
  const values = ["mouse", "pen"];
  if (!strict) {
    values.push("", void 0);
  }
  return values.includes(pointerType);
}
function isReactEvent(event) {
  return "nativeEvent" in event;
}
function isRootElement(element) {
  return element.matches("html,body");
}
function getDocument(node) {
  return (node == null ? void 0 : node.ownerDocument) || document;
}
function isEventTargetWithin(event, node) {
  if (node == null) {
    return false;
  }
  if ("composedPath" in event) {
    return event.composedPath().includes(node);
  }
  const e2 = event;
  return e2.target != null && node.contains(e2.target);
}
function getTarget(event) {
  if ("composedPath" in event) {
    return event.composedPath()[0];
  }
  return event.target;
}
var TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function isTypeableElement(element) {
  return isHTMLElement(element) && element.matches(TYPEABLE_SELECTOR);
}
function stopEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
function isTypeableCombobox(element) {
  if (!element) return false;
  return element.getAttribute("role") === "combobox" && isTypeableElement(element);
}

// ../../../node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
var sides = ["top", "right", "bottom", "left"];
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = (v) => ({
  x: v,
  y: v
});
var oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
var oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case "left":
    case "right":
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

// ../../../node_modules/tabbable/dist/index.esm.js
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
  var _element$getRootNode;
  return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
  return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
var isInert = function isInert2(node, lookUp) {
  var _node$getAttribute;
  if (lookUp === void 0) {
    lookUp = true;
  }
  var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, "inert");
  var inert = inertAtt === "" || inertAtt === "true";
  var result = inert || lookUp && node && isInert2(node.parentNode);
  return result;
};
var isContentEditable = function isContentEditable2(node) {
  var _node$getAttribute2;
  var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, "contenteditable");
  return attValue === "" || attValue === "true";
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
  if (isInert(el)) {
    return [];
  }
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }
  candidates = candidates.filter(filter);
  return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);
  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();
    if (isInert(element, false)) {
      continue;
    }
    if (element.tagName === "SLOT") {
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively2(content, true, options);
      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scopeParent: element,
          candidates: nestedCandidates
        });
      }
    } else {
      var validCandidate = matches.call(element, candidateSelector);
      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      }
      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
      var validShadowRoot = !isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
      if (shadowRoot && validShadowRoot) {
        var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scopeParent: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }
  return candidates;
};
var hasTabIndex = function hasTabIndex2(node) {
  return !isNaN(parseInt(node.getAttribute("tabindex"), 10));
};
var getTabIndex = function getTabIndex2(node) {
  if (!node) {
    throw new Error("No node provided");
  }
  if (node.tabIndex < 0) {
    if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || isContentEditable(node)) && !hasTabIndex(node)) {
      return 0;
    }
  }
  return node.tabIndex;
};
var getSortOrderTabIndex = function getSortOrderTabIndex2(node, isScope) {
  var tabIndex = getTabIndex(node);
  if (tabIndex < 0 && isScope && !hasTabIndex(node)) {
    return 0;
  }
  return tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
  return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
  return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
  var r3 = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
    return child.tagName === "SUMMARY";
  });
  return r3;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
  for (var i2 = 0; i2 < nodes.length; i2++) {
    if (nodes[i2].checked && nodes[i2].form === form) {
      return nodes[i2];
    }
  }
};
var isTabbableRadio = function isTabbableRadio2(node) {
  if (!node.name) {
    return true;
  }
  var radioScope = node.form || getRootNode(node);
  var queryRadios = function queryRadios2(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };
  var radioSet;
  if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
      return false;
    }
  }
  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
  return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
  return isRadio(node) && !isTabbableRadio(node);
};
var isNodeAttached = function isNodeAttached2(node) {
  var _nodeRoot;
  var nodeRoot = node && getRootNode(node);
  var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
  var attached = false;
  if (nodeRoot && nodeRoot !== node) {
    var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
    attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
    while (!attached && nodeRootHost) {
      var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
      nodeRoot = getRootNode(nodeRootHost);
      nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
      attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
    }
  }
  return attached;
};
var isZeroArea = function isZeroArea2(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
  return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
  var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
  if (getComputedStyle(node).visibility === "hidden") {
    return true;
  }
  var isDirectSummary = matches.call(node, "details>summary:first-of-type");
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
  if (matches.call(nodeUnderDetails, "details:not([open]) *")) {
    return true;
  }
  if (!displayCheck || displayCheck === "full" || displayCheck === "legacy-full") {
    if (typeof getShadowRoot === "function") {
      var originalNode = node;
      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);
        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) {
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          node = rootNode.host;
        } else {
          node = parentElement;
        }
      }
      node = originalNode;
    }
    if (isNodeAttached(node)) {
      return !node.getClientRects().length;
    }
    if (displayCheck !== "legacy-full") {
      return true;
    }
  } else if (displayCheck === "non-zero-area") {
    return isZeroArea(node);
  }
  return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement;
    while (parentNode) {
      if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
        for (var i2 = 0; i2 < parentNode.children.length; i2++) {
          var child = parentNode.children.item(i2);
          if (child.tagName === "LEGEND") {
            return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
          }
        }
        return true;
      }
      parentNode = parentNode.parentElement;
    }
  }
  return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
  if (node.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  isInert(node) || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }
  return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
  if (isNonTabbableRadio(node) || getTabIndex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }
  return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  }
  return false;
};
var sortByOrder = function sortByOrder2(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function(item, i2) {
    var isScope = !!item.scopeParent;
    var element = isScope ? item.scopeParent : item;
    var candidateTabindex = getSortOrderTabIndex(element, isScope);
    var elements = isScope ? sortByOrder2(item.candidates) : element;
    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i2,
        tabIndex: candidateTabindex,
        item,
        isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(container, options) {
  options = options || {};
  var candidates;
  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([container], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(container, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }
  return sortByOrder(candidates);
};
var isTabbable = function isTabbable2(node, options) {
  options = options || {};
  if (!node) {
    throw new Error("No node provided");
  }
  if (matches.call(node, candidateSelector) === false) {
    return false;
  }
  return isNodeMatchingSelectorTabbable(options, node);
};

// ../../../node_modules/@floating-ui/react/dist/floating-ui.react.mjs
import * as ReactDOM2 from "react-dom";

// ../../../node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
var computePosition = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name,
      fn
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
var arrow = (options) => ({
  name: "arrow",
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state;
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$1 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset4 = clamp(min$1, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset4 && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset4,
        centerOffset: center - offset4 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
var flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d) => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d) => [d.placement, d.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides.some((side) => overflow[side] >= 0);
}
var hide = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "hide",
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = "referenceHidden",
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case "referenceHidden": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            elementContext: "reference"
          });
          const offsets = getSideOffsets(overflow, rects.reference);
          return {
            data: {
              referenceHiddenOffsets: offsets,
              referenceHidden: isAnySideFullyClipped(offsets)
            }
          };
        }
        case "escaped": {
          const overflow = await detectOverflow(state, {
            ...detectOverflowOptions,
            altBoundary: true
          });
          const offsets = getSideOffsets(overflow, rects.floating);
          return {
            data: {
              escapedOffsets: offsets,
              escaped: isAnySideFullyClipped(offsets)
            }
          };
        }
        default: {
          return {};
        }
      }
    }
  };
};
async function convertValueToCoords(state, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
var offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
var shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x2,
              y: y2
            } = _ref;
            return {
              x: x2,
              y: y2
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
var size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

// ../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
  const css = getComputedStyle2(element);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;
  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle2(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX(documentElement, htmlRect)
  ));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element) {
  return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle2(body).direction === "rtl") {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle2(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle2(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle2(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      result = result.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element) {
  return getComputedStyle2(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle2(element).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element) {
  return getComputedStyle2(element).direction === "rtl";
}
var platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};
function observeMove(element, onMove) {
  let io = null;
  let timeoutId2;
  const root = getDocumentElement(element);
  function cleanup2() {
    var _io;
    clearTimeout(timeoutId2);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup2();
    const {
      left,
      top,
      width,
      height
    } = element.getBoundingClientRect();
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId2 = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      isFirstUpdate = false;
    }
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e2) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup2;
}
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
var offset2 = offset;
var shift2 = shift;
var flip2 = flip;
var size2 = size;
var hide2 = hide;
var arrow2 = arrow;
var computePosition2 = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

// ../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
import * as React3 from "react";
import { useLayoutEffect as useLayoutEffect2, useEffect as useEffect7 } from "react";
import * as ReactDOM from "react-dom";
var index = typeof document !== "undefined" ? useLayoutEffect2 : useEffect7;
function deepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (typeof a === "function" && a.toString() === b.toString()) {
    return true;
  }
  let length;
  let i2;
  let keys;
  if (a && b && typeof a === "object") {
    if (Array.isArray(a)) {
      length = a.length;
      if (length !== b.length) return false;
      for (i2 = length; i2-- !== 0; ) {
        if (!deepEqual(a[i2], b[i2])) {
          return false;
        }
      }
      return true;
    }
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) {
      return false;
    }
    for (i2 = length; i2-- !== 0; ) {
      if (!{}.hasOwnProperty.call(b, keys[i2])) {
        return false;
      }
    }
    for (i2 = length; i2-- !== 0; ) {
      const key = keys[i2];
      if (key === "_owner" && a.$$typeof) {
        continue;
      }
      if (!deepEqual(a[key], b[key])) {
        return false;
      }
    }
    return true;
  }
  return a !== a && b !== b;
}
function getDPR(element) {
  if (typeof window === "undefined") {
    return 1;
  }
  const win = element.ownerDocument.defaultView || window;
  return win.devicePixelRatio || 1;
}
function roundByDPR(element, value) {
  const dpr = getDPR(element);
  return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
  const ref = React3.useRef(value);
  index(() => {
    ref.current = value;
  });
  return ref;
}
function useFloating(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2,
    elements: {
      reference: externalReference,
      floating: externalFloating
    } = {},
    transform = true,
    whileElementsMounted,
    open
  } = options;
  const [data, setData] = React3.useState({
    x: 0,
    y: 0,
    strategy,
    placement,
    middlewareData: {},
    isPositioned: false
  });
  const [latestMiddleware, setLatestMiddleware] = React3.useState(middleware);
  if (!deepEqual(latestMiddleware, middleware)) {
    setLatestMiddleware(middleware);
  }
  const [_reference, _setReference] = React3.useState(null);
  const [_floating, _setFloating] = React3.useState(null);
  const setReference = React3.useCallback((node) => {
    if (node !== referenceRef.current) {
      referenceRef.current = node;
      _setReference(node);
    }
  }, []);
  const setFloating = React3.useCallback((node) => {
    if (node !== floatingRef.current) {
      floatingRef.current = node;
      _setFloating(node);
    }
  }, []);
  const referenceEl = externalReference || _reference;
  const floatingEl = externalFloating || _floating;
  const referenceRef = React3.useRef(null);
  const floatingRef = React3.useRef(null);
  const dataRef = React3.useRef(data);
  const hasWhileElementsMounted = whileElementsMounted != null;
  const whileElementsMountedRef = useLatestRef(whileElementsMounted);
  const platformRef = useLatestRef(platform2);
  const openRef = useLatestRef(open);
  const update = React3.useCallback(() => {
    if (!referenceRef.current || !floatingRef.current) {
      return;
    }
    const config = {
      placement,
      strategy,
      middleware: latestMiddleware
    };
    if (platformRef.current) {
      config.platform = platformRef.current;
    }
    computePosition2(referenceRef.current, floatingRef.current, config).then((data2) => {
      const fullData = {
        ...data2,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: openRef.current !== false
      };
      if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
        dataRef.current = fullData;
        ReactDOM.flushSync(() => {
          setData(fullData);
        });
      }
    });
  }, [latestMiddleware, placement, strategy, platformRef, openRef]);
  index(() => {
    if (open === false && dataRef.current.isPositioned) {
      dataRef.current.isPositioned = false;
      setData((data2) => ({
        ...data2,
        isPositioned: false
      }));
    }
  }, [open]);
  const isMountedRef = React3.useRef(false);
  index(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  index(() => {
    if (referenceEl) referenceRef.current = referenceEl;
    if (floatingEl) floatingRef.current = floatingEl;
    if (referenceEl && floatingEl) {
      if (whileElementsMountedRef.current) {
        return whileElementsMountedRef.current(referenceEl, floatingEl, update);
      }
      update();
    }
  }, [referenceEl, floatingEl, update, whileElementsMountedRef, hasWhileElementsMounted]);
  const refs = React3.useMemo(() => ({
    reference: referenceRef,
    floating: floatingRef,
    setReference,
    setFloating
  }), [setReference, setFloating]);
  const elements = React3.useMemo(() => ({
    reference: referenceEl,
    floating: floatingEl
  }), [referenceEl, floatingEl]);
  const floatingStyles = React3.useMemo(() => {
    const initialStyles = {
      position: strategy,
      left: 0,
      top: 0
    };
    if (!elements.floating) {
      return initialStyles;
    }
    const x = roundByDPR(elements.floating, data.x);
    const y = roundByDPR(elements.floating, data.y);
    if (transform) {
      return {
        ...initialStyles,
        transform: "translate(" + x + "px, " + y + "px)",
        ...getDPR(elements.floating) >= 1.5 && {
          willChange: "transform"
        }
      };
    }
    return {
      position: strategy,
      left: x,
      top: y
    };
  }, [strategy, transform, elements.floating, data.x, data.y]);
  return React3.useMemo(() => ({
    ...data,
    update,
    refs,
    elements,
    floatingStyles
  }), [data, update, refs, elements, floatingStyles]);
}
var arrow$1 = (options) => {
  function isRef(value) {
    return {}.hasOwnProperty.call(value, "current");
  }
  return {
    name: "arrow",
    options,
    fn(state) {
      const {
        element,
        padding
      } = typeof options === "function" ? options(state) : options;
      if (element && isRef(element)) {
        if (element.current != null) {
          return arrow2({
            element: element.current,
            padding
          }).fn(state);
        }
        return {};
      }
      if (element) {
        return arrow2({
          element,
          padding
        }).fn(state);
      }
      return {};
    }
  };
};
var offset3 = (options, deps) => ({
  ...offset2(options),
  options: [options, deps]
});
var shift3 = (options, deps) => ({
  ...shift2(options),
  options: [options, deps]
});
var flip3 = (options, deps) => ({
  ...flip2(options),
  options: [options, deps]
});
var size3 = (options, deps) => ({
  ...size2(options),
  options: [options, deps]
});
var hide3 = (options, deps) => ({
  ...hide2(options),
  options: [options, deps]
});
var arrow3 = (options, deps) => ({
  ...arrow$1(options),
  options: [options, deps]
});

// ../../../node_modules/@floating-ui/react/dist/floating-ui.react.mjs
var SafeReact = {
  ...React4
};
var useInsertionEffect = SafeReact.useInsertionEffect;
var useSafeInsertionEffect = useInsertionEffect || ((fn) => fn());
function useEffectEvent(callback) {
  const ref = React4.useRef(() => {
    if (true) {
      throw new Error("Cannot call an event handler while rendering.");
    }
  });
  useSafeInsertionEffect(() => {
    ref.current = callback;
  });
  return React4.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return ref.current == null ? void 0 : ref.current(...args);
  }, []);
}
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
function isDifferentRow(index3, cols, prevRow) {
  return Math.floor(index3 / cols) !== prevRow;
}
function isIndexOutOfBounds(listRef, index3) {
  return index3 < 0 || index3 >= listRef.current.length;
}
function getMinIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    disabledIndices
  });
}
function getMaxIndex(listRef, disabledIndices) {
  return findNonDisabledIndex(listRef, {
    decrement: true,
    startingIndex: listRef.current.length,
    disabledIndices
  });
}
function findNonDisabledIndex(listRef, _temp) {
  let {
    startingIndex = -1,
    decrement = false,
    disabledIndices,
    amount = 1
  } = _temp === void 0 ? {} : _temp;
  const list = listRef.current;
  let index3 = startingIndex;
  do {
    index3 += decrement ? -amount : amount;
  } while (index3 >= 0 && index3 <= list.length - 1 && isDisabled(list, index3, disabledIndices));
  return index3;
}
function getGridNavigatedIndex(elementsRef, _ref) {
  let {
    event,
    orientation,
    loop,
    rtl,
    cols,
    disabledIndices,
    minIndex,
    maxIndex,
    prevIndex,
    stopEvent: stop = false
  } = _ref;
  let nextIndex = prevIndex;
  if (event.key === ARROW_UP) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = maxIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: nextIndex,
        amount: cols,
        decrement: true,
        disabledIndices
      });
      if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
        const col = prevIndex % cols;
        const maxCol = maxIndex % cols;
        const offset4 = maxIndex - (maxCol - col);
        if (maxCol === col) {
          nextIndex = maxIndex;
        } else {
          nextIndex = maxCol > col ? offset4 : offset4 - cols;
        }
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (event.key === ARROW_DOWN) {
    stop && stopEvent(event);
    if (prevIndex === -1) {
      nextIndex = minIndex;
    } else {
      nextIndex = findNonDisabledIndex(elementsRef, {
        startingIndex: prevIndex,
        amount: cols,
        disabledIndices
      });
      if (loop && prevIndex + cols > maxIndex) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex % cols - cols,
          amount: cols,
          disabledIndices
        });
      }
    }
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      nextIndex = prevIndex;
    }
  }
  if (orientation === "both") {
    const prevRow = floor(prevIndex / cols);
    if (event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== cols - 1) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex - prevIndex % cols - 1,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    if (event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT)) {
      stop && stopEvent(event);
      if (prevIndex % cols !== 0) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex,
          decrement: true,
          disabledIndices
        });
        if (loop && isDifferentRow(nextIndex, cols, prevRow)) {
          nextIndex = findNonDisabledIndex(elementsRef, {
            startingIndex: prevIndex + (cols - prevIndex % cols),
            decrement: true,
            disabledIndices
          });
        }
      } else if (loop) {
        nextIndex = findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex + (cols - prevIndex % cols),
          decrement: true,
          disabledIndices
        });
      }
      if (isDifferentRow(nextIndex, cols, prevRow)) {
        nextIndex = prevIndex;
      }
    }
    const lastRow = floor(maxIndex / cols) === prevRow;
    if (isIndexOutOfBounds(elementsRef, nextIndex)) {
      if (loop && lastRow) {
        nextIndex = event.key === (rtl ? ARROW_RIGHT : ARROW_LEFT) ? maxIndex : findNonDisabledIndex(elementsRef, {
          startingIndex: prevIndex - prevIndex % cols - 1,
          disabledIndices
        });
      } else {
        nextIndex = prevIndex;
      }
    }
  }
  return nextIndex;
}
function buildCellMap(sizes, cols, dense) {
  const cellMap = [];
  let startIndex = 0;
  sizes.forEach((_ref2, index3) => {
    let {
      width,
      height
    } = _ref2;
    if (width > cols) {
      if (true) {
        throw new Error("[Floating UI]: Invalid grid - item width at index " + index3 + " is greater than grid columns");
      }
    }
    let itemPlaced = false;
    if (dense) {
      startIndex = 0;
    }
    while (!itemPlaced) {
      const targetCells = [];
      for (let i2 = 0; i2 < width; i2++) {
        for (let j = 0; j < height; j++) {
          targetCells.push(startIndex + i2 + j * cols);
        }
      }
      if (startIndex % cols + width <= cols && targetCells.every((cell) => cellMap[cell] == null)) {
        targetCells.forEach((cell) => {
          cellMap[cell] = index3;
        });
        itemPlaced = true;
      } else {
        startIndex++;
      }
    }
  });
  return [...cellMap];
}
function getCellIndexOfCorner(index3, sizes, cellMap, cols, corner) {
  if (index3 === -1) return -1;
  const firstCellIndex = cellMap.indexOf(index3);
  const sizeItem = sizes[index3];
  switch (corner) {
    case "tl":
      return firstCellIndex;
    case "tr":
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + sizeItem.width - 1;
    case "bl":
      if (!sizeItem) {
        return firstCellIndex;
      }
      return firstCellIndex + (sizeItem.height - 1) * cols;
    case "br":
      return cellMap.lastIndexOf(index3);
  }
}
function getCellIndices(indices, cellMap) {
  return cellMap.flatMap((index3, cellIndex) => indices.includes(index3) ? [cellIndex] : []);
}
function isDisabled(list, index3, disabledIndices) {
  if (disabledIndices) {
    return disabledIndices.includes(index3);
  }
  const element = list[index3];
  return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
var index2 = typeof document !== "undefined" ? useLayoutEffect3 : useEffect9;
var horizontalKeys = [ARROW_LEFT, ARROW_RIGHT];
var verticalKeys = [ARROW_UP, ARROW_DOWN];
var allKeys = [...horizontalKeys, ...verticalKeys];
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var serverHandoffComplete = false;
var count = 0;
var genId = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + count++
);
function useFloatingId() {
  const [id, setId] = React4.useState(() => serverHandoffComplete ? genId() : void 0);
  index2(() => {
    if (id == null) {
      setId(genId());
    }
  }, []);
  React4.useEffect(() => {
    serverHandoffComplete = true;
  }, []);
  return id;
}
var useReactId = SafeReact.useId;
var useId = useReactId || useFloatingId;
var devMessageSet;
if (true) {
  devMessageSet = /* @__PURE__ */ new Set();
}
function warn() {
  var _devMessageSet;
  for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }
  const message = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet = devMessageSet) != null && _devMessageSet.has(message))) {
    var _devMessageSet2;
    (_devMessageSet2 = devMessageSet) == null || _devMessageSet2.add(message);
    console.warn(message);
  }
}
function error() {
  var _devMessageSet3;
  for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    messages[_key2] = arguments[_key2];
  }
  const message = "Floating UI: " + messages.join(" ");
  if (!((_devMessageSet3 = devMessageSet) != null && _devMessageSet3.has(message))) {
    var _devMessageSet4;
    (_devMessageSet4 = devMessageSet) == null || _devMessageSet4.add(message);
    console.error(message);
  }
}
var FloatingArrow = /* @__PURE__ */ React4.forwardRef(function FloatingArrow2(props, ref) {
  const {
    context: {
      placement,
      elements: {
        floating
      },
      middlewareData: {
        arrow: arrow4,
        shift: shift4
      }
    },
    width = 14,
    height = 7,
    tipRadius = 0,
    strokeWidth = 0,
    staticOffset,
    stroke,
    d,
    style: {
      transform,
      ...restStyle
    } = {},
    ...rest
  } = props;
  if (true) {
    if (!ref) {
      warn("The `ref` prop is required for `FloatingArrow`.");
    }
  }
  const clipPathId = useId();
  const [isRTL2, setIsRTL] = React4.useState(false);
  index2(() => {
    if (!floating) return;
    const isRTL3 = getComputedStyle2(floating).direction === "rtl";
    if (isRTL3) {
      setIsRTL(true);
    }
  }, [floating]);
  if (!floating) {
    return null;
  }
  const [side, alignment] = placement.split("-");
  const isVerticalSide = side === "top" || side === "bottom";
  let computedStaticOffset = staticOffset;
  if (isVerticalSide && shift4 != null && shift4.x || !isVerticalSide && shift4 != null && shift4.y) {
    computedStaticOffset = null;
  }
  const computedStrokeWidth = strokeWidth * 2;
  const halfStrokeWidth = computedStrokeWidth / 2;
  const svgX = width / 2 * (tipRadius / -8 + 1);
  const svgY = height / 2 * tipRadius / 4;
  const isCustomShape = !!d;
  const yOffsetProp = computedStaticOffset && alignment === "end" ? "bottom" : "top";
  let xOffsetProp = computedStaticOffset && alignment === "end" ? "right" : "left";
  if (computedStaticOffset && isRTL2) {
    xOffsetProp = alignment === "end" ? "left" : "right";
  }
  const arrowX = (arrow4 == null ? void 0 : arrow4.x) != null ? computedStaticOffset || arrow4.x : "";
  const arrowY = (arrow4 == null ? void 0 : arrow4.y) != null ? computedStaticOffset || arrow4.y : "";
  const dValue = d || "M0,0" + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + " Z";
  const rotation = {
    top: isCustomShape ? "rotate(180deg)" : "",
    left: isCustomShape ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: isCustomShape ? "" : "rotate(180deg)",
    right: isCustomShape ? "rotate(-90deg)" : "rotate(90deg)"
  }[side];
  return /* @__PURE__ */ React4.createElement("svg", _extends({}, rest, {
    "aria-hidden": true,
    ref,
    width: isCustomShape ? width : width + computedStrokeWidth,
    height: width,
    viewBox: "0 0 " + width + " " + (height > width ? height : width),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [xOffsetProp]: arrowX,
      [yOffsetProp]: arrowY,
      [side]: isVerticalSide || isCustomShape ? "100%" : "calc(100% - " + computedStrokeWidth / 2 + "px)",
      transform: [rotation, transform].filter((t2) => !!t2).join(" "),
      ...restStyle
    }
  }), computedStrokeWidth > 0 && /* @__PURE__ */ React4.createElement("path", {
    clipPath: "url(#" + clipPathId + ")",
    fill: "none",
    stroke,
    strokeWidth: computedStrokeWidth + (d ? 0 : 1),
    d: dValue
  }), /* @__PURE__ */ React4.createElement("path", {
    stroke: computedStrokeWidth && !d ? rest.fill : "none",
    d: dValue
  }), /* @__PURE__ */ React4.createElement("clipPath", {
    id: clipPathId
  }, /* @__PURE__ */ React4.createElement("rect", {
    x: -halfStrokeWidth,
    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
    width: width + computedStrokeWidth,
    height: width
  })));
});
function createPubSub() {
  const map = /* @__PURE__ */ new Map();
  return {
    emit(event, data) {
      var _map$get;
      (_map$get = map.get(event)) == null || _map$get.forEach((handler) => handler(data));
    },
    on(event, listener) {
      map.set(event, [...map.get(event) || [], listener]);
    },
    off(event, listener) {
      var _map$get2;
      map.set(event, ((_map$get2 = map.get(event)) == null ? void 0 : _map$get2.filter((l) => l !== listener)) || []);
    }
  };
}
var FloatingNodeContext = /* @__PURE__ */ React4.createContext(null);
var FloatingTreeContext = /* @__PURE__ */ React4.createContext(null);
var useFloatingParentNodeId = () => {
  var _React$useContext;
  return ((_React$useContext = React4.useContext(FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
var useFloatingTree = () => React4.useContext(FloatingTreeContext);
function createAttribute(name) {
  return "data-floating-ui-" + name;
}
function useLatestRef2(value) {
  const ref = useRef7(value);
  index2(() => {
    ref.current = value;
  });
  return ref;
}
var safePolygonIdentifier = /* @__PURE__ */ createAttribute("safe-polygon");
function getDelay(value, prop, pointerType) {
  if (pointerType && !isMouseLikePointerType(pointerType)) {
    return 0;
  }
  if (typeof value === "number") {
    return value;
  }
  return value == null ? void 0 : value[prop];
}
function useHover(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    events,
    elements
  } = context;
  const {
    enabled = true,
    delay = 0,
    handleClose = null,
    mouseOnly = false,
    restMs = 0,
    move = true
  } = props;
  const tree = useFloatingTree();
  const parentId = useFloatingParentNodeId();
  const handleCloseRef = useLatestRef2(handleClose);
  const delayRef = useLatestRef2(delay);
  const openRef = useLatestRef2(open);
  const pointerTypeRef = React4.useRef();
  const timeoutRef = React4.useRef(-1);
  const handlerRef = React4.useRef();
  const restTimeoutRef = React4.useRef(-1);
  const blockMouseMoveRef = React4.useRef(true);
  const performedPointerEventsMutationRef = React4.useRef(false);
  const unbindMouseMoveRef = React4.useRef(() => {
  });
  const restTimeoutPendingRef = React4.useRef(false);
  const isHoverOpen = React4.useCallback(() => {
    var _dataRef$current$open;
    const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
    return (type == null ? void 0 : type.includes("mouse")) && type !== "mousedown";
  }, [dataRef]);
  React4.useEffect(() => {
    if (!enabled) return;
    function onOpenChange2(_ref) {
      let {
        open: open2
      } = _ref;
      if (!open2) {
        clearTimeout(timeoutRef.current);
        clearTimeout(restTimeoutRef.current);
        blockMouseMoveRef.current = true;
        restTimeoutPendingRef.current = false;
      }
    }
    events.on("openchange", onOpenChange2);
    return () => {
      events.off("openchange", onOpenChange2);
    };
  }, [enabled, events]);
  React4.useEffect(() => {
    if (!enabled) return;
    if (!handleCloseRef.current) return;
    if (!open) return;
    function onLeave(event) {
      if (isHoverOpen()) {
        onOpenChange(false, event, "hover");
      }
    }
    const html = getDocument(elements.floating).documentElement;
    html.addEventListener("mouseleave", onLeave);
    return () => {
      html.removeEventListener("mouseleave", onLeave);
    };
  }, [elements.floating, open, onOpenChange, enabled, handleCloseRef, isHoverOpen]);
  const closeWithDelay = React4.useCallback(function(event, runElseBranch, reason) {
    if (runElseBranch === void 0) {
      runElseBranch = true;
    }
    if (reason === void 0) {
      reason = "hover";
    }
    const closeDelay = getDelay(delayRef.current, "close", pointerTypeRef.current);
    if (closeDelay && !handlerRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => onOpenChange(false, event, reason), closeDelay);
    } else if (runElseBranch) {
      clearTimeout(timeoutRef.current);
      onOpenChange(false, event, reason);
    }
  }, [delayRef, onOpenChange]);
  const cleanupMouseMoveHandler = useEffectEvent(() => {
    unbindMouseMoveRef.current();
    handlerRef.current = void 0;
  });
  const clearPointerEvents = useEffectEvent(() => {
    if (performedPointerEventsMutationRef.current) {
      const body = getDocument(elements.floating).body;
      body.style.pointerEvents = "";
      body.removeAttribute(safePolygonIdentifier);
      performedPointerEventsMutationRef.current = false;
    }
  });
  const isClickLikeOpenEvent = useEffectEvent(() => {
    return dataRef.current.openEvent ? ["click", "mousedown"].includes(dataRef.current.openEvent.type) : false;
  });
  React4.useEffect(() => {
    if (!enabled) return;
    function onMouseEnter(event) {
      clearTimeout(timeoutRef.current);
      blockMouseMoveRef.current = false;
      if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current) || restMs > 0 && !getDelay(delayRef.current, "open")) {
        return;
      }
      const openDelay = getDelay(delayRef.current, "open", pointerTypeRef.current);
      if (openDelay) {
        timeoutRef.current = window.setTimeout(() => {
          if (!openRef.current) {
            onOpenChange(true, event, "hover");
          }
        }, openDelay);
      } else if (!open) {
        onOpenChange(true, event, "hover");
      }
    }
    function onMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      unbindMouseMoveRef.current();
      const doc = getDocument(elements.floating);
      clearTimeout(restTimeoutRef.current);
      restTimeoutPendingRef.current = false;
      if (handleCloseRef.current && dataRef.current.floatingContext) {
        if (!open) {
          clearTimeout(timeoutRef.current);
        }
        handlerRef.current = handleCloseRef.current({
          ...dataRef.current.floatingContext,
          tree,
          x: event.clientX,
          y: event.clientY,
          onClose() {
            clearPointerEvents();
            cleanupMouseMoveHandler();
            if (!isClickLikeOpenEvent()) {
              closeWithDelay(event, true, "safe-polygon");
            }
          }
        });
        const handler = handlerRef.current;
        doc.addEventListener("mousemove", handler);
        unbindMouseMoveRef.current = () => {
          doc.removeEventListener("mousemove", handler);
        };
        return;
      }
      const shouldClose = pointerTypeRef.current === "touch" ? !contains(elements.floating, event.relatedTarget) : true;
      if (shouldClose) {
        closeWithDelay(event);
      }
    }
    function onScrollMouseLeave(event) {
      if (isClickLikeOpenEvent()) return;
      if (!dataRef.current.floatingContext) return;
      handleCloseRef.current == null || handleCloseRef.current({
        ...dataRef.current.floatingContext,
        tree,
        x: event.clientX,
        y: event.clientY,
        onClose() {
          clearPointerEvents();
          cleanupMouseMoveHandler();
          if (!isClickLikeOpenEvent()) {
            closeWithDelay(event);
          }
        }
      })(event);
    }
    if (isElement(elements.domReference)) {
      var _elements$floating;
      const ref = elements.domReference;
      open && ref.addEventListener("mouseleave", onScrollMouseLeave);
      (_elements$floating = elements.floating) == null || _elements$floating.addEventListener("mouseleave", onScrollMouseLeave);
      move && ref.addEventListener("mousemove", onMouseEnter, {
        once: true
      });
      ref.addEventListener("mouseenter", onMouseEnter);
      ref.addEventListener("mouseleave", onMouseLeave);
      return () => {
        var _elements$floating2;
        open && ref.removeEventListener("mouseleave", onScrollMouseLeave);
        (_elements$floating2 = elements.floating) == null || _elements$floating2.removeEventListener("mouseleave", onScrollMouseLeave);
        move && ref.removeEventListener("mousemove", onMouseEnter);
        ref.removeEventListener("mouseenter", onMouseEnter);
        ref.removeEventListener("mouseleave", onMouseLeave);
      };
    }
  }, [elements, enabled, context, mouseOnly, restMs, move, closeWithDelay, cleanupMouseMoveHandler, clearPointerEvents, onOpenChange, open, openRef, tree, delayRef, handleCloseRef, dataRef, isClickLikeOpenEvent]);
  index2(() => {
    var _handleCloseRef$curre;
    if (!enabled) return;
    if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && _handleCloseRef$curre.__options.blockPointerEvents && isHoverOpen()) {
      performedPointerEventsMutationRef.current = true;
      const floatingEl = elements.floating;
      if (isElement(elements.domReference) && floatingEl) {
        var _tree$nodesRef$curren;
        const body = getDocument(elements.floating).body;
        body.setAttribute(safePolygonIdentifier, "");
        const ref = elements.domReference;
        const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node) => node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
        if (parentFloating) {
          parentFloating.style.pointerEvents = "";
        }
        body.style.pointerEvents = "none";
        ref.style.pointerEvents = "auto";
        floatingEl.style.pointerEvents = "auto";
        return () => {
          body.style.pointerEvents = "";
          ref.style.pointerEvents = "";
          floatingEl.style.pointerEvents = "";
        };
      }
    }
  }, [enabled, open, parentId, elements, tree, handleCloseRef, isHoverOpen]);
  index2(() => {
    if (!open) {
      pointerTypeRef.current = void 0;
      restTimeoutPendingRef.current = false;
      cleanupMouseMoveHandler();
      clearPointerEvents();
    }
  }, [open, cleanupMouseMoveHandler, clearPointerEvents]);
  React4.useEffect(() => {
    return () => {
      cleanupMouseMoveHandler();
      clearTimeout(timeoutRef.current);
      clearTimeout(restTimeoutRef.current);
      clearPointerEvents();
    };
  }, [enabled, elements.domReference, cleanupMouseMoveHandler, clearPointerEvents]);
  const reference = React4.useMemo(() => {
    function setPointerRef(event) {
      pointerTypeRef.current = event.pointerType;
    }
    return {
      onPointerDown: setPointerRef,
      onPointerEnter: setPointerRef,
      onMouseMove(event) {
        const {
          nativeEvent
        } = event;
        function handleMouseMove() {
          if (!blockMouseMoveRef.current && !openRef.current) {
            onOpenChange(true, nativeEvent, "hover");
          }
        }
        if (mouseOnly && !isMouseLikePointerType(pointerTypeRef.current)) {
          return;
        }
        if (open || restMs === 0) {
          return;
        }
        if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) {
          return;
        }
        clearTimeout(restTimeoutRef.current);
        if (pointerTypeRef.current === "touch") {
          handleMouseMove();
        } else {
          restTimeoutPendingRef.current = true;
          restTimeoutRef.current = window.setTimeout(handleMouseMove, restMs);
        }
      }
    };
  }, [mouseOnly, onOpenChange, open, openRef, restMs]);
  const floating = React4.useMemo(() => ({
    onMouseEnter() {
      clearTimeout(timeoutRef.current);
    },
    onMouseLeave(event) {
      if (!isClickLikeOpenEvent()) {
        closeWithDelay(event.nativeEvent, false);
      }
    }
  }), [closeWithDelay, isClickLikeOpenEvent]);
  return React4.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}
var NOOP = () => {
};
var FloatingDelayGroupContext = /* @__PURE__ */ React4.createContext({
  delay: 0,
  initialDelay: 0,
  timeoutMs: 0,
  currentId: null,
  setCurrentId: NOOP,
  setState: NOOP,
  isInstantPhase: false
});
var useDelayGroupContext = () => React4.useContext(FloatingDelayGroupContext);
function useDelayGroup(context, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    open,
    onOpenChange,
    floatingId
  } = context;
  const {
    id: optionId,
    enabled = true
  } = options;
  const id = optionId != null ? optionId : floatingId;
  const groupContext = useDelayGroupContext();
  const {
    currentId,
    setCurrentId,
    initialDelay,
    setState,
    timeoutMs
  } = groupContext;
  index2(() => {
    if (!enabled) return;
    if (!currentId) return;
    setState({
      delay: {
        open: 1,
        close: getDelay(initialDelay, "close")
      }
    });
    if (currentId !== id) {
      onOpenChange(false);
    }
  }, [enabled, id, onOpenChange, setState, currentId, initialDelay]);
  index2(() => {
    function unset() {
      onOpenChange(false);
      setState({
        delay: initialDelay,
        currentId: null
      });
    }
    if (!enabled) return;
    if (!currentId) return;
    if (!open && currentId === id) {
      if (timeoutMs) {
        const timeout = window.setTimeout(unset, timeoutMs);
        return () => {
          clearTimeout(timeout);
        };
      }
      unset();
    }
  }, [enabled, open, setState, currentId, id, onOpenChange, initialDelay, timeoutMs]);
  index2(() => {
    if (!enabled) return;
    if (setCurrentId === NOOP || !open) return;
    setCurrentId(id);
  }, [enabled, open, setCurrentId, id]);
  return groupContext;
}
var rafId = 0;
function enqueueFocus(el, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    preventScroll = false,
    cancelPrevious = true,
    sync = false
  } = options;
  cancelPrevious && cancelAnimationFrame(rafId);
  const exec = () => el == null ? void 0 : el.focus({
    preventScroll
  });
  if (sync) {
    exec();
  } else {
    rafId = requestAnimationFrame(exec);
  }
}
function getAncestors(nodes, id) {
  var _nodes$find;
  let allAncestors = [];
  let currentParentId = (_nodes$find = nodes.find((node) => node.id === id)) == null ? void 0 : _nodes$find.parentId;
  while (currentParentId) {
    const currentNode = nodes.find((node) => node.id === currentParentId);
    currentParentId = currentNode == null ? void 0 : currentNode.parentId;
    if (currentNode) {
      allAncestors = allAncestors.concat(currentNode);
    }
  }
  return allAncestors;
}
function getChildren(nodes, id) {
  let allChildren = nodes.filter((node) => {
    var _node$context;
    return node.parentId === id && ((_node$context = node.context) == null ? void 0 : _node$context.open);
  });
  let currentChildren = allChildren;
  while (currentChildren.length) {
    currentChildren = nodes.filter((node) => {
      var _currentChildren;
      return (_currentChildren = currentChildren) == null ? void 0 : _currentChildren.some((n2) => {
        var _node$context2;
        return node.parentId === n2.id && ((_node$context2 = node.context) == null ? void 0 : _node$context2.open);
      });
    });
    allChildren = allChildren.concat(currentChildren);
  }
  return allChildren;
}
function getDeepestNode(nodes, id) {
  let deepestNodeId;
  let maxDepth = -1;
  function findDeepest(nodeId, depth) {
    if (depth > maxDepth) {
      deepestNodeId = nodeId;
      maxDepth = depth;
    }
    const children = getChildren(nodes, nodeId);
    children.forEach((child) => {
      findDeepest(child.id, depth + 1);
    });
  }
  findDeepest(id, 0);
  return nodes.find((node) => node.id === deepestNodeId);
}
var counterMap = /* @__PURE__ */ new WeakMap();
var uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
var markerMap = {};
var lockCount$1 = 0;
var supportsInert = () => typeof HTMLElement !== "undefined" && "inert" in HTMLElement.prototype;
var unwrapHost = (node) => node && (node.host || unwrapHost(node.parentNode));
var correctElements = (parent, targets) => targets.map((target) => {
  if (parent.contains(target)) {
    return target;
  }
  const correctedTarget = unwrapHost(target);
  if (parent.contains(correctedTarget)) {
    return correctedTarget;
  }
  return null;
}).filter((x) => x != null);
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
  const markerName = "data-floating-ui-inert";
  const controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
  const avoidElements = correctElements(body, uncorrectedAvoidElements);
  const elementsToKeep = /* @__PURE__ */ new Set();
  const elementsToStop = new Set(avoidElements);
  const hiddenElements = [];
  if (!markerMap[markerName]) {
    markerMap[markerName] = /* @__PURE__ */ new WeakMap();
  }
  const markerCounter = markerMap[markerName];
  avoidElements.forEach(keep);
  deep(body);
  elementsToKeep.clear();
  function keep(el) {
    if (!el || elementsToKeep.has(el)) {
      return;
    }
    elementsToKeep.add(el);
    el.parentNode && keep(el.parentNode);
  }
  function deep(parent) {
    if (!parent || elementsToStop.has(parent)) {
      return;
    }
    [].forEach.call(parent.children, (node) => {
      if (getNodeName(node) === "script") return;
      if (elementsToKeep.has(node)) {
        deep(node);
      } else {
        const attr2 = controlAttribute ? node.getAttribute(controlAttribute) : null;
        const alreadyHidden = attr2 !== null && attr2 !== "false";
        const counterValue = (counterMap.get(node) || 0) + 1;
        const markerValue = (markerCounter.get(node) || 0) + 1;
        counterMap.set(node, counterValue);
        markerCounter.set(node, markerValue);
        hiddenElements.push(node);
        if (counterValue === 1 && alreadyHidden) {
          uncontrolledElementsSet.add(node);
        }
        if (markerValue === 1) {
          node.setAttribute(markerName, "");
        }
        if (!alreadyHidden && controlAttribute) {
          node.setAttribute(controlAttribute, "true");
        }
      }
    });
  }
  lockCount$1++;
  return () => {
    hiddenElements.forEach((element) => {
      const counterValue = (counterMap.get(element) || 0) - 1;
      const markerValue = (markerCounter.get(element) || 0) - 1;
      counterMap.set(element, counterValue);
      markerCounter.set(element, markerValue);
      if (!counterValue) {
        if (!uncontrolledElementsSet.has(element) && controlAttribute) {
          element.removeAttribute(controlAttribute);
        }
        uncontrolledElementsSet.delete(element);
      }
      if (!markerValue) {
        element.removeAttribute(markerName);
      }
    });
    lockCount$1--;
    if (!lockCount$1) {
      counterMap = /* @__PURE__ */ new WeakMap();
      counterMap = /* @__PURE__ */ new WeakMap();
      uncontrolledElementsSet = /* @__PURE__ */ new WeakSet();
      markerMap = {};
    }
  };
}
function markOthers(avoidElements, ariaHidden, inert) {
  if (ariaHidden === void 0) {
    ariaHidden = false;
  }
  if (inert === void 0) {
    inert = false;
  }
  const body = getDocument(avoidElements[0]).body;
  return applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll("[aria-live]"))), body, ariaHidden, inert);
}
var getTabbableOptions = () => ({
  getShadowRoot: true,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver === "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function getTabbableIn(container, direction) {
  const allTabbable = tabbable(container, getTabbableOptions());
  if (direction === "prev") {
    allTabbable.reverse();
  }
  const activeIndex = allTabbable.indexOf(activeElement(getDocument(container)));
  const nextTabbableElements = allTabbable.slice(activeIndex + 1);
  return nextTabbableElements[0];
}
function getNextTabbable() {
  return getTabbableIn(document.body, "next");
}
function getPreviousTabbable() {
  return getTabbableIn(document.body, "prev");
}
function isOutsideEvent(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
  const tabbableElements = tabbable(container, getTabbableOptions());
  tabbableElements.forEach((element) => {
    element.dataset.tabindex = element.getAttribute("tabindex") || "";
    element.setAttribute("tabindex", "-1");
  });
}
function enableFocusInside(container) {
  const elements = container.querySelectorAll("[data-tabindex]");
  elements.forEach((element) => {
    const tabindex = element.dataset.tabindex;
    delete element.dataset.tabindex;
    if (tabindex) {
      element.setAttribute("tabindex", tabindex);
    } else {
      element.removeAttribute("tabindex");
    }
  });
}
var HIDDEN_STYLES = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
var timeoutId;
function setActiveElementOnTab(event) {
  if (event.key === "Tab") {
    event.target;
    clearTimeout(timeoutId);
  }
}
var FocusGuard = /* @__PURE__ */ React4.forwardRef(function FocusGuard2(props, ref) {
  const [role, setRole] = React4.useState();
  index2(() => {
    if (isSafari()) {
      setRole("button");
    }
    document.addEventListener("keydown", setActiveElementOnTab);
    return () => {
      document.removeEventListener("keydown", setActiveElementOnTab);
    };
  }, []);
  const restProps = {
    ref,
    tabIndex: 0,
    // Role is only for VoiceOver
    role,
    "aria-hidden": role ? void 0 : true,
    [createAttribute("focus-guard")]: "",
    style: HIDDEN_STYLES
  };
  return /* @__PURE__ */ React4.createElement("span", _extends({}, props, restProps));
});
var PortalContext = /* @__PURE__ */ React4.createContext(null);
var attr = /* @__PURE__ */ createAttribute("portal");
function useFloatingPortalNode(props) {
  if (props === void 0) {
    props = {};
  }
  const {
    id,
    root
  } = props;
  const uniqueId = useId();
  const portalContext = usePortalContext();
  const [portalNode, setPortalNode] = React4.useState(null);
  const portalNodeRef = React4.useRef(null);
  index2(() => {
    return () => {
      portalNode == null || portalNode.remove();
      queueMicrotask(() => {
        portalNodeRef.current = null;
      });
    };
  }, [portalNode]);
  index2(() => {
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    const existingIdRoot = id ? document.getElementById(id) : null;
    if (!existingIdRoot) return;
    const subRoot = document.createElement("div");
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, "");
    existingIdRoot.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, uniqueId]);
  index2(() => {
    if (root === null) return;
    if (!uniqueId) return;
    if (portalNodeRef.current) return;
    let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
    if (container && !isElement(container)) container = container.current;
    container = container || document.body;
    let idWrapper = null;
    if (id) {
      idWrapper = document.createElement("div");
      idWrapper.id = id;
      container.appendChild(idWrapper);
    }
    const subRoot = document.createElement("div");
    subRoot.id = uniqueId;
    subRoot.setAttribute(attr, "");
    container = idWrapper || container;
    container.appendChild(subRoot);
    portalNodeRef.current = subRoot;
    setPortalNode(subRoot);
  }, [id, root, uniqueId, portalContext]);
  return portalNode;
}
function FloatingPortal(props) {
  const {
    children,
    id,
    root,
    preserveTabOrder = true
  } = props;
  const portalNode = useFloatingPortalNode({
    id,
    root
  });
  const [focusManagerState, setFocusManagerState] = React4.useState(null);
  const beforeOutsideRef = React4.useRef(null);
  const afterOutsideRef = React4.useRef(null);
  const beforeInsideRef = React4.useRef(null);
  const afterInsideRef = React4.useRef(null);
  const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
  const open = focusManagerState == null ? void 0 : focusManagerState.open;
  const shouldRenderGuards = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode)
  );
  React4.useEffect(() => {
    if (!portalNode || !preserveTabOrder || modal) {
      return;
    }
    function onFocus(event) {
      if (portalNode && isOutsideEvent(event)) {
        const focusing = event.type === "focusin";
        const manageFocus = focusing ? enableFocusInside : disableFocusInside;
        manageFocus(portalNode);
      }
    }
    portalNode.addEventListener("focusin", onFocus, true);
    portalNode.addEventListener("focusout", onFocus, true);
    return () => {
      portalNode.removeEventListener("focusin", onFocus, true);
      portalNode.removeEventListener("focusout", onFocus, true);
    };
  }, [portalNode, preserveTabOrder, modal]);
  React4.useEffect(() => {
    if (!portalNode) return;
    if (open) return;
    enableFocusInside(portalNode);
  }, [open, portalNode]);
  return /* @__PURE__ */ React4.createElement(PortalContext.Provider, {
    value: React4.useMemo(() => ({
      preserveTabOrder,
      beforeOutsideRef,
      afterOutsideRef,
      beforeInsideRef,
      afterInsideRef,
      portalNode,
      setFocusManagerState
    }), [preserveTabOrder, portalNode])
  }, shouldRenderGuards && portalNode && /* @__PURE__ */ React4.createElement(FocusGuard, {
    "data-type": "outside",
    ref: beforeOutsideRef,
    onFocus: (event) => {
      if (isOutsideEvent(event, portalNode)) {
        var _beforeInsideRef$curr;
        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
      } else {
        const prevTabbable = getPreviousTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        prevTabbable == null || prevTabbable.focus();
      }
    }
  }), shouldRenderGuards && portalNode && /* @__PURE__ */ React4.createElement("span", {
    "aria-owns": portalNode.id,
    style: HIDDEN_STYLES
  }), portalNode && /* @__PURE__ */ ReactDOM2.createPortal(children, portalNode), shouldRenderGuards && portalNode && /* @__PURE__ */ React4.createElement(FocusGuard, {
    "data-type": "outside",
    ref: afterOutsideRef,
    onFocus: (event) => {
      if (isOutsideEvent(event, portalNode)) {
        var _afterInsideRef$curre;
        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
      } else {
        const nextTabbable = getNextTabbable() || (focusManagerState == null ? void 0 : focusManagerState.refs.domReference.current);
        nextTabbable == null || nextTabbable.focus();
        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null ? void 0 : focusManagerState.onOpenChange(false, event.nativeEvent, "focus-out"));
      }
    }
  }));
}
var usePortalContext = () => React4.useContext(PortalContext);
var FOCUSABLE_ATTRIBUTE = "data-floating-ui-focusable";
function getFloatingFocusElement(floatingElement) {
  if (!floatingElement) {
    return null;
  }
  return floatingElement.hasAttribute(FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
var LIST_LIMIT = 20;
var previouslyFocusedElements = [];
function addPreviouslyFocusedElement(element) {
  previouslyFocusedElements = previouslyFocusedElements.filter((el) => el.isConnected);
  let tabbableEl = element;
  if (!tabbableEl || getNodeName(tabbableEl) === "body") return;
  if (!isTabbable(tabbableEl, getTabbableOptions())) {
    const tabbableChild = tabbable(tabbableEl, getTabbableOptions())[0];
    if (tabbableChild) {
      tabbableEl = tabbableChild;
    }
  }
  previouslyFocusedElements.push(tabbableEl);
  if (previouslyFocusedElements.length > LIST_LIMIT) {
    previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
  }
}
function getPreviouslyFocusedElement() {
  return previouslyFocusedElements.slice().reverse().find((el) => el.isConnected);
}
var VisuallyHiddenDismiss = /* @__PURE__ */ React4.forwardRef(function VisuallyHiddenDismiss2(props, ref) {
  return /* @__PURE__ */ React4.createElement("button", _extends({}, props, {
    type: "button",
    ref,
    tabIndex: -1,
    style: HIDDEN_STYLES
  }));
});
function FloatingFocusManager(props) {
  const {
    context,
    children,
    disabled = false,
    order = ["content"],
    guards: _guards = true,
    initialFocus = 0,
    returnFocus = true,
    restoreFocus = false,
    modal = true,
    visuallyHiddenDismiss = false,
    closeOnFocusOut = true
  } = props;
  const {
    open,
    refs,
    nodeId,
    onOpenChange,
    events,
    dataRef,
    floatingId,
    elements: {
      domReference,
      floating
    }
  } = context;
  const ignoreInitialFocus = typeof initialFocus === "number" && initialFocus < 0;
  const isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;
  const guards = supportsInert() ? _guards : true;
  const orderRef = useLatestRef2(order);
  const initialFocusRef = useLatestRef2(initialFocus);
  const returnFocusRef = useLatestRef2(returnFocus);
  const tree = useFloatingTree();
  const portalContext = usePortalContext();
  const startDismissButtonRef = React4.useRef(null);
  const endDismissButtonRef = React4.useRef(null);
  const preventReturnFocusRef = React4.useRef(false);
  const isPointerDownRef = React4.useRef(false);
  const tabbableIndexRef = React4.useRef(-1);
  const isInsidePortal = portalContext != null;
  const floatingFocusElement = getFloatingFocusElement(floating);
  const getTabbableContent = useEffectEvent(function(container) {
    if (container === void 0) {
      container = floatingFocusElement;
    }
    return container ? tabbable(container, getTabbableOptions()) : [];
  });
  const getTabbableElements = useEffectEvent((container) => {
    const content = getTabbableContent(container);
    return orderRef.current.map((type) => {
      if (domReference && type === "reference") {
        return domReference;
      }
      if (floatingFocusElement && type === "floating") {
        return floatingFocusElement;
      }
      return content;
    }).filter(Boolean).flat();
  });
  React4.useEffect(() => {
    if (disabled) return;
    if (!modal) return;
    function onKeyDown(event) {
      if (event.key === "Tab") {
        if (contains(floatingFocusElement, activeElement(getDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) {
          stopEvent(event);
        }
        const els = getTabbableElements();
        const target = getTarget(event);
        if (orderRef.current[0] === "reference" && target === domReference) {
          stopEvent(event);
          if (event.shiftKey) {
            enqueueFocus(els[els.length - 1]);
          } else {
            enqueueFocus(els[1]);
          }
        }
        if (orderRef.current[1] === "floating" && target === floatingFocusElement && event.shiftKey) {
          stopEvent(event);
          enqueueFocus(els[0]);
        }
      }
    }
    const doc = getDocument(floatingFocusElement);
    doc.addEventListener("keydown", onKeyDown);
    return () => {
      doc.removeEventListener("keydown", onKeyDown);
    };
  }, [disabled, domReference, floatingFocusElement, modal, orderRef, isUntrappedTypeableCombobox, getTabbableContent, getTabbableElements]);
  React4.useEffect(() => {
    if (disabled) return;
    if (!floating) return;
    function handleFocusIn(event) {
      const target = getTarget(event);
      const tabbableContent = getTabbableContent();
      const tabbableIndex = tabbableContent.indexOf(target);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
    }
    floating.addEventListener("focusin", handleFocusIn);
    return () => {
      floating.removeEventListener("focusin", handleFocusIn);
    };
  }, [disabled, floating, getTabbableContent]);
  React4.useEffect(() => {
    if (disabled) return;
    if (!closeOnFocusOut) return;
    function handlePointerDown() {
      isPointerDownRef.current = true;
      setTimeout(() => {
        isPointerDownRef.current = false;
      });
    }
    function handleFocusOutside(event) {
      const relatedTarget = event.relatedTarget;
      queueMicrotask(() => {
        const movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute(createAttribute("focus-guard")) || tree && (getChildren(tree.nodesRef.current, nodeId).find((node) => {
          var _node$context, _node$context2;
          return contains((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || contains((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
        }) || getAncestors(tree.nodesRef.current, nodeId).find((node) => {
          var _node$context3, _node$context4;
          return ((_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating) === relatedTarget || ((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.domReference) === relatedTarget;
        })));
        if (restoreFocus && movedToUnrelatedNode && activeElement(getDocument(floatingFocusElement)) === getDocument(floatingFocusElement).body) {
          if (isHTMLElement(floatingFocusElement)) {
            floatingFocusElement.focus();
          }
          const prevTabbableIndex = tabbableIndexRef.current;
          const tabbableContent = getTabbableContent();
          const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
          if (isHTMLElement(nodeToFocus)) {
            nodeToFocus.focus();
          }
        }
        if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        relatedTarget !== getPreviouslyFocusedElement()) {
          preventReturnFocusRef.current = true;
          onOpenChange(false, event, "focus-out");
        }
      });
    }
    if (floating && isHTMLElement(domReference)) {
      domReference.addEventListener("focusout", handleFocusOutside);
      domReference.addEventListener("pointerdown", handlePointerDown);
      floating.addEventListener("focusout", handleFocusOutside);
      return () => {
        domReference.removeEventListener("focusout", handleFocusOutside);
        domReference.removeEventListener("pointerdown", handlePointerDown);
        floating.removeEventListener("focusout", handleFocusOutside);
      };
    }
  }, [disabled, domReference, floating, floatingFocusElement, modal, nodeId, tree, portalContext, onOpenChange, closeOnFocusOut, restoreFocus, getTabbableContent, isUntrappedTypeableCombobox]);
  React4.useEffect(() => {
    var _portalContext$portal;
    if (disabled) return;
    const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + createAttribute("portal") + "]")) || []);
    if (floating) {
      const insideElements = [floating, ...portalNodes, startDismissButtonRef.current, endDismissButtonRef.current, orderRef.current.includes("reference") || isUntrappedTypeableCombobox ? domReference : null].filter((x) => x != null);
      const cleanup2 = modal || isUntrappedTypeableCombobox ? markOthers(insideElements, guards, !guards) : markOthers(insideElements);
      return () => {
        cleanup2();
      };
    }
  }, [disabled, domReference, floating, modal, orderRef, portalContext, isUntrappedTypeableCombobox, guards]);
  index2(() => {
    if (disabled || !isHTMLElement(floatingFocusElement)) return;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    queueMicrotask(() => {
      const focusableElements = getTabbableElements(floatingFocusElement);
      const initialFocusValue = initialFocusRef.current;
      const elToFocus = (typeof initialFocusValue === "number" ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
      const focusAlreadyInsideFloatingEl = contains(floatingFocusElement, previouslyFocusedElement);
      if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) {
        enqueueFocus(elToFocus, {
          preventScroll: elToFocus === floatingFocusElement
        });
      }
    });
  }, [disabled, open, floatingFocusElement, ignoreInitialFocus, getTabbableElements, initialFocusRef]);
  index2(() => {
    if (disabled || !floatingFocusElement) return;
    let preventReturnFocusScroll = false;
    const doc = getDocument(floatingFocusElement);
    const previouslyFocusedElement = activeElement(doc);
    const contextData = dataRef.current;
    let openEvent = contextData.openEvent;
    addPreviouslyFocusedElement(previouslyFocusedElement);
    function onOpenChange2(_ref) {
      let {
        open: open2,
        reason,
        event,
        nested
      } = _ref;
      if (open2) {
        openEvent = event;
      }
      if (reason === "escape-key" && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      if (reason === "hover" && event.type === "mouseleave") {
        preventReturnFocusRef.current = true;
      }
      if (reason !== "outside-press") return;
      if (nested) {
        preventReturnFocusRef.current = false;
        preventReturnFocusScroll = true;
      } else {
        preventReturnFocusRef.current = !(isVirtualClick(event) || isVirtualPointerEvent(event));
      }
    }
    events.on("openchange", onOpenChange2);
    const fallbackEl = doc.createElement("span");
    fallbackEl.setAttribute("tabindex", "-1");
    fallbackEl.setAttribute("aria-hidden", "true");
    Object.assign(fallbackEl.style, HIDDEN_STYLES);
    if (isInsidePortal && domReference) {
      domReference.insertAdjacentElement("afterend", fallbackEl);
    }
    function getReturnElement() {
      if (typeof returnFocusRef.current === "boolean") {
        return getPreviouslyFocusedElement() || fallbackEl;
      }
      return returnFocusRef.current.current || fallbackEl;
    }
    return () => {
      events.off("openchange", onOpenChange2);
      const activeEl = activeElement(doc);
      const isFocusInsideFloatingTree = contains(floating, activeEl) || tree && getChildren(tree.nodesRef.current, nodeId).some((node) => {
        var _node$context5;
        return contains((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.floating, activeEl);
      });
      const shouldFocusReference = isFocusInsideFloatingTree || openEvent && ["click", "mousedown"].includes(openEvent.type);
      if (shouldFocusReference && refs.domReference.current) {
        addPreviouslyFocusedElement(refs.domReference.current);
      }
      const returnElement = getReturnElement();
      queueMicrotask(() => {
        if (
          // eslint-disable-next-line react-hooks/exhaustive-deps
          returnFocusRef.current && !preventReturnFocusRef.current && isHTMLElement(returnElement) && // If the focus moved somewhere else after mount, avoid returning focus
          // since it likely entered a different element which should be
          // respected: https://github.com/floating-ui/floating-ui/issues/2607
          (returnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)
        ) {
          returnElement.focus({
            preventScroll: preventReturnFocusScroll
          });
        }
        fallbackEl.remove();
      });
    };
  }, [disabled, floating, floatingFocusElement, returnFocusRef, dataRef, refs, events, tree, nodeId, isInsidePortal, domReference]);
  React4.useEffect(() => {
    queueMicrotask(() => {
      preventReturnFocusRef.current = false;
    });
  }, [disabled]);
  index2(() => {
    if (disabled) return;
    if (!portalContext) return;
    portalContext.setFocusManagerState({
      modal,
      closeOnFocusOut,
      open,
      onOpenChange,
      refs
    });
    return () => {
      portalContext.setFocusManagerState(null);
    };
  }, [disabled, portalContext, modal, open, onOpenChange, refs, closeOnFocusOut]);
  index2(() => {
    if (disabled) return;
    if (!floatingFocusElement) return;
    if (typeof MutationObserver !== "function") return;
    if (ignoreInitialFocus) return;
    const handleMutation = () => {
      const tabIndex = floatingFocusElement.getAttribute("tabindex");
      const tabbableContent = getTabbableContent();
      const activeEl = activeElement(getDocument(floating));
      const tabbableIndex = tabbableContent.indexOf(activeEl);
      if (tabbableIndex !== -1) {
        tabbableIndexRef.current = tabbableIndex;
      }
      if (orderRef.current.includes("floating") || activeEl !== refs.domReference.current && tabbableContent.length === 0) {
        if (tabIndex !== "0") {
          floatingFocusElement.setAttribute("tabindex", "0");
        }
      } else if (tabIndex !== "-1") {
        floatingFocusElement.setAttribute("tabindex", "-1");
      }
    };
    handleMutation();
    const observer = new MutationObserver(handleMutation);
    observer.observe(floatingFocusElement, {
      childList: true,
      subtree: true,
      attributes: true
    });
    return () => {
      observer.disconnect();
    };
  }, [disabled, floating, floatingFocusElement, refs, orderRef, getTabbableContent, ignoreInitialFocus]);
  function renderDismissButton(location2) {
    if (disabled || !visuallyHiddenDismiss || !modal) {
      return null;
    }
    return /* @__PURE__ */ React4.createElement(VisuallyHiddenDismiss, {
      ref: location2 === "start" ? startDismissButtonRef : endDismissButtonRef,
      onClick: (event) => onOpenChange(false, event.nativeEvent)
    }, typeof visuallyHiddenDismiss === "string" ? visuallyHiddenDismiss : "Dismiss");
  }
  const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
  return /* @__PURE__ */ React4.createElement(React4.Fragment, null, shouldRenderGuards && /* @__PURE__ */ React4.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.beforeInsideRef,
    onFocus: (event) => {
      if (modal) {
        const els = getTabbableElements();
        enqueueFocus(order[0] === "reference" ? els[0] : els[els.length - 1]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        preventReturnFocusRef.current = false;
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const nextTabbable = getNextTabbable() || domReference;
          nextTabbable == null || nextTabbable.focus();
        } else {
          var _portalContext$before;
          (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
        }
      }
    }
  }), !isUntrappedTypeableCombobox && renderDismissButton("start"), children, renderDismissButton("end"), shouldRenderGuards && /* @__PURE__ */ React4.createElement(FocusGuard, {
    "data-type": "inside",
    ref: portalContext == null ? void 0 : portalContext.afterInsideRef,
    onFocus: (event) => {
      if (modal) {
        enqueueFocus(getTabbableElements()[0]);
      } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
        if (closeOnFocusOut) {
          preventReturnFocusRef.current = true;
        }
        if (isOutsideEvent(event, portalContext.portalNode)) {
          const prevTabbable = getPreviousTabbable() || domReference;
          prevTabbable == null || prevTabbable.focus();
        } else {
          var _portalContext$afterO;
          (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
        }
      }
    }
  }));
}
var lockCount = 0;
function enableScrollLock() {
  const isIOS = /iP(hone|ad|od)|iOS/.test(getPlatform());
  const bodyStyle = document.body.style;
  const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
  const paddingProp = scrollbarX ? "paddingLeft" : "paddingRight";
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
  const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
  bodyStyle.overflow = "hidden";
  if (scrollbarWidth) {
    bodyStyle[paddingProp] = scrollbarWidth + "px";
  }
  if (isIOS) {
    var _window$visualViewpor, _window$visualViewpor2;
    const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
    const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
    Object.assign(bodyStyle, {
      position: "fixed",
      top: -(scrollY - Math.floor(offsetTop)) + "px",
      left: -(scrollX - Math.floor(offsetLeft)) + "px",
      right: "0"
    });
  }
  return () => {
    Object.assign(bodyStyle, {
      overflow: "",
      [paddingProp]: ""
    });
    if (isIOS) {
      Object.assign(bodyStyle, {
        position: "",
        top: "",
        left: "",
        right: ""
      });
      window.scrollTo(scrollX, scrollY);
    }
  };
}
var cleanup = () => {
};
var FloatingOverlay = /* @__PURE__ */ React4.forwardRef(function FloatingOverlay2(props, ref) {
  const {
    lockScroll = false,
    ...rest
  } = props;
  index2(() => {
    if (!lockScroll) return;
    lockCount++;
    if (lockCount === 1) {
      cleanup = enableScrollLock();
    }
    return () => {
      lockCount--;
      if (lockCount === 0) {
        cleanup();
      }
    };
  }, [lockScroll]);
  return /* @__PURE__ */ React4.createElement("div", _extends({
    ref
  }, rest, {
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...rest.style
    }
  }));
});
function isButtonTarget(event) {
  return isHTMLElement(event.target) && event.target.tagName === "BUTTON";
}
function isSpaceIgnored(element) {
  return isTypeableElement(element);
}
function useClick(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    dataRef,
    elements: {
      domReference
    }
  } = context;
  const {
    enabled = true,
    event: eventOption = "click",
    toggle = true,
    ignoreMouse = false,
    keyboardHandlers = true,
    stickIfOpen = true
  } = props;
  const pointerTypeRef = React4.useRef();
  const didKeyDownRef = React4.useRef(false);
  const reference = React4.useMemo(() => ({
    onPointerDown(event) {
      pointerTypeRef.current = event.pointerType;
    },
    onMouseDown(event) {
      const pointerType = pointerTypeRef.current;
      if (event.button !== 0) return;
      if (eventOption === "click") return;
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "mousedown" : true)) {
        onOpenChange(false, event.nativeEvent, "click");
      } else {
        event.preventDefault();
        onOpenChange(true, event.nativeEvent, "click");
      }
    },
    onClick(event) {
      const pointerType = pointerTypeRef.current;
      if (eventOption === "mousedown" && pointerTypeRef.current) {
        pointerTypeRef.current = void 0;
        return;
      }
      if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
      if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === "click" : true)) {
        onOpenChange(false, event.nativeEvent, "click");
      } else {
        onOpenChange(true, event.nativeEvent, "click");
      }
    },
    onKeyDown(event) {
      pointerTypeRef.current = void 0;
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event)) {
        return;
      }
      if (event.key === " " && !isSpaceIgnored(domReference)) {
        event.preventDefault();
        didKeyDownRef.current = true;
      }
      if (event.key === "Enter") {
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, "click");
        } else {
          onOpenChange(true, event.nativeEvent, "click");
        }
      }
    },
    onKeyUp(event) {
      if (event.defaultPrevented || !keyboardHandlers || isButtonTarget(event) || isSpaceIgnored(domReference)) {
        return;
      }
      if (event.key === " " && didKeyDownRef.current) {
        didKeyDownRef.current = false;
        if (open && toggle) {
          onOpenChange(false, event.nativeEvent, "click");
        } else {
          onOpenChange(true, event.nativeEvent, "click");
        }
      }
    }
  }), [dataRef, domReference, eventOption, ignoreMouse, keyboardHandlers, onOpenChange, open, stickIfOpen, toggle]);
  return React4.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}
var bubbleHandlerKeys = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
};
var captureHandlerKeys = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
};
var normalizeProp = (normalizable) => {
  var _normalizable$escapeK, _normalizable$outside;
  return {
    escapeKey: typeof normalizable === "boolean" ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
    outsidePress: typeof normalizable === "boolean" ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
  };
};
function useDismiss(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    elements,
    dataRef
  } = context;
  const {
    enabled = true,
    escapeKey = true,
    outsidePress: unstable_outsidePress = true,
    outsidePressEvent = "pointerdown",
    referencePress = false,
    referencePressEvent = "pointerdown",
    ancestorScroll = false,
    bubbles,
    capture
  } = props;
  const tree = useFloatingTree();
  const outsidePressFn = useEffectEvent(typeof unstable_outsidePress === "function" ? unstable_outsidePress : () => false);
  const outsidePress = typeof unstable_outsidePress === "function" ? outsidePressFn : unstable_outsidePress;
  const insideReactTreeRef = React4.useRef(false);
  const endedOrStartedInsideRef = React4.useRef(false);
  const {
    escapeKey: escapeKeyBubbles,
    outsidePress: outsidePressBubbles
  } = normalizeProp(bubbles);
  const {
    escapeKey: escapeKeyCapture,
    outsidePress: outsidePressCapture
  } = normalizeProp(capture);
  const isComposingRef = React4.useRef(false);
  const closeOnEscapeKeyDown = useEffectEvent((event) => {
    var _dataRef$current$floa;
    if (!open || !enabled || !escapeKey || event.key !== "Escape") {
      return;
    }
    if (isComposingRef.current) {
      return;
    }
    const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (!escapeKeyBubbles) {
      event.stopPropagation();
      if (children.length > 0) {
        let shouldDismiss = true;
        children.forEach((child) => {
          var _child$context;
          if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
            shouldDismiss = false;
            return;
          }
        });
        if (!shouldDismiss) {
          return;
        }
      }
    }
    onOpenChange(false, isReactEvent(event) ? event.nativeEvent : event, "escape-key");
  });
  const closeOnEscapeKeyDownCapture = useEffectEvent((event) => {
    var _getTarget2;
    const callback = () => {
      var _getTarget;
      closeOnEscapeKeyDown(event);
      (_getTarget = getTarget(event)) == null || _getTarget.removeEventListener("keydown", callback);
    };
    (_getTarget2 = getTarget(event)) == null || _getTarget2.addEventListener("keydown", callback);
  });
  const closeOnPressOutside = useEffectEvent((event) => {
    var _dataRef$current$floa2;
    const insideReactTree = insideReactTreeRef.current;
    insideReactTreeRef.current = false;
    const endedOrStartedInside = endedOrStartedInsideRef.current;
    endedOrStartedInsideRef.current = false;
    if (outsidePressEvent === "click" && endedOrStartedInside) {
      return;
    }
    if (insideReactTree) {
      return;
    }
    if (typeof outsidePress === "function" && !outsidePress(event)) {
      return;
    }
    const target = getTarget(event);
    const inertSelector = "[" + createAttribute("inert") + "]";
    const markers = getDocument(elements.floating).querySelectorAll(inertSelector);
    let targetRootAncestor = isElement(target) ? target : null;
    while (targetRootAncestor && !isLastTraversableNode(targetRootAncestor)) {
      const nextParent = getParentNode(targetRootAncestor);
      if (isLastTraversableNode(nextParent) || !isElement(nextParent)) {
        break;
      }
      targetRootAncestor = nextParent;
    }
    if (markers.length && isElement(target) && !isRootElement(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !contains(target, elements.floating) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(markers).every((marker) => !contains(targetRootAncestor, marker))) {
      return;
    }
    if (isHTMLElement(target) && floating) {
      const canScrollX = target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
      const canScrollY = target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
      let xCond = canScrollY && event.offsetX > target.clientWidth;
      if (canScrollY) {
        const isRTL2 = getComputedStyle2(target).direction === "rtl";
        if (isRTL2) {
          xCond = event.offsetX <= target.offsetWidth - target.clientWidth;
        }
      }
      if (xCond || canScrollX && event.offsetY > target.clientHeight) {
        return;
      }
    }
    const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
    const targetIsInsideChildren = tree && getChildren(tree.nodesRef.current, nodeId).some((node) => {
      var _node$context;
      return isEventTargetWithin(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
    });
    if (isEventTargetWithin(event, elements.floating) || isEventTargetWithin(event, elements.domReference) || targetIsInsideChildren) {
      return;
    }
    const children = tree ? getChildren(tree.nodesRef.current, nodeId) : [];
    if (children.length > 0) {
      let shouldDismiss = true;
      children.forEach((child) => {
        var _child$context2;
        if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
          shouldDismiss = false;
          return;
        }
      });
      if (!shouldDismiss) {
        return;
      }
    }
    onOpenChange(false, event, "outside-press");
  });
  const closeOnPressOutsideCapture = useEffectEvent((event) => {
    var _getTarget4;
    const callback = () => {
      var _getTarget3;
      closeOnPressOutside(event);
      (_getTarget3 = getTarget(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
    };
    (_getTarget4 = getTarget(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
  });
  React4.useEffect(() => {
    if (!open || !enabled) {
      return;
    }
    dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
    dataRef.current.__outsidePressBubbles = outsidePressBubbles;
    let compositionTimeout = -1;
    function onScroll(event) {
      onOpenChange(false, event, "ancestor-scroll");
    }
    function handleCompositionStart() {
      window.clearTimeout(compositionTimeout);
      isComposingRef.current = true;
    }
    function handleCompositionEnd() {
      compositionTimeout = window.setTimeout(
        () => {
          isComposingRef.current = false;
        },
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        isWebKit() ? 5 : 0
      );
    }
    const doc = getDocument(elements.floating);
    if (escapeKey) {
      doc.addEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
      doc.addEventListener("compositionstart", handleCompositionStart);
      doc.addEventListener("compositionend", handleCompositionEnd);
    }
    outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
    let ancestors = [];
    if (ancestorScroll) {
      if (isElement(elements.domReference)) {
        ancestors = getOverflowAncestors(elements.domReference);
      }
      if (isElement(elements.floating)) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.floating));
      }
      if (!isElement(elements.reference) && elements.reference && elements.reference.contextElement) {
        ancestors = ancestors.concat(getOverflowAncestors(elements.reference.contextElement));
      }
    }
    ancestors = ancestors.filter((ancestor) => {
      var _doc$defaultView;
      return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
    });
    ancestors.forEach((ancestor) => {
      ancestor.addEventListener("scroll", onScroll, {
        passive: true
      });
    });
    return () => {
      if (escapeKey) {
        doc.removeEventListener("keydown", escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
        doc.removeEventListener("compositionstart", handleCompositionStart);
        doc.removeEventListener("compositionend", handleCompositionEnd);
      }
      outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
      ancestors.forEach((ancestor) => {
        ancestor.removeEventListener("scroll", onScroll);
      });
      window.clearTimeout(compositionTimeout);
    };
  }, [dataRef, elements, escapeKey, outsidePress, outsidePressEvent, open, onOpenChange, ancestorScroll, enabled, escapeKeyBubbles, outsidePressBubbles, closeOnEscapeKeyDown, escapeKeyCapture, closeOnEscapeKeyDownCapture, closeOnPressOutside, outsidePressCapture, closeOnPressOutsideCapture]);
  React4.useEffect(() => {
    insideReactTreeRef.current = false;
  }, [outsidePress, outsidePressEvent]);
  const reference = React4.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    [bubbleHandlerKeys[referencePressEvent]]: (event) => {
      if (referencePress) {
        onOpenChange(false, event.nativeEvent, "reference-press");
      }
    }
  }), [closeOnEscapeKeyDown, onOpenChange, referencePress, referencePressEvent]);
  const floating = React4.useMemo(() => ({
    onKeyDown: closeOnEscapeKeyDown,
    onMouseDown() {
      endedOrStartedInsideRef.current = true;
    },
    onMouseUp() {
      endedOrStartedInsideRef.current = true;
    },
    [captureHandlerKeys[outsidePressEvent]]: () => {
      insideReactTreeRef.current = true;
    }
  }), [closeOnEscapeKeyDown, outsidePressEvent]);
  return React4.useMemo(() => enabled ? {
    reference,
    floating
  } : {}, [enabled, reference, floating]);
}
function useFloatingRootContext(options) {
  const {
    open = false,
    onOpenChange: onOpenChangeProp,
    elements: elementsProp
  } = options;
  const floatingId = useId();
  const dataRef = React4.useRef({});
  const [events] = React4.useState(() => createPubSub());
  const nested = useFloatingParentNodeId() != null;
  if (true) {
    const optionDomReference = elementsProp.reference;
    if (optionDomReference && !isElement(optionDomReference)) {
      error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
    }
  }
  const [positionReference, setPositionReference] = React4.useState(elementsProp.reference);
  const onOpenChange = useEffectEvent((open2, event, reason) => {
    dataRef.current.openEvent = open2 ? event : void 0;
    events.emit("openchange", {
      open: open2,
      event,
      reason,
      nested
    });
    onOpenChangeProp == null || onOpenChangeProp(open2, event, reason);
  });
  const refs = React4.useMemo(() => ({
    setPositionReference
  }), []);
  const elements = React4.useMemo(() => ({
    reference: positionReference || elementsProp.reference || null,
    floating: elementsProp.floating || null,
    domReference: elementsProp.reference
  }), [positionReference, elementsProp.reference, elementsProp.floating]);
  return React4.useMemo(() => ({
    dataRef,
    open,
    onOpenChange,
    elements,
    events,
    floatingId,
    refs
  }), [open, onOpenChange, elements, events, floatingId, refs]);
}
function useFloating2(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    nodeId
  } = options;
  const internalRootContext = useFloatingRootContext({
    ...options,
    elements: {
      reference: null,
      floating: null,
      ...options.elements
    }
  });
  const rootContext = options.rootContext || internalRootContext;
  const computedElements = rootContext.elements;
  const [_domReference, setDomReference] = React4.useState(null);
  const [positionReference, _setPositionReference] = React4.useState(null);
  const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
  const domReference = optionDomReference || _domReference;
  const domReferenceRef = React4.useRef(null);
  const tree = useFloatingTree();
  index2(() => {
    if (domReference) {
      domReferenceRef.current = domReference;
    }
  }, [domReference]);
  const position = useFloating({
    ...options,
    elements: {
      ...computedElements,
      ...positionReference && {
        reference: positionReference
      }
    }
  });
  const setPositionReference = React4.useCallback((node) => {
    const computedPositionReference = isElement(node) ? {
      getBoundingClientRect: () => node.getBoundingClientRect(),
      contextElement: node
    } : node;
    _setPositionReference(computedPositionReference);
    position.refs.setReference(computedPositionReference);
  }, [position.refs]);
  const setReference = React4.useCallback((node) => {
    if (isElement(node) || node === null) {
      domReferenceRef.current = node;
      setDomReference(node);
    }
    if (isElement(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    node !== null && !isElement(node)) {
      position.refs.setReference(node);
    }
  }, [position.refs]);
  const refs = React4.useMemo(() => ({
    ...position.refs,
    setReference,
    setPositionReference,
    domReference: domReferenceRef
  }), [position.refs, setReference, setPositionReference]);
  const elements = React4.useMemo(() => ({
    ...position.elements,
    domReference
  }), [position.elements, domReference]);
  const context = React4.useMemo(() => ({
    ...position,
    ...rootContext,
    refs,
    elements,
    nodeId
  }), [position, refs, elements, nodeId, rootContext]);
  index2(() => {
    rootContext.dataRef.current.floatingContext = context;
    const node = tree == null ? void 0 : tree.nodesRef.current.find((node2) => node2.id === nodeId);
    if (node) {
      node.context = context;
    }
  });
  return React4.useMemo(() => ({
    ...position,
    context,
    refs,
    elements
  }), [position, refs, elements, context]);
}
function useFocus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    onOpenChange,
    events,
    dataRef,
    elements
  } = context;
  const {
    enabled = true,
    visibleOnly = true
  } = props;
  const blockFocusRef = React4.useRef(false);
  const timeoutRef = React4.useRef();
  const keyboardModalityRef = React4.useRef(true);
  React4.useEffect(() => {
    if (!enabled) return;
    const win = getWindow(elements.domReference);
    function onBlur() {
      if (!open && isHTMLElement(elements.domReference) && elements.domReference === activeElement(getDocument(elements.domReference))) {
        blockFocusRef.current = true;
      }
    }
    function onKeyDown() {
      keyboardModalityRef.current = true;
    }
    win.addEventListener("blur", onBlur);
    win.addEventListener("keydown", onKeyDown, true);
    return () => {
      win.removeEventListener("blur", onBlur);
      win.removeEventListener("keydown", onKeyDown, true);
    };
  }, [elements.domReference, open, enabled]);
  React4.useEffect(() => {
    if (!enabled) return;
    function onOpenChange2(_ref) {
      let {
        reason
      } = _ref;
      if (reason === "reference-press" || reason === "escape-key") {
        blockFocusRef.current = true;
      }
    }
    events.on("openchange", onOpenChange2);
    return () => {
      events.off("openchange", onOpenChange2);
    };
  }, [events, enabled]);
  React4.useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);
  const reference = React4.useMemo(() => ({
    onPointerDown(event) {
      if (isVirtualPointerEvent(event.nativeEvent)) return;
      keyboardModalityRef.current = false;
    },
    onMouseLeave() {
      blockFocusRef.current = false;
    },
    onFocus(event) {
      if (blockFocusRef.current) return;
      const target = getTarget(event.nativeEvent);
      if (visibleOnly && isElement(target)) {
        try {
          if (isSafari() && isMac()) throw Error();
          if (!target.matches(":focus-visible")) return;
        } catch (e2) {
          if (!keyboardModalityRef.current && !isTypeableElement(target)) {
            return;
          }
        }
      }
      onOpenChange(true, event.nativeEvent, "focus");
    },
    onBlur(event) {
      blockFocusRef.current = false;
      const relatedTarget = event.relatedTarget;
      const nativeEvent = event.nativeEvent;
      const movedToFocusGuard = isElement(relatedTarget) && relatedTarget.hasAttribute(createAttribute("focus-guard")) && relatedTarget.getAttribute("data-type") === "outside";
      timeoutRef.current = window.setTimeout(() => {
        var _dataRef$current$floa;
        const activeEl = activeElement(elements.domReference ? elements.domReference.ownerDocument : document);
        if (!relatedTarget && activeEl === elements.domReference) return;
        if (contains((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || contains(elements.domReference, activeEl) || movedToFocusGuard) {
          return;
        }
        onOpenChange(false, nativeEvent, "focus");
      });
    }
  }), [dataRef, elements.domReference, onOpenChange, visibleOnly]);
  return React4.useMemo(() => enabled ? {
    reference
  } : {}, [enabled, reference]);
}
var ACTIVE_KEY = "active";
var SELECTED_KEY = "selected";
function mergeProps(userProps, propsList, elementKey) {
  const map = /* @__PURE__ */ new Map();
  const isItem = elementKey === "item";
  let domUserProps = userProps;
  if (isItem && userProps) {
    const {
      [ACTIVE_KEY]: _,
      [SELECTED_KEY]: __,
      ...validProps
    } = userProps;
    domUserProps = validProps;
  }
  return {
    ...elementKey === "floating" && {
      tabIndex: -1,
      [FOCUSABLE_ATTRIBUTE]: ""
    },
    ...domUserProps,
    ...propsList.map((value) => {
      const propsOrGetProps = value ? value[elementKey] : null;
      if (typeof propsOrGetProps === "function") {
        return userProps ? propsOrGetProps(userProps) : null;
      }
      return propsOrGetProps;
    }).concat(userProps).reduce((acc, props) => {
      if (!props) {
        return acc;
      }
      Object.entries(props).forEach((_ref) => {
        let [key, value] = _ref;
        if (isItem && [ACTIVE_KEY, SELECTED_KEY].includes(key)) {
          return;
        }
        if (key.indexOf("on") === 0) {
          if (!map.has(key)) {
            map.set(key, []);
          }
          if (typeof value === "function") {
            var _map$get;
            (_map$get = map.get(key)) == null || _map$get.push(value);
            acc[key] = function() {
              var _map$get2;
              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn) => fn(...args)).find((val) => val !== void 0);
            };
          }
        } else {
          acc[key] = value;
        }
      });
      return acc;
    }, {})
  };
}
function useInteractions(propsList) {
  if (propsList === void 0) {
    propsList = [];
  }
  const referenceDeps = propsList.map((key) => key == null ? void 0 : key.reference);
  const floatingDeps = propsList.map((key) => key == null ? void 0 : key.floating);
  const itemDeps = propsList.map((key) => key == null ? void 0 : key.item);
  const getReferenceProps = React4.useCallback(
    (userProps) => mergeProps(userProps, propsList, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps
  );
  const getFloatingProps = React4.useCallback(
    (userProps) => mergeProps(userProps, propsList, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps
  );
  const getItemProps = React4.useCallback(
    (userProps) => mergeProps(userProps, propsList, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps
  );
  return React4.useMemo(() => ({
    getReferenceProps,
    getFloatingProps,
    getItemProps
  }), [getReferenceProps, getFloatingProps, getItemProps]);
}
var isPreventScrollSupported = false;
function doSwitch(orientation, vertical, horizontal) {
  switch (orientation) {
    case "vertical":
      return vertical;
    case "horizontal":
      return horizontal;
    default:
      return vertical || horizontal;
  }
}
function isMainOrientationKey(key, orientation) {
  const vertical = key === ARROW_UP || key === ARROW_DOWN;
  const horizontal = key === ARROW_LEFT || key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal);
}
function isMainOrientationToEndKey(key, orientation, rtl) {
  const vertical = key === ARROW_DOWN;
  const horizontal = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  return doSwitch(orientation, vertical, horizontal) || key === "Enter" || key === " " || key === "";
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_LEFT : key === ARROW_RIGHT;
  const horizontal = key === ARROW_DOWN;
  return doSwitch(orientation, vertical, horizontal);
}
function isCrossOrientationCloseKey(key, orientation, rtl) {
  const vertical = rtl ? key === ARROW_RIGHT : key === ARROW_LEFT;
  const horizontal = key === ARROW_UP;
  return doSwitch(orientation, vertical, horizontal);
}
function useListNavigation(context, props) {
  const {
    open,
    onOpenChange,
    elements
  } = context;
  const {
    listRef,
    activeIndex,
    onNavigate: unstable_onNavigate = () => {
    },
    enabled = true,
    selectedIndex = null,
    allowEscape = false,
    loop = false,
    nested = false,
    rtl = false,
    virtual = false,
    focusItemOnOpen = "auto",
    focusItemOnHover = true,
    openOnArrowKeyDown = true,
    disabledIndices = void 0,
    orientation = "vertical",
    cols = 1,
    scrollItemIntoView = true,
    virtualItemRef,
    itemSizes,
    dense = false
  } = props;
  if (true) {
    if (allowEscape) {
      if (!loop) {
        warn("`useListNavigation` looping must be enabled to allow escaping.");
      }
      if (!virtual) {
        warn("`useListNavigation` must be virtual to allow escaping.");
      }
    }
    if (orientation === "vertical" && cols > 1) {
      warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".');
    }
  }
  const floatingFocusElement = getFloatingFocusElement(elements.floating);
  const floatingFocusElementRef = useLatestRef2(floatingFocusElement);
  const parentId = useFloatingParentNodeId();
  const tree = useFloatingTree();
  const onNavigate = useEffectEvent(unstable_onNavigate);
  const typeableComboboxReference = isTypeableCombobox(elements.domReference);
  const focusItemOnOpenRef = React4.useRef(focusItemOnOpen);
  const indexRef = React4.useRef(selectedIndex != null ? selectedIndex : -1);
  const keyRef = React4.useRef(null);
  const isPointerModalityRef = React4.useRef(true);
  const previousOnNavigateRef = React4.useRef(onNavigate);
  const previousMountedRef = React4.useRef(!!elements.floating);
  const previousOpenRef = React4.useRef(open);
  const forceSyncFocus = React4.useRef(false);
  const forceScrollIntoViewRef = React4.useRef(false);
  const disabledIndicesRef = useLatestRef2(disabledIndices);
  const latestOpenRef = useLatestRef2(open);
  const scrollItemIntoViewRef = useLatestRef2(scrollItemIntoView);
  const selectedIndexRef = useLatestRef2(selectedIndex);
  const [activeId, setActiveId] = React4.useState();
  const [virtualId, setVirtualId] = React4.useState();
  const focusItem = useEffectEvent(function(listRef2, indexRef2, forceScrollIntoView) {
    if (forceScrollIntoView === void 0) {
      forceScrollIntoView = false;
    }
    function runFocus(item2) {
      if (virtual) {
        setActiveId(item2.id);
        tree == null || tree.events.emit("virtualfocus", item2);
        if (virtualItemRef) {
          virtualItemRef.current = item2;
        }
      } else {
        enqueueFocus(item2, {
          preventScroll: true,
          // Mac Safari does not move the virtual cursor unless the focus call
          // is sync. However, for the very first focus call, we need to wait
          // for the position to be ready in order to prevent unwanted
          // scrolling. This means the virtual cursor will not move to the first
          // item when first opening the floating element, but will on
          // subsequent calls. `preventScroll` is supported in modern Safari,
          // so we can use that instead.
          // iOS Safari must be async or the first item will not be focused.
          sync: isMac() && isSafari() ? isPreventScrollSupported || forceSyncFocus.current : false
        });
      }
    }
    const initialItem = listRef2.current[indexRef2.current];
    if (initialItem) {
      runFocus(initialItem);
    }
    requestAnimationFrame(() => {
      const waitedItem = listRef2.current[indexRef2.current] || initialItem;
      if (!waitedItem) return;
      if (!initialItem) {
        runFocus(waitedItem);
      }
      const scrollIntoViewOptions = scrollItemIntoViewRef.current;
      const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
      if (shouldScrollIntoView) {
        waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === "boolean" ? {
          block: "nearest",
          inline: "nearest"
        } : scrollIntoViewOptions);
      }
    });
  });
  index2(() => {
    document.createElement("div").focus({
      get preventScroll() {
        isPreventScrollSupported = true;
        return false;
      }
    });
  }, []);
  index2(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (focusItemOnOpenRef.current && selectedIndex != null) {
        forceScrollIntoViewRef.current = true;
        indexRef.current = selectedIndex;
        onNavigate(selectedIndex);
      }
    } else if (previousMountedRef.current) {
      indexRef.current = -1;
      previousOnNavigateRef.current(null);
    }
  }, [enabled, open, elements.floating, selectedIndex, onNavigate]);
  index2(() => {
    if (!enabled) return;
    if (open && elements.floating) {
      if (activeIndex == null) {
        forceSyncFocus.current = false;
        if (selectedIndexRef.current != null) {
          return;
        }
        if (previousMountedRef.current) {
          indexRef.current = -1;
          focusItem(listRef, indexRef);
        }
        if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
          let runs = 0;
          const waitForListPopulated = () => {
            if (listRef.current[0] == null) {
              if (runs < 2) {
                const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                scheduler(waitForListPopulated);
              }
              runs++;
            } else {
              indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinIndex(listRef, disabledIndicesRef.current) : getMaxIndex(listRef, disabledIndicesRef.current);
              keyRef.current = null;
              onNavigate(indexRef.current);
            }
          };
          waitForListPopulated();
        }
      } else if (!isIndexOutOfBounds(listRef, activeIndex)) {
        indexRef.current = activeIndex;
        focusItem(listRef, indexRef, forceScrollIntoViewRef.current);
        forceScrollIntoViewRef.current = false;
      }
    }
  }, [enabled, open, elements.floating, activeIndex, selectedIndexRef, nested, listRef, orientation, rtl, onNavigate, focusItem, disabledIndicesRef]);
  index2(() => {
    var _nodes$find;
    if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) {
      return;
    }
    const nodes = tree.nodesRef.current;
    const parent = (_nodes$find = nodes.find((node) => node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
    const activeEl = activeElement(getDocument(elements.floating));
    const treeContainsActiveEl = nodes.some((node) => node.context && contains(node.context.elements.floating, activeEl));
    if (parent && !treeContainsActiveEl && isPointerModalityRef.current) {
      parent.focus({
        preventScroll: true
      });
    }
  }, [enabled, elements.floating, tree, parentId, virtual]);
  index2(() => {
    if (!enabled) return;
    if (!tree) return;
    if (!virtual) return;
    if (parentId) return;
    function handleVirtualFocus(item2) {
      setVirtualId(item2.id);
      if (virtualItemRef) {
        virtualItemRef.current = item2;
      }
    }
    tree.events.on("virtualfocus", handleVirtualFocus);
    return () => {
      tree.events.off("virtualfocus", handleVirtualFocus);
    };
  }, [enabled, tree, virtual, parentId, virtualItemRef]);
  index2(() => {
    previousOnNavigateRef.current = onNavigate;
    previousMountedRef.current = !!elements.floating;
  });
  index2(() => {
    if (!open) {
      keyRef.current = null;
    }
  }, [open]);
  index2(() => {
    previousOpenRef.current = open;
  }, [open]);
  const hasActiveIndex = activeIndex != null;
  const item = React4.useMemo(() => {
    function syncCurrentTarget(currentTarget) {
      if (!open) return;
      const index3 = listRef.current.indexOf(currentTarget);
      if (index3 !== -1) {
        onNavigate(index3);
      }
    }
    const props2 = {
      onFocus(_ref) {
        let {
          currentTarget
        } = _ref;
        syncCurrentTarget(currentTarget);
      },
      onClick: (_ref2) => {
        let {
          currentTarget
        } = _ref2;
        return currentTarget.focus({
          preventScroll: true
        });
      },
      // Safari
      ...focusItemOnHover && {
        onMouseMove(_ref3) {
          let {
            currentTarget
          } = _ref3;
          syncCurrentTarget(currentTarget);
        },
        onPointerLeave(_ref4) {
          let {
            pointerType
          } = _ref4;
          if (!isPointerModalityRef.current || pointerType === "touch") {
            return;
          }
          indexRef.current = -1;
          focusItem(listRef, indexRef);
          onNavigate(null);
          if (!virtual) {
            enqueueFocus(floatingFocusElementRef.current, {
              preventScroll: true
            });
          }
        }
      }
    };
    return props2;
  }, [open, floatingFocusElementRef, focusItem, focusItemOnHover, listRef, onNavigate, virtual]);
  const commonOnKeyDown = useEffectEvent((event) => {
    isPointerModalityRef.current = false;
    forceSyncFocus.current = true;
    if (event.which === 229) {
      return;
    }
    if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) {
      return;
    }
    if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl)) {
      stopEvent(event);
      onOpenChange(false, event.nativeEvent, "list-navigation");
      if (isHTMLElement(elements.domReference)) {
        if (virtual) {
          tree == null || tree.events.emit("virtualfocus", elements.domReference);
        } else {
          elements.domReference.focus();
        }
      }
      return;
    }
    const currentIndex = indexRef.current;
    const minIndex = getMinIndex(listRef, disabledIndices);
    const maxIndex = getMaxIndex(listRef, disabledIndices);
    if (!typeableComboboxReference) {
      if (event.key === "Home") {
        stopEvent(event);
        indexRef.current = minIndex;
        onNavigate(indexRef.current);
      }
      if (event.key === "End") {
        stopEvent(event);
        indexRef.current = maxIndex;
        onNavigate(indexRef.current);
      }
    }
    if (cols > 1) {
      const sizes = itemSizes || Array.from({
        length: listRef.current.length
      }, () => ({
        width: 1,
        height: 1
      }));
      const cellMap = buildCellMap(sizes, cols, dense);
      const minGridIndex = cellMap.findIndex((index4) => index4 != null && !isDisabled(listRef.current, index4, disabledIndices));
      const maxGridIndex = cellMap.reduce((foundIndex, index4, cellIndex) => index4 != null && !isDisabled(listRef.current, index4, disabledIndices) ? cellIndex : foundIndex, -1);
      const index3 = cellMap[getGridNavigatedIndex({
        current: cellMap.map((itemIndex) => itemIndex != null ? listRef.current[itemIndex] : null)
      }, {
        event,
        orientation,
        loop,
        rtl,
        cols,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: getCellIndices([...disabledIndices || listRef.current.map((_, index4) => isDisabled(listRef.current, index4) ? index4 : void 0), void 0], cellMap),
        minIndex: minGridIndex,
        maxIndex: maxGridIndex,
        prevIndex: getCellIndexOfCorner(
          indexRef.current > maxIndex ? minIndex : indexRef.current,
          sizes,
          cellMap,
          cols,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          event.key === ARROW_DOWN ? "bl" : event.key === (rtl ? ARROW_LEFT : ARROW_RIGHT) ? "tr" : "tl"
        ),
        stopEvent: true
      })];
      if (index3 != null) {
        indexRef.current = index3;
        onNavigate(indexRef.current);
      }
      if (orientation === "both") {
        return;
      }
    }
    if (isMainOrientationKey(event.key, orientation)) {
      stopEvent(event);
      if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
        indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
        onNavigate(indexRef.current);
        return;
      }
      if (isMainOrientationToEndKey(event.key, orientation, rtl)) {
        if (loop) {
          indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          });
        } else {
          indexRef.current = Math.min(maxIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            disabledIndices
          }));
        }
      } else {
        if (loop) {
          indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          });
        } else {
          indexRef.current = Math.max(minIndex, findNonDisabledIndex(listRef, {
            startingIndex: currentIndex,
            decrement: true,
            disabledIndices
          }));
        }
      }
      if (isIndexOutOfBounds(listRef, indexRef.current)) {
        onNavigate(null);
      } else {
        onNavigate(indexRef.current);
      }
    }
  });
  const ariaActiveDescendantProp = React4.useMemo(() => {
    return virtual && open && hasActiveIndex && {
      "aria-activedescendant": virtualId || activeId
    };
  }, [virtual, open, hasActiveIndex, virtualId, activeId]);
  const floating = React4.useMemo(() => {
    return {
      "aria-orientation": orientation === "both" ? void 0 : orientation,
      ...!isTypeableCombobox(elements.domReference) && ariaActiveDescendantProp,
      onKeyDown: commonOnKeyDown,
      onPointerMove() {
        isPointerModalityRef.current = true;
      }
    };
  }, [ariaActiveDescendantProp, commonOnKeyDown, elements.domReference, orientation]);
  const reference = React4.useMemo(() => {
    function checkVirtualMouse(event) {
      if (focusItemOnOpen === "auto" && isVirtualClick(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    function checkVirtualPointer(event) {
      focusItemOnOpenRef.current = focusItemOnOpen;
      if (focusItemOnOpen === "auto" && isVirtualPointerEvent(event.nativeEvent)) {
        focusItemOnOpenRef.current = true;
      }
    }
    return {
      ...ariaActiveDescendantProp,
      onKeyDown(event) {
        isPointerModalityRef.current = false;
        const isArrowKey = event.key.startsWith("Arrow");
        const isHomeOrEndKey = ["Home", "End"].includes(event.key);
        const isMoveKey = isArrowKey || isHomeOrEndKey;
        const isCrossOpenKey = isCrossOrientationOpenKey(event.key, orientation, rtl);
        const isCrossCloseKey = isCrossOrientationCloseKey(event.key, orientation, rtl);
        const isMainKey = isMainOrientationKey(event.key, orientation);
        const isNavigationKey = (nested ? isCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
        if (virtual && open) {
          const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node) => node.parentId == null);
          const deepestNode = tree && rootNode ? getDeepestNode(tree.nodesRef.current, rootNode.id) : null;
          if (isMoveKey && deepestNode && virtualItemRef) {
            const eventObject = new KeyboardEvent("keydown", {
              key: event.key,
              bubbles: true
            });
            if (isCrossOpenKey || isCrossCloseKey) {
              var _deepestNode$context, _deepestNode$context2;
              const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
              const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item2) => (item2 == null ? void 0 : item2.id) === activeId) : null;
              if (dispatchItem) {
                stopEvent(event);
                dispatchItem.dispatchEvent(eventObject);
                setVirtualId(void 0);
              }
            }
            if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
              if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                var _deepestNode$context$;
                stopEvent(event);
                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                return;
              }
            }
          }
          return commonOnKeyDown(event);
        }
        if (!open && !openOnArrowKeyDown && isArrowKey) {
          return;
        }
        if (isNavigationKey) {
          keyRef.current = nested && isMainKey ? null : event.key;
        }
        if (nested) {
          if (isCrossOpenKey) {
            stopEvent(event);
            if (open) {
              indexRef.current = getMinIndex(listRef, disabledIndicesRef.current);
              onNavigate(indexRef.current);
            } else {
              onOpenChange(true, event.nativeEvent, "list-navigation");
            }
          }
          return;
        }
        if (isMainKey) {
          if (selectedIndex != null) {
            indexRef.current = selectedIndex;
          }
          stopEvent(event);
          if (!open && openOnArrowKeyDown) {
            onOpenChange(true, event.nativeEvent, "list-navigation");
          } else {
            commonOnKeyDown(event);
          }
          if (open) {
            onNavigate(indexRef.current);
          }
        }
      },
      onFocus() {
        if (open && !virtual) {
          onNavigate(null);
        }
      },
      onPointerDown: checkVirtualPointer,
      onMouseDown: checkVirtualMouse,
      onClick: checkVirtualMouse
    };
  }, [activeId, ariaActiveDescendantProp, commonOnKeyDown, disabledIndicesRef, focusItemOnOpen, listRef, nested, onNavigate, onOpenChange, open, openOnArrowKeyDown, orientation, rtl, selectedIndex, tree, virtual, virtualItemRef]);
  return React4.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}
var componentRoleToAriaRoleMap = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", false]]);
function useRole(context, props) {
  var _componentRoleToAriaR;
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    floatingId
  } = context;
  const {
    enabled = true,
    role = "dialog"
  } = props;
  const ariaRole = (_componentRoleToAriaR = componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
  const referenceId = useId();
  const parentId = useFloatingParentNodeId();
  const isNested = parentId != null;
  const reference = React4.useMemo(() => {
    if (ariaRole === "tooltip" || role === "label") {
      return {
        ["aria-" + (role === "label" ? "labelledby" : "describedby")]: open ? floatingId : void 0
      };
    }
    return {
      "aria-expanded": open ? "true" : "false",
      "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
      "aria-controls": open ? floatingId : void 0,
      ...ariaRole === "listbox" && {
        role: "combobox"
      },
      ...ariaRole === "menu" && {
        id: referenceId
      },
      ...ariaRole === "menu" && isNested && {
        role: "menuitem"
      },
      ...role === "select" && {
        "aria-autocomplete": "none"
      },
      ...role === "combobox" && {
        "aria-autocomplete": "list"
      }
    };
  }, [ariaRole, floatingId, isNested, open, referenceId, role]);
  const floating = React4.useMemo(() => {
    const floatingProps = {
      id: floatingId,
      ...ariaRole && {
        role: ariaRole
      }
    };
    if (ariaRole === "tooltip" || role === "label") {
      return floatingProps;
    }
    return {
      ...floatingProps,
      ...ariaRole === "menu" && {
        "aria-labelledby": referenceId
      }
    };
  }, [ariaRole, floatingId, referenceId, role]);
  const item = React4.useCallback((_ref) => {
    let {
      active,
      selected
    } = _ref;
    const commonProps = {
      role: "option",
      ...active && {
        id: floatingId + "-option"
      }
    };
    switch (role) {
      case "select":
        return {
          ...commonProps,
          "aria-selected": active && selected
        };
      case "combobox": {
        return {
          ...commonProps,
          ...active && {
            "aria-selected": true
          }
        };
      }
    }
    return {};
  }, [floatingId, role]);
  return React4.useMemo(() => enabled ? {
    reference,
    floating,
    item
  } : {}, [enabled, reference, floating, item]);
}
function useDelayUnmount(open, durationMs) {
  const [isMounted, setIsMounted] = React4.useState(open);
  if (open && !isMounted) {
    setIsMounted(true);
  }
  React4.useEffect(() => {
    if (!open && isMounted) {
      const timeout = setTimeout(() => setIsMounted(false), durationMs);
      return () => clearTimeout(timeout);
    }
  }, [open, isMounted, durationMs]);
  return isMounted;
}
function useTransitionStatus(context, props) {
  if (props === void 0) {
    props = {};
  }
  const {
    open,
    elements: {
      floating
    }
  } = context;
  const {
    duration = 250
  } = props;
  const isNumberDuration = typeof duration === "number";
  const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
  const [status, setStatus] = React4.useState("unmounted");
  const isMounted = useDelayUnmount(open, closeDuration);
  if (!isMounted && status === "close") {
    setStatus("unmounted");
  }
  index2(() => {
    if (!floating) return;
    if (open) {
      setStatus("initial");
      const frame = requestAnimationFrame(() => {
        setStatus("open");
      });
      return () => {
        cancelAnimationFrame(frame);
      };
    }
    setStatus("close");
  }, [open, floating]);
  return {
    isMounted,
    status
  };
}
function isPointInPolygon(point, polygon) {
  const [x, y] = point;
  let isInside2 = false;
  const length = polygon.length;
  for (let i2 = 0, j = length - 1; i2 < length; j = i2++) {
    const [xi, yi] = polygon[i2] || [0, 0];
    const [xj, yj] = polygon[j] || [0, 0];
    const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
    if (intersect) {
      isInside2 = !isInside2;
    }
  }
  return isInside2;
}
function isInside(point, rect) {
  return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
function safePolygon(options) {
  if (options === void 0) {
    options = {};
  }
  const {
    buffer = 0.5,
    blockPointerEvents = false,
    requireIntent = true
  } = options;
  let timeoutId2;
  let hasLanded = false;
  let lastX = null;
  let lastY = null;
  let lastCursorTime = performance.now();
  function getCursorSpeed(x, y) {
    const currentTime = performance.now();
    const elapsedTime = currentTime - lastCursorTime;
    if (lastX === null || lastY === null || elapsedTime === 0) {
      lastX = x;
      lastY = y;
      lastCursorTime = currentTime;
      return null;
    }
    const deltaX = x - lastX;
    const deltaY = y - lastY;
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    const speed = distance / elapsedTime;
    lastX = x;
    lastY = y;
    lastCursorTime = currentTime;
    return speed;
  }
  const fn = (_ref) => {
    let {
      x,
      y,
      placement,
      elements,
      onClose,
      nodeId,
      tree
    } = _ref;
    return function onMouseMove(event) {
      function close() {
        clearTimeout(timeoutId2);
        onClose();
      }
      clearTimeout(timeoutId2);
      if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) {
        return;
      }
      const {
        clientX,
        clientY
      } = event;
      const clientPoint = [clientX, clientY];
      const target = getTarget(event);
      const isLeave = event.type === "mouseleave";
      const isOverFloatingEl = contains(elements.floating, target);
      const isOverReferenceEl = contains(elements.domReference, target);
      const refRect = elements.domReference.getBoundingClientRect();
      const rect = elements.floating.getBoundingClientRect();
      const side = placement.split("-")[0];
      const cursorLeaveFromRight = x > rect.right - rect.width / 2;
      const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
      const isOverReferenceRect = isInside(clientPoint, refRect);
      const isFloatingWider = rect.width > refRect.width;
      const isFloatingTaller = rect.height > refRect.height;
      const left = (isFloatingWider ? refRect : rect).left;
      const right = (isFloatingWider ? refRect : rect).right;
      const top = (isFloatingTaller ? refRect : rect).top;
      const bottom = (isFloatingTaller ? refRect : rect).bottom;
      if (isOverFloatingEl) {
        hasLanded = true;
        if (!isLeave) {
          return;
        }
      }
      if (isOverReferenceEl) {
        hasLanded = false;
      }
      if (isOverReferenceEl && !isLeave) {
        hasLanded = true;
        return;
      }
      if (isLeave && isElement(event.relatedTarget) && contains(elements.floating, event.relatedTarget)) {
        return;
      }
      if (tree && getChildren(tree.nodesRef.current, nodeId).some((_ref2) => {
        let {
          context
        } = _ref2;
        return context == null ? void 0 : context.open;
      })) {
        return;
      }
      if (side === "top" && y >= refRect.bottom - 1 || side === "bottom" && y <= refRect.top + 1 || side === "left" && x >= refRect.right - 1 || side === "right" && x <= refRect.left + 1) {
        return close();
      }
      let rectPoly = [];
      switch (side) {
        case "top":
          rectPoly = [[left, refRect.top + 1], [left, rect.bottom - 1], [right, rect.bottom - 1], [right, refRect.top + 1]];
          break;
        case "bottom":
          rectPoly = [[left, rect.top + 1], [left, refRect.bottom - 1], [right, refRect.bottom - 1], [right, rect.top + 1]];
          break;
        case "left":
          rectPoly = [[rect.right - 1, bottom], [rect.right - 1, top], [refRect.left + 1, top], [refRect.left + 1, bottom]];
          break;
        case "right":
          rectPoly = [[refRect.right - 1, bottom], [refRect.right - 1, top], [rect.left + 1, top], [rect.left + 1, bottom]];
          break;
      }
      function getPolygon(_ref3) {
        let [x2, y2] = _ref3;
        switch (side) {
          case "top": {
            const cursorPointOne = [isFloatingWider ? x2 + buffer / 2 : cursorLeaveFromRight ? x2 + buffer * 4 : x2 - buffer * 4, y2 + buffer + 1];
            const cursorPointTwo = [isFloatingWider ? x2 - buffer / 2 : cursorLeaveFromRight ? x2 + buffer * 4 : x2 - buffer * 4, y2 + buffer + 1];
            const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer]];
            return [cursorPointOne, cursorPointTwo, ...commonPoints];
          }
          case "bottom": {
            const cursorPointOne = [isFloatingWider ? x2 + buffer / 2 : cursorLeaveFromRight ? x2 + buffer * 4 : x2 - buffer * 4, y2 - buffer];
            const cursorPointTwo = [isFloatingWider ? x2 - buffer / 2 : cursorLeaveFromRight ? x2 + buffer * 4 : x2 - buffer * 4, y2 - buffer];
            const commonPoints = [[rect.left, cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom], [rect.right, cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer]];
            return [cursorPointOne, cursorPointTwo, ...commonPoints];
          }
          case "left": {
            const cursorPointOne = [x2 + buffer + 1, isFloatingTaller ? y2 + buffer / 2 : cursorLeaveFromBottom ? y2 + buffer * 4 : y2 - buffer * 4];
            const cursorPointTwo = [x2 + buffer + 1, isFloatingTaller ? y2 - buffer / 2 : cursorLeaveFromBottom ? y2 + buffer * 4 : y2 - buffer * 4];
            const commonPoints = [[cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer, rect.bottom]];
            return [...commonPoints, cursorPointOne, cursorPointTwo];
          }
          case "right": {
            const cursorPointOne = [x2 - buffer, isFloatingTaller ? y2 + buffer / 2 : cursorLeaveFromBottom ? y2 + buffer * 4 : y2 - buffer * 4];
            const cursorPointTwo = [x2 - buffer, isFloatingTaller ? y2 - buffer / 2 : cursorLeaveFromBottom ? y2 + buffer * 4 : y2 - buffer * 4];
            const commonPoints = [[cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right, rect.top], [cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer, rect.bottom]];
            return [cursorPointOne, cursorPointTwo, ...commonPoints];
          }
        }
      }
      if (isPointInPolygon([clientX, clientY], rectPoly)) {
        return;
      }
      if (hasLanded && !isOverReferenceRect) {
        return close();
      }
      if (!isLeave && requireIntent) {
        const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
        const cursorSpeedThreshold = 0.1;
        if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) {
          return close();
        }
      }
      if (!isPointInPolygon([clientX, clientY], getPolygon([x, y]))) {
        close();
      } else if (!hasLanded && requireIntent) {
        timeoutId2 = window.setTimeout(close, 40);
      }
    };
  };
  fn.__options = {
    blockPointerEvents
  };
  return fn;
}

// ../../components/dist/esm/Checkbox/Checkbox.js
import { forwardRef as forwardRef17, useCallback as useCallback10, useEffect as useEffect13 } from "react";

// ../../styles/dist/esm/__generated__/AuraColor.js
var AURA_COLORS = [
  "amber",
  "blue",
  "cyan",
  "fuchsia",
  "gray",
  "green",
  "grey",
  "indigo",
  "lime",
  "magenta",
  "mint",
  "orange",
  "pink",
  "purple",
  "red",
  "rose",
  "teal",
  "violet",
  "yellow"
];

// ../../styles/dist/esm/ColorThemeProvider/ColorThemeProvider.js
import React5, { forwardRef as forwardRef14, useContext as useContext7 } from "react";

// ../../styles/dist/esm/hooks/useColorTheme.js
import { useContext as useContext6, useMemo as useMemo9 } from "react";

// ../../styles/dist/esm/ColorThemeProvider/ColorThemeContext.js
import { createContext as createContext4 } from "react";
var ColorThemeContext = createContext4(null);

// ../../config/style-dictionary/dist/esm/variables.js
var variables_exports = {};
__export(variables_exports, {
  AngleBase120deg: () => AngleBase120deg,
  AngleBase90deg: () => AngleBase90deg,
  AngleBase96deg: () => AngleBase96deg,
  AngleGradientBackground: () => AngleGradientBackground,
  AngleGradientSelectorBackground: () => AngleGradientSelectorBackground,
  ColorBackgroundGlassDark: () => ColorBackgroundGlassDark,
  ColorBackgroundGlassLight: () => ColorBackgroundGlassLight,
  ColorBackgroundInvertedlowcontrastDark: () => ColorBackgroundInvertedlowcontrastDark,
  ColorBackgroundInvertedlowcontrastLight: () => ColorBackgroundInvertedlowcontrastLight,
  ColorBackgroundNegativeDark: () => ColorBackgroundNegativeDark,
  ColorBackgroundNegativeLight: () => ColorBackgroundNegativeLight,
  ColorBackgroundNeutralDark: () => ColorBackgroundNeutralDark,
  ColorBackgroundNeutralLight: () => ColorBackgroundNeutralLight,
  ColorBackgroundNoticeDark: () => ColorBackgroundNoticeDark,
  ColorBackgroundNoticeLight: () => ColorBackgroundNoticeLight,
  ColorBackgroundObjectDark: () => ColorBackgroundObjectDark,
  ColorBackgroundObjectInvertedDark: () => ColorBackgroundObjectInvertedDark,
  ColorBackgroundObjectInvertedLight: () => ColorBackgroundObjectInvertedLight,
  ColorBackgroundObjectLight: () => ColorBackgroundObjectLight,
  ColorBackgroundPageDark: () => ColorBackgroundPageDark,
  ColorBackgroundPageInvertedDark: () => ColorBackgroundPageInvertedDark,
  ColorBackgroundPageInvertedLight: () => ColorBackgroundPageInvertedLight,
  ColorBackgroundPageLight: () => ColorBackgroundPageLight,
  ColorBackgroundPositiveDark: () => ColorBackgroundPositiveDark,
  ColorBackgroundPositiveLight: () => ColorBackgroundPositiveLight,
  ColorBaseAmber100: () => ColorBaseAmber100,
  ColorBaseAmber1000: () => ColorBaseAmber1000,
  ColorBaseAmber200: () => ColorBaseAmber200,
  ColorBaseAmber300: () => ColorBaseAmber300,
  ColorBaseAmber400: () => ColorBaseAmber400,
  ColorBaseAmber50: () => ColorBaseAmber50,
  ColorBaseAmber500: () => ColorBaseAmber500,
  ColorBaseAmber600: () => ColorBaseAmber600,
  ColorBaseAmber700: () => ColorBaseAmber700,
  ColorBaseAmber800: () => ColorBaseAmber800,
  ColorBaseAmber900: () => ColorBaseAmber900,
  ColorBaseAmber950: () => ColorBaseAmber950,
  ColorBaseBlue100: () => ColorBaseBlue100,
  ColorBaseBlue1000: () => ColorBaseBlue1000,
  ColorBaseBlue200: () => ColorBaseBlue200,
  ColorBaseBlue300: () => ColorBaseBlue300,
  ColorBaseBlue400: () => ColorBaseBlue400,
  ColorBaseBlue50: () => ColorBaseBlue50,
  ColorBaseBlue500: () => ColorBaseBlue500,
  ColorBaseBlue600: () => ColorBaseBlue600,
  ColorBaseBlue700: () => ColorBaseBlue700,
  ColorBaseBlue800: () => ColorBaseBlue800,
  ColorBaseBlue900: () => ColorBaseBlue900,
  ColorBaseBlue950: () => ColorBaseBlue950,
  ColorBaseCyan100: () => ColorBaseCyan100,
  ColorBaseCyan1000: () => ColorBaseCyan1000,
  ColorBaseCyan200: () => ColorBaseCyan200,
  ColorBaseCyan300: () => ColorBaseCyan300,
  ColorBaseCyan400: () => ColorBaseCyan400,
  ColorBaseCyan50: () => ColorBaseCyan50,
  ColorBaseCyan500: () => ColorBaseCyan500,
  ColorBaseCyan600: () => ColorBaseCyan600,
  ColorBaseCyan700: () => ColorBaseCyan700,
  ColorBaseCyan800: () => ColorBaseCyan800,
  ColorBaseCyan900: () => ColorBaseCyan900,
  ColorBaseCyan950: () => ColorBaseCyan950,
  ColorBaseFuchsia100: () => ColorBaseFuchsia100,
  ColorBaseFuchsia1000: () => ColorBaseFuchsia1000,
  ColorBaseFuchsia200: () => ColorBaseFuchsia200,
  ColorBaseFuchsia300: () => ColorBaseFuchsia300,
  ColorBaseFuchsia400: () => ColorBaseFuchsia400,
  ColorBaseFuchsia50: () => ColorBaseFuchsia50,
  ColorBaseFuchsia500: () => ColorBaseFuchsia500,
  ColorBaseFuchsia600: () => ColorBaseFuchsia600,
  ColorBaseFuchsia700: () => ColorBaseFuchsia700,
  ColorBaseFuchsia800: () => ColorBaseFuchsia800,
  ColorBaseFuchsia900: () => ColorBaseFuchsia900,
  ColorBaseFuchsia950: () => ColorBaseFuchsia950,
  ColorBaseGray0: () => ColorBaseGray0,
  ColorBaseGray100: () => ColorBaseGray100,
  ColorBaseGray1000: () => ColorBaseGray1000,
  ColorBaseGray150: () => ColorBaseGray150,
  ColorBaseGray200: () => ColorBaseGray200,
  ColorBaseGray250: () => ColorBaseGray250,
  ColorBaseGray300: () => ColorBaseGray300,
  ColorBaseGray350: () => ColorBaseGray350,
  ColorBaseGray400: () => ColorBaseGray400,
  ColorBaseGray450: () => ColorBaseGray450,
  ColorBaseGray50: () => ColorBaseGray50,
  ColorBaseGray500: () => ColorBaseGray500,
  ColorBaseGray550: () => ColorBaseGray550,
  ColorBaseGray600: () => ColorBaseGray600,
  ColorBaseGray650: () => ColorBaseGray650,
  ColorBaseGray700: () => ColorBaseGray700,
  ColorBaseGray750: () => ColorBaseGray750,
  ColorBaseGray800: () => ColorBaseGray800,
  ColorBaseGray850: () => ColorBaseGray850,
  ColorBaseGray900: () => ColorBaseGray900,
  ColorBaseGray950: () => ColorBaseGray950,
  ColorBaseGreen100: () => ColorBaseGreen100,
  ColorBaseGreen1000: () => ColorBaseGreen1000,
  ColorBaseGreen200: () => ColorBaseGreen200,
  ColorBaseGreen300: () => ColorBaseGreen300,
  ColorBaseGreen400: () => ColorBaseGreen400,
  ColorBaseGreen50: () => ColorBaseGreen50,
  ColorBaseGreen500: () => ColorBaseGreen500,
  ColorBaseGreen600: () => ColorBaseGreen600,
  ColorBaseGreen700: () => ColorBaseGreen700,
  ColorBaseGreen800: () => ColorBaseGreen800,
  ColorBaseGreen900: () => ColorBaseGreen900,
  ColorBaseGreen950: () => ColorBaseGreen950,
  ColorBaseIndigo100: () => ColorBaseIndigo100,
  ColorBaseIndigo1000: () => ColorBaseIndigo1000,
  ColorBaseIndigo200: () => ColorBaseIndigo200,
  ColorBaseIndigo300: () => ColorBaseIndigo300,
  ColorBaseIndigo400: () => ColorBaseIndigo400,
  ColorBaseIndigo50: () => ColorBaseIndigo50,
  ColorBaseIndigo500: () => ColorBaseIndigo500,
  ColorBaseIndigo600: () => ColorBaseIndigo600,
  ColorBaseIndigo700: () => ColorBaseIndigo700,
  ColorBaseIndigo800: () => ColorBaseIndigo800,
  ColorBaseIndigo900: () => ColorBaseIndigo900,
  ColorBaseIndigo950: () => ColorBaseIndigo950,
  ColorBaseLime100: () => ColorBaseLime100,
  ColorBaseLime1000: () => ColorBaseLime1000,
  ColorBaseLime200: () => ColorBaseLime200,
  ColorBaseLime300: () => ColorBaseLime300,
  ColorBaseLime400: () => ColorBaseLime400,
  ColorBaseLime50: () => ColorBaseLime50,
  ColorBaseLime500: () => ColorBaseLime500,
  ColorBaseLime600: () => ColorBaseLime600,
  ColorBaseLime700: () => ColorBaseLime700,
  ColorBaseLime800: () => ColorBaseLime800,
  ColorBaseLime900: () => ColorBaseLime900,
  ColorBaseLime950: () => ColorBaseLime950,
  ColorBaseMagenta100: () => ColorBaseMagenta100,
  ColorBaseMagenta1000: () => ColorBaseMagenta1000,
  ColorBaseMagenta200: () => ColorBaseMagenta200,
  ColorBaseMagenta300: () => ColorBaseMagenta300,
  ColorBaseMagenta400: () => ColorBaseMagenta400,
  ColorBaseMagenta50: () => ColorBaseMagenta50,
  ColorBaseMagenta500: () => ColorBaseMagenta500,
  ColorBaseMagenta600: () => ColorBaseMagenta600,
  ColorBaseMagenta700: () => ColorBaseMagenta700,
  ColorBaseMagenta800: () => ColorBaseMagenta800,
  ColorBaseMagenta900: () => ColorBaseMagenta900,
  ColorBaseMagenta950: () => ColorBaseMagenta950,
  ColorBaseMint100: () => ColorBaseMint100,
  ColorBaseMint1000: () => ColorBaseMint1000,
  ColorBaseMint200: () => ColorBaseMint200,
  ColorBaseMint300: () => ColorBaseMint300,
  ColorBaseMint400: () => ColorBaseMint400,
  ColorBaseMint50: () => ColorBaseMint50,
  ColorBaseMint500: () => ColorBaseMint500,
  ColorBaseMint600: () => ColorBaseMint600,
  ColorBaseMint700: () => ColorBaseMint700,
  ColorBaseMint800: () => ColorBaseMint800,
  ColorBaseMint900: () => ColorBaseMint900,
  ColorBaseMint950: () => ColorBaseMint950,
  ColorBaseOrange100: () => ColorBaseOrange100,
  ColorBaseOrange1000: () => ColorBaseOrange1000,
  ColorBaseOrange200: () => ColorBaseOrange200,
  ColorBaseOrange300: () => ColorBaseOrange300,
  ColorBaseOrange400: () => ColorBaseOrange400,
  ColorBaseOrange50: () => ColorBaseOrange50,
  ColorBaseOrange500: () => ColorBaseOrange500,
  ColorBaseOrange600: () => ColorBaseOrange600,
  ColorBaseOrange700: () => ColorBaseOrange700,
  ColorBaseOrange800: () => ColorBaseOrange800,
  ColorBaseOrange900: () => ColorBaseOrange900,
  ColorBaseOrange950: () => ColorBaseOrange950,
  ColorBasePink100: () => ColorBasePink100,
  ColorBasePink1000: () => ColorBasePink1000,
  ColorBasePink200: () => ColorBasePink200,
  ColorBasePink300: () => ColorBasePink300,
  ColorBasePink400: () => ColorBasePink400,
  ColorBasePink50: () => ColorBasePink50,
  ColorBasePink500: () => ColorBasePink500,
  ColorBasePink600: () => ColorBasePink600,
  ColorBasePink700: () => ColorBasePink700,
  ColorBasePink800: () => ColorBasePink800,
  ColorBasePink900: () => ColorBasePink900,
  ColorBasePink950: () => ColorBasePink950,
  ColorBasePurple100: () => ColorBasePurple100,
  ColorBasePurple1000: () => ColorBasePurple1000,
  ColorBasePurple200: () => ColorBasePurple200,
  ColorBasePurple300: () => ColorBasePurple300,
  ColorBasePurple400: () => ColorBasePurple400,
  ColorBasePurple50: () => ColorBasePurple50,
  ColorBasePurple500: () => ColorBasePurple500,
  ColorBasePurple600: () => ColorBasePurple600,
  ColorBasePurple700: () => ColorBasePurple700,
  ColorBasePurple800: () => ColorBasePurple800,
  ColorBasePurple900: () => ColorBasePurple900,
  ColorBasePurple950: () => ColorBasePurple950,
  ColorBaseRed100: () => ColorBaseRed100,
  ColorBaseRed1000: () => ColorBaseRed1000,
  ColorBaseRed200: () => ColorBaseRed200,
  ColorBaseRed300: () => ColorBaseRed300,
  ColorBaseRed400: () => ColorBaseRed400,
  ColorBaseRed50: () => ColorBaseRed50,
  ColorBaseRed500: () => ColorBaseRed500,
  ColorBaseRed600: () => ColorBaseRed600,
  ColorBaseRed700: () => ColorBaseRed700,
  ColorBaseRed800: () => ColorBaseRed800,
  ColorBaseRed900: () => ColorBaseRed900,
  ColorBaseRed950: () => ColorBaseRed950,
  ColorBaseRose100: () => ColorBaseRose100,
  ColorBaseRose1000: () => ColorBaseRose1000,
  ColorBaseRose200: () => ColorBaseRose200,
  ColorBaseRose300: () => ColorBaseRose300,
  ColorBaseRose400: () => ColorBaseRose400,
  ColorBaseRose50: () => ColorBaseRose50,
  ColorBaseRose500: () => ColorBaseRose500,
  ColorBaseRose600: () => ColorBaseRose600,
  ColorBaseRose700: () => ColorBaseRose700,
  ColorBaseRose800: () => ColorBaseRose800,
  ColorBaseRose900: () => ColorBaseRose900,
  ColorBaseRose950: () => ColorBaseRose950,
  ColorBaseTeal100: () => ColorBaseTeal100,
  ColorBaseTeal1000: () => ColorBaseTeal1000,
  ColorBaseTeal200: () => ColorBaseTeal200,
  ColorBaseTeal300: () => ColorBaseTeal300,
  ColorBaseTeal400: () => ColorBaseTeal400,
  ColorBaseTeal50: () => ColorBaseTeal50,
  ColorBaseTeal500: () => ColorBaseTeal500,
  ColorBaseTeal600: () => ColorBaseTeal600,
  ColorBaseTeal700: () => ColorBaseTeal700,
  ColorBaseTeal800: () => ColorBaseTeal800,
  ColorBaseTeal900: () => ColorBaseTeal900,
  ColorBaseTeal950: () => ColorBaseTeal950,
  ColorBaseTransparent: () => ColorBaseTransparent,
  ColorBaseViolet100: () => ColorBaseViolet100,
  ColorBaseViolet1000: () => ColorBaseViolet1000,
  ColorBaseViolet200: () => ColorBaseViolet200,
  ColorBaseViolet300: () => ColorBaseViolet300,
  ColorBaseViolet400: () => ColorBaseViolet400,
  ColorBaseViolet50: () => ColorBaseViolet50,
  ColorBaseViolet500: () => ColorBaseViolet500,
  ColorBaseViolet600: () => ColorBaseViolet600,
  ColorBaseViolet700: () => ColorBaseViolet700,
  ColorBaseViolet800: () => ColorBaseViolet800,
  ColorBaseViolet900: () => ColorBaseViolet900,
  ColorBaseViolet950: () => ColorBaseViolet950,
  ColorBaseWhite: () => ColorBaseWhite,
  ColorBaseYellow100: () => ColorBaseYellow100,
  ColorBaseYellow1000: () => ColorBaseYellow1000,
  ColorBaseYellow200: () => ColorBaseYellow200,
  ColorBaseYellow300: () => ColorBaseYellow300,
  ColorBaseYellow400: () => ColorBaseYellow400,
  ColorBaseYellow50: () => ColorBaseYellow50,
  ColorBaseYellow500: () => ColorBaseYellow500,
  ColorBaseYellow600: () => ColorBaseYellow600,
  ColorBaseYellow700: () => ColorBaseYellow700,
  ColorBaseYellow800: () => ColorBaseYellow800,
  ColorBaseYellow900: () => ColorBaseYellow900,
  ColorBaseYellow950: () => ColorBaseYellow950,
  ColorBorderHighcontrastDark: () => ColorBorderHighcontrastDark,
  ColorBorderHighcontrastInvertedDark: () => ColorBorderHighcontrastInvertedDark,
  ColorBorderHighcontrastInvertedLight: () => ColorBorderHighcontrastInvertedLight,
  ColorBorderHighcontrastLight: () => ColorBorderHighcontrastLight,
  ColorBorderLowcontrastDark: () => ColorBorderLowcontrastDark,
  ColorBorderLowcontrastLight: () => ColorBorderLowcontrastLight,
  ColorBorderMediumcontrastDark: () => ColorBorderMediumcontrastDark,
  ColorBorderMediumcontrastLight: () => ColorBorderMediumcontrastLight,
  ColorCodeWindowDark: () => ColorCodeWindowDark,
  ColorCodeWindowLight: () => ColorCodeWindowLight,
  ColorLinkAlternateDark: () => ColorLinkAlternateDark,
  ColorLinkAlternateLight: () => ColorLinkAlternateLight,
  ColorLinkDefaultDark: () => ColorLinkDefaultDark,
  ColorLinkDefaultLight: () => ColorLinkDefaultLight,
  ColorLinkFocusDark: () => ColorLinkFocusDark,
  ColorLinkFocusLight: () => ColorLinkFocusLight,
  ColorLinkHoverDark: () => ColorLinkHoverDark,
  ColorLinkHoverInvertedDark: () => ColorLinkHoverInvertedDark,
  ColorLinkHoverInvertedLight: () => ColorLinkHoverInvertedLight,
  ColorLinkHoverLight: () => ColorLinkHoverLight,
  ColorLinkInactiveDark: () => ColorLinkInactiveDark,
  ColorLinkInactiveLight: () => ColorLinkInactiveLight,
  ColorLinkPressedDark: () => ColorLinkPressedDark,
  ColorLinkPressedLight: () => ColorLinkPressedLight,
  ColorLinkSelectedDark: () => ColorLinkSelectedDark,
  ColorLinkSelectedLight: () => ColorLinkSelectedLight,
  ColorLinkVisitedDark: () => ColorLinkVisitedDark,
  ColorLinkVisitedLight: () => ColorLinkVisitedLight,
  ColorScrimDark: () => ColorScrimDark,
  ColorScrimLight: () => ColorScrimLight,
  ColorStatusErrorDark: () => ColorStatusErrorDark,
  ColorStatusErrorLight: () => ColorStatusErrorLight,
  ColorStatusInfoDark: () => ColorStatusInfoDark,
  ColorStatusInfoLight: () => ColorStatusInfoLight,
  ColorStatusSuccessDark: () => ColorStatusSuccessDark,
  ColorStatusSuccessLight: () => ColorStatusSuccessLight,
  ColorStatusWarnDark: () => ColorStatusWarnDark,
  ColorStatusWarnLight: () => ColorStatusWarnLight,
  ColorTextBodyDark: () => ColorTextBodyDark,
  ColorTextBodyLight: () => ColorTextBodyLight,
  ColorTextDisabledDark: () => ColorTextDisabledDark,
  ColorTextDisabledLight: () => ColorTextDisabledLight,
  ColorTextEyebrowDark: () => ColorTextEyebrowDark,
  ColorTextEyebrowLight: () => ColorTextEyebrowLight,
  ColorTextFadedDark: () => ColorTextFadedDark,
  ColorTextFadedLight: () => ColorTextFadedLight,
  ColorTextHeadingDark: () => ColorTextHeadingDark,
  ColorTextHeadingLight: () => ColorTextHeadingLight,
  ColorTextPrimaryDark: () => ColorTextPrimaryDark,
  ColorTextPrimaryInvertedDark: () => ColorTextPrimaryInvertedDark,
  ColorTextPrimaryInvertedLight: () => ColorTextPrimaryInvertedLight,
  ColorTextPrimaryLight: () => ColorTextPrimaryLight,
  ColorTextSecondaryDark: () => ColorTextSecondaryDark,
  ColorTextSecondaryLight: () => ColorTextSecondaryLight,
  ColorTextSubheadingDark: () => ColorTextSubheadingDark,
  ColorTextSubheadingLight: () => ColorTextSubheadingLight,
  ColorTextTitleDark: () => ColorTextTitleDark,
  ColorTextTitleInvertedDark: () => ColorTextTitleInvertedDark,
  ColorTextTitleInvertedLight: () => ColorTextTitleInvertedLight,
  ColorTextTitleLight: () => ColorTextTitleLight,
  ColorTextUtilityDark: () => ColorTextUtilityDark,
  ColorTextUtilityInvertedDark: () => ColorTextUtilityInvertedDark,
  ColorTextUtilityInvertedLight: () => ColorTextUtilityInvertedLight,
  ColorTextUtilityLight: () => ColorTextUtilityLight,
  FilterBlurNormal: () => FilterBlurNormal,
  FontAmazonemberArabic: () => FontAmazonemberArabic,
  FontAmazonemberDisplay: () => FontAmazonemberDisplay,
  FontAmazonemberMono: () => FontAmazonemberMono,
  FontNotosansKorean: () => FontNotosansKorean,
  FontNotosansSimplifiedchinese: () => FontNotosansSimplifiedchinese,
  FontNotosansThai: () => FontNotosansThai,
  FontNotosansTraditionalchinese: () => FontNotosansTraditionalchinese,
  FontShingo: () => FontShingo,
  FontstackAr: () => FontstackAr,
  FontstackCn: () => FontstackCn,
  FontstackEn: () => FontstackEn,
  FontstackFallback: () => FontstackFallback,
  FontstackJp: () => FontstackJp,
  FontstackKo: () => FontstackKo,
  FontstackMonospace: () => FontstackMonospace,
  FontstackTh: () => FontstackTh,
  FontstackTw: () => FontstackTw,
  GradientBlueLightAPressed: () => GradientBlueLightAPressed,
  GradientBlueLightARegular: () => GradientBlueLightARegular,
  GradientFuchsiaDarkAPressed: () => GradientFuchsiaDarkAPressed,
  GradientFuchsiaDarkARegular: () => GradientFuchsiaDarkARegular,
  GradientFuchsiaDarkBPressed: () => GradientFuchsiaDarkBPressed,
  GradientFuchsiaDarkBRegular: () => GradientFuchsiaDarkBRegular,
  GradientFuchsiaDarkCPressed: () => GradientFuchsiaDarkCPressed,
  GradientFuchsiaDarkCRegular: () => GradientFuchsiaDarkCRegular,
  GradientFuchsiaLightAPressed: () => GradientFuchsiaLightAPressed,
  GradientFuchsiaLightARegular: () => GradientFuchsiaLightARegular,
  GradientFuchsiaLightBPressed: () => GradientFuchsiaLightBPressed,
  GradientFuchsiaLightBRegular: () => GradientFuchsiaLightBRegular,
  GradientFuchsiaLightCPressed: () => GradientFuchsiaLightCPressed,
  GradientFuchsiaLightCRegular: () => GradientFuchsiaLightCRegular,
  GradientHero1DarkA: () => GradientHero1DarkA,
  GradientHero1DarkB: () => GradientHero1DarkB,
  GradientHero1DarkC: () => GradientHero1DarkC,
  GradientHero1DarkD: () => GradientHero1DarkD,
  GradientHero1DarkE: () => GradientHero1DarkE,
  GradientHero1DarkF: () => GradientHero1DarkF,
  GradientHero1LightA: () => GradientHero1LightA,
  GradientHero1LightB: () => GradientHero1LightB,
  GradientHero1LightC: () => GradientHero1LightC,
  GradientHero1LightD: () => GradientHero1LightD,
  GradientHero1LightE: () => GradientHero1LightE,
  GradientHero1LightF: () => GradientHero1LightF,
  GradientHero2DarkA: () => GradientHero2DarkA,
  GradientHero2DarkB: () => GradientHero2DarkB,
  GradientHero2DarkC: () => GradientHero2DarkC,
  GradientHero2DarkD: () => GradientHero2DarkD,
  GradientHero2DarkE: () => GradientHero2DarkE,
  GradientHero2DarkF: () => GradientHero2DarkF,
  GradientHero2LightA: () => GradientHero2LightA,
  GradientHero2LightB: () => GradientHero2LightB,
  GradientHero2LightC: () => GradientHero2LightC,
  GradientHero2LightD: () => GradientHero2LightD,
  GradientHero2LightE: () => GradientHero2LightE,
  GradientHero2LightF: () => GradientHero2LightF,
  GradientHero3DarkA: () => GradientHero3DarkA,
  GradientHero3DarkB: () => GradientHero3DarkB,
  GradientHero3DarkC: () => GradientHero3DarkC,
  GradientHero3DarkD: () => GradientHero3DarkD,
  GradientHero3DarkE: () => GradientHero3DarkE,
  GradientHero3DarkF: () => GradientHero3DarkF,
  GradientHero3LightA: () => GradientHero3LightA,
  GradientHero3LightB: () => GradientHero3LightB,
  GradientHero3LightC: () => GradientHero3LightC,
  GradientHero3LightD: () => GradientHero3LightD,
  GradientHero3LightE: () => GradientHero3LightE,
  GradientHero3LightF: () => GradientHero3LightF,
  GradientIndigoDarkAPressed: () => GradientIndigoDarkAPressed,
  GradientIndigoDarkARegular: () => GradientIndigoDarkARegular,
  GradientIndigoDarkBPressed: () => GradientIndigoDarkBPressed,
  GradientIndigoDarkBRegular: () => GradientIndigoDarkBRegular,
  GradientIndigoDarkCPressed: () => GradientIndigoDarkCPressed,
  GradientIndigoDarkCRegular: () => GradientIndigoDarkCRegular,
  GradientIndigoLightAPressed: () => GradientIndigoLightAPressed,
  GradientIndigoLightARegular: () => GradientIndigoLightARegular,
  GradientIndigoLightBPressed: () => GradientIndigoLightBPressed,
  GradientIndigoLightBRegular: () => GradientIndigoLightBRegular,
  GradientIndigoLightCPressed: () => GradientIndigoLightCPressed,
  GradientIndigoLightCRegular: () => GradientIndigoLightCRegular,
  GradientLinear1DarkABold: () => GradientLinear1DarkABold,
  GradientLinear1DarkAStandard: () => GradientLinear1DarkAStandard,
  GradientLinear1DarkBBold: () => GradientLinear1DarkBBold,
  GradientLinear1DarkBStandard: () => GradientLinear1DarkBStandard,
  GradientLinear1DarkCBold: () => GradientLinear1DarkCBold,
  GradientLinear1DarkCStandard: () => GradientLinear1DarkCStandard,
  GradientLinear1DarkDBold: () => GradientLinear1DarkDBold,
  GradientLinear1DarkDStandard: () => GradientLinear1DarkDStandard,
  GradientLinear1DarkEBold: () => GradientLinear1DarkEBold,
  GradientLinear1DarkEStandard: () => GradientLinear1DarkEStandard,
  GradientLinear1DarkFBold: () => GradientLinear1DarkFBold,
  GradientLinear1DarkFStandard: () => GradientLinear1DarkFStandard,
  GradientLinear1DarkGBold: () => GradientLinear1DarkGBold,
  GradientLinear1DarkGStandard: () => GradientLinear1DarkGStandard,
  GradientLinear1LightABold: () => GradientLinear1LightABold,
  GradientLinear1LightAStandard: () => GradientLinear1LightAStandard,
  GradientLinear1LightBBold: () => GradientLinear1LightBBold,
  GradientLinear1LightBStandard: () => GradientLinear1LightBStandard,
  GradientLinear1LightCBold: () => GradientLinear1LightCBold,
  GradientLinear1LightCStandard: () => GradientLinear1LightCStandard,
  GradientLinear1LightDBold: () => GradientLinear1LightDBold,
  GradientLinear1LightDStandard: () => GradientLinear1LightDStandard,
  GradientLinear1LightEBold: () => GradientLinear1LightEBold,
  GradientLinear1LightEStandard: () => GradientLinear1LightEStandard,
  GradientLinear1LightFBold: () => GradientLinear1LightFBold,
  GradientLinear1LightFStandard: () => GradientLinear1LightFStandard,
  GradientLinear1LightGBold: () => GradientLinear1LightGBold,
  GradientLinear1LightGStandard: () => GradientLinear1LightGStandard,
  GradientLinear2DarkABold: () => GradientLinear2DarkABold,
  GradientLinear2DarkAStandard: () => GradientLinear2DarkAStandard,
  GradientLinear2DarkBBold: () => GradientLinear2DarkBBold,
  GradientLinear2DarkBStandard: () => GradientLinear2DarkBStandard,
  GradientLinear2DarkCBold: () => GradientLinear2DarkCBold,
  GradientLinear2DarkCStandard: () => GradientLinear2DarkCStandard,
  GradientLinear2DarkDBold: () => GradientLinear2DarkDBold,
  GradientLinear2DarkDStandard: () => GradientLinear2DarkDStandard,
  GradientLinear2DarkEBold: () => GradientLinear2DarkEBold,
  GradientLinear2DarkEStandard: () => GradientLinear2DarkEStandard,
  GradientLinear2DarkFBold: () => GradientLinear2DarkFBold,
  GradientLinear2DarkFStandard: () => GradientLinear2DarkFStandard,
  GradientLinear2DarkGBold: () => GradientLinear2DarkGBold,
  GradientLinear2DarkGStandard: () => GradientLinear2DarkGStandard,
  GradientLinear2LightABold: () => GradientLinear2LightABold,
  GradientLinear2LightAStandard: () => GradientLinear2LightAStandard,
  GradientLinear2LightBBold: () => GradientLinear2LightBBold,
  GradientLinear2LightBStandard: () => GradientLinear2LightBStandard,
  GradientLinear2LightCBold: () => GradientLinear2LightCBold,
  GradientLinear2LightCStandard: () => GradientLinear2LightCStandard,
  GradientLinear2LightDBold: () => GradientLinear2LightDBold,
  GradientLinear2LightDStandard: () => GradientLinear2LightDStandard,
  GradientLinear2LightEBold: () => GradientLinear2LightEBold,
  GradientLinear2LightEStandard: () => GradientLinear2LightEStandard,
  GradientLinear2LightFBold: () => GradientLinear2LightFBold,
  GradientLinear2LightFStandard: () => GradientLinear2LightFStandard,
  GradientLinear2LightGBold: () => GradientLinear2LightGBold,
  GradientLinear2LightGStandard: () => GradientLinear2LightGStandard,
  GradientLinear3DarkABold: () => GradientLinear3DarkABold,
  GradientLinear3DarkAStandard: () => GradientLinear3DarkAStandard,
  GradientLinear3DarkBBold: () => GradientLinear3DarkBBold,
  GradientLinear3DarkBStandard: () => GradientLinear3DarkBStandard,
  GradientLinear3DarkCBold: () => GradientLinear3DarkCBold,
  GradientLinear3DarkCStandard: () => GradientLinear3DarkCStandard,
  GradientLinear3DarkDBold: () => GradientLinear3DarkDBold,
  GradientLinear3DarkDStandard: () => GradientLinear3DarkDStandard,
  GradientLinear3DarkEBold: () => GradientLinear3DarkEBold,
  GradientLinear3DarkEStandard: () => GradientLinear3DarkEStandard,
  GradientLinear3DarkFBold: () => GradientLinear3DarkFBold,
  GradientLinear3DarkFStandard: () => GradientLinear3DarkFStandard,
  GradientLinear3DarkGBold: () => GradientLinear3DarkGBold,
  GradientLinear3DarkGStandard: () => GradientLinear3DarkGStandard,
  GradientLinear3LightABold: () => GradientLinear3LightABold,
  GradientLinear3LightAStandard: () => GradientLinear3LightAStandard,
  GradientLinear3LightBBold: () => GradientLinear3LightBBold,
  GradientLinear3LightBStandard: () => GradientLinear3LightBStandard,
  GradientLinear3LightCBold: () => GradientLinear3LightCBold,
  GradientLinear3LightCStandard: () => GradientLinear3LightCStandard,
  GradientLinear3LightDBold: () => GradientLinear3LightDBold,
  GradientLinear3LightDStandard: () => GradientLinear3LightDStandard,
  GradientLinear3LightEBold: () => GradientLinear3LightEBold,
  GradientLinear3LightEStandard: () => GradientLinear3LightEStandard,
  GradientLinear3LightFBold: () => GradientLinear3LightFBold,
  GradientLinear3LightFStandard: () => GradientLinear3LightFStandard,
  GradientLinear3LightGBold: () => GradientLinear3LightGBold,
  GradientLinear3LightGStandard: () => GradientLinear3LightGStandard,
  GradientMesh1DarkABold: () => GradientMesh1DarkABold,
  GradientMesh1DarkAStandard: () => GradientMesh1DarkAStandard,
  GradientMesh1DarkBBold: () => GradientMesh1DarkBBold,
  GradientMesh1DarkBStandard: () => GradientMesh1DarkBStandard,
  GradientMesh1DarkCBold: () => GradientMesh1DarkCBold,
  GradientMesh1DarkCStandard: () => GradientMesh1DarkCStandard,
  GradientMesh1DarkDBold: () => GradientMesh1DarkDBold,
  GradientMesh1DarkDStandard: () => GradientMesh1DarkDStandard,
  GradientMesh1DarkEBold: () => GradientMesh1DarkEBold,
  GradientMesh1DarkEStandard: () => GradientMesh1DarkEStandard,
  GradientMesh1DarkFBold: () => GradientMesh1DarkFBold,
  GradientMesh1DarkFStandard: () => GradientMesh1DarkFStandard,
  GradientMesh1DarkGBold: () => GradientMesh1DarkGBold,
  GradientMesh1DarkGStandard: () => GradientMesh1DarkGStandard,
  GradientMesh1LightABold: () => GradientMesh1LightABold,
  GradientMesh1LightAStandard: () => GradientMesh1LightAStandard,
  GradientMesh1LightBBold: () => GradientMesh1LightBBold,
  GradientMesh1LightBStandard: () => GradientMesh1LightBStandard,
  GradientMesh1LightCBold: () => GradientMesh1LightCBold,
  GradientMesh1LightCStandard: () => GradientMesh1LightCStandard,
  GradientMesh1LightDBold: () => GradientMesh1LightDBold,
  GradientMesh1LightDStandard: () => GradientMesh1LightDStandard,
  GradientMesh1LightEBold: () => GradientMesh1LightEBold,
  GradientMesh1LightEStandard: () => GradientMesh1LightEStandard,
  GradientMesh1LightFBold: () => GradientMesh1LightFBold,
  GradientMesh1LightFStandard: () => GradientMesh1LightFStandard,
  GradientMesh1LightGBold: () => GradientMesh1LightGBold,
  GradientMesh1LightGStandard: () => GradientMesh1LightGStandard,
  GradientMesh2DarkABold: () => GradientMesh2DarkABold,
  GradientMesh2DarkAStandard: () => GradientMesh2DarkAStandard,
  GradientMesh2DarkBBold: () => GradientMesh2DarkBBold,
  GradientMesh2DarkBStandard: () => GradientMesh2DarkBStandard,
  GradientMesh2DarkCBold: () => GradientMesh2DarkCBold,
  GradientMesh2DarkCStandard: () => GradientMesh2DarkCStandard,
  GradientMesh2DarkDBold: () => GradientMesh2DarkDBold,
  GradientMesh2DarkDStandard: () => GradientMesh2DarkDStandard,
  GradientMesh2DarkEBold: () => GradientMesh2DarkEBold,
  GradientMesh2DarkEStandard: () => GradientMesh2DarkEStandard,
  GradientMesh2DarkFBold: () => GradientMesh2DarkFBold,
  GradientMesh2DarkFStandard: () => GradientMesh2DarkFStandard,
  GradientMesh2DarkGBold: () => GradientMesh2DarkGBold,
  GradientMesh2DarkGStandard: () => GradientMesh2DarkGStandard,
  GradientMesh2LightABold: () => GradientMesh2LightABold,
  GradientMesh2LightAStandard: () => GradientMesh2LightAStandard,
  GradientMesh2LightBBold: () => GradientMesh2LightBBold,
  GradientMesh2LightBStandard: () => GradientMesh2LightBStandard,
  GradientMesh2LightCBold: () => GradientMesh2LightCBold,
  GradientMesh2LightCStandard: () => GradientMesh2LightCStandard,
  GradientMesh2LightDBold: () => GradientMesh2LightDBold,
  GradientMesh2LightDStandard: () => GradientMesh2LightDStandard,
  GradientMesh2LightEBold: () => GradientMesh2LightEBold,
  GradientMesh2LightEStandard: () => GradientMesh2LightEStandard,
  GradientMesh2LightFBold: () => GradientMesh2LightFBold,
  GradientMesh2LightFStandard: () => GradientMesh2LightFStandard,
  GradientMesh2LightGBold: () => GradientMesh2LightGBold,
  GradientMesh2LightGStandard: () => GradientMesh2LightGStandard,
  GradientMesh3DarkABold: () => GradientMesh3DarkABold,
  GradientMesh3DarkAStandard: () => GradientMesh3DarkAStandard,
  GradientMesh3DarkBBold: () => GradientMesh3DarkBBold,
  GradientMesh3DarkBStandard: () => GradientMesh3DarkBStandard,
  GradientMesh3DarkCBold: () => GradientMesh3DarkCBold,
  GradientMesh3DarkCStandard: () => GradientMesh3DarkCStandard,
  GradientMesh3DarkDBold: () => GradientMesh3DarkDBold,
  GradientMesh3DarkDStandard: () => GradientMesh3DarkDStandard,
  GradientMesh3DarkEBold: () => GradientMesh3DarkEBold,
  GradientMesh3DarkEStandard: () => GradientMesh3DarkEStandard,
  GradientMesh3DarkFBold: () => GradientMesh3DarkFBold,
  GradientMesh3DarkFStandard: () => GradientMesh3DarkFStandard,
  GradientMesh3DarkGBold: () => GradientMesh3DarkGBold,
  GradientMesh3DarkGStandard: () => GradientMesh3DarkGStandard,
  GradientMesh3LightABold: () => GradientMesh3LightABold,
  GradientMesh3LightAStandard: () => GradientMesh3LightAStandard,
  GradientMesh3LightBBold: () => GradientMesh3LightBBold,
  GradientMesh3LightBStandard: () => GradientMesh3LightBStandard,
  GradientMesh3LightCBold: () => GradientMesh3LightCBold,
  GradientMesh3LightCStandard: () => GradientMesh3LightCStandard,
  GradientMesh3LightDBold: () => GradientMesh3LightDBold,
  GradientMesh3LightDStandard: () => GradientMesh3LightDStandard,
  GradientMesh3LightEBold: () => GradientMesh3LightEBold,
  GradientMesh3LightEStandard: () => GradientMesh3LightEStandard,
  GradientMesh3LightFBold: () => GradientMesh3LightFBold,
  GradientMesh3LightFStandard: () => GradientMesh3LightFStandard,
  GradientMesh3LightGBold: () => GradientMesh3LightGBold,
  GradientMesh3LightGStandard: () => GradientMesh3LightGStandard,
  GradientOrangeDarkAPressed: () => GradientOrangeDarkAPressed,
  GradientOrangeDarkARegular: () => GradientOrangeDarkARegular,
  GradientOrangeDarkBPressed: () => GradientOrangeDarkBPressed,
  GradientOrangeDarkBRegular: () => GradientOrangeDarkBRegular,
  GradientOrangeDarkCPressed: () => GradientOrangeDarkCPressed,
  GradientOrangeDarkCRegular: () => GradientOrangeDarkCRegular,
  GradientOrangeLightAPressed: () => GradientOrangeLightAPressed,
  GradientOrangeLightARegular: () => GradientOrangeLightARegular,
  GradientOrangeLightBPressed: () => GradientOrangeLightBPressed,
  GradientOrangeLightBRegular: () => GradientOrangeLightBRegular,
  GradientOrangeLightCPressed: () => GradientOrangeLightCPressed,
  GradientOrangeLightCRegular: () => GradientOrangeLightCRegular,
  GradientPurpleLightAPressed: () => GradientPurpleLightAPressed,
  GradientPurpleLightARegular: () => GradientPurpleLightARegular,
  GradientShadow1DarkA: () => GradientShadow1DarkA,
  GradientShadow1DarkB: () => GradientShadow1DarkB,
  GradientShadow1DarkC: () => GradientShadow1DarkC,
  GradientShadow1DarkD: () => GradientShadow1DarkD,
  GradientShadow1DarkE: () => GradientShadow1DarkE,
  GradientShadow1DarkF: () => GradientShadow1DarkF,
  GradientShadow1DarkG: () => GradientShadow1DarkG,
  GradientShadow1LightA: () => GradientShadow1LightA,
  GradientShadow1LightB: () => GradientShadow1LightB,
  GradientShadow1LightC: () => GradientShadow1LightC,
  GradientShadow1LightD: () => GradientShadow1LightD,
  GradientShadow1LightE: () => GradientShadow1LightE,
  GradientShadow1LightF: () => GradientShadow1LightF,
  GradientShadow1LightG: () => GradientShadow1LightG,
  GradientShadow2DarkA: () => GradientShadow2DarkA,
  GradientShadow2DarkB: () => GradientShadow2DarkB,
  GradientShadow2DarkC: () => GradientShadow2DarkC,
  GradientShadow2DarkD: () => GradientShadow2DarkD,
  GradientShadow2DarkE: () => GradientShadow2DarkE,
  GradientShadow2DarkF: () => GradientShadow2DarkF,
  GradientShadow2DarkG: () => GradientShadow2DarkG,
  GradientShadow2LightA: () => GradientShadow2LightA,
  GradientShadow2LightB: () => GradientShadow2LightB,
  GradientShadow2LightC: () => GradientShadow2LightC,
  GradientShadow2LightD: () => GradientShadow2LightD,
  GradientShadow2LightE: () => GradientShadow2LightE,
  GradientShadow2LightF: () => GradientShadow2LightF,
  GradientShadow2LightG: () => GradientShadow2LightG,
  GradientShadow3DarkA: () => GradientShadow3DarkA,
  GradientShadow3DarkB: () => GradientShadow3DarkB,
  GradientShadow3DarkC: () => GradientShadow3DarkC,
  GradientShadow3DarkD: () => GradientShadow3DarkD,
  GradientShadow3DarkE: () => GradientShadow3DarkE,
  GradientShadow3DarkF: () => GradientShadow3DarkF,
  GradientShadow3DarkG: () => GradientShadow3DarkG,
  GradientShadow3LightA: () => GradientShadow3LightA,
  GradientShadow3LightB: () => GradientShadow3LightB,
  GradientShadow3LightC: () => GradientShadow3LightC,
  GradientShadow3LightD: () => GradientShadow3LightD,
  GradientShadow3LightE: () => GradientShadow3LightE,
  GradientShadow3LightF: () => GradientShadow3LightF,
  GradientShadow3LightG: () => GradientShadow3LightG,
  GradientTealDarkAPressed: () => GradientTealDarkAPressed,
  GradientTealDarkARegular: () => GradientTealDarkARegular,
  GradientTealDarkBPressed: () => GradientTealDarkBPressed,
  GradientTealDarkBRegular: () => GradientTealDarkBRegular,
  GradientTealDarkCPressed: () => GradientTealDarkCPressed,
  GradientTealDarkCRegular: () => GradientTealDarkCRegular,
  GradientTealLightAPressed: () => GradientTealLightAPressed,
  GradientTealLightARegular: () => GradientTealLightARegular,
  GradientTealLightBPressed: () => GradientTealLightBPressed,
  GradientTealLightBRegular: () => GradientTealLightBRegular,
  GradientTealLightCPressed: () => GradientTealLightCPressed,
  GradientTealLightCRegular: () => GradientTealLightCRegular,
  GradientVioletLightAPressed: () => GradientVioletLightAPressed,
  GradientVioletLightARegular: () => GradientVioletLightARegular,
  MultiplierSpacing: () => MultiplierSpacing,
  RadiusBlurBackdropGlass: () => RadiusBlurBackdropGlass,
  RadiusBlurHover: () => RadiusBlurHover,
  RadiusBlurNormal: () => RadiusBlurNormal,
  RadiusBlurPressed: () => RadiusBlurPressed,
  ScrimLinearDarkBottom: () => ScrimLinearDarkBottom,
  ScrimLinearDarkLeft: () => ScrimLinearDarkLeft,
  ScrimLinearDarkRight: () => ScrimLinearDarkRight,
  ScrimLinearDarkTop: () => ScrimLinearDarkTop,
  ScrimLinearLightBottom: () => ScrimLinearLightBottom,
  ScrimLinearLightLeft: () => ScrimLinearLightLeft,
  ScrimLinearLightRight: () => ScrimLinearLightRight,
  ScrimLinearLightTop: () => ScrimLinearLightTop,
  ShadowBlurHover: () => ShadowBlurHover,
  ShadowBlurPressed: () => ShadowBlurPressed,
  ShadowGradientBlueDark: () => ShadowGradientBlueDark,
  ShadowGradientBlueLight: () => ShadowGradientBlueLight,
  ShadowGradientFuchsiaDark: () => ShadowGradientFuchsiaDark,
  ShadowGradientFuchsiaLight: () => ShadowGradientFuchsiaLight,
  ShadowGradientIndigoDark: () => ShadowGradientIndigoDark,
  ShadowGradientIndigoLight: () => ShadowGradientIndigoLight,
  ShadowGradientOrangeDark: () => ShadowGradientOrangeDark,
  ShadowGradientOrangeLight: () => ShadowGradientOrangeLight,
  ShadowGradientPurpleDark: () => ShadowGradientPurpleDark,
  ShadowGradientPurpleLight: () => ShadowGradientPurpleLight,
  ShadowGradientTealDark: () => ShadowGradientTealDark,
  ShadowGradientTealLight: () => ShadowGradientTealLight,
  ShadowGradientVioletDark: () => ShadowGradientVioletDark,
  ShadowGradientVioletLight: () => ShadowGradientVioletLight,
  ShadowGrayElevation1Dark: () => ShadowGrayElevation1Dark,
  ShadowGrayElevation1Light: () => ShadowGrayElevation1Light,
  ShadowGrayElevation2Dark: () => ShadowGrayElevation2Dark,
  ShadowGrayElevation2Light: () => ShadowGrayElevation2Light,
  TransitionLongDuration: () => TransitionLongDuration,
  TransitionLongFunction: () => TransitionLongFunction,
  TransitionMediumDuration: () => TransitionMediumDuration,
  TransitionMediumFunction: () => TransitionMediumFunction,
  TransitionShortDuration: () => TransitionShortDuration,
  TransitionShortFunction: () => TransitionShortFunction,
  TransitionStaggerDuration: () => TransitionStaggerDuration,
  ZindexDialogBackdrop: () => ZindexDialogBackdrop,
  ZindexGlobalnavNav: () => ZindexGlobalnavNav,
  ZindexGlobalnavScrim: () => ZindexGlobalnavScrim,
  ZindexGlobalnavSubnav: () => ZindexGlobalnavSubnav,
  ZindexPopoverArrow: () => ZindexPopoverArrow,
  ZindexStickywrapperDefault: () => ZindexStickywrapperDefault,
  ZindexSubnavNav: () => ZindexSubnavNav,
  ZindexTableStickyHeader: () => ZindexTableStickyHeader
});
var AngleBase90deg = "90deg";
var AngleBase96deg = "96deg";
var AngleBase120deg = "120deg";
var AngleGradientBackground = "120deg";
var AngleGradientSelectorBackground = "96deg";
var ColorBackgroundPageLight = "#ffffff";
var ColorBackgroundPageDark = "#0f141a";
var ColorBackgroundPageInvertedLight = "#0f141a";
var ColorBackgroundPageInvertedDark = "#ffffff";
var ColorBackgroundObjectLight = "#f3f3f7";
var ColorBackgroundObjectDark = "#1b232d";
var ColorBackgroundObjectInvertedLight = "#232b37";
var ColorBackgroundObjectInvertedDark = "#f6f6f9";
var ColorBackgroundInvertedlowcontrastLight = "#656871";
var ColorBackgroundInvertedlowcontrastDark = "#ccccd1";
var ColorBackgroundGlassLight = "rgba(#ffffff, 0.75)";
var ColorBackgroundGlassDark = "rgba(#0f141a, 0.75)";
var ColorBackgroundPositiveLight = "#d9ffd6";
var ColorBackgroundPositiveDark = "#00471e";
var ColorBackgroundNeutralLight = "#d1f1ff";
var ColorBackgroundNeutralDark = "#002a66";
var ColorBackgroundNoticeLight = "#ffe8bd";
var ColorBackgroundNoticeDark = "#5c1b00";
var ColorBackgroundNegativeLight = "#ffe0e0";
var ColorBackgroundNegativeDark = "#700000";
var ColorBaseTransparent = "#000000";
var ColorBaseWhite = "#ffffff";
var ColorBaseGray0 = "#ffffff";
var ColorBaseGray50 = "#fcfcfd";
var ColorBaseGray100 = "#f9f9fb";
var ColorBaseGray150 = "#f6f6f9";
var ColorBaseGray200 = "#f3f3f7";
var ColorBaseGray250 = "#ebebf0";
var ColorBaseGray300 = "#dedee3";
var ColorBaseGray350 = "#ccccd1";
var ColorBaseGray400 = "#b4b4bb";
var ColorBaseGray450 = "#a4a4ad";
var ColorBaseGray500 = "#8c8c94";
var ColorBaseGray550 = "#72747e";
var ColorBaseGray600 = "#656871";
var ColorBaseGray650 = "#424650";
var ColorBaseGray700 = "#333843";
var ColorBaseGray750 = "#232b37";
var ColorBaseGray800 = "#1b232d";
var ColorBaseGray850 = "#161d26";
var ColorBaseGray900 = "#131920";
var ColorBaseGray950 = "#0f141a";
var ColorBaseGray1000 = "#06080a";
var ColorBaseLime50 = "#f7ffeb";
var ColorBaseLime100 = "#ebffcc";
var ColorBaseLime200 = "#d1ff8a";
var ColorBaseLime300 = "#acff2e";
var ColorBaseLime400 = "#7ae500";
var ColorBaseLime500 = "#31b800";
var ColorBaseLime600 = "#008a00";
var ColorBaseLime700 = "#007000";
var ColorBaseLime800 = "#005700";
var ColorBaseLime900 = "#003d00";
var ColorBaseLime950 = "#002e00";
var ColorBaseLime1000 = "#001400";
var ColorBaseGreen50 = "#effff1";
var ColorBaseGreen100 = "#d9ffd6";
var ColorBaseGreen200 = "#aeffa8";
var ColorBaseGreen300 = "#62ff57";
var ColorBaseGreen400 = "#00e500";
var ColorBaseGreen500 = "#2bb534";
var ColorBaseGreen600 = "#00802f";
var ColorBaseGreen700 = "#007029";
var ColorBaseGreen800 = "#005c26";
var ColorBaseGreen900 = "#00471e";
var ColorBaseGreen950 = "#003311";
var ColorBaseGreen1000 = "#001401";
var ColorBaseMint50 = "#ebfff6";
var ColorBaseMint100 = "#ccffe9";
var ColorBaseMint200 = "#8fffce";
var ColorBaseMint300 = "#3dff9e";
var ColorBaseMint400 = "#00e582";
var ColorBaseMint500 = "#00bd6b";
var ColorBaseMint600 = "#008559";
var ColorBaseMint700 = "#006b48";
var ColorBaseMint800 = "#005237";
var ColorBaseMint900 = "#00422c";
var ColorBaseMint950 = "#003322";
var ColorBaseMint1000 = "#00140e";
var ColorBaseTeal50 = "#ebfffe";
var ColorBaseTeal100 = "#ccfffc";
var ColorBaseTeal200 = "#8ffff8";
var ColorBaseTeal300 = "#00f5e4";
var ColorBaseTeal400 = "#00d6c8";
var ColorBaseTeal500 = "#00ada2";
var ColorBaseTeal600 = "#008077";
var ColorBaseTeal700 = "#00665f";
var ColorBaseTeal800 = "#00524c";
var ColorBaseTeal900 = "#003d39";
var ColorBaseTeal950 = "#003330";
var ColorBaseTeal1000 = "#001413";
var ColorBaseCyan50 = "#f0feff";
var ColorBaseCyan100 = "#d1fbff";
var ColorBaseCyan200 = "#99f7ff";
var ColorBaseCyan300 = "#3defff";
var ColorBaseCyan400 = "#00d2e5";
var ColorBaseCyan500 = "#00a4bd";
var ColorBaseCyan600 = "#007e94";
var ColorBaseCyan700 = "#00627a";
var ColorBaseCyan800 = "#004761";
var ColorBaseCyan900 = "#003652";
var ColorBaseCyan950 = "#00293d";
var ColorBaseCyan1000 = "#00111a";
var ColorBaseBlue50 = "#f0fbff";
var ColorBaseBlue100 = "#d1f1ff";
var ColorBaseBlue200 = "#b8e7ff";
var ColorBaseBlue300 = "#75cfff";
var ColorBaseBlue400 = "#42b4ff";
var ColorBaseBlue500 = "#0099ff";
var ColorBaseBlue600 = "#006ce0";
var ColorBaseBlue700 = "#004a9e";
var ColorBaseBlue800 = "#003b8f";
var ColorBaseBlue900 = "#002a66";
var ColorBaseBlue950 = "#00204d";
var ColorBaseBlue1000 = "#001129";
var ColorBaseIndigo50 = "#f5f7ff";
var ColorBaseIndigo100 = "#dbe4ff";
var ColorBaseIndigo200 = "#c2d1ff";
var ColorBaseIndigo300 = "#94afff";
var ColorBaseIndigo400 = "#7598ff";
var ColorBaseIndigo500 = "#5c7fff";
var ColorBaseIndigo600 = "#295eff";
var ColorBaseIndigo700 = "#003efa";
var ColorBaseIndigo800 = "#0033cc";
var ColorBaseIndigo900 = "#001a99";
var ColorBaseIndigo950 = "#001475";
var ColorBaseIndigo1000 = "#000833";
var ColorBaseViolet50 = "#f6f5ff";
var ColorBaseViolet100 = "#e8e5ff";
var ColorBaseViolet200 = "#d2ccff";
var ColorBaseViolet300 = "#b2a8ff";
var ColorBaseViolet400 = "#978aff";
var ColorBaseViolet500 = "#8575ff";
var ColorBaseViolet600 = "#6842ff";
var ColorBaseViolet700 = "#5724ff";
var ColorBaseViolet800 = "#4200db";
var ColorBaseViolet900 = "#35009e";
var ColorBaseViolet950 = "#250070";
var ColorBaseViolet1000 = "#110033";
var ColorBasePurple50 = "#faf5ff";
var ColorBasePurple100 = "#f2e5ff";
var ColorBasePurple200 = "#e8d1ff";
var ColorBasePurple300 = "#d4a8ff";
var ColorBasePurple400 = "#bf80ff";
var ColorBasePurple500 = "#ad5cff";
var ColorBasePurple600 = "#962eff";
var ColorBasePurple700 = "#7300e5";
var ColorBasePurple800 = "#5900b2";
var ColorBasePurple900 = "#45008a";
var ColorBasePurple950 = "#300061";
var ColorBasePurple1000 = "#1a0033";
var ColorBaseFuchsia50 = "#fdf5ff";
var ColorBaseFuchsia100 = "#fce5ff";
var ColorBaseFuchsia200 = "#f8c7ff";
var ColorBaseFuchsia300 = "#f299ff";
var ColorBaseFuchsia400 = "#ec70ff";
var ColorBaseFuchsia500 = "#e433ff";
var ColorBaseFuchsia600 = "#c300e0";
var ColorBaseFuchsia700 = "#a000b8";
var ColorBaseFuchsia800 = "#78008a";
var ColorBaseFuchsia900 = "#590066";
var ColorBaseFuchsia950 = "#43004d";
var ColorBaseFuchsia1000 = "#1f0024";
var ColorBaseMagenta50 = "#fff5fe";
var ColorBaseMagenta100 = "#ffe0fb";
var ColorBaseMagenta200 = "#ffccf8";
var ColorBaseMagenta300 = "#ff94f1";
var ColorBaseMagenta400 = "#ff57e9";
var ColorBaseMagenta500 = "#ff1ae0";
var ColorBaseMagenta600 = "#d600ba";
var ColorBaseMagenta700 = "#b2008f";
var ColorBaseMagenta800 = "#8f0072";
var ColorBaseMagenta900 = "#660052";
var ColorBaseMagenta950 = "#470039";
var ColorBaseMagenta1000 = "#24001d";
var ColorBasePink50 = "#fff5fa";
var ColorBasePink100 = "#ffe0f0";
var ColorBasePink200 = "#ffc7e3";
var ColorBasePink300 = "#ff99cc";
var ColorBasePink400 = "#ff66b2";
var ColorBasePink500 = "#ff3399";
var ColorBasePink600 = "#e5006f";
var ColorBasePink700 = "#bb005d";
var ColorBasePink800 = "#8f0047";
var ColorBasePink900 = "#660033";
var ColorBasePink950 = "#4d0020";
var ColorBasePink1000 = "#24000f";
var ColorBaseRose50 = "#fff5f8";
var ColorBaseRose100 = "#ffe0e8";
var ColorBaseRose200 = "#ffc2d1";
var ColorBaseRose300 = "#ff8fab";
var ColorBaseRose400 = "#ff5c85";
var ColorBaseRose500 = "#ff386a";
var ColorBaseRose600 = "#eb003b";
var ColorBaseRose700 = "#c20030";
var ColorBaseRose800 = "#940025";
var ColorBaseRose900 = "#6b001b";
var ColorBaseRose950 = "#4d0013";
var ColorBaseRose1000 = "#1f0008";
var ColorBaseRed50 = "#fff5f5";
var ColorBaseRed100 = "#ffe0e0";
var ColorBaseRed200 = "#ffc2c2";
var ColorBaseRed300 = "#ff9e9e";
var ColorBaseRed400 = "#ff7a7a";
var ColorBaseRed500 = "#ff3d3d";
var ColorBaseRed600 = "#db0000";
var ColorBaseRed700 = "#c20000";
var ColorBaseRed800 = "#990000";
var ColorBaseRed900 = "#700000";
var ColorBaseRed950 = "#520000";
var ColorBaseRed1000 = "#1f0000";
var ColorBaseOrange50 = "#fff7f5";
var ColorBaseOrange100 = "#ffe0d6";
var ColorBaseOrange200 = "#ffc0ad";
var ColorBaseOrange300 = "#ff997a";
var ColorBaseOrange400 = "#ff6a3d";
var ColorBaseOrange500 = "#ff4b14";
var ColorBaseOrange600 = "#db3300";
var ColorBaseOrange700 = "#a82700";
var ColorBaseOrange800 = "#8a2000";
var ColorBaseOrange900 = "#661800";
var ColorBaseOrange950 = "#471100";
var ColorBaseOrange1000 = "#1f0700";
var ColorBaseAmber50 = "#fff7e6";
var ColorBaseAmber100 = "#ffe8bd";
var ColorBaseAmber200 = "#ffd78a";
var ColorBaseAmber300 = "#ffbb45";
var ColorBaseAmber400 = "#ff9900";
var ColorBaseAmber500 = "#fa6f00";
var ColorBaseAmber600 = "#d14600";
var ColorBaseAmber700 = "#9e3700";
var ColorBaseAmber800 = "#7a2b00";
var ColorBaseAmber900 = "#5c1b00";
var ColorBaseAmber950 = "#471500";
var ColorBaseAmber1000 = "#1a0800";
var ColorBaseYellow50 = "#fffef0";
var ColorBaseYellow100 = "#fffbbd";
var ColorBaseYellow200 = "#fef571";
var ColorBaseYellow300 = "#ffed4d";
var ColorBaseYellow400 = "#ffe347";
var ColorBaseYellow500 = "#fbd332";
var ColorBaseYellow600 = "#f2b100";
var ColorBaseYellow700 = "#db9200";
var ColorBaseYellow800 = "#9e6900";
var ColorBaseYellow900 = "#855900";
var ColorBaseYellow950 = "#573a00";
var ColorBaseYellow1000 = "#291b00";
var ColorBorderLowcontrastLight = "#ccccd1";
var ColorBorderLowcontrastDark = "#424650";
var ColorBorderMediumcontrastLight = "#72747e";
var ColorBorderMediumcontrastDark = "#72747e";
var ColorBorderHighcontrastLight = "#161d26";
var ColorBorderHighcontrastDark = "#ffffff";
var ColorBorderHighcontrastInvertedLight = "#ffffff";
var ColorBorderHighcontrastInvertedDark = "#161d26";
var ColorScrimLight = "#ffffff";
var ColorScrimDark = "#131920";
var ColorStatusSuccessLight = "#00802f";
var ColorStatusSuccessDark = "#00e500";
var ColorStatusWarnLight = "#d14600";
var ColorStatusWarnDark = "#ff9900";
var ColorStatusErrorLight = "#db0000";
var ColorStatusErrorDark = "#ff7a7a";
var ColorStatusInfoLight = "#006ce0";
var ColorStatusInfoDark = "#42b4ff";
var ColorTextPrimaryLight = "#161d26";
var ColorTextPrimaryDark = "#ffffff";
var ColorTextPrimaryInvertedLight = "#ffffff";
var ColorTextPrimaryInvertedDark = "#161d26";
var ColorTextSecondaryLight = "#232b37";
var ColorTextSecondaryDark = "#f9f9fb";
var ColorTextHeadingLight = "#161d26";
var ColorTextHeadingDark = "#ffffff";
var ColorTextTitleLight = "#161d26";
var ColorTextTitleDark = "#ffffff";
var ColorTextTitleInvertedLight = "#ffffff";
var ColorTextTitleInvertedDark = "#161d26";
var ColorTextSubheadingLight = "#232b37";
var ColorTextSubheadingDark = "#f9f9fb";
var ColorTextBodyLight = "#232b37";
var ColorTextBodyDark = "#f9f9fb";
var ColorTextUtilityLight = "#161d26";
var ColorTextUtilityDark = "#ffffff";
var ColorTextUtilityInvertedLight = "#ffffff";
var ColorTextUtilityInvertedDark = "#161d26";
var ColorTextEyebrowLight = "#161d26";
var ColorTextEyebrowDark = "#ffffff";
var ColorTextFadedLight = "#72747e";
var ColorTextFadedDark = "#a4a4ad";
var ColorTextDisabledLight = "#b4b4bb";
var ColorTextDisabledDark = "#656871";
var ColorLinkDefaultLight = "#006ce0";
var ColorLinkDefaultDark = "#0099ff";
var ColorLinkAlternateLight = "#161d26";
var ColorLinkAlternateDark = "#ffffff";
var ColorLinkHoverLight = "#003b8f";
var ColorLinkHoverDark = "#75cfff";
var ColorLinkHoverInvertedLight = "#75cfff";
var ColorLinkHoverInvertedDark = "#003b8f";
var ColorLinkFocusLight = "#006ce0";
var ColorLinkFocusDark = "#0099ff";
var ColorLinkPressedLight = "#006ce0";
var ColorLinkPressedDark = "#0099ff";
var ColorLinkSelectedLight = "#006ce0";
var ColorLinkSelectedDark = "#0099ff";
var ColorLinkVisitedLight = "#6842ff";
var ColorLinkVisitedDark = "#978aff";
var ColorLinkInactiveLight = "#b4b4bb";
var ColorLinkInactiveDark = "#8c8c94";
var ColorCodeWindowLight = "#f6f6f9";
var ColorCodeWindowDark = "#333843";
var FilterBlurNormal = "blur(50px)";
var FontstackFallback = "Helvetica, Arial, sans-serif";
var FontstackMonospace = "Amazon Ember Mono, Consolas, 'Andale Mono WT', 'Andale Mono', 'Lucida Console', 'Lucida Sans Typewriter', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Liberation Mono', 'Nimbus Mono L', Monaco, 'Courier New', Courier, monospace";
var FontstackEn = "Amazon Ember Display, 'Helvetica Neue', Helvetica, Arial, sans-serif";
var FontstackAr = "AmazonEmberArabic, Helvetica, Arial, sans-serif";
var FontstackJp = "ShinGo, '\u30D2\u30E9\u30AE\u30CE\u89D2\u30B4 Pro W3', 'Hiragino Kaku Gothic Pro', Osaka, '\u30E1\u30A4\u30EA\u30AA', Meiryo, '\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF', 'MS PGothic', sans-serif";
var FontstackKo = "NotoSansKR, 'Malgun Gothic', sans-serif";
var FontstackTh = "NotoSansThai, Helvetica, Arial, sans-serif";
var FontstackCn = "NotoSansSC, Helvetica, Arial, 'Microsoft Yahei', '\u5FAE\u8F6F\u96C5\u9ED1', STXihei, '\u534E\u6587\u7EC6\u9ED1', sans-serif";
var FontstackTw = "NotoSansTC, Helvetica, Arial, 'Microsoft Yahei', '\u5FAE\u8F6F\u96C5\u9ED1', STXihei, '\u534E\u6587\u7EC6\u9ED1', sans-serif";
var FontAmazonemberArabic = "AmazonEmberArabic";
var FontAmazonemberDisplay = "Amazon Ember Display";
var FontAmazonemberMono = "Amazon Ember Mono";
var FontNotosansKorean = "NotoSansKR";
var FontNotosansThai = "NotoSansThai";
var FontNotosansSimplifiedchinese = "NotoSansSC";
var FontNotosansTraditionalchinese = "NotoSansTC";
var FontShingo = "ShinGo";
var GradientFuchsiaLightARegular = "linear-gradient(120deg, #ffc0ad 0%, #f8c7ff 37.79%, #d2ccff 75.81%, #c2d1ff 100%)";
var GradientFuchsiaLightAPressed = "linear-gradient(120deg, rgba(#ffc0ad, 0.5) 0%, rgba(#f8c7ff, 0.67) 37.79%, rgba(#d2ccff, 0.83) 75.81%, rgba(#c2d1ff, 1) 100%)";
var GradientFuchsiaLightBRegular = "linear-gradient(120deg, #ffc0ad 0%, #f8c7ff 59.42%, #d2ccff 100%)";
var GradientFuchsiaLightBPressed = "linear-gradient(120deg, rgba(#ffc0ad, 0.5) 0%, rgba(#f8c7ff, 0.75) 59.42%, rgba(#d2ccff, 1) 100%)";
var GradientFuchsiaLightCRegular = "linear-gradient(120deg, #f8c7ff 20.08%, #d2ccff 75.81%)";
var GradientFuchsiaLightCPressed = "linear-gradient(120deg, rgba(#f8c7ff, 0.5) 20.08%, rgba(#d2ccff, 1) 75.81%)";
var GradientFuchsiaDarkARegular = "linear-gradient(120deg, #00627a 0%, #003b8f 23.21%, #78008a 63.31%, #b2008f 100%)";
var GradientFuchsiaDarkAPressed = "linear-gradient(120deg, rgba(#00627a, 0.5) 0%, rgba(#003b8f, 0.67) 23.21%, rgba(#78008a, 0.83) 63.31%, rgba(#b2008f, 1) 100%)";
var GradientFuchsiaDarkBRegular = "linear-gradient(120deg, #003b8f 0%, #78008a 38.63%, #b2008f 85.71%)";
var GradientFuchsiaDarkBPressed = "linear-gradient(120deg, rgba(#003b8f, 0.5) 0%, rgba(#78008a, 0.75) 38.63%, rgba(#b2008f, 1) 85.71%)";
var GradientFuchsiaDarkCRegular = "linear-gradient(120deg, #78008a 24.25%, #b2008f 69.56%)";
var GradientFuchsiaDarkCPressed = "linear-gradient(120deg, rgba(#78008a, 0.5) 24.25%, rgba(#b2008f, 1) 69.56%)";
var GradientIndigoLightARegular = "linear-gradient(120deg, #8fffce 0%, #b8e7ff 26.85%, #c2d1ff 59.66%, #d2ccff 100%)";
var GradientIndigoLightAPressed = "linear-gradient(120deg, rgba(#8fffce, 0.5) 0%, rgba(#b8e7ff, 0.67) 26.85%, rgba(#c2d1ff, 0.83) 59.66%, rgba(#d2ccff, 1) 100%)";
var GradientIndigoLightBRegular = "linear-gradient(120deg, #8fffce 0%, #c2d1ff 70.6%, #d2ccff 100%)";
var GradientIndigoLightBPressed = "linear-gradient(120deg, rgba(#8fffce, 0.5) 0%, rgba(#c2d1ff, 0.75) 70.6%, rgba(#d2ccff, 1) 100%)";
var GradientIndigoLightCRegular = "linear-gradient(120deg, #b8e7ff 26.85%, #d2ccff 70.08%)";
var GradientIndigoLightCPressed = "linear-gradient(120deg, rgba(#b8e7ff, 0.5) 26.85%, rgba(#d2ccff, 1) 70.08%)";
var GradientIndigoDarkARegular = "linear-gradient(120deg, #00665f 0%, #003b8f 26.85%, #0033cc 44.56%, #7300e5 100%)";
var GradientIndigoDarkAPressed = "linear-gradient(120deg, rgba(#00665f, 0.5) 0%, rgba(#003b8f, 0.67) 26.85%, rgba(#0033cc, 0.83) 44.56%, rgba(#7300e5, 1) 100%)";
var GradientIndigoDarkBRegular = "linear-gradient(120deg, #003b8f 7.61%, #0033cc 29.46%, #7300e5 91.96%)";
var GradientIndigoDarkBPressed = "linear-gradient(120deg, rgba(#003b8f, 0.5) 7.61%, rgba(#0033cc, 0.75) 29.46%, rgba(#7300e5, 1) 91.96%)";
var GradientIndigoDarkCRegular = "linear-gradient(120deg, #0033cc 27.37%, #7300e5 100%)";
var GradientIndigoDarkCPressed = "linear-gradient(120deg, rgba(#0033cc, 0.5) 27.37%, rgba(#7300e5, 1) 100%)";
var GradientOrangeLightARegular = "linear-gradient(120deg, #ffccf8 0%, #ffc0ad 26.85%, #ffd78a 59.66%, #fef571 100%)";
var GradientOrangeLightAPressed = "linear-gradient(120deg, rgba(#ffccf8, 0.5) 0%, rgba(#ffc0ad, 0.67) 26.85%, rgba(#ffd78a, 0.83) 59.66%, rgba(#fef571, 1) 100%)";
var GradientOrangeLightBRegular = "linear-gradient(120deg, #ffccf8 0%, #ffc0ad 63.83%, #ffd78a 100%)";
var GradientOrangeLightBPressed = "linear-gradient(120deg, rgba(#ffccf8, 0.5) 0%, rgba(#ffc0ad, 0.75) 63.83%, rgba(#ffd78a, 1) 100%)";
var GradientOrangeLightCRegular = "linear-gradient(120deg, #ffc0ad 26.85%, #ffd78a 71.64%)";
var GradientOrangeLightCPressed = "linear-gradient(120deg, rgba(#ffc0ad, 0.5) 26.85%, rgba(#ffd78a, 1) 71.64%)";
var GradientOrangeDarkARegular = "linear-gradient(120deg, #7300e5 0%, #940025 37.85%, #a82700 73.32%, #d14600 100%)";
var GradientOrangeDarkAPressed = "linear-gradient(120deg, rgba(#7300e5, 0.5) 0%, rgba(#940025, 0.67) 37.85%, rgba(#a82700, 0.83) 73.32%, rgba(#d14600, 1) 100%)";
var GradientOrangeDarkBRegular = "linear-gradient(120deg, #940025 39.87%, #a82700 76.33%, #d14600 100%)";
var GradientOrangeDarkBPressed = "linear-gradient(120deg, rgba(#940025, 0.5) 39.87%, rgba(#a82700, 0.75) 76.33%, rgba(#d14600, 1) 100%)";
var GradientOrangeDarkCRegular = "linear-gradient(120deg, #940025 0%, #d14600 58.1%)";
var GradientOrangeDarkCPressed = "linear-gradient(120deg, rgba(#940025, 0.5) 0%, rgba(#d14600, 1) 58.1%)";
var GradientTealLightARegular = "linear-gradient(120deg, #fef571 0%, #aeffa8 29.94%, #8fffce 66.98%, #99f7ff 100%)";
var GradientTealLightAPressed = "linear-gradient(120deg, rgba(#fef571, 0.5) 0%, rgba(#aeffa8, 0.67) 29.94%, rgba(#8fffce, 0.83) 66.98%, rgba(#99f7ff, 1) 100%)";
var GradientTealLightBRegular = "linear-gradient(120deg, #fef571 0%, #8fffce 51.33%, #99f7ff 87.79%)";
var GradientTealLightBPressed = "linear-gradient(120deg, rgba(#fef571, 0.5) 0%, rgba(#8fffce, 0.75) 51.33%, rgba(#99f7ff, 1) 87.79%)";
var GradientTealLightCRegular = "linear-gradient(120deg, #8fffce 28.41%, #99f7ff 69.04%)";
var GradientTealLightCPressed = "linear-gradient(120deg, rgba(#8fffce, 0.5) 28.41%, rgba(#99f7ff, 1) 69.04%)";
var GradientTealDarkARegular = "linear-gradient(120deg, #006b48 0%, #00627a 28.7%, #004a9e 56.3%, #5724ff 86.75%)";
var GradientTealDarkAPressed = "linear-gradient(120deg, rgba(#006b48, 0.5) 0%, rgba(#00627a, 0.67) 28.7%, rgba(#004a9e, 0.83) 56.3%, rgba(#5724ff, 1) 86.75%)";
var GradientTealDarkBRegular = "linear-gradient(120deg, #006b48 0%, #00627a 60.19%, #004a9e 100%)";
var GradientTealDarkBPressed = "linear-gradient(120deg, rgba(#006b48, 0.5) 0%, rgba(#00627a, 0.75) 60.19%, rgba(#004a9e, 1) 100%)";
var GradientTealDarkCRegular = "linear-gradient(120deg, #006b48 31.54%, #00627a 74.25%)";
var GradientTealDarkCPressed = "linear-gradient(120deg, rgba(#006b48, 0.5) 31.54%, rgba(#00627a, 1) 74.25%)";
var GradientBlueLightARegular = "linear-gradient(120deg, #d1fbff 0%, #75cfff 29.13%, #978aff 70.56%)";
var GradientBlueLightAPressed = "linear-gradient(120deg, rgba(#d1fbff, 0.5) 0%, rgba(#75cfff, 0.75) 29.13%, rgba(#978aff, 1) 70.56%)";
var GradientVioletLightARegular = "linear-gradient(120deg, #ad5cff 0%, #0099ff 48.96%, #99f7ff 100%)";
var GradientVioletLightAPressed = "linear-gradient(120deg, rgba(#ad5cff, 0.5) 0%, rgba(#0099ff, 0.75) 48.96%, rgba(#99f7ff, 1) 100%)";
var GradientPurpleLightARegular = "linear-gradient(120deg, #ff94f1 7.63%, #978aff 37.94%, #00d2e5 65.23%, #8ffff8 92.12%)";
var GradientPurpleLightAPressed = "linear-gradient(120deg, rgba(#ff94f1, 0.5) 7.63%, rgba(#978aff, 0.67) 37.94%, rgba(#00d2e5, 0.83) 65.23%, rgba(#8ffff8, 1) 92.12%)";
var GradientHero1LightA = "conic-gradient(from 180deg at 50% 50%, #62ff57 94deg, #8ffff8 147deg, #62ff57 187deg, #fef571 228deg, #ec70ff 265deg)";
var GradientHero1LightB = "conic-gradient(from 180deg at 50% 50%, #42b4ff 94deg, #b8e7ff 130deg, #42b4ff 155deg, #3defff 207deg, #ff94f1 250deg)";
var GradientHero1LightC = "conic-gradient(from 180deg at 50% 50%, #75cfff 102deg, #62ff57 139deg, #00d6c8 196deg, #d1ff8a 236deg, #acff2e 266deg)";
var GradientHero1LightD = "conic-gradient(from 180deg at 50% 50%, #ffc7e3 101deg, #7598ff 123deg, #d4a8ff 151deg, #75cfff 220deg, #62ff57 242deg)";
var GradientHero1LightE = "conic-gradient(from 180deg at 50% 50%, #8ffff8 89deg, #aeffa8 133deg, #75cfff 211deg, #42b4ff 242deg, #94afff 279deg)";
var GradientHero1LightF = "conic-gradient(from 180deg at 50% 50%, #fef571 117deg, #f299ff 141deg, #d4a8ff 170deg, #75cfff 220deg, #42b4ff 254deg)";
var GradientHero1DarkA = "conic-gradient(from 180deg at 50% 50%, #00802f 94deg, #008077 147deg, #00802f 187deg, #9e6900 228deg, #c300e0 265deg)";
var GradientHero1DarkB = "conic-gradient(from 180deg at 50% 50%, #006ce0 94deg, #006ce0 130deg, #006ce0 155deg, #007e94 207deg, #d600ba 250deg)";
var GradientHero1DarkC = "conic-gradient(from 180deg at 50% 50%, #006ce0 102deg, #00802f 139deg, #008077 196deg, #008a00 236deg, #008a00 266deg)";
var GradientHero1DarkD = "conic-gradient(from 180deg at 50% 50%, #e5006f 101deg, #295eff 123deg, #962eff 151deg, #006ce0 220deg, #00802f 242deg)";
var GradientHero1DarkE = "conic-gradient(from 180deg at 50% 50%, #008077 89deg, #00802f 133deg, #006ce0 211deg, #004a9e 242deg, #003efa 279deg)";
var GradientHero1DarkF = "conic-gradient(from 180deg at 50% 50%, #9e6900 117deg, #c300e0 141deg, #962eff 170deg, #004a9e 220deg, #004a9e 254deg)";
var GradientHero2LightA = "conic-gradient(from 180deg at 50% 50%, #00d2e5 92deg, #75cfff 145deg, #99f7ff 184deg, #94afff 221deg, #42b4ff 255deg)";
var GradientHero2LightB = "conic-gradient(from 180deg at 50% 50%, #ff8fab 107deg, #ff94f1 137deg, #978aff 153deg, #8ffff8 223deg, #ff94f1 259deg)";
var GradientHero2LightC = "conic-gradient(from 180deg at 50% 50%, #ffc0ad 139deg, #ff997a 195deg, #d4a8ff 214deg, #75cfff 246deg, #42b4ff 258deg)";
var GradientHero2LightD = "conic-gradient(from 180deg at 50% 50%, #978aff 92deg, #b8e7ff 130deg, #75cfff 168deg, #d4a8ff 210deg, #bf80ff 250deg)";
var GradientHero2LightE = "conic-gradient(from 180deg at 50% 50%, #ff94f1 152deg, #ff5c85 115deg, #ff94f1 151deg, #75cfff 222deg, #3defff 301deg)";
var GradientHero2LightF = "conic-gradient(from 180deg at 50% 50%, #b2a8ff 147deg, #f299ff 169deg, #ff5c85 197deg, #ff7a7a 306deg, #ff94f1 327deg)";
var GradientHero2DarkA = "conic-gradient(from 180deg at 50% 50%, #007e94 92deg, #006ce0 145deg, #007e94 184deg, #003efa 221deg, #006ce0 255deg)";
var GradientHero2DarkB = "conic-gradient(from 180deg at 50% 50%, #eb003b 107deg, #d600ba 137deg, #5724ff 153deg, #00665f 223deg, #d600ba 259deg)";
var GradientHero2DarkC = "conic-gradient(from 180deg at 50% 50%, #db3300 139deg, #8a2000 195deg, #962eff 214deg, #006ce0 246deg, #003b8f 258deg)";
var GradientHero2DarkD = "conic-gradient(from 180deg at 50% 50%, #6842ff 92deg, #006ce0 130deg, #006ce0 168deg, #962eff 210deg, #7300e5 250deg)";
var GradientHero2DarkE = "conic-gradient(from 180deg at 50% 50%, #b2008f 152deg, #c20030 115deg, #b2008f 151deg, #006ce0 222deg, #007e94 301deg)";
var GradientHero2DarkF = "conic-gradient(from 180deg at 50% 50%, #6842ff 147deg, #c300e0 169deg, #eb003b 197deg, #db0000 306deg, #d600ba 327deg)";
var GradientHero3LightA = "conic-gradient(from 180deg at 50% 50%, #f299ff 94deg, #b2a8ff 130deg, #ff1ae0 171deg, #ff9900 222deg, #e8d1ff 270deg)";
var GradientHero3LightB = "conic-gradient(from 180deg at 50% 50%, #f299ff 94deg, #ff5c85 130deg, #ff94f1 171deg, #ff9e9e 222deg, #e8d1ff 301deg)";
var GradientHero3LightC = "conic-gradient(from 180deg at 50% 50%, #ff8fab 115deg, #ffccf8 141deg, #ec70ff 189deg, #ffed4d 219deg, #aeffa8 260deg)";
var GradientHero3LightD = "conic-gradient(from 180deg at 50% 50%, #ffc7e3 91deg, #ffbb45 139deg, #f299ff 196deg, #ff7a7a 226deg, #ffed4d 264deg)";
var GradientHero3LightE = "conic-gradient(from 180deg at 50% 50%, #acff2e 94deg, #7ae500 130deg, #fef571 158deg, #ff94f1 200deg, #ffbb45 265deg)";
var GradientHero3LightF = "conic-gradient(from 180deg at 50% 50%, #acff2e 86deg, #ffd78a 131deg, #f299ff 155deg, #d2ccff 234deg, #978aff 272deg)";
var GradientHero3DarkA = "conic-gradient(from 180deg at 50% 50%, #c300e0 94deg, #6842ff 130deg, #d600ba 171deg, #d14600 222deg, #962eff 270deg)";
var GradientHero3DarkB = "conic-gradient(from 180deg at 50% 50%, #c300e0 94deg, #eb003b 130deg, #d600ba 171deg, #db0000 222deg, #7300e5 301deg)";
var GradientHero3DarkC = "conic-gradient(from 180deg at 50% 50%, #eb003b 115deg, #d600ba 141deg, #c300e0 189deg, #db9200 219deg, #00802f 260deg)";
var GradientHero3DarkD = "conic-gradient(from 180deg at 50% 50%, #e5006f 91deg, #d14600 139deg, #c300e0 196deg, #db0000 226deg, #9e6900 264deg)";
var GradientHero3DarkE = "conic-gradient(from 180deg at 50% 50%, #008a00 94deg, #008a00 130deg, #9e6900 158deg, #d600ba 200deg, #d14600 265deg)";
var GradientHero3DarkF = "conic-gradient(from 180deg at 50% 50%, #008a00 86deg, #d14600 131deg, #c300e0 155deg, #6842ff 234deg, #6842ff 272deg)";
var GradientLinear1LightAStandard = "linear-gradient(90deg, #ec70ff, #ffed4d)";
var GradientLinear1LightABold = "linear-gradient(90deg, #a000b8, #f2b100)";
var GradientLinear1LightBStandard = "linear-gradient(90deg, #00e500, #75cfff)";
var GradientLinear1LightBBold = "linear-gradient(90deg, #007029, #006ce0)";
var GradientLinear1LightCStandard = "linear-gradient(90deg, #42b4ff, #00f5e4)";
var GradientLinear1LightCBold = "linear-gradient(90deg, #004a9e, #008077)";
var GradientLinear1LightDStandard = "linear-gradient(90deg, #7598ff, #f299ff)";
var GradientLinear1LightDBold = "linear-gradient(90deg, #003efa, #c300e0)";
var GradientLinear1LightEStandard = "linear-gradient(90deg, #42b4ff, #f299ff)";
var GradientLinear1LightEBold = "linear-gradient(90deg, #004a9e, #c300e0)";
var GradientLinear1LightFStandard = "linear-gradient(90deg, #bf80ff, #00f5e4)";
var GradientLinear1LightFBold = "linear-gradient(90deg, #7300e5, #008077)";
var GradientLinear1LightGStandard = "linear-gradient(90deg, #ec70ff, #00f5e4)";
var GradientLinear1LightGBold = "linear-gradient(90deg, #a000b8, #008077)";
var GradientLinear1DarkAStandard = "linear-gradient(90deg, #a000b8, #f2b100)";
var GradientLinear1DarkABold = "linear-gradient(90deg, #ec70ff, #ffed4d)";
var GradientLinear1DarkBStandard = "linear-gradient(90deg, #007029, #006ce0)";
var GradientLinear1DarkBBold = "linear-gradient(90deg, #00e500, #75cfff)";
var GradientLinear1DarkCStandard = "linear-gradient(90deg, #004a9e, #008077)";
var GradientLinear1DarkCBold = "linear-gradient(90deg, #42b4ff, #00f5e4)";
var GradientLinear1DarkDStandard = "linear-gradient(90deg, #003efa, #c300e0)";
var GradientLinear1DarkDBold = "linear-gradient(90deg, #7598ff, #f299ff)";
var GradientLinear1DarkEStandard = "linear-gradient(90deg, #004a9e, #c300e0)";
var GradientLinear1DarkEBold = "linear-gradient(90deg, #42b4ff, #f299ff)";
var GradientLinear1DarkFStandard = "linear-gradient(90deg, #7300e5, #008077)";
var GradientLinear1DarkFBold = "linear-gradient(90deg, #bf80ff, #00f5e4)";
var GradientLinear1DarkGStandard = "linear-gradient(90deg, #a000b8, #008077)";
var GradientLinear1DarkGBold = "linear-gradient(90deg, #ec70ff, #00f5e4)";
var GradientLinear2LightAStandard = "linear-gradient(90deg, #ff6a3d, #f299ff)";
var GradientLinear2LightABold = "linear-gradient(90deg, #a82700, #c300e0)";
var GradientLinear2LightBStandard = "linear-gradient(90deg, #ff66b2, #b2a8ff)";
var GradientLinear2LightBBold = "linear-gradient(90deg, #bb005d, #6842ff)";
var GradientLinear2LightCStandard = "linear-gradient(90deg, #ec70ff, #94afff)";
var GradientLinear2LightCBold = "linear-gradient(90deg, #a000b8, #295eff)";
var GradientLinear2LightDStandard = "linear-gradient(90deg, #42b4ff, #f299ff)";
var GradientLinear2LightDBold = "linear-gradient(90deg, #004a9e, #c300e0)";
var GradientLinear2LightEStandard = "linear-gradient(90deg, #ec70ff, #75cfff)";
var GradientLinear2LightEBold = "linear-gradient(90deg, #a000b8, #006ce0)";
var GradientLinear2LightFStandard = "linear-gradient(90deg, #978aff, #75cfff)";
var GradientLinear2LightFBold = "linear-gradient(90deg, #5724ff, #006ce0)";
var GradientLinear2LightGStandard = "linear-gradient(90deg, #42b4ff, #00f5e4)";
var GradientLinear2LightGBold = "linear-gradient(90deg, #004a9e, #008077)";
var GradientLinear2DarkAStandard = "linear-gradient(90deg, #a82700, #c300e0)";
var GradientLinear2DarkABold = "linear-gradient(90deg, #ff6a3d, #f299ff)";
var GradientLinear2DarkBStandard = "linear-gradient(90deg, #bb005d, #6842ff)";
var GradientLinear2DarkBBold = "linear-gradient(90deg, #ff66b2, #b2a8ff)";
var GradientLinear2DarkCStandard = "linear-gradient(90deg, #a000b8, #295eff)";
var GradientLinear2DarkCBold = "linear-gradient(90deg, #ec70ff, #94afff)";
var GradientLinear2DarkDStandard = "linear-gradient(90deg, #42b4ff, #f299ff)";
var GradientLinear2DarkDBold = "linear-gradient(90deg, #004a9e, #c300e0)";
var GradientLinear2DarkEStandard = "linear-gradient(90deg, #a000b8, #006ce0)";
var GradientLinear2DarkEBold = "linear-gradient(90deg, #ec70ff, #75cfff)";
var GradientLinear2DarkFStandard = "linear-gradient(90deg, #5724ff, #006ce0)";
var GradientLinear2DarkFBold = "linear-gradient(90deg, #978aff, #75cfff)";
var GradientLinear2DarkGStandard = "linear-gradient(90deg, #004a9e, #008077)";
var GradientLinear2DarkGBold = "linear-gradient(90deg, #42b4ff, #00f5e4)";
var GradientLinear3LightAStandard = "linear-gradient(90deg, #7ae500, #b2a8ff)";
var GradientLinear3LightABold = "linear-gradient(90deg, #007000, #6842ff)";
var GradientLinear3LightBStandard = "linear-gradient(90deg, #ec70ff, #ffbb45)";
var GradientLinear3LightBBold = "linear-gradient(90deg, #a000b8, #d14600)";
var GradientLinear3LightCStandard = "linear-gradient(90deg, #ff66b2, #ff997a)";
var GradientLinear3LightCBold = "linear-gradient(90deg, #bb005d, #db3300)";
var GradientLinear3LightDStandard = "linear-gradient(90deg, #ff6a3d, #d4a8ff)";
var GradientLinear3LightDBold = "linear-gradient(90deg, #a82700, #962eff)";
var GradientLinear3LightEStandard = "linear-gradient(90deg, #ff57e9, #d4a8ff)";
var GradientLinear3LightEBold = "linear-gradient(90deg, #b2008f, #962eff)";
var GradientLinear3LightFStandard = "linear-gradient(90deg, #bf80ff, #f299ff)";
var GradientLinear3LightFBold = "linear-gradient(90deg, #7300e5, #c300e0)";
var GradientLinear3LightGStandard = "linear-gradient(90deg, #978aff, #d4a8ff)";
var GradientLinear3LightGBold = "linear-gradient(90deg, #5724ff, #962eff)";
var GradientLinear3DarkAStandard = "linear-gradient(90deg, #007000, #6842ff)";
var GradientLinear3DarkABold = "linear-gradient(90deg, #7ae500, #b2a8ff)";
var GradientLinear3DarkBStandard = "linear-gradient(90deg, #a000b8, #d14600)";
var GradientLinear3DarkBBold = "linear-gradient(90deg, #ec70ff, #ffbb45)";
var GradientLinear3DarkCStandard = "linear-gradient(90deg, #bb005d, #db3300)";
var GradientLinear3DarkCBold = "linear-gradient(90deg, #ff66b2, #ff997a)";
var GradientLinear3DarkDStandard = "linear-gradient(90deg, #a82700, #962eff)";
var GradientLinear3DarkDBold = "linear-gradient(90deg, #ff6a3d, #d4a8ff)";
var GradientLinear3DarkEStandard = "linear-gradient(90deg, #b2008f, #962eff)";
var GradientLinear3DarkEBold = "linear-gradient(90deg, #ff57e9, #d4a8ff)";
var GradientLinear3DarkFStandard = "linear-gradient(90deg, #7300e5, #c300e0)";
var GradientLinear3DarkFBold = "linear-gradient(90deg, #bf80ff, #f299ff)";
var GradientLinear3DarkGStandard = "linear-gradient(90deg, #5724ff, #962eff)";
var GradientLinear3DarkGBold = "linear-gradient(90deg, #978aff, #d4a8ff)";
var GradientMesh1LightAStandard = "linear-gradient(237deg, #000000 31.61%, #ffed4d 116.35%), linear-gradient(125deg, #f299ff 21.47%, #75cfff 100%)";
var GradientMesh1LightABold = "linear-gradient(237deg, #000000 31.61%, #db9200 116.35%), linear-gradient(125deg, #a000b8 21.47%, #004a9e 100%)";
var GradientMesh1LightBStandard = "linear-gradient(231deg, #000000 20.35%, #94afff 121.74%), linear-gradient(123deg, #75cfff 29.58%, #62ff57 109.8%)";
var GradientMesh1LightBBold = "linear-gradient(231deg, #000000 20.35%, #003efa 121.74%), linear-gradient(123deg, #004a9e 29.58%, #007029 109.8%)";
var GradientMesh1LightCStandard = "linear-gradient(233deg, #000000 26.39%, #3defff 96.63%), linear-gradient(123deg, #00f5e4 29.58%, #3dff9e 109.8%)";
var GradientMesh1LightCBold = "linear-gradient(233deg, #000000 26.39%, #00627a 96.63%), linear-gradient(123deg, #00665f 29.58%, #006b48 109.8%)";
var GradientMesh1LightDStandard = "linear-gradient(233deg, #000000 26.39%, #f299ff 96.63%), linear-gradient(123deg, #b2a8ff 29.58%, #94afff 109.8%)";
var GradientMesh1LightDBold = "linear-gradient(233deg, #000000 26.39%, #a000b8 96.63%), linear-gradient(123deg, #5724ff 29.58%, #003efa 109.8%)";
var GradientMesh1LightEStandard = "linear-gradient(230deg, #000000 10.57%, #3defff 95.48%), linear-gradient(90deg, #94afff 48.05%, #b2a8ff 124.4%)";
var GradientMesh1LightEBold = "linear-gradient(230deg, #000000 10.57%, #00627a 95.48%), linear-gradient(90deg, #003efa 48.05%, #5724ff 124.4%)";
var GradientMesh1LightFStandard = "linear-gradient(223deg, #000000 6.82%, #3defff 92.7%), linear-gradient(123deg, #b2a8ff 29.58%, #f299ff 109.8%)";
var GradientMesh1LightFBold = "linear-gradient(223deg, #000000 6.82%, #00627a 92.7%), linear-gradient(123deg, #5724ff 29.58%, #a000b8 109.8%)";
var GradientMesh1LightGStandard = "linear-gradient(235deg, #000000 27.79%, #d4a8ff 97.31%), linear-gradient(123deg, #94afff 29.58%, #3dff9e 109.8%)";
var GradientMesh1LightGBold = "linear-gradient(235deg, #000000 27.79%, #7300e5 97.31%), linear-gradient(123deg, #003efa 29.58%, #006b48 109.8%)";
var GradientMesh1DarkAStandard = "linear-gradient(237deg, #000000 31.61%, #db9200 116.35%), linear-gradient(125deg, #a000b8 21.47%, #004a9e 100%)";
var GradientMesh1DarkABold = "linear-gradient(237deg, #000000 31.61%, #ffed4d 116.35%), linear-gradient(125deg, #f299ff 21.47%, #75cfff 100%)";
var GradientMesh1DarkBStandard = "linear-gradient(231deg, #000000 20.35%, #003efa 121.74%), linear-gradient(123deg, #004a9e 29.58%, #007029 109.8%)";
var GradientMesh1DarkBBold = "linear-gradient(231deg, #000000 20.35%, #94afff 121.74%), linear-gradient(123deg, #75cfff 29.58%, #62ff57 109.8%)";
var GradientMesh1DarkCStandard = "linear-gradient(233deg, #000000 26.39%, #00627a 96.63%), linear-gradient(123deg, #00665f 29.58%, #006b48 109.8%)";
var GradientMesh1DarkCBold = "linear-gradient(233deg, #000000 26.39%, #3defff 96.63%), linear-gradient(123deg, #00f5e4 29.58%, #3dff9e 109.8%)";
var GradientMesh1DarkDStandard = "linear-gradient(233deg, #000000 26.39%, #a000b8 96.63%), linear-gradient(123deg, #5724ff 29.58%, #003efa 109.8%)";
var GradientMesh1DarkDBold = "linear-gradient(233deg, #000000 26.39%, #f299ff 96.63%), linear-gradient(123deg, #b2a8ff 29.58%, #94afff 109.8%)";
var GradientMesh1DarkEStandard = "linear-gradient(230deg, #000000 10.57%, #00627a 95.48%), linear-gradient(90deg, #003efa 48.05%, #5724ff 124.4%)";
var GradientMesh1DarkEBold = "linear-gradient(230deg, #000000 10.57%, #3defff 95.48%), linear-gradient(90deg, #94afff 48.05%, #b2a8ff 124.4%)";
var GradientMesh1DarkFStandard = "linear-gradient(223deg, #000000 6.82%, #00627a 92.7%), linear-gradient(123deg, #5724ff 29.58%, #a000b8 109.8%)";
var GradientMesh1DarkFBold = "linear-gradient(223deg, #000000 6.82%, #3defff 92.7%), linear-gradient(123deg, #b2a8ff 29.58%, #f299ff 109.8%)";
var GradientMesh1DarkGStandard = "linear-gradient(235deg, #000000 27.79%, #7300e5 97.31%), linear-gradient(123deg, #003efa 29.58%, #006b48 109.8%)";
var GradientMesh1DarkGBold = "linear-gradient(235deg, #000000 27.79%, #d4a8ff 97.31%), linear-gradient(123deg, #94afff 29.58%, #3dff9e 109.8%)";
var GradientMesh2LightAStandard = "linear-gradient(238deg, #000000 30.71%, #ff8fab 116.48%), linear-gradient(125deg, #ff99cc 21.47%, #f299ff 100%)";
var GradientMesh2LightABold = "linear-gradient(238deg, #000000 30.71%, #c20030 116.48%), linear-gradient(125deg, #bb005d 21.47%, #a000b8 100%)";
var GradientMesh2LightBStandard = "linear-gradient(231deg, #000000 36.65%, #b2a8ff 115.22%), linear-gradient(125deg, #f299ff 21.47%, #ff997a 100%)";
var GradientMesh2LightBBold = "linear-gradient(231deg, #000000 36.65%, #5724ff 115.22%), linear-gradient(125deg, #a000b8 21.47%, #a82700 100%)";
var GradientMesh2LightCStandard = "linear-gradient(231deg, #000000 36.65%, #94afff 115.22%), linear-gradient(125deg, #d4a8ff 21.47%, #ff99cc 100%)";
var GradientMesh2LightCBold = "linear-gradient(231deg, #000000 36.65%, #003efa 115.22%), linear-gradient(125deg, #7300e5 21.47%, #bb005d 100%)";
var GradientMesh2LightDStandard = "linear-gradient(231deg, #000000 36.65%, #3defff 115.22%), linear-gradient(125deg, #94afff 21.47%, #f299ff 100%)";
var GradientMesh2LightDBold = "linear-gradient(231deg, #000000 36.65%, #00627a 115.22%), linear-gradient(125deg, #003efa 21.47%, #a000b8 100%)";
var GradientMesh2LightEStandard = "linear-gradient(231deg, #000000 36.65%, #d4a8ff 115.22%), linear-gradient(125deg, #94afff 21.47%, #75cfff 100%)";
var GradientMesh2LightEBold = "linear-gradient(231deg, #000000 36.65%, #7300e5 115.22%), linear-gradient(125deg, #003efa 21.47%, #004a9e 100%)";
var GradientMesh2LightFStandard = "linear-gradient(217deg, #000000 19.22%, #ff99cc 112.82%), linear-gradient(125deg, #b2a8ff 21.47%, #75cfff 100%)";
var GradientMesh2LightFBold = "linear-gradient(217deg, #000000 19.22%, #bb005d 112.82%), linear-gradient(125deg, #5724ff 21.47%, #004a9e 100%)";
var GradientMesh2LightGStandard = "linear-gradient(217deg, #000000 40.83%, #ff997a 105.86%), linear-gradient(125deg, #d4a8ff 21.47%, #3defff 100%)";
var GradientMesh2LightGBold = "linear-gradient(217deg, #000000 40.83%, #a82700 105.86%), linear-gradient(125deg, #7300e5 21.47%, #00627a 100%)";
var GradientMesh2DarkAStandard = "linear-gradient(238deg, #000000 30.71%, #c20030 116.48%), linear-gradient(125deg, #bb005d 21.47%, #a000b8 100%)";
var GradientMesh2DarkABold = "linear-gradient(238deg, #000000 30.71%, #ff8fab 116.48%), linear-gradient(125deg, #ff99cc 21.47%, #f299ff 100%)";
var GradientMesh2DarkBStandard = "linear-gradient(231deg, #000000 36.65%, #5724ff 115.22%), linear-gradient(125deg, #a000b8 21.47%, #a82700 100%)";
var GradientMesh2DarkBBold = "linear-gradient(231deg, #000000 36.65%, #b2a8ff 115.22%), linear-gradient(125deg, #f299ff 21.47%, #ff997a 100%)";
var GradientMesh2DarkCStandard = "linear-gradient(231deg, #000000 36.65%, #003efa 115.22%), linear-gradient(125deg, #7300e5 21.47%, #bb005d 100%)";
var GradientMesh2DarkCBold = "linear-gradient(231deg, #000000 36.65%, #94afff 115.22%), linear-gradient(125deg, #d4a8ff 21.47%, #ff99cc 100%)";
var GradientMesh2DarkDStandard = "linear-gradient(231deg, #000000 36.65%, #00627a 115.22%), linear-gradient(125deg, #003efa 21.47%, #a000b8 100%)";
var GradientMesh2DarkDBold = "linear-gradient(231deg, #000000 36.65%, #3defff 115.22%), linear-gradient(125deg, #94afff 21.47%, #f299ff 100%)";
var GradientMesh2DarkEStandard = "linear-gradient(231deg, #000000 36.65%, #7300e5 115.22%), linear-gradient(125deg, #003efa 21.47%, #004a9e 100%)";
var GradientMesh2DarkEBold = "linear-gradient(231deg, #000000 36.65%, #d4a8ff 115.22%), linear-gradient(125deg, #94afff 21.47%, #75cfff 100%)";
var GradientMesh2DarkFStandard = "linear-gradient(217deg, #000000 19.22%, #bb005d 112.82%), linear-gradient(125deg, #5724ff 21.47%, #004a9e 100%)";
var GradientMesh2DarkFBold = "linear-gradient(217deg, #000000 19.22%, #ff99cc 112.82%), linear-gradient(125deg, #b2a8ff 21.47%, #75cfff 100%)";
var GradientMesh2DarkGStandard = "linear-gradient(217deg, #000000 40.83%, #a82700 105.86%), linear-gradient(125deg, #7300e5 21.47%, #00627a 100%)";
var GradientMesh2DarkGBold = "linear-gradient(217deg, #000000 40.83%, #ff997a 105.86%), linear-gradient(125deg, #d4a8ff 21.47%, #3defff 100%)";
var GradientMesh3LightAStandard = "linear-gradient(214deg, #000000 42.03%, #acff2e 112.37%), linear-gradient(125deg, #d4a8ff 21.47%, #ff94f1 100%)";
var GradientMesh3LightABold = "linear-gradient(214deg, #000000 42.03%, #007000 112.37%), linear-gradient(125deg, #7300e5 21.47%, #b2008f 100%)";
var GradientMesh3LightBStandard = "linear-gradient(231deg, #000000 27.2%, #b2a8ff 115.31%), linear-gradient(125deg, #ff94f1 21.47%, #ffbb45 100%)";
var GradientMesh3LightBBold = "linear-gradient(231deg, #000000 27.2%, #5724ff 115.31%), linear-gradient(125deg, #b2008f 21.47%, #9e3700 100%)";
var GradientMesh3LightCStandard = "linear-gradient(231deg, #000000 27.2%, #ff99cc 115.31%), linear-gradient(125deg, #ff8fab 21.47%, #ff997a 100%)";
var GradientMesh3LightCBold = "linear-gradient(231deg, #000000 27.2%, #bb005d 115.31%), linear-gradient(125deg, #c20030 21.47%, #a82700 100%)";
var GradientMesh3LightDStandard = "linear-gradient(231deg, #000000 27.2%, #ff997a 115.31%), linear-gradient(125deg, #f299ff 21.47%, #d4a8ff 100%)";
var GradientMesh3LightDBold = "linear-gradient(231deg, #000000 27.2%, #a82700 115.31%), linear-gradient(125deg, #a000b8 21.47%, #7300e5 100%)";
var GradientMesh3LightEStandard = "linear-gradient(230deg, #000000 41.44%, #ff8fab 97.54%), linear-gradient(120deg, #b2a8ff 33.01%, #f299ff 100%)";
var GradientMesh3LightEBold = "linear-gradient(230deg, #000000 41.44%, #c20030 97.54%), linear-gradient(120deg, #5724ff 33.01%, #a000b8 100%)";
var GradientMesh3LightFStandard = "linear-gradient(222deg, #000000 32.74%, #d4a8ff 130.1%), linear-gradient(120deg, #f299ff 33.01%, #ffed4d 100%)";
var GradientMesh3LightFBold = "linear-gradient(222deg, #000000 32.74%, #7300e5 130.1%), linear-gradient(120deg, #a000b8 33.01%, #db9200 100%)";
var GradientMesh3LightGStandard = "linear-gradient(232deg, #000000 28.78%, #b2a8ff 97.97%), linear-gradient(120deg, #75cfff 33.01%, #acff2e 100%)";
var GradientMesh3LightGBold = "linear-gradient(232deg, #000000 28.78%, #5724ff 97.97%), linear-gradient(120deg, #004a9e 33.01%, #007000 100%)";
var GradientMesh3DarkAStandard = "linear-gradient(214deg, #000000 42.03%, #007000 112.37%), linear-gradient(125deg, #7300e5 21.47%, #b2008f 100%)";
var GradientMesh3DarkABold = "linear-gradient(214deg, #000000 42.03%, #acff2e 112.37%), linear-gradient(125deg, #d4a8ff 21.47%, #ff94f1 100%)";
var GradientMesh3DarkBStandard = "linear-gradient(231deg, #000000 27.2%, #5724ff 115.31%), linear-gradient(125deg, #b2008f 21.47%, #9e3700 100%)";
var GradientMesh3DarkBBold = "linear-gradient(231deg, #000000 27.2%, #b2a8ff 115.31%), linear-gradient(125deg, #ff94f1 21.47%, #ffbb45 100%)";
var GradientMesh3DarkCStandard = "linear-gradient(231deg, #000000 27.2%, #bb005d 115.31%), linear-gradient(125deg, #c20030 21.47%, #a82700 100%)";
var GradientMesh3DarkCBold = "linear-gradient(231deg, #000000 27.2%, #ff99cc 115.31%), linear-gradient(125deg, #ff8fab 21.47%, #ff997a 100%)";
var GradientMesh3DarkDStandard = "linear-gradient(231deg, #000000 27.2%, #a82700 115.31%), linear-gradient(125deg, #a000b8 21.47%, #7300e5 100%)";
var GradientMesh3DarkDBold = "linear-gradient(231deg, #000000 27.2%, #ff997a 115.31%), linear-gradient(125deg, #f299ff 21.47%, #d4a8ff 100%)";
var GradientMesh3DarkEStandard = "linear-gradient(230deg, #000000 41.44%, #c20030 97.54%), linear-gradient(120deg, #5724ff 33.01%, #a000b8 100%)";
var GradientMesh3DarkEBold = "linear-gradient(230deg, #000000 41.44%, #ff8fab 97.54%), linear-gradient(120deg, #b2a8ff 33.01%, #f299ff 100%)";
var GradientMesh3DarkFStandard = "linear-gradient(222deg, #000000 32.74%, #7300e5 130.1%), linear-gradient(120deg, #a000b8 33.01%, #db9200 100%)";
var GradientMesh3DarkFBold = "linear-gradient(222deg, #000000 32.74%, #d4a8ff 130.1%), linear-gradient(120deg, #f299ff 33.01%, #ffed4d 100%)";
var GradientMesh3DarkGStandard = "linear-gradient(232deg, #000000 28.78%, #5724ff 97.97%), linear-gradient(120deg, #004a9e 33.01%, #007000 100%)";
var GradientMesh3DarkGBold = "linear-gradient(232deg, #000000 28.78%, #b2a8ff 97.97%), linear-gradient(120deg, #75cfff 33.01%, #acff2e 100%)";
var GradientShadow1LightA = "linear-gradient(237deg, #000000 31.61%, #ffed4d 116.35%), linear-gradient(125deg, #f299ff 21.47%, #75cfff 100%)";
var GradientShadow1LightB = "linear-gradient(231deg, #000000 20.35%, #94afff 121.74%), linear-gradient(123deg, #75cfff 29.58%, #62ff57 109.8%)";
var GradientShadow1LightC = "linear-gradient(233deg, #000000 26.39%, #3defff 96.63%), linear-gradient(123deg, #00f5e4 29.58%, #3dff9e 109.8%)";
var GradientShadow1LightD = "linear-gradient(233deg, #000000 26.39%, #f299ff 96.63%), linear-gradient(123deg, #b2a8ff 29.58%, #94afff 109.8%)";
var GradientShadow1LightE = "linear-gradient(230deg, #000000 10.57%, #3defff 95.48%), linear-gradient(90deg, #94afff 48.05%, #b2a8ff 124.4%)";
var GradientShadow1LightF = "linear-gradient(223deg, #000000 6.82%, #3defff 92.7%), linear-gradient(123deg, #b2a8ff 29.58%, #f299ff 109.8%)";
var GradientShadow1LightG = "linear-gradient(235deg, #000000 27.79%, #d4a8ff 97.31%), linear-gradient(123deg, #94afff 29.58%, #3dff9e 109.8%)";
var GradientShadow1DarkA = "linear-gradient(237deg, #000000 31.61%, #db9200 116.35%), linear-gradient(125deg, #a000b8 21.47%, #004a9e 100%)";
var GradientShadow1DarkB = "linear-gradient(231deg, #000000 20.35%, #003efa 121.74%), linear-gradient(123deg, #004a9e 29.58%, #007029 109.8%)";
var GradientShadow1DarkC = "linear-gradient(233deg, #000000 26.39%, #00627a 96.63%), linear-gradient(123deg, #00665f 29.58%, #006b48 109.8%)";
var GradientShadow1DarkD = "linear-gradient(233deg, #000000 26.39%, #a000b8 96.63%), linear-gradient(123deg, #5724ff 29.58%, #003efa 109.8%)";
var GradientShadow1DarkE = "linear-gradient(230deg, #000000 10.57%, #00627a 95.48%), linear-gradient(90deg, #003efa 48.05%, #5724ff 124.4%)";
var GradientShadow1DarkF = "linear-gradient(223deg, #000000 6.82%, #00627a 92.7%), linear-gradient(123deg, #5724ff 29.58%, #a000b8 109.8%)";
var GradientShadow1DarkG = "linear-gradient(235deg, #000000 27.79%, #7300e5 97.31%), linear-gradient(123deg, #003efa 29.58%, #006b48 109.8%)";
var GradientShadow2LightA = "linear-gradient(238deg, #000000 30.71%, #ff8fab 116.48%), linear-gradient(125deg, #ff99cc 21.47%, #f299ff 100%)";
var GradientShadow2LightB = "linear-gradient(231deg, #000000 36.65%, #b2a8ff 115.22%), linear-gradient(125deg, #f299ff 21.47%, #ff997a 100%)";
var GradientShadow2LightC = "linear-gradient(231deg, #000000 36.65%, #94afff 115.22%), linear-gradient(125deg, #d4a8ff 21.47%, #ff99cc 100%)";
var GradientShadow2LightD = "linear-gradient(231deg, #000000 36.65%, #3defff 115.22%), linear-gradient(125deg, #94afff 21.47%, #f299ff 100%)";
var GradientShadow2LightE = "linear-gradient(231deg, #000000 36.65%, #d4a8ff 115.22%), linear-gradient(125deg, #94afff 21.47%, #75cfff 100%)";
var GradientShadow2LightF = "linear-gradient(217deg, #000000 19.22%, #ff99cc 112.82%), linear-gradient(125deg, #b2a8ff 21.47%, #75cfff 100%)";
var GradientShadow2LightG = "linear-gradient(217deg, #000000 40.83%, #ff997a 105.86%), linear-gradient(125deg, #d4a8ff 21.47%, #3defff 100%)";
var GradientShadow2DarkA = "linear-gradient(238deg, #000000 30.71%, #c20030 116.48%), linear-gradient(125deg, #bb005d 21.47%, #a000b8 100%)";
var GradientShadow2DarkB = "linear-gradient(231deg, #000000 36.65%, #5724ff 115.22%), linear-gradient(125deg, #a000b8 21.47%, #a82700 100%)";
var GradientShadow2DarkC = "linear-gradient(231deg, #000000 36.65%, #003efa 115.22%), linear-gradient(125deg, #7300e5 21.47%, #bb005d 100%)";
var GradientShadow2DarkD = "linear-gradient(231deg, #000000 36.65%, #00627a 115.22%), linear-gradient(125deg, #003efa 21.47%, #a000b8 100%)";
var GradientShadow2DarkE = "linear-gradient(231deg, #000000 36.65%, #7300e5 115.22%), linear-gradient(125deg, #003efa 21.47%, #004a9e 100%)";
var GradientShadow2DarkF = "linear-gradient(217deg, #000000 19.22%, #bb005d 112.82%), linear-gradient(125deg, #5724ff 21.47%, #004a9e 100%)";
var GradientShadow2DarkG = "linear-gradient(217deg, #000000 40.83%, #a82700 105.86%), linear-gradient(125deg, #7300e5 21.47%, #00627a 100%)";
var GradientShadow3LightA = "linear-gradient(214deg, #000000 42.03%, #acff2e 112.37%), linear-gradient(125deg, #d4a8ff 21.47%, #ff94f1 100%)";
var GradientShadow3LightB = "linear-gradient(231deg, #000000 27.2%, #b2a8ff 115.31%), linear-gradient(125deg, #ff94f1 21.47%, #ffbb45 100%)";
var GradientShadow3LightC = "linear-gradient(231deg, #000000 27.2%, #ff99cc 115.31%), linear-gradient(125deg, #ff8fab 21.47%, #ff997a 100%)";
var GradientShadow3LightD = "linear-gradient(231deg, #000000 27.2%, #ff997a 115.31%), linear-gradient(125deg, #f299ff 21.47%, #d4a8ff 100%)";
var GradientShadow3LightE = "linear-gradient(230deg, #000000 41.44%, #ff8fab 97.54%), linear-gradient(120deg, #b2a8ff 33.01%, #f299ff 100%)";
var GradientShadow3LightF = "linear-gradient(222deg, #000000 32.74%, #d4a8ff 130.1%), linear-gradient(120deg, #f299ff 33.01%, #ffed4d 100%)";
var GradientShadow3LightG = "linear-gradient(232deg, #000000 28.78%, #b2a8ff 97.97%), linear-gradient(120deg, #75cfff 33.01%, #acff2e 100%)";
var GradientShadow3DarkA = "linear-gradient(214deg, #000000 42.03%, #007000 112.37%), linear-gradient(125deg, #7300e5 21.47%, #b2008f 100%)";
var GradientShadow3DarkB = "linear-gradient(231deg, #000000 27.2%, #5724ff 115.31%), linear-gradient(125deg, #b2008f 21.47%, #9e3700 100%)";
var GradientShadow3DarkC = "linear-gradient(231deg, #000000 27.2%, #bb005d 115.31%), linear-gradient(125deg, #c20030 21.47%, #a82700 100%)";
var GradientShadow3DarkD = "linear-gradient(231deg, #000000 27.2%, #a82700 115.31%), linear-gradient(125deg, #a000b8 21.47%, #7300e5 100%)";
var GradientShadow3DarkE = "linear-gradient(230deg, #000000 41.44%, #c20030 97.54%), linear-gradient(120deg, #5724ff 33.01%, #a000b8 100%)";
var GradientShadow3DarkF = "linear-gradient(222deg, #000000 32.74%, #7300e5 130.1%), linear-gradient(120deg, #a000b8 33.01%, #db9200 100%)";
var GradientShadow3DarkG = "linear-gradient(232deg, #000000 28.78%, #5724ff 97.97%), linear-gradient(120deg, #004a9e 33.01%, #007000 100%)";
var ZindexPopoverArrow = 1;
var ZindexStickywrapperDefault = 10;
var ZindexSubnavNav = 5e3;
var ZindexGlobalnavScrim = 6e3;
var ZindexGlobalnavNav = 6002;
var ZindexGlobalnavSubnav = 6001;
var ZindexDialogBackdrop = 9999;
var ZindexTableStickyHeader = 601;
var MultiplierSpacing = "4px";
var RadiusBlurNormal = "15px";
var RadiusBlurHover = "20px";
var RadiusBlurPressed = "8px";
var RadiusBlurBackdropGlass = "25px";
var ScrimLinearLightTop = { "color": "#ffffff", "direction": "180deg" };
var ScrimLinearLightRight = { "color": "#ffffff", "direction": "270deg" };
var ScrimLinearLightBottom = { "color": "#ffffff", "direction": "0deg" };
var ScrimLinearLightLeft = { "color": "#ffffff", "direction": "90deg" };
var ScrimLinearDarkTop = { "color": "#131920", "direction": "180deg" };
var ScrimLinearDarkRight = { "color": "#131920", "direction": "270deg" };
var ScrimLinearDarkBottom = { "color": "#131920", "direction": "0deg" };
var ScrimLinearDarkLeft = { "color": "#131920", "direction": "90deg" };
var ShadowBlurHover = "16px";
var ShadowBlurPressed = "8px";
var ShadowGrayElevation1Light = "1px 1px 20px rgba(0, 0, 0, 0.10)";
var ShadowGrayElevation1Dark = "1px 1px 20px rgba(0, 0, 0, 0.10)";
var ShadowGrayElevation2Light = "1px 1px 24px rgba(0, 0, 0, 0.25)";
var ShadowGrayElevation2Dark = "1px 1px 24px rgba(0, 0, 0, 0.25)";
var ShadowGradientFuchsiaLight = "linear-gradient(123deg, #d14600 0%, #c300e0 50%, #6842ff 100%)";
var ShadowGradientFuchsiaDark = "linear-gradient(123deg, #fa6f00 0%, #e433ff 50%, #8575ff 100%)";
var ShadowGradientIndigoLight = "linear-gradient(123deg, #006ce0 0%, #295eff 50%, #6842ff 100%)";
var ShadowGradientIndigoDark = "linear-gradient(123deg, #0099ff 0%, #5c7fff 50%, #8575ff 100%)";
var ShadowGradientOrangeLight = "linear-gradient(123deg, #d600ba 0%, #eb003b 50%, #d14600 100%)";
var ShadowGradientOrangeDark = "linear-gradient(123deg, #ff1ae0 0%, #ff386a 50%, #fa6f00 100%)";
var ShadowGradientTealLight = "linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%)";
var ShadowGradientTealDark = "linear-gradient(123deg, #00bd6b 0%, #00a4bd 50%, #0099ff 100%)";
var ShadowGradientBlueLight = "linear-gradient(123deg, #008559 0%, #006ce0 50%, #6842ff 100%)";
var ShadowGradientBlueDark = "linear-gradient(123deg, #00bd6b 0%, #0099ff 50%, #8575ff 100%)";
var ShadowGradientVioletLight = "linear-gradient(123deg, #962eff 0%, #006ce0 50%, #007e94 100%)";
var ShadowGradientVioletDark = "linear-gradient(123deg, #ad5cff 0%, #0099ff 50%, #00a4bd 100%)";
var ShadowGradientPurpleLight = "linear-gradient(123deg, #d600ba 0%, #6842ff 50%, #007e94 100%)";
var ShadowGradientPurpleDark = "linear-gradient(123deg, #ff1ae0 0%, #8575ff 50%, #00a4bd 100%)";
var TransitionShortDuration = "300ms";
var TransitionShortFunction = "cubic-bezier(0, 0, 0.2, 1)";
var TransitionMediumDuration = "500ms";
var TransitionMediumFunction = "cubic-bezier(0.4, 0, 0.2, 1)";
var TransitionLongDuration = "700ms";
var TransitionLongFunction = "cubic-bezier(0, 0, 0.2, 1)";
var TransitionStaggerDuration = "200ms";

// ../../../node_modules/rand-seed/dist/rand-seed.es.js
var t = function(r3, n2) {
  return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t2, r4) {
    t2.__proto__ = r4;
  } || function(t2, r4) {
    for (var n3 in r4) Object.prototype.hasOwnProperty.call(r4, n3) && (t2[n3] = r4[n3]);
  }, t(r3, n2);
};
function r2(r3, n2) {
  if ("function" != typeof n2 && null !== n2) throw new TypeError("Class extends value " + String(n2) + " is not a constructor or null");
  function i2() {
    this.constructor = r3;
  }
  t(r3, n2), r3.prototype = null === n2 ? Object.create(n2) : (i2.prototype = n2.prototype, new i2());
}
var n;
var i = function() {
  function t2() {
  }
  return t2._xfnv1a = function(t3) {
    for (var r3 = 2166136261, n2 = 0; n2 < t3.length; n2++) r3 = Math.imul(r3 ^ t3.charCodeAt(n2), 16777619);
    return function() {
      return r3 += r3 << 13, r3 ^= r3 >>> 7, r3 += r3 << 3, r3 ^= r3 >>> 17, (r3 += r3 << 5) >>> 0;
    };
  }, t2;
}();
var s = function(t2) {
  function n2(r3) {
    var i2 = t2.call(this) || this;
    return i2.a = n2._xfnv1a(r3)(), i2;
  }
  return r2(n2, t2), n2.prototype.next = function() {
    var t3 = this.a += 1831565813;
    return t3 = Math.imul(t3 ^ t3 >>> 15, 1 | t3), (((t3 ^= t3 + Math.imul(t3 ^ t3 >>> 7, 61 | t3)) ^ t3 >>> 14) >>> 0) / 4294967296;
  }, n2;
}(i);
var o = function(t2) {
  function n2(r3) {
    var i2 = t2.call(this) || this, s2 = n2._xfnv1a(r3);
    return i2.a = s2(), i2.b = s2(), i2.c = s2(), i2.d = s2(), i2;
  }
  return r2(n2, t2), n2.prototype.next = function() {
    this.a >>>= 0, this.b >>>= 0, this.c >>>= 0, this.d >>>= 0;
    var t3 = this.a + this.b | 0;
    return this.a = this.b ^ this.b >>> 9, this.b = this.c + (this.c << 3) | 0, this.c = this.c << 21 | this.c >>> 11, this.d = this.d + 1 | 0, t3 = t3 + this.d | 0, this.c = this.c + t3 | 0, (t3 >>> 0) / 4294967296;
  }, n2;
}(i);
var e = function(t2) {
  function n2(r3) {
    var i2 = t2.call(this) || this, s2 = n2._xfnv1a(r3);
    return i2.a = s2(), i2.b = s2(), i2.c = s2(), i2.d = s2(), i2;
  }
  return r2(n2, t2), n2.prototype.next = function() {
    var t3 = this.b << 9, r3 = 5 * this.a;
    return r3 = r3 << 7 | 9 * (r3 >>> 25), this.c ^= this.a, this.d ^= this.b, this.b ^= this.c, this.a ^= this.d, this.c ^= t3, this.d = this.d << 11 | this.d >>> 21, (r3 >>> 0) / 4294967296;
  }, n2;
}(i);
!function(t2) {
  t2.sfc32 = "sfc32", t2.mulberry32 = "mulberry32", t2.xoshiro128ss = "xoshiro128ss";
}(n || (n = {}));
var u = function() {
  function t2(t3, r3) {
    void 0 === r3 && (r3 = n.sfc32), this.str = t3, this.prng = r3, this.generator = this._initializeGenerator();
  }
  return t2.prototype.next = function() {
    return this.generator.next();
  }, t2.prototype._initializeGenerator = function() {
    if (/* @__PURE__ */ function(t4) {
      return null === t4;
    }(t3 = this.str) || /* @__PURE__ */ function(t4) {
      return void 0 === t4;
    }(t3)) return this.wrap();
    var t3;
    switch (this.prng) {
      case "sfc32":
        return new o(this.str);
      case "mulberry32":
        return new s(this.str);
      case "xoshiro128ss":
        return new e(this.str);
      default:
        return this.wrap();
    }
  }, t2.prototype.wrap = function() {
    return { next: function() {
      return Math.random();
    } };
  }, t2;
}();

// ../../styles/dist/esm/types/colors.js
var GradientOptions = /* @__PURE__ */ ((GradientOptions2) => {
  GradientOptions2["fuchsia"] = "fuchsia";
  GradientOptions2["orange"] = "orange";
  GradientOptions2["indigo"] = "indigo";
  GradientOptions2["teal"] = "teal";
  GradientOptions2["blue"] = "blue";
  GradientOptions2["violet"] = "violet";
  GradientOptions2["purple"] = `purple`;
  return GradientOptions2;
})(GradientOptions || {});

// ../../styles/dist/esm/utils/themes.js
var defaultRng = new u();
var rngs = /* @__PURE__ */ new Map();
var getRng = (seed) => {
  if (!rngs.has(seed)) {
    rngs.set(seed, new u(seed));
  }
  return rngs.get(seed);
};
var getValidTheme = (theme, randomSeed) => {
  let validatedTheme;
  if (theme && theme in GradientOptions) {
    validatedTheme = theme;
  } else {
    const themes = Object.values(GradientOptions);
    const rng = randomSeed ? getRng(randomSeed) : defaultRng;
    const index3 = Math.floor(rng.next() * themes.length);
    validatedTheme = themes[index3];
  }
  return validatedTheme;
};

// ../../styles/dist/esm/hooks/useColorTheme.js
var useColorTheme = (overrides) => {
  const outerTheme = useContext6(ColorThemeContext);
  return useMemo9(() => {
    const newTheme = !overrides?.theme && outerTheme ? outerTheme.theme : getValidTheme(overrides?.theme);
    const newDark = overrides?.dark === "invert" ? !outerTheme?.dark : Boolean(overrides?.dark === void 0 && outerTheme ? outerTheme.dark : overrides?.dark);
    const themeObj = {
      theme: newTheme,
      dark: newDark
    };
    const propsObj = {
      "data-rg-theme": themeObj.theme,
      "data-rg-mode": themeObj.dark ? "dark" : "light"
    };
    return {
      ...themeObj,
      themeProps: propsObj
    };
  }, [outerTheme, overrides?.dark, overrides?.theme]);
};

// ../../styles/dist/esm/ColorThemeProvider/css-variables.module.css
var css_variables_default = {};

// ../../styles/dist/esm/ColorThemeProvider/ColorThemeProvider.js
import { jsx as jsx26 } from "react/jsx-runtime";
var ColorThemeProvider = forwardRef14(
  ({ children, theme, dark, wrap = true }, ref) => {
    const value = useColorTheme({ theme, dark });
    const outerContext = useContext7(ColorThemeContext);
    const shouldWrap = !outerContext || wrap;
    return /* @__PURE__ */ jsx26(ColorThemeContext.Provider, { value: { dark: value.dark, theme: value.theme }, children: shouldWrap ? /* @__PURE__ */ jsx26(
      "div",
      {
        ...value.themeProps,
        ref,
        "data-style-count": (
          // This is a hack to prevent treeshakers from deleting the styles import. This attribute isn't actually used anywhere.
          // It would be better if there was a <StyleProvider> component that could be used once per pattern or page that rendered a <style> element
          // containing the evaluated SASS instead of relying on style extraction by the bundler.
          Object.keys(css_variables_default).length
        ),
        children
      }
    ) : (
      // If we're not wrapping `children` in a div with the theme attributes on it, attempt to add the theme props directly.
      React5.Children.map(children, (child) => {
        if (React5.isValidElement(child)) {
          return React5.cloneElement(child, value.themeProps);
        }
        return child;
      })
    ) });
  }
);

// ../../components/dist/esm/CheckboxBase/CheckboxBase.js
import { forwardRef as forwardRef16, useCallback as useCallback9, useEffect as useEffect12, useState as useState9 } from "react";

// ../../components/dist/esm/CheckboxGroup/CheckboxGroupContext.js
import { createContext as createContext5, useContext as useContext8 } from "react";
var CheckboxGroupContext = createContext5({
  currentCheckedCount: 0,
  setChecked: () => null,
  maxCheckedCount: void 0
});
var useCheckboxGroup = () => {
  return useContext8(CheckboxGroupContext);
};

// ../../components/dist/esm/hooks/useDraggablePanel.js
import { useCallback as useCallback8 } from "react";

// ../../utils/dist/esm/math2d.js
var calculateVelocity = () => {
  const sourceTime = window.performance.now();
  return (distance) => {
    const currentTime = window.performance.now();
    const eventDuration = currentTime - sourceTime;
    return distance / eventDuration;
  };
};

// ../../components/dist/esm/hooks/useDraggablePanel.js
var useDraggablePanel = (ref, axis = "xy", onTouchEndCallback) => {
  let offset4 = {
    x: 0,
    y: 0
  };
  const onTouchStart = useCallback8(
    (e2) => {
      if (!ref?.current) return;
      const element = ref.current;
      const touch = e2.touches[0];
      const startPos = {
        x: touch.clientX - offset4.x,
        y: touch.clientY - offset4.y
      };
      const getVelocity = calculateVelocity();
      const onTouchMove = (e22) => {
        if (!element) {
          return;
        }
        const touch2 = e22.touches[0];
        const distanceX = Math.max(touch2.clientX - startPos.x, 0);
        const distanceY = Math.max(touch2.clientY - startPos.y, 0);
        if (axis === "xy") {
          element.style.transform = `translate(${distanceX}px, ${distanceY}px)`;
        }
        if (axis === "x") {
          element.style.transform = `translate(${distanceX}px, 0px)`;
        }
        if (axis === "y") {
          element.style.transform = `translate(0px, ${distanceY}px)`;
        }
        offset4 = { x: distanceX, y: distanceY };
      };
      const onTouchEnd = () => {
        element.style.transform = "";
        const v = getVelocity(offset4.y);
        if ((axis === "xy" || axis === "y") && offset4.y < 40) return;
        onTouchEndCallback?.(offset4, v, element);
        document.removeEventListener("touchmove", onTouchMove);
        document.removeEventListener("touchend", onTouchEnd);
        offset4 = { x: 0, y: 0 };
      };
      document.addEventListener("touchmove", onTouchMove);
      document.addEventListener("touchend", onTouchEnd);
    },
    [ref?.current, axis, onTouchEndCallback]
  );
  return {
    onTouchStart
  };
};

// ../../components/dist/esm/hooks/useFormContext.js
import { useContext as useContext9 } from "react";

// ../../components/dist/esm/providers/FormProvider/FormContext.js
import { createContext as createContext6 } from "react";
var FormContext = createContext6({
  disabled: false
});

// ../../components/dist/esm/hooks/useFormContext.js
var useFormContext = () => {
  return useContext9(FormContext);
};

// ../../components/dist/esm/hooks/useFormControlContext.js
import { useContext as useContext10 } from "react";

// ../../components/dist/esm/providers/FormControlProvider/FormControlContext.js
import { createContext as createContext7 } from "react";
var FormControlContext = createContext7({
  id: "",
  error: false,
  required: false,
  disabled: false,
  readOnly: false,
  fullWidth: false,
  hasValue: false,
  hasFocus: false
});

// ../../components/dist/esm/hooks/useFormControlContext.js
var useFormControlContext = () => {
  return useContext10(FormControlContext);
};

// ../../components/dist/esm/hooks/usePopover.js
import { useContext as useContext11 } from "react";

// ../../components/dist/esm/Popover/PopoverContext.js
import { createContext as createContext8 } from "react";
var PopoverContext = createContext8(void 0);

// ../../components/dist/esm/hooks/usePopover.js
var usePopover = () => {
  const ctx = useContext11(PopoverContext);
  if (!ctx) {
    throw new Error("usePopover must be used inside a Popover's content.");
  }
  return ctx;
};

// ../../components/dist/esm/hooks/usePortalRoot.js
var import_isElement = __toESM(require_isElement());
import { useContext as useContext12, useEffect as useEffect10, useMemo as useMemo10, useState as useState7 } from "react";

// ../../components/dist/esm/providers/PortalProvider/PortalContext.js
import { createContext as createContext9 } from "react";
var PortalContext2 = createContext9({
  root: typeof document !== "undefined" ? document.body : void 0
});

// ../../components/dist/esm/hooks/usePortalRoot.js
var isElement2 = (value) => (0, import_isElement.default)(value);
var getElement = (param) => {
  if (!param) {
    return null;
  }
  if (isElement2(param)) {
    return param;
  }
  if (isElement2(param.current)) {
    return param?.current ?? null;
  }
  return null;
};
var usePortalRoot = (params) => {
  const { root: rootFromProps } = params ?? {};
  const { root: rootFromContext } = useContext12(PortalContext2);
  const [activeContainer, setActiveContainer] = useState7(null);
  useEffect10(() => {
    if (rootFromProps) {
      setActiveContainer(getElement(rootFromProps) || document.body);
    } else if (rootFromContext) {
      setActiveContainer(getElement(rootFromContext) || document.body);
    } else {
      setActiveContainer(document.body);
    }
  }, [rootFromProps, rootFromContext]);
  return useMemo10(
    () => ({
      rootElement: activeContainer
    }),
    [activeContainer]
  );
};

// ../../utils/dist/esm/locale.js
var getUserPreferredLanguage = (options = { defaultLocale: "en-US" }) => {
  const { defaultLocale, supportedLocales } = options;
  const language = navigator.language;
  const locale = new Intl.Locale(language);
  if (supportedLocales) {
    const code = `${locale.language}-${locale.region}`;
    const isDirectlySupported = supportedLocales.has(code);
    if (isDirectlySupported) {
      return code;
    }
    const matchByLanguage = Array.from(supportedLocales).find((code2) => code2.startsWith(locale.language));
    if (matchByLanguage) {
      return matchByLanguage;
    }
  }
  return defaultLocale;
};

// ../../hooks/dist/esm/usePreferredLanguage.js
import { useEffect as useEffect11, useState as useState8 } from "react";
var usePreferredLanguage = (opts = { defaultLocale: "en-US" }) => {
  const [lang, setLang] = useState8();
  useEffect11(() => {
    setLang(getUserPreferredLanguage(opts));
  }, []);
  return lang;
};

// ../../components/dist/esm/hooks/usePreferredLanguage.js
var usePreferredLanguage2 = () => {
  return usePreferredLanguage({
    defaultLocale: DEFAULT_LOCALE,
    supportedLocales: SUPPORTED_LOCALES
  });
};

// ../../components/dist/esm/providers/FormControlProvider/FormControlProvider.js
import { jsx as jsx27 } from "react/jsx-runtime";
var FormControlProvider = ({
  children,
  ...rest
}) => {
  return /* @__PURE__ */ jsx27(FormControlContext.Provider, { value: rest, children });
};

// ../../components/dist/esm/FormControl/FormControl.js
import { jsx as jsx28 } from "react/jsx-runtime";
var FormControl = ({
  children,
  disabled = false,
  error: error2 = false,
  fullWidth = false,
  readOnly = false,
  required = false,
  value,
  hasFocus = false
}) => {
  const id = useId();
  const { disabled: globalDisabled } = useFormContext();
  const outerContext = useFormControlContext();
  return /* @__PURE__ */ jsx28(
    FormControlProvider,
    {
      id,
      disabled: disabled || outerContext.disabled || globalDisabled,
      error: error2 || outerContext.error,
      fullWidth: fullWidth || outerContext.fullWidth,
      readOnly: readOnly || outerContext.readOnly,
      required: required || outerContext.required,
      hasValue: value !== "" && value != null,
      hasFocus,
      children
    }
  );
};

// ../../components/dist/esm/FormHelperText/FormHelperText.js
import { forwardRef as forwardRef15 } from "react";

// ../../components/dist/esm/FormHelperText/form-helper-text.module.css
var form_helper_text_default = {
  "helper-text": "rgft_d33cb098",
  "error": "rgft_d4d95d43"
};

// ../../components/dist/esm/FormHelperText/FormHelperText.js
import { jsx as jsx29, jsxs as jsxs12 } from "react/jsx-runtime";
var FormHelperText = forwardRef15(({ children, icon = "alert" }, ref) => {
  const { error: error2 } = useFormControlContext();
  return /* @__PURE__ */ jsxs12(BodyText, { as: "span", size: 2, ref, className: clsx_default(form_helper_text_default["helper-text"], error2 && form_helper_text_default.error), children: [
    /* @__PURE__ */ jsx29(When, { condition: error2, children: /* @__PURE__ */ jsx29(Icon, { name: icon, size: "s", className: form_helper_text_default.icon }) }),
    children
  ] });
});

// ../../components/dist/esm/CheckboxBase/checkbox-base.module.css
var checkbox_base_default = {
  "checkbox-base": "rgft_e48753ab",
  "full-width": "rgft_1668590e",
  "checkbox-container": "rgft_83ff0357",
  "checked": "rgft_6dd255a6",
  "disabled": "rgft_b89456a0",
  "hidden": "rgft_0f45bf91",
  "content": "rgft_b66c7a26",
  "checkmark-container": "rgft_1891fed8",
  "control": "rgft_c433a440"
};

// ../../components/dist/esm/CheckboxBase/CheckboxBase.js
import { jsx as jsx30, jsxs as jsxs13 } from "react/jsx-runtime";
var CheckboxBase = forwardRef16(
  ({
    type = "checkbox",
    label,
    name,
    value,
    description,
    disabled: disabledByProp = false,
    readOnly: readOnlyByProp = false,
    fullWidth: fullWidthByProp = false,
    error: error2 = false,
    errorIcon = "alert",
    helperText,
    checked = false,
    onChange = () => null,
    classes: additionalClassNames
  }, ref) => {
    const {
      disabled: disabledByContext,
      readOnly: readonlyByContext,
      fullWidth: fullWidthByContext
    } = useFormControlContext();
    const [innerValue, setInnerValue] = useState9(checked);
    const checkboxGroupContext = useCheckboxGroup();
    const atMaxCheckedItemsInGroup = checkboxGroupContext?.maxCheckedCount ? checkboxGroupContext.currentCheckedCount >= checkboxGroupContext.maxCheckedCount : false;
    const disabled = disabledByProp || disabledByContext || atMaxCheckedItemsInGroup && !innerValue;
    const readOnly = readOnlyByProp || readonlyByContext;
    const fullWidth = fullWidthByProp || fullWidthByContext;
    const classes = clsx_default(checkbox_base_default["checkbox-base"], {
      [checkbox_base_default["full-width"]]: fullWidth,
      [checkbox_base_default.disabled]: disabled
    });
    useEffect12(() => {
      setInnerValue(checked);
    }, [checked]);
    const handleChange = useCallback9(
      (e2) => {
        setInnerValue(e2.target.checked);
        onChange(e2, e2.target.checked);
      },
      [onChange]
    );
    return /* @__PURE__ */ jsx30(FormControl, { error: error2, disabled, readOnly, value: innerValue, children: /* @__PURE__ */ jsxs13("div", { ref, className: classes, children: [
      /* @__PURE__ */ jsx30(
        CheckboxInner,
        {
          type,
          name,
          value,
          checked: innerValue,
          onChange: handleChange,
          label,
          description,
          classes: additionalClassNames
        }
      ),
      /* @__PURE__ */ jsx30(When, { condition: helperText, children: /* @__PURE__ */ jsx30(FormHelperText, { icon: errorIcon, children: helperText }) })
    ] }) });
  }
);
var CheckboxInner = ({
  type,
  name,
  value,
  label,
  description,
  checked,
  onChange = () => null,
  classes = {}
}) => {
  const { id, disabled, readOnly } = useFormControlContext();
  const { themeProps } = useColorTheme({ dark: checked ? "invert" : void 0 });
  return /* @__PURE__ */ jsxs13(
    "label",
    {
      htmlFor: id,
      className: clsx_default(checkbox_base_default["checkbox-container"], {
        [checkbox_base_default.checked]: checked,
        [checkbox_base_default.disabled]: disabled
      }),
      ...themeProps,
      children: [
        /* @__PURE__ */ jsxs13("div", { className: clsx_default(checkbox_base_default["checkmark-container"], classes.controlContainer), children: [
          /* @__PURE__ */ jsx30(
            "input",
            {
              name,
              value,
              type,
              role: type,
              checked,
              "aria-checked": checked,
              "aria-labelledby": `${id}-label`,
              "aria-describedby": description ? `${id}-desc` : void 0,
              onChange: (e2) => !readOnly && onChange(e2, e2.target.checked),
              id,
              className: checkbox_base_default.hidden,
              disabled,
              readOnly
            }
          ),
          type === "checkbox" ? /* @__PURE__ */ jsx30("span", { className: clsx_default(checkbox_base_default.control, classes.controlIndicator), children: checked ? /* @__PURE__ */ jsx30(Icon, { name: "checkmark", size: "xs" }) : null }) : /* @__PURE__ */ jsx30("span", { className: clsx_default(checkbox_base_default.control, classes.controlIndicator) })
        ] }),
        /* @__PURE__ */ jsxs13("div", { className: checkbox_base_default.content, children: [
          /* @__PURE__ */ jsx30(BodyText, { size: 1, block: true, id: `${id}-label`, children: label }),
          /* @__PURE__ */ jsx30(When, { condition: Boolean(description), children: /* @__PURE__ */ jsx30(BodyText, { size: 2, block: true, id: `${id}-desc`, children: description }) })
        ] })
      ]
    }
  );
};

// ../../components/dist/esm/Checkbox/checkbox.module.css
var checkbox_default = {
  "checkmark": "rgft_fb104adc"
};

// ../../components/dist/esm/Checkbox/Checkbox.js
import { jsx as jsx31 } from "react/jsx-runtime";
var Checkbox = forwardRef17(({ onChange, ...props }, ref) => {
  const groupContext = useCheckboxGroup();
  const onChangeRef = useCallbackRef(onChange);
  const groupContextSetChecked = useCallbackRef(groupContext?.setChecked);
  const id = useId();
  useEffect13(() => {
    groupContextSetChecked(id, props.checked || false);
    return () => {
      groupContextSetChecked(id, false);
    };
  }, [id, props.checked]);
  const handleChange = useCallback10(
    (e2, checked) => {
      onChangeRef(e2, checked);
      groupContextSetChecked(id, checked);
    },
    [id]
  );
  return /* @__PURE__ */ jsx31(
    CheckboxBase,
    {
      ref,
      ...props,
      disabled: props.disabled,
      onChange: handleChange,
      classes: {
        controlIndicator: checkbox_default.checkmark
      },
      type: "checkbox"
    }
  );
});

// ../../components/dist/esm/CloseButton/CloseButton.js
import { forwardRef as forwardRef19 } from "react";

// ../../components/dist/esm/IconButton/IconButton.js
import { forwardRef as forwardRef18 } from "react";

// ../../components/dist/esm/IconButton/iconbutton.module.css
var iconbutton_default = {
  "button-base": "rgft_04a7a440",
  "size-s": "rgft_7841c627",
  "primary": "rgft_49687c04",
  "secondary": "rgft_c3a65edd",
  "tertiary": "rgft_491e4dab",
  "flat": "rgft_a34689e3",
  "selected": "rgft_cf5e6f42",
  "visited": "rgft_be8c500e",
  "disabled": "rgft_b623f248",
  "icon-button": "rgft_b675880e",
  "icon": "rgft_127a95e3",
  "label-on-hover": "rgft_73699e62",
  "content": "rgft_2552ca02",
  "without-border": "rgft_837570f1",
  "hovering": "rgft_1cac6ce7",
  "flip-label": "rgft_1e8bda87"
};

// ../../components/dist/esm/IconButton/IconButton.js
import { jsx as jsx32, jsxs as jsxs14 } from "react/jsx-runtime";
var IconButton = forwardRef18(
  ({
    icon,
    labelOnHover,
    labelPosition = "right",
    variant,
    className,
    size: size4 = "m",
    iconSize = "s",
    injectAnalyticsMetadata = false,
    ...props
  }, ref) => {
    const { dark } = useColorTheme();
    const variantWithoutBorder = variant === "primary" && dark || variant === "tertiary" || variant === "flat";
    const classes = clsx_default(
      [iconbutton_default["icon-button"]],
      {
        [iconbutton_default["without-border"]]: variantWithoutBorder,
        [iconbutton_default["label-on-hover"]]: labelOnHover,
        [iconbutton_default["flip-label"]]: labelPosition === "left",
        [iconbutton_default["hovering"]]: props.hovering
      },
      className
    );
    const analyticsMetadata = !injectAnalyticsMetadata ? {} : {
      [ANALYTICS_METADATA_ATTRIBUTE]: JSON.stringify({
        name: "IconButton",
        properties: {
          variant,
          icon
        }
      })
    };
    const buttonProps = {
      ...props,
      ...analyticsMetadata
    };
    return /* @__PURE__ */ jsxs14(ButtonBase, { ...buttonProps, size: size4, className: classes, variant, ref, children: [
      /* @__PURE__ */ jsx32(Icon, { name: icon, size: iconSize, className: iconbutton_default.icon }),
      /* @__PURE__ */ jsx32(When, { condition: labelOnHover, children: /* @__PURE__ */ jsx32(UtilityText, { size: 3, center: true, className: iconbutton_default.content, children: labelOnHover }) })
    ] });
  }
);

// ../../components/dist/esm/CloseButton/close-button.module.css
var close_button_default = {
  "close-button": "rgft_b0761591",
  "size-s": "rgft_881f9b16"
};

// ../../components/dist/esm/CloseButton/i18n.js
var CLOSEBUTTON_I18N_STRINGS = {
  Close: {
    "ar-SA": "\u0625\u063A\u0644\u0627\u0642",
    "de-DE": "Schluss",
    "en-GB": "Close",
    "en-US": "Close",
    "es-ES": "Cerrar",
    "fr-FR": "Fermer",
    "id-ID": "Tutup",
    "it-IT": "Chiudi",
    "ja-JP": "\u9589\u3058\u308B",
    "ko-KR": "\uB9C8\uBB34\uB9AC",
    "pt-BR": "Fechar",
    "ru-RU": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    "th-TH": "\u0E1B\u0E34\u0E14",
    "tr-TR": "Kapat",
    "vi-VN": "\u0110\xF3ng",
    "zh-CN": "\u5173\u95ED",
    "zh-TW": "\u95DC\u9589"
  }
};

// ../../components/dist/esm/CloseButton/CloseButton.js
import { jsx as jsx33 } from "react/jsx-runtime";
var CloseButton = forwardRef19(
  ({ label, onClick, className, size: size4 = "m", ...props }, ref) => {
    const { T } = useTranslate(CLOSEBUTTON_I18N_STRINGS);
    return /* @__PURE__ */ jsx33(
      IconButton,
      {
        icon: "close",
        iconSize: size4 === "m" ? "s" : "xs",
        onClick,
        variant: "tertiary",
        "aria-label": label || T("Close"),
        className: clsx_default(className, close_button_default["close-button"], close_button_default[`size-${size4}`]),
        size: size4,
        ref,
        ...props
      }
    );
  }
);

// ../../components/dist/esm/Drawer/Drawer.js
import { cloneElement as cloneElement3, forwardRef as forwardRef22, useCallback as useCallback11, useRef as useRef8 } from "react";

// ../../components/dist/esm/Paper/Paper.js
import { forwardRef as forwardRef21 } from "react";

// ../../components/dist/esm/Box/Box.js
import { forwardRef as forwardRef20 } from "react";

// ../../components/dist/esm/Box/box.module.css
var box_default = {
  "box": "rgft_1587b0f0",
  "glass": "rgft_f97b9002"
};

// ../../components/dist/esm/Box/utils.js
var DEFAULT_LIGHT_SHADE = 100;
var DEFAULT_DARK_SHADE = 900;
var DARK_SHADE_THRESHOLD = 600;
var baseColorRegex = new RegExp(`(${AURA_COLORS.join("|")})`);
var shadedColorRegex = new RegExp(`(${AURA_COLORS.join("|")})-\\d+`);
var getBackgroundColorShouldBeForDarkMode = (bg) => {
  if (!bg || !bg.includes("-")) {
    return null;
  }
  if (!shadedColorRegex.test(bg)) {
    return null;
  }
  const shade = parseInt(bg.substring(bg.lastIndexOf("-") + 1));
  if (isNaN(shade)) {
    return null;
  }
  return shade >= DARK_SHADE_THRESHOLD;
};
var getCSSVarName = (prop) => `--rg-box-${prop}`;
var getBoxStyles = (props) => {
  const styles = {};
  const { p, m, radius, bg, isDarkScheme } = props;
  if (p) {
    const paddings = Array.isArray(p) ? p : [p];
    const varName = getCSSVarName("p");
    if (paddings.length === 1) {
      styles[varName] = getPaddingStyle(paddings[0], "all");
    } else if (paddings.length === 2) {
      styles[varName] = `${getPaddingStyle(paddings[0], "vertical")} ${getPaddingStyle(paddings[1], "horizontal")}`;
    } else if (paddings.length === 4) {
      styles[varName] = `${getPaddingStyle(paddings[0], "vertical")} ${getPaddingStyle(
        paddings[1],
        "horizontal"
      )} ${getPaddingStyle(paddings[2], "vertical")} ${getPaddingStyle(paddings[3], "horizontal")}`;
    } else {
      throw new Error("`p` only supports `all`, `top-bottom left-right`, `top right bottom left` formats.");
    }
  }
  if (m) {
    const varName = getCSSVarName("m");
    const margins = Array.isArray(m) ? m : [m];
    styles[varName] = margins.map(getMarginStyle).join(" ");
  }
  if (bg) {
    const varName = getCSSVarName("bg");
    if (baseColorRegex.test(bg)) {
      const [name, shade = isDarkScheme ? DEFAULT_DARK_SHADE : DEFAULT_LIGHT_SHADE] = bg.split("-");
      styles[varName] = `var(--rg-color-base-${name}-${shade})`;
    } else {
      styles[varName] = `var(--rg-color-background-${bg})`;
    }
  }
  if (radius) {
    const varName = getCSSVarName("r");
    if (typeof radius === "number") {
      styles[varName] = getRadiusStyle(radius);
    } else {
      const { t: t2, r: r3, b, l, tl, tr, br, bl } = radius;
      styles[varName] = `${getRadiusStyle(tl ?? t2 ?? l ?? 0)} ${getRadiusStyle(tr ?? t2 ?? r3 ?? 0)} ${getRadiusStyle(
        br ?? b ?? r3 ?? 0
      )} ${getRadiusStyle(bl ?? b ?? l ?? 0)}`;
    }
  }
  return styles;
};
var getRadiusStyle = (radius) => {
  if (radius === 0) {
    return "0";
  }
  return `var(--rg-radius-unit-${radius}x)`;
};
var getMarginStyle = (margin) => {
  if (margin === 0) {
    return "0";
  }
  return `var(--rg-margin-${margin})`;
};
var getPaddingStyle = (padding, side) => {
  if (padding === 0) {
    return "0";
  }
  if (padding === 1) {
    if (side === "all") {
      return "var(--rg-padding-2) var(--rg-padding-1)";
    } else if (side === "horizontal") {
      return "var(--rg-padding-1)";
    } else {
      return "var(--rg-padding-2)";
    }
  } else {
    return `var(--rg-padding-${padding + 1})`;
  }
};

// ../../components/dist/esm/Box/Box.js
import { jsx as jsx34 } from "react/jsx-runtime";
var polyRef6 = forwardRef20;
var Box = polyRef6(
  ({ as: As = "div", className, children, bg, radius, p, m, style, colorScheme, ...props }, ref) => {
    const classes = clsx_default(className, box_default.box, bg === "glass" && box_default.glass);
    const { dark: isParentDarkScheme } = useColorTheme();
    const isDarkScheme = colorScheme === void 0 ? isParentDarkScheme : colorScheme === "invert" ? !isParentDarkScheme : colorScheme === "dark";
    const computedStyles = {
      ...getBoxStyles({ radius, bg, p, m, isDarkScheme }),
      ...style
    };
    const backgroundColorShouldBeForDarkMode = colorScheme ? null : getBackgroundColorShouldBeForDarkMode(bg);
    const colorSchemeFromBackgroundShade = backgroundColorShouldBeForDarkMode === null ? void 0 : backgroundColorShouldBeForDarkMode ? "dark" : "light";
    const colorSchemeFromParent = isDarkScheme === isParentDarkScheme ? void 0 : isDarkScheme ? "dark" : "light";
    return /* @__PURE__ */ jsx34(
      As,
      {
        ref,
        className: classes,
        style: computedStyles,
        "data-rg-mode": colorSchemeFromBackgroundShade || colorSchemeFromParent,
        ...props,
        children
      }
    );
  }
);

// ../../components/dist/esm/Paper/paper.module.css
var paper_default = {
  "outlined": "rgft_53cf285e"
};

// ../../components/dist/esm/Paper/Paper.js
import { jsx as jsx35 } from "react/jsx-runtime";
var Paper = forwardRef21(
  ({ children, className, shadowVariant = "themed", variant = "opaque", outlined = false, elevation = 1, ...props }, ref) => {
    const classes = clsx_default(className, outlined && paper_default.outlined);
    return /* @__PURE__ */ jsx35(
      DropShadow,
      {
        disabled: shadowVariant === "none",
        variant: variant === "glass" || shadowVariant === "none" ? "grayscale" : shadowVariant,
        elevation,
        children: /* @__PURE__ */ jsx35(Box, { radius: 2, p: 4, bg: variant === "opaque" ? "page" : "glass", ...props, ref, className: classes, children })
      }
    );
  }
);

// ../../components/dist/esm/Popover/PopoverProvider.js
import { useMemo as useMemo11 } from "react";
import { jsx as jsx36 } from "react/jsx-runtime";
var PopoverProvider = ({ children, closePopover, isOpen, context }) => {
  const value = useMemo11(
    () => ({
      isOpen,
      context,
      closePopover
    }),
    [context, closePopover, isOpen]
  );
  return /* @__PURE__ */ jsx36(PopoverContext.Provider, { value, children });
};

// ../../components/dist/esm/Drawer/drawer.module.css
var drawer_default = {
  "backdrop": "rgft_c426c267",
  "drawer": "rgft_06e7508a",
  "full-screen": "rgft_8d3333e9",
  "paper": "rgft_2fe7796f",
  "draggable-panel": "rgft_e04cb363",
  "draggable-panel-top": "rgft_93a1030c"
};

// ../../components/dist/esm/Drawer/Drawer.js
import { Fragment as Fragment4, jsx as jsx37, jsxs as jsxs15 } from "react/jsx-runtime";
var Drawer = forwardRef22(
  ({
    children,
    open = false,
    onOpen = () => null,
    onClose = () => null,
    referenceElement,
    fullScreen = false,
    side = "bottom",
    classes,
    drag
  }, ref) => {
    const { rootElement } = usePortalRoot();
    const { themeProps } = useColorTheme();
    const drawerClasses = clsx_default(
      drawer_default.drawer,
      {
        [drawer_default["full-screen"]]: fullScreen
      },
      classes?.drawer
    );
    const setOpen = useCallback11((state) => state ? onOpen() : onClose(), [onOpen, onClose]);
    const closeDialog = useCallback11(() => onClose(), [onClose]);
    const { refs, context } = useFloating2({
      open,
      onOpenChange: setOpen,
      whileElementsMounted: autoUpdate
    });
    const click = useClick(context);
    const roleInteraction = useRole(context, { role: "dialog" });
    const dismiss = useDismiss(context, {
      outsidePress: true,
      escapeKey: true
    });
    const { getFloatingProps, getReferenceProps } = useInteractions([click, roleInteraction, dismiss]);
    const { isMounted, status } = useTransitionStatus(context, { duration: 500 });
    const draggingRef = useRef8(null);
    const floatingRef = useMergeRefs(refs.setFloating, ref);
    const DRAG_TARGET_VELOCITY = drag?.closeVelocity || 0.5;
    const DRAG_CLOSE_RANGE = drag?.closeRange || 220;
    const { onTouchStart } = useDraggablePanel(
      draggingRef,
      side === "bottom" ? "y" : "x",
      (offset4, velocity, element) => {
        if (offset4[side === "bottom" ? "y" : "x"] > DRAG_CLOSE_RANGE || velocity > DRAG_TARGET_VELOCITY) {
          element?.parentElement?.style.setProperty("transition", "none");
          onClose && onClose();
        }
      }
    );
    return /* @__PURE__ */ jsxs15(Fragment4, { children: [
      referenceElement ? cloneElement3(referenceElement, {
        ...getReferenceProps({
          ...referenceElement.props
        })
      }) : null,
      /* @__PURE__ */ jsx37(PopoverProvider, { closePopover: closeDialog, isOpen: isMounted, context, children: isMounted ? /* @__PURE__ */ jsx37(FloatingPortal, { root: rootElement, children: /* @__PURE__ */ jsx37(FloatingOverlay, { lockScroll: true, className: drawer_default.backdrop, "data-transition-status": status, ...themeProps, children: /* @__PURE__ */ jsx37(FloatingFocusManager, { context, children: /* @__PURE__ */ jsx37(
        "div",
        {
          ref: floatingRef,
          ...getFloatingProps(),
          className: drawerClasses,
          "data-transition-status": status,
          "data-side": side,
          children: /* @__PURE__ */ jsxs15(
            Paper,
            {
              ref: drag?.active ? draggingRef : null,
              shadowVariant: "grayscale",
              className: clsx_default(drawer_default.paper, classes?.paper),
              radius: { [side === "bottom" ? "t" : "l"]: fullScreen ? 0 : 4 },
              children: [
                drag?.active && /* @__PURE__ */ jsx37(
                  "div",
                  {
                    className: side === "right" ? drawer_default["draggable-panel"] : drawer_default["draggable-panel-top"],
                    onTouchStart
                  }
                ),
                children
              ]
            }
          )
        }
      ) }) }) }) : null })
    ] });
  }
);

// ../../components/dist/esm/Popover/Popover.js
import { isServer as isServer4 } from "@amzn/aws-marketing-experience-builder-template-helpers";
var import_clamp = __toESM(require_clamp());
import { cloneElement as cloneElement4, useCallback as useCallback12, useEffect as useEffect14, useRef as useRef9, useState as useState10 } from "react";

// ../../components/dist/esm/Popover/popover.module.css
var popover_default = {
  "popover": "rgft_d8090906",
  "backdrop": "rgft_20793a08",
  "arrow": "rgft_45192e28",
  "popover-scale": "rgft_39367efd",
  "select-popover-enter": "rgft_3ce6fdf3",
  "select-popover-exit": "rgft_28d8af2f"
};

// ../../components/dist/esm/Popover/Popover.js
import { Fragment as Fragment5, jsx as jsx38, jsxs as jsxs16 } from "react/jsx-runtime";
var PADDING_PIXELS = 20;
var SMALL_PADDING_PIXELS = 4;
var TRANSITION_DURATION_MAP = {
  none: "0ms",
  short: variables_exports.TransitionShortDuration,
  medium: variables_exports.TransitionMediumDuration,
  long: variables_exports.TransitionLongDuration,
  stagger: variables_exports.TransitionStaggerDuration
};
var referenceSizeMiddleware = size3({
  apply({ rects, elements }) {
    Object.assign(elements.floating.style, {
      minWidth: `${rects.reference.width}px`
    });
  },
  padding: PADDING_PIXELS
});
var contentSizeMiddleware = (minHeight, maxHeight) => size3({
  apply({ elements, availableHeight, availableWidth }) {
    Object.assign(elements.floating.style, {
      height: minHeight && maxHeight ? `${(0, import_clamp.default)(availableHeight, minHeight, maxHeight)}px` : void 0,
      maxWidth: `${availableWidth}px`
    });
  },
  padding: PADDING_PIXELS
});
var matchWidthMiddleware = size3({
  apply({ rects, elements }) {
    Object.assign(elements.floating.style, {
      width: `${rects.reference.width}px`
    });
  },
  padding: PADDING_PIXELS
});
var Popover = ({
  children,
  open: externalOpen,
  popoverContent,
  openOnClick = false,
  openOnHover = false,
  role = "dialog",
  placement = "top",
  cover = false,
  lockScroll = false,
  backdrop = false,
  arrow: showArrow = false,
  popoverContentHeights,
  triggerPadding = "normal",
  matchWidth = false,
  onOpen = () => null,
  onClose = () => null,
  transitionDuration = "none",
  classes = {},
  fixedPosition,
  useAnimationFrame = false,
  animated = false
}) => {
  const { rootElement } = usePortalRoot();
  const { themeProps } = useColorTheme();
  const arrowRef = useRef9(null);
  const [internalOpen, setInternalOpen] = useState10(false);
  const padding = typeof triggerPadding === "number" ? triggerPadding : triggerPadding === "normal" ? PADDING_PIXELS : SMALL_PADDING_PIXELS;
  const [pixelOffset, setPixelOffset] = useState10(padding);
  const open = externalOpen ?? internalOpen;
  const backdropClasses = clsx_default(backdrop && popover_default.backdrop, classes.backdrop, popover_default.popover);
  const transitionDurationMs = parseInt(TRANSITION_DURATION_MAP[transitionDuration], 10);
  const hasTransition = transitionDuration !== "none";
  const handleSetOpen = useCallback12(
    (state) => {
      state ? onOpen() : onClose();
      setInternalOpen(state);
    },
    [onOpen, onClose]
  );
  const closePopover = useCallback12(() => handleSetOpen(false), [handleSetOpen]);
  const { refs, floatingStyles, context, elements, middlewareData } = useFloating2({
    open,
    onOpenChange: handleSetOpen,
    middleware: [
      pixelOffset !== 0 && offset3(pixelOffset),
      cover && referenceSizeMiddleware,
      popoverContentHeights && contentSizeMiddleware(popoverContentHeights.min, popoverContentHeights.max),
      matchWidth && matchWidthMiddleware,
      flip3({
        crossAxis: placement.includes("-"),
        padding: PADDING_PIXELS,
        fallbackStrategy: "initialPlacement"
      }),
      shift3({
        padding: PADDING_PIXELS
      }),
      !fixedPosition && hide3({
        padding: PADDING_PIXELS,
        strategy: "referenceHidden"
      }),
      showArrow && arrow3({ element: arrowRef.current })
    ],
    placement,
    transform: !hasTransition,
    whileElementsMounted: (referenceEl, floatingEl, update) => {
      const cleanup2 = autoUpdate(referenceEl, floatingEl, update, {
        animationFrame: useAnimationFrame
      });
      return cleanup2;
    }
  });
  useEffect14(() => {
    if (elements.reference && cover) {
      const refRect = elements.reference.getBoundingClientRect();
      setPixelOffset(-refRect.height);
    } else {
      setPixelOffset(padding);
    }
  }, [cover, elements.reference, padding]);
  const roleInteraction = useRole(context, { role });
  const dismiss = useDismiss(context);
  const clickEnabled = openOnClick && !openOnHover || !openOnClick && !openOnHover;
  const { delay } = useDelayGroup(context);
  const click = useClick(context, { enabled: clickEnabled });
  const hover = useHover(context, { enabled: openOnHover, delay, handleClose: isServer4() ? void 0 : safePolygon() });
  const focus = useFocus(context, { enabled: openOnHover });
  const { getFloatingProps, getReferenceProps } = useInteractions([click, hover, focus, roleInteraction, dismiss]);
  const { isMounted, status } = useTransitionStatus(context, { duration: transitionDurationMs });
  const referenceRefs = useMergeRefs(refs.setReference, children?.ref);
  useEffect14(() => {
    if (fixedPosition) {
      refs.setPositionReference({
        getBoundingClientRect: () => fixedPosition.boundingClientRect,
        getClientRects: fixedPosition.clientRects ? () => fixedPosition.clientRects : void 0,
        contextElement: fixedPosition.contextElement
      });
    }
  }, [refs.setPositionReference, fixedPosition]);
  const content = /* @__PURE__ */ jsx38(FloatingFocusManager, { context, disabled: openOnHover, children: /* @__PURE__ */ jsxs16(
    "div",
    {
      ref: refs.setFloating,
      style: {
        ...floatingStyles,
        visibility: middlewareData.hide?.referenceHidden ? "hidden" : void 0
      },
      ...getFloatingProps(),
      ...themeProps,
      className: clsx_default(popover_default.popover, classes.popover, animated && hasTransition && popover_default["popover-scale"]),
      "data-placement": placement,
      "data-transition-status": hasTransition ? status : void 0,
      children: [
        showArrow ? /* @__PURE__ */ jsx38(FloatingArrow, { ref: arrowRef, context, className: clsx_default(popover_default.arrow, classes.arrow) }) : null,
        popoverContent
      ]
    }
  ) });
  return /* @__PURE__ */ jsxs16(Fragment5, { children: [
    children ? cloneElement4(children, {
      ref: referenceRefs,
      ...getReferenceProps({
        ...children.props
      })
    }) : null,
    /* @__PURE__ */ jsx38(PopoverProvider, { closePopover, isOpen: isMounted, context, children: isMounted ? /* @__PURE__ */ jsx38(FloatingPortal, { root: rootElement, children: openOnHover || !lockScroll ? content : /* @__PURE__ */ jsx38(FloatingOverlay, { lockScroll, className: backdropClasses, children: content }) }) : null })
  ] });
};

// ../../hooks/dist/esm/useIsClient.js
import { useEffect as useEffect15, useState as useState11 } from "react";
var useIsClient = () => {
  const [isClient, setIsClient] = useState11(false);
  useEffect15(() => setIsClient(true), []);
  return isClient;
};

// ../../components/dist/esm/LanguageSelector/LanguageList.js
import { useEffect as useEffect19, useMemo as useMemo12, useRef as useRef11, useState as useState15 } from "react";

// ../../components/dist/esm/List/List.js
import { Children, forwardRef as forwardRef24 } from "react";

// ../../hooks/dist/esm/useDebouncedState.js
var import_lodash = __toESM(require_lodash());
import { useEffect as useEffect16, useState as useState12 } from "react";
function useDebouncedState(value, delay) {
  const [debounced, setDebounced] = useState12(value);
  const updateState = useDebouncedCallback(
    setDebounced,
    // @ts-ignore
    delay
  );
  useEffect16(() => {
    updateState(value);
  }, [value]);
  return debounced;
}

// ../../utils/dist/esm/managedIntersectionObserver.js
var ManagedIntersectionObserver = class {
  observer;
  callbacks = /* @__PURE__ */ new Map();
  /**
   * @param initOptions initialization options for the IntersectionObserver instance
   */
  constructor(initOptions) {
    if ("IntersectionObserver" in globalThis) {
      this.observer = new IntersectionObserver(this.onIntersection, initOptions);
    }
  }
  onIntersection = (entries) => {
    entries.map((entry) => this.callbacks.get(entry.target)?.(entry));
  };
  /** Registers a callback for a specific element's intersection events */
  observe(target, callback) {
    if (this.observer) {
      this.callbacks.set(target, callback);
      this.observer.observe(target);
    }
  }
  /** Stops observing a specific element */
  unobserve(target) {
    if (this.observer) {
      this.callbacks.delete(target);
      this.observer.unobserve(target);
    }
  }
  /** Clears callbacks and disconnects the IntersectionObserver */
  dispose() {
    if (this.observer) {
      this.callbacks.clear();
      this.observer.disconnect();
    }
  }
};

// ../../hooks/dist/esm/useElementIsVisible.js
import { useEffect as useEffect17, useState as useState13 } from "react";
var isVisibleObserver = new ManagedIntersectionObserver();
function useElementIsVisible() {
  const [element, setElement] = useState13(null);
  const [visible, setVisible] = useState13();
  useEffect17(() => {
    if (!element) {
      setVisible(false);
      return;
    }
    isVisibleObserver.observe(element, (entry) => {
      setVisible(entry.isIntersecting);
    });
    return () => {
      isVisibleObserver.unobserve(element);
      setVisible(false);
    };
  }, [element]);
  return {
    ref: setElement,
    visible: visible ?? false
  };
}

// ../../utils/dist/esm/smoothScrollTo.js
var smoothScrollTo = (el, options) => {
  return new Promise((resolve) => {
    const handleScroll = () => {
      const isAtTop = options.top === void 0 || el.scrollTop === options.top;
      const isAtLeft = options.left === void 0 || el.scrollLeft === options.left;
      if (isAtTop && isAtLeft) {
        el.removeEventListener("scroll", handleScroll);
        resolve();
      }
    };
    el.addEventListener("scroll", handleScroll);
    setTimeout(() => {
      el.removeEventListener("scroll", handleScroll);
      resolve();
    }, 1e3);
    el.scrollTo({
      ...options,
      behavior: "smooth"
    });
  });
};

// ../../components/dist/esm/ScrollContainer/ScrollContainer.js
import { forwardRef as forwardRef23, useCallback as useCallback13, useEffect as useEffect18, useRef as useRef10, useState as useState14 } from "react";

// ../../components/dist/esm/ScrollContainer/scroll-container.module.css
var scroll_container_default = {
  "scroll-container": "rgft_f99f709a",
  "vertical": "rgft_c0de2cd2",
  "scrim": "rgft_4ba04ca0",
  "horizontal": "rgft_cfc97a30",
  "sentinel": "rgft_83f5293f",
  "sentinel-vertical": "rgft_3dc68c56",
  "sentinel-horizontal": "rgft_35b3a639",
  "sentinel-wrapper": "rgft_ba4cf4bd",
  "scroller": "rgft_3da1576c",
  "disabled": "rgft_92856350",
  "scrim-button": "rgft_3515a78a",
  "scrim-button__start": "rgft_848d27f8",
  "scrim-button__end": "rgft_652ae09c",
  "scrim-button__active": "rgft_8dca3549"
};

// ../../components/dist/esm/ScrollContainer/ScrollContainer.js
import { jsx as jsx39, jsxs as jsxs17 } from "react/jsx-runtime";
var polyRef7 = forwardRef23;
var STEPS = 100;
var THRESHOLDS = new Array(STEPS).fill(0).map((_, i2) => 1 / STEPS * i2);
var OBSERVER_THRESHOLD = THRESHOLDS[THRESHOLDS.length - 1];
var ScrollContainer = polyRef7(
  ({
    as: As = "div",
    className,
    children,
    direction = "vertical",
    scrim = false,
    disableScroll = false,
    scrollButtons = false,
    innerClasses = {},
    innerProps = {},
    relativeScrollBehavior = false,
    ...props
  }, ref) => {
    const classes = clsx_default(scroll_container_default["scroll-container"], scroll_container_default[direction], className, {
      [scroll_container_default.scrim]: scrim,
      [scroll_container_default.disabled]: disableScroll
    });
    const [startScrimActive, setStartScrimActive] = useState14(false);
    const [endScrimActive, setEndScrimActive] = useState14(false);
    const containerRef = useRef10(null);
    const scrollerRef = useRef10(null);
    const sentinelRefStart = useRef10(null);
    const sentinelRefEnd = useRef10(null);
    const { ref: visibleRef, visible } = useElementIsVisible();
    const outerRef = useMergeRefs(ref, visibleRef, containerRef);
    const startScrimActiveDebounced = useDebouncedState(startScrimActive && visible, 100);
    const endScrimActiveDebounced = useDebouncedState(endScrimActive && visible, 100);
    const updateScrollButtonState = useCallback13(
      (active, isStartSentinel) => {
        if (!scrollButtons) return;
        if (isStartSentinel) {
          setStartScrimActive(active);
        } else {
          setEndScrimActive(active);
        }
      },
      [scrollButtons]
    );
    useEffect18(() => {
      if (!scrim) {
        return;
      }
      const firstChild = sentinelRefStart.current;
      const lastChild = sentinelRefEnd.current;
      const scroller = scrollerRef.current;
      if (!firstChild || !lastChild || !scroller) {
        return;
      }
      const obs = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const varName = entry.target === firstChild ? "--scrim-start" : "--scrim-end";
            if (entry.intersectionRatio < OBSERVER_THRESHOLD) {
              containerRef.current?.style.setProperty(varName, (1 - entry.intersectionRatio).toString());
            } else {
              containerRef.current?.style.removeProperty(varName);
            }
            updateScrollButtonState(entry.intersectionRatio < OBSERVER_THRESHOLD, entry.target === firstChild);
          }
        },
        {
          root: scroller,
          threshold: THRESHOLDS
        }
      );
      obs.observe(firstChild);
      obs.observe(lastChild);
      return () => {
        obs.disconnect();
      };
    }, [scrim, updateScrollButtonState]);
    const handleScrimButtonClick = (buttonDirection) => {
      if (!scrollerRef.current) return;
      if (relativeScrollBehavior) {
        const scrollOptions = buttonDirection === "start" ? { left: 0 } : {
          left: scrollerRef.current.scrollWidth
        };
        smoothScrollTo(scrollerRef.current, scrollOptions);
      } else {
        const scrollOptions = buttonDirection === "start" ? { left: 0, top: 0 } : {
          left: scrollerRef.current.scrollWidth,
          top: scrollerRef.current.scrollHeight
        };
        smoothScrollTo(scrollerRef.current, scrollOptions);
      }
    };
    return /* @__PURE__ */ jsx39("div", { ref: outerRef, className: classes, ...props, children: /* @__PURE__ */ jsxs17(As, { ref: scrollerRef, className: clsx_default(scroll_container_default.scroller, innerClasses.scroller), ...innerProps.scroller, children: [
      scrollButtons ? /* @__PURE__ */ jsx39(
        "div",
        {
          className: clsx_default(scroll_container_default["scrim-button"], scroll_container_default["scrim-button__start"], {
            [scroll_container_default["scrim-button__active"]]: startScrimActiveDebounced
          }),
          children: /* @__PURE__ */ jsx39(
            IconButton,
            {
              onClick: () => handleScrimButtonClick("start"),
              size: "s",
              icon: "caret-left",
              "aria-label": "Scroll to"
            }
          )
        }
      ) : null,
      scrim && /* @__PURE__ */ jsx39("div", { className: scroll_container_default["sentinel-wrapper"], "aria-hidden": true, children: /* @__PURE__ */ jsx39(
        "div",
        {
          "data-scroll-sentinel": "start",
          ref: sentinelRefStart,
          className: clsx_default(scroll_container_default.sentinel, scroll_container_default[`sentinel-${direction}`], scroll_container_default[`sentinel-start-${direction}`])
        }
      ) }),
      children,
      scrim && /* @__PURE__ */ jsx39("div", { className: scroll_container_default["sentinel-wrapper"], style: { justifyContent: "end" }, "aria-hidden": true, children: /* @__PURE__ */ jsx39(
        "div",
        {
          "data-scroll-sentinel": "end",
          ref: sentinelRefEnd,
          className: clsx_default(scroll_container_default.sentinel, scroll_container_default[`sentinel-${direction}`], scroll_container_default[`sentinel-end-${direction}`])
        }
      ) }),
      scrollButtons ? /* @__PURE__ */ jsx39(
        "div",
        {
          className: clsx_default(scroll_container_default["scrim-button"], scroll_container_default["scrim-button__end"], {
            [scroll_container_default["scrim-button__active"]]: endScrimActiveDebounced
          }),
          children: /* @__PURE__ */ jsx39(
            IconButton,
            {
              onClick: () => handleScrimButtonClick("end"),
              size: "s",
              icon: "caret-right",
              "aria-label": "Scroll to"
            }
          )
        }
      ) : null
    ] }) });
  }
);

// ../../components/dist/esm/List/list.module.css
var list_default = {
  "list-container": "rgft_23885d27",
  "vertical": "rgft_f4965145",
  "horizontal": "rgft_c82f547b",
  "list": "rgft_1035c2c9"
};

// ../../components/dist/esm/List/List.js
import { jsx as jsx40 } from "react/jsx-runtime";
var polyRef8 = forwardRef24;
var List = polyRef8(
  ({
    as: As = "ul",
    children,
    className,
    scrollerClassName,
    scrim = false,
    horizontal = false,
    containerProps,
    ...props
  }, ref) => {
    const containerClasses = clsx_default(className, list_default["list-container"], {
      [list_default["horizontal"]]: horizontal,
      [list_default["vertical"]]: !horizontal
    });
    const scrollerClasses = clsx_default(list_default.list, scrollerClassName);
    return /* @__PURE__ */ jsx40(
      ScrollContainer,
      {
        ref,
        as: As,
        scrim: scrim && Children.count(children) > 1,
        direction: horizontal ? "horizontal" : "vertical",
        className: containerClasses,
        ...containerProps,
        innerClasses: {
          scroller: scrollerClasses
        },
        innerProps: {
          scroller: props
        },
        children
      }
    );
  }
);

// ../../components/dist/esm/List/ListItem.js
import { forwardRef as forwardRef25 } from "react";

// ../../components/dist/esm/List/list-item.module.css
var list_item_default = {
  "list-item": "rgft_8ed090e4",
  "button": "rgft_5299a281",
  "wrap": "rgft_5e6327f4",
  "left-container": "rgft_eb71844b",
  "right-container": "rgft_bb9a2578",
  "selected": "rgft_4059e5bf",
  "disabled": "rgft_6190075a",
  "start-icon": "rgft_581d90b8",
  "end-icon": "rgft_605e1087"
};

// ../../components/dist/esm/List/ListItem.js
import { jsx as jsx41, jsxs as jsxs18 } from "react/jsx-runtime";
var polyRef9 = forwardRef25;
var ListItem = polyRef9(
  ({
    children,
    className,
    button = false,
    wrap = false,
    selected = false,
    disabled = false,
    badge,
    role,
    endIcon,
    startIcon,
    href,
    as,
    injectAnalyticsMetadata = false,
    onClick,
    onKeyDown,
    onKeyUp,
    ...props
  }, ref) => {
    if (as === "li") {
      as = void 0;
    }
    const As = as || (href ? "a" : button ? "button" : "div");
    const hrefProps = useHrefProps(href);
    const classes = clsx_default(className, list_item_default["list-item"]);
    const innerClasses = clsx_default({
      [list_item_default.button]: button,
      [list_item_default.wrap]: wrap,
      [list_item_default.selected]: selected,
      [list_item_default.disabled]: disabled
    });
    const ariaAttributes = {};
    const liAttributes = {};
    Object.entries(props).forEach(([key, value]) => {
      if (key.startsWith("aria-") && (button || href)) {
        ariaAttributes[key] = value;
      } else {
        liAttributes[key] = value;
      }
    });
    const { themeProps } = useColorTheme({ dark: selected ? "invert" : void 0 });
    const roleProp = role || (button ? "button" : void 0);
    const tabIndex = (roleProp === "button" || roleProp === "option") && !disabled ? 0 : void 0;
    const ariaSelected = roleProp === "option" || roleProp === "tab" ? selected || void 0 : void 0;
    const ariaCurrent = roleProp === "option" || roleProp === "tab" ? void 0 : selected || void 0;
    const analyticsMetadata = !injectAnalyticsMetadata ? {} : {
      [ANALYTICS_METADATA_ATTRIBUTE]: JSON.stringify({
        name: "ListItem",
        properties: {
          as: As.toString(),
          button: button.toString(),
          disabled,
          selected
        }
      })
    };
    return /* @__PURE__ */ jsx41("li", { ...liAttributes, className: classes, ...themeProps, children: /* @__PURE__ */ jsxs18(
      As,
      {
        className: innerClasses,
        role: roleProp,
        disabled,
        ...analyticsMetadata,
        ...hrefProps,
        ...ariaAttributes,
        ref,
        tabIndex,
        "aria-selected": ariaSelected,
        "aria-current": ariaCurrent,
        "aria-disabled": disabled,
        onClick,
        onKeyDown,
        onKeyUp,
        children: [
          startIcon ? /* @__PURE__ */ jsx41("div", { className: list_item_default["left-container"], children: /* @__PURE__ */ jsx41(BodyText, { className: list_item_default["start-icon"], children: startIcon }) }) : null,
          children,
          badge || endIcon ? /* @__PURE__ */ jsxs18("div", { className: list_item_default["right-container"], children: [
            typeof badge === "string" ? /* @__PURE__ */ jsx41(BodyText, { size: 2, children: badge }) : badge,
            endIcon ? /* @__PURE__ */ jsx41(BodyText, { className: list_item_default["end-icon"], children: endIcon }) : null
          ] }) : null
        ]
      }
    ) });
  }
);

// ../../components/dist/esm/LanguageSelector/language-selector.module.css
var language_selector_default = {
  "heading": "rgft_ebccb38e",
  "title": "rgft_fb245b24",
  "lists": "rgft_463e1ae0",
  "list": "rgft_e88bf32e",
  "autodetect": "rgft_f4632721",
  "popover-container": "rgft_9263aa66",
  "popover": "rgft_d3ad1394",
  "drawer-content": "rgft_02d29dcb",
  "caret": "rgft_aadbf8f1"
};

// ../../components/dist/esm/LanguageSelector/LanguageList.js
import { jsx as jsx42 } from "react/jsx-runtime";
var getLTRIndex = (numColumns, rowIndex, columnIndex) => {
  if (numColumns === 1) {
    return rowIndex;
  }
  if (columnIndex === 0) {
    return rowIndex * 2;
  }
  if (columnIndex === 1) {
    return rowIndex * 2 + 1;
  }
  throw new Error("Up to 2 columns are supported.");
};
var LanguageList = ({ languages, onSelect, value }) => {
  const isClient = useIsClient();
  const isMobile = useIsMobile() ?? false;
  const cols = isMobile ? 1 : 2;
  const id = useId();
  const { context } = usePopover();
  const listRef = useRef11([]);
  const languageColumns = useMemo12(() => {
    if (cols === 1) {
      return [languages];
    }
    return [languages.slice(0, Math.floor(languages.length / 2)), languages.slice(Math.floor(languages.length / 2))];
  }, [languages, cols]);
  const topToBottomIndex = useMemo12(() => languages.findIndex((lang) => lang.code === value), [languages, value]);
  const [activeIndex, setActiveIndex] = useState15(null);
  useEffect19(() => {
    setActiveIndex(
      topToBottomIndex === -1 ? null : getLTRIndex(
        cols,
        topToBottomIndex % languageColumns[0].length,
        topToBottomIndex < languageColumns[0].length ? 0 : 1
      )
    );
  }, [topToBottomIndex, languageColumns, cols]);
  const listNavigation = useListNavigation(context, {
    enabled: isClient,
    listRef,
    activeIndex,
    onNavigate: setActiveIndex,
    loop: true,
    focusItemOnHover: false,
    focusItemOnOpen: false,
    scrollItemIntoView: true,
    cols,
    orientation: cols === 1 ? "vertical" : "both"
  });
  const { getItemProps, getFloatingProps } = useInteractions([listNavigation]);
  return /* @__PURE__ */ jsx42("div", { ...getFloatingProps(), role: "listbox", className: language_selector_default.lists, children: languageColumns.map((languagesInColumn, columnIndex) => {
    return /* @__PURE__ */ jsx42(List, { className: language_selector_default.list, scrim: isMobile, children: languagesInColumn.map((lang, index3) => {
      const ltrIndex = getLTRIndex(cols, index3, columnIndex);
      const active = activeIndex === ltrIndex;
      const selected = value === lang.code;
      return /* @__PURE__ */ jsx42(
        ListItem,
        {
          id: `${id}-${lang.code}`,
          button: true,
          className: language_selector_default["list-item"],
          selected,
          ...getItemProps({
            onClick: (e2) => {
              onSelect(e2, lang.code);
            }
          }),
          endIcon: selected ? /* @__PURE__ */ jsx42(Icon, { name: "checkmark" }) : null,
          role: "option",
          ref: (node) => {
            listRef.current[ltrIndex] = node;
          },
          tabIndex: active ? 0 : -1,
          children: /* @__PURE__ */ jsx42(BodyText, { children: lang.name })
        },
        lang.code
      );
    }) }, columnIndex);
  }) });
};

// ../../components/dist/esm/LanguageSelector/i18n.js
var LANGUAGESELECTOR_I18N_STRINGS = {
  "Language settings": {
    "ar-SA": "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u0644\u063A\u0629",
    "de-DE": "Spracheinstellungen",
    "en-GB": "Language settings",
    "en-US": "Language settings",
    "es-ES": "Ajustes de idioma",
    "fr-FR": "Param\xE8tres de langue",
    "id-ID": "Pengaturan bahasa",
    "it-IT": "Impostazioni della lingua",
    "ja-JP": "\u8A00\u8A9E\u8A2D\u5B9A",
    "ko-KR": "\uC5B8\uC5B4 \uC124\uC815",
    "pt-BR": "Configura\xE7\xF5es de idioma",
    "ru-RU": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u044F\u0437\u044B\u043A\u0430",
    "th-TH": "\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E20\u0E32\u0E29\u0E32",
    "tr-TR": "Dil ayarlar\u0131",
    "vi-VN": "C\xE0i \u0111\u1EB7t ng\xF4n ng\u1EEF",
    "zh-CN": "\u8BED\u8A00\u8BBE\u7F6E",
    "zh-TW": "\u8A9E\u8A00\u8A2D\u5B9A"
  },
  "Detect language": {
    "ar-SA": "\u0627\u0643\u062A\u0634\u0627\u0641 \u0627\u0644\u0644\u063A\u0629",
    "de-DE": "Sprache erkennen",
    "en-GB": "Detect language",
    "en-US": "Detect language",
    "es-ES": "Detectar idioma",
    "fr-FR": "D\xE9tecter la langue",
    "id-ID": "Deteksi bahasa",
    "it-IT": "Rileva la lingua",
    "ja-JP": "\u8A00\u8A9E\u3092\u81EA\u52D5\u691C\u51FA",
    "ko-KR": "\uC5B8\uC5B4 \uAC10\uC9C0",
    "pt-BR": "Detectar idioma",
    "ru-RU": "\u041E\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u0435 \u044F\u0437\u044B\u043A",
    "th-TH": "\u0E15\u0E23\u0E27\u0E08\u0E08\u0E31\u0E1A\u0E20\u0E32\u0E29\u0E32",
    "tr-TR": "Dili alg\u0131la",
    "vi-VN": "Ph\xE1t hi\u1EC7n ng\xF4n ng\u1EEF",
    "zh-CN": "\u68C0\u6D4B\u8BED\u8A00",
    "zh-TW": "\u5075\u6E2C\u8A9E\u8A00"
  },
  "Automatically translated to": {
    "ar-SA": "\u062A\u0645\u062A \u0627\u0644\u062A\u0631\u062C\u0645\u0629 \u062A\u0644\u0642\u0627\u0626\u064A\u064B\u0627 \u0625\u0644\u0649 {{ language }}",
    "de-DE": "Automatisch \xFCbersetzt in {{language}}",
    "en-GB": "Automatically translated to {{ language }}",
    "en-US": "Automatically translated to {{ language }}",
    "es-ES": "Traducido autom\xE1ticamente a {{language}}",
    "fr-FR": "Traduit automatiquement en {{ language }}",
    "id-ID": "Diterjemahkan otomatis ke {{ language }}",
    "it-IT": "Tradotto automaticamente in {{language}}",
    "ja-JP": "{{ language }} \u306B\u81EA\u52D5\u7FFB\u8A33\u3055\u308C\u307E\u3057\u305F",
    "ko-KR": "{{language}}(\uC73C)\uB85C \uC790\uB3D9 \uBC88\uC5ED",
    "pt-BR": "Traduzido automaticamente para {{language}}",
    "ru-RU": "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0435\u0440\u0435\u0432\u0435\u0434\u0435\u043D\u043E \u043D\u0430 {{language}}",
    "th-TH": "\u0E41\u0E1B\u0E25\u0E40\u0E1B\u0E47\u0E19 {{ language }} \u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34",
    "tr-TR": "Otomatik olarak {{ language }} diline \xE7evrildi",
    "vi-VN": "T\u1EF1 \u0111\u1ED9ng d\u1ECBch sang {{language}}",
    "zh-CN": "\u81EA\u52A8\u7FFB\u8BD1\u4E3A {{ language }}",
    "zh-TW": "\u81EA\u52D5\u7FFB\u8B6F\u6210 {{ language }}"
  }
};

// ../../components/dist/esm/LanguageSelector/useLanguageSelector.js
import { useEffect as useEffect20, useMemo as useMemo13, useState as useState16 } from "react";
var useLanguageSelector = (locale) => {
  const autodetectedLanguage = usePreferredLanguage2();
  const [selectedLanguage, setSelectedLanguage] = useState16("en-US");
  useEffect20(() => {
    const langCode = SUPPORTED_LANGUAGES.find((r3) => r3.code === locale)?.code;
    setSelectedLanguage(langCode ?? autodetectedLanguage);
  }, [locale, autodetectedLanguage]);
  const selectedLabel = useMemo13(
    () => SUPPORTED_LANGUAGES.find((r3) => r3.code === selectedLanguage)?.name ?? "English",
    [selectedLanguage]
  );
  return { selectedLanguage, setSelectedLanguage, selectedLabel, autodetectedLanguage };
};

// ../../components/dist/esm/LanguageSelector/LanguageSelector.js
import { Fragment as Fragment6, jsx as jsx43, jsxs as jsxs19 } from "react/jsx-runtime";
var LanguageSelector = forwardRef26(
  ({
    value,
    onSelect = () => null,
    languages = SUPPORTED_LANGUAGES,
    triggerElement,
    mobileDialog = true,
    onIsOpenChange = () => null
  }, ref) => {
    const { T } = useTranslate(LANGUAGESELECTOR_I18N_STRINGS);
    const [autodetect, setAutodetect] = useState17(true);
    const [open, setOpen] = useState17(false);
    const { selectedLanguage, setSelectedLanguage, selectedLabel, autodetectedLanguage } = useLanguageSelector(value);
    const isMobile = useIsMobile();
    useEffect21(() => {
      if (selectedLanguage !== autodetectedLanguage) {
        setAutodetect(false);
      }
    }, [selectedLanguage, autodetectedLanguage]);
    const handleSelect = useCallback14(
      (e2, code) => {
        setSelectedLanguage(code);
        const match = languages.find((region) => region.code === code);
        if (match) {
          onSelect(e2, match);
          handleOnIsOpenChange(false);
        }
      },
      [languages, onSelect]
    );
    const handleOnIsOpenChange = useCallback14(
      (open2) => {
        setOpen(open2);
        onIsOpenChange(open2);
      },
      [onIsOpenChange]
    );
    const trigger = triggerElement || /* @__PURE__ */ jsxs19(Button, { startIcon: /* @__PURE__ */ jsx43(Icon, { name: "globe" }), variant: "secondary", ref, "data-testid": "language-selector-button", children: [
      selectedLabel,
      open ? /* @__PURE__ */ jsx43(Icon, { name: "caret-up", className: language_selector_default.caret }) : /* @__PURE__ */ jsx43(Icon, { name: "caret-down", className: language_selector_default.caret })
    ] });
    const content = /* @__PURE__ */ jsxs19(Fragment6, { children: [
      /* @__PURE__ */ jsx43(When, { condition: isMobile, children: /* @__PURE__ */ jsxs19("div", { className: language_selector_default.heading, children: [
        /* @__PURE__ */ jsx43(TitleText, { size: 2, className: language_selector_default.title, children: T("Language settings") }),
        /* @__PURE__ */ jsx43(CloseButton, { onClick: () => handleOnIsOpenChange(false) })
      ] }) }),
      /* @__PURE__ */ jsx43(LanguageList, { languages, value: selectedLanguage, onSelect: handleSelect }),
      /* @__PURE__ */ jsx43("div", { className: language_selector_default.autodetect, children: /* @__PURE__ */ jsx43(
        Checkbox,
        {
          fullWidth: true,
          checked: autodetect,
          onChange: (e2) => {
            setAutodetect(e2.target.checked);
            if (e2.target.checked && autodetectedLanguage !== void 0) {
              handleSelect(e2, autodetectedLanguage);
              return;
            }
            !e2.target.checked && setOpen(false);
          },
          label: T("Detect language"),
          description: T("Automatically translated to", {
            data: { language: languages.find((r3) => r3.code === autodetectedLanguage)?.name ?? "English" }
          })
        }
      ) })
    ] });
    if (isMobile && mobileDialog) {
      return /* @__PURE__ */ jsx43(
        Drawer,
        {
          open,
          onClose: () => handleOnIsOpenChange(false),
          onOpen: () => handleOnIsOpenChange(true),
          referenceElement: trigger,
          fullScreen: true,
          side: "bottom",
          children: /* @__PURE__ */ jsx43("div", { className: language_selector_default["drawer-content"], children: content })
        }
      );
    }
    return /* @__PURE__ */ jsx43(
      Popover,
      {
        openOnClick: true,
        onOpen: () => handleOnIsOpenChange(true),
        onClose: () => handleOnIsOpenChange(false),
        open,
        placement: "bottom",
        triggerPadding: "small",
        transitionDuration: "short",
        animated: true,
        classes: {
          popover: language_selector_default["popover-container"]
        },
        popoverContent: /* @__PURE__ */ jsx43(Paper, { shadowVariant: "grayscale", className: language_selector_default.popover, outlined: true, radius: 3, children: content }),
        children: trigger
      }
    );
  }
);

// ../../components/dist/esm/providers/PortalProvider/PortalProvider.js
import { useEffect as useEffect22, useMemo as useMemo14, useState as useState18 } from "react";
import { Fragment as Fragment7, jsx as jsx44, jsxs as jsxs20 } from "react/jsx-runtime";
var PortalProvider = ({ children, findRoot, root: staticRoot }) => {
  const [reference, setReference] = useState18(null);
  const [root, setRoot] = useState18();
  useEffect22(() => {
    if (reference && findRoot) {
      const foundRoot = findRoot(reference);
      if (foundRoot === reference) {
        throw new Error(
          "findRoot returned the same element as the reference element. The reference element is removed, so findRoot must return a different one."
        );
      }
      setRoot(foundRoot);
    }
  }, [reference, findRoot]);
  const value = useMemo14(() => ({ root: staticRoot || root }), [root, staticRoot]);
  return /* @__PURE__ */ jsxs20(Fragment7, { children: [
    !root && !staticRoot ? /* @__PURE__ */ jsx44("span", { ref: (el) => setReference(el), "data-rigel-portal-reference": true }) : null,
    /* @__PURE__ */ jsx44(PortalContext2.Provider, { value, children })
  ] });
};

// ../../components/dist/esm/Tooltip/Tooltip.js
import { cloneElement as cloneElement5, forwardRef as forwardRef27 } from "react";

// ../../components/dist/esm/Tooltip/tooltip.module.css
var tooltip_default = {
  "tooltip": "rgft_7ca16681",
  "invert-arrow": "rgft_a422836d",
  "popover": "rgft_873400bd"
};

// ../../components/dist/esm/Tooltip/Tooltip.js
import { Fragment as Fragment8, jsx as jsx45 } from "react/jsx-runtime";
var DEFAULT_MAX_WIDTH = 326;
var DEFAULT_TRIGGER_PAD = 16;
var Tooltip = forwardRef27(
  ({
    children,
    title,
    placement = "top",
    arrow: arrow4 = false,
    maxWidth = DEFAULT_MAX_WIDTH,
    triggerPadding = DEFAULT_TRIGGER_PAD,
    classes = {},
    invert = false,
    open,
    useAnimationFrame = false
  }, ref) => {
    const { dark } = useColorTheme();
    const content = typeof title === "string" ? /* @__PURE__ */ jsx45(BodyText, { size: 2, innerHTML: title }) : title;
    const combinedRefs = useMergeRefs(ref, children?.ref);
    const isChildElementDisabled = Boolean(children?.props.disabled);
    if (children == null) {
      return null;
    }
    return /* @__PURE__ */ jsx45(
      Popover,
      {
        open,
        openOnHover: !isChildElementDisabled,
        placement,
        role: "tooltip",
        arrow: arrow4,
        triggerPadding,
        transitionDuration: "short",
        useAnimationFrame,
        classes: {
          popover: tooltip_default.popover,
          ...classes,
          arrow: clsx_default(tooltip_default.arrow, invert && tooltip_default["invert-arrow"])
        },
        popoverContent: /* @__PURE__ */ jsx45(ColorThemeProvider, { dark: invert ? dark : !dark, children: /* @__PURE__ */ jsx45(
          Paper,
          {
            shadowVariant: "grayscale",
            className: clsx_default(tooltip_default.tooltip, classes.tooltip),
            elevation: 2,
            style: { maxWidth },
            children: content
          }
        ) }),
        children: children ? cloneElement5(children, {
          ref: combinedRefs
        }) : /* @__PURE__ */ jsx45(Fragment8, {})
      }
    );
  }
);

// ../../utils/dist/esm/string-formatting.js
function queryParameterCase(unsanitizedString) {
  return unsanitizedString.replace(/\s+/g, "-").replace(/[^\p{L}\p{N}-]/ug, "").toLowerCase();
}

// ../../patterncomponents/dist/esm/TemplateContainer/TemplateContainer.js
import { forwardRef as forwardRef29 } from "react";

// ../../patterncomponents/dist/esm/JumpLinkContainer/JumpLinkContainer.js
import { forwardRef as forwardRef28 } from "react";

// ../../patterncomponents/dist/esm/JumpLinkContainer/jumplink-container.module.css
var jumplink_container_default = {
  "jumplink-container": "rgft_70747978",
  "with-subnav": "rgft_ddb4146d"
};

// ../../patterncomponents/dist/esm/JumpLinkContainer/JumpLinkContainer.js
import { jsx as jsx46 } from "react/jsx-runtime";
var JumpLinkContainer = forwardRef28(({ id, style, children }, ref) => {
  return /* @__PURE__ */ jsx46(
    "div",
    {
      ref,
      id: queryParameterCase(id),
      className: clsx_default(jumplink_container_default["jumplink-container"], jumplink_container_default["with-subnav"]),
      style: {
        ...style
      },
      children
    }
  );
});

// ../../patterncomponents/dist/esm/TemplateContainer/TemplateContainer.js
import { jsx as jsx47, jsxs as jsxs21 } from "react/jsx-runtime";
var TemplateContainer = forwardRef29(
  ({ id, children, heading, className, headingGridProps, direction = "vertical", verticalGap = 2 }, ref) => {
    if (direction === "vertical") {
      return /* @__PURE__ */ jsx47(JumpLinkContainer, { ref, id: queryParameterCase(id || ""), children: /* @__PURE__ */ jsxs21(GridStack, { className, gap: verticalGap, children: [
        /* @__PURE__ */ jsx47(When, { condition: Boolean(heading), children: /* @__PURE__ */ jsx47(Grid, { ...headingGridProps, children: /* @__PURE__ */ jsx47(Col, { children: heading }) }) }),
        children
      ] }) });
    } else {
      if (!heading) {
        throw new Error("Horizontal direction requires a heading.");
      }
      return /* @__PURE__ */ jsx47(JumpLinkContainer, { id: id || "", children: /* @__PURE__ */ jsxs21(Grid, { className, ref, children: [
        /* @__PURE__ */ jsx47(
          Col,
          {
            span: {
              xxl: 5,
              xl: 5,
              l: 5,
              m: 5,
              s: 11,
              xs: 11
            },
            children: heading
          }
        ),
        /* @__PURE__ */ jsx47(
          Col,
          {
            span: {
              xxl: 1,
              xl: 1,
              l: 1,
              m: 1,
              s: 0,
              xs: 0
            }
          }
        ),
        /* @__PURE__ */ jsx47(
          Col,
          {
            span: {
              xxl: 6,
              xl: 6,
              l: 6,
              m: 6,
              s: 12,
              xs: 12
            },
            children
          }
        )
      ] }) });
    }
  }
);

// src/Footer.tsx
var import_capitalize = __toESM(require_capitalize());
import { useMemo as useMemo15, useState as useState20 } from "react";

// src/chinaIcon.tsx
import { jsx as jsx48, jsxs as jsxs22 } from "react/jsx-runtime";
function chinaIcon() {
  return /* @__PURE__ */ jsxs22("svg", { xmlns: "http://www.w3.org/2000/svg", width: "22.776", height: "24.001", viewBox: "0 0 22.776 24.001", children: [
    /* @__PURE__ */ jsx48(
      "path",
      {
        fill: "#ca8f4c",
        d: "M10.762 23.973c-.435-.027-.925-.163-1.225-.34l-.136-.054-.231.068c-.272.068-.898.068-1.252 0l-.367-.027c-.136 0-.313-.054-.367-.136-.027-.054-.082-.054-.19 0a.65.65 0 0 1-.395 0l-.136-.122c-.082-.054-.095-.068-.163-.041l-.272.027q-.327 0-.408-.163c-.014-.068-.027-.068-.109-.054-.054 0-.177.027-.272.014-.204 0-.381-.068-.449-.177q-.027-.068-.272-.068c-.259 0-.259 0-.354-.082l-.163-.136c-.041-.068-.054-.068-.204-.082-.082 0-.231-.014-.327-.041-.136-.027-.163-.041-.313-.204-.15-.15-.177-.163-.272-.177l-.272-.068c-.136-.041-.19-.068-.272-.163a.8.8 0 0 1-.136-.204q-.02-.082-.082-.082c-.204-.054-.367-.163-.408-.299-.041-.054-.041-.082 0-.15 0-.054 0-.068-.082-.136-.054-.054-.082-.082-.082-.15 0-.122.068-.204.177-.245.082-.014.109-.027.136-.136.082-.163.272-.231.544-.177l.15.027.082-.095c.15-.15.381-.177.762-.082.163.041.163.041.231-.014l.163-.082c.136-.041.435 0 .599.054.136.054.177.054.109-.014l-.054-.109c0-.041-.027-.054-.068-.054a.85.85 0 0 1-.367-.095.54.54 0 0 1-.15-.231c0-.027-.041-.041-.177-.068-.245-.041-.449-.19-.449-.34 0-.041 0-.054-.218-.095-.122-.014-.163-.041-.231-.109a.4.4 0 0 1-.109-.177c-.014-.082-.027-.095-.204-.15a1.2 1.2 0 0 1-.272-.136c-.109-.082-.177-.204-.177-.299 0-.014-.041-.054-.095-.068-.327-.136-.449-.231-.49-.408l-.041-.136-.15-.068c-.19-.068-.354-.218-.354-.34v-.109c0-.027-.068-.082-.163-.136-.204-.136-.218-.15-.299-.313-.054-.109-.068-.15-.054-.231 0-.082 0-.095-.136-.231a.7.7 0 0 1-.163-.231c-.014-.082 0-.177.041-.231.041-.041.041-.054 0-.095l-.027-.136c0-.082 0-.109.082-.177.068-.082.082-.082.19-.068.109 0 .122 0 .15-.041.068-.095.15-.136.286-.109h.122l-.014-.082.014-.136c.027-.041.027-.054 0-.054a.6.6 0 0 1-.231-.259c-.041-.095-.041-.177 0-.231.027-.027 0-.068-.136-.177-.095-.068-.136-.327-.054-.354.027 0 .014-.027-.054-.109-.18-.19-.234-.354-.18-.49l.041-.068-.082-.082-.122-.177a.42.42 0 0 1 .027-.34c.027-.054.027-.054-.054-.177a.4.4 0 0 1-.095-.259c0-.122 0-.163.054-.259l.054-.109-.041-.095L0 11.495c0-.109.014-.136.068-.177.027-.041.082-.068.109-.082.054 0 .054-.014.041-.082 0-.054 0-.095.041-.15.041-.068.068-.082.136-.082l.136.041c.027.041.041.041.082 0 .014-.027.054-.041.068-.041l.014-.095c0-.082.027-.109.068-.15l.054-.054-.041-.082c-.095-.15-.082-.381.027-.435.027-.014.041-.027.027-.054a.7.7 0 0 1-.068-.136.38.38 0 0 1 .082-.381l.068-.054-.041-.122c-.082-.218-.054-.381.054-.503l.082-.082-.014-.15v-.245c0-.095.095-.19.163-.218.041-.014.054-.041.054-.19 0-.259.095-.395.286-.435.041 0 .068-.027.068-.054l.054-.109c.082-.082.204-.082.299 0 .054.068.082.068.177.068.082 0 .109 0 .177.068l.068.068-.014-.299a46 46 0 0 1-.012-1.836l.014-.435.136-.027c.517-.122.585-.136.952-.313a3.46 3.46 0 0 0 1.823-2.286l.041-.15.245-.095a97 97 0 0 0 2.64-.952 65 65 0 0 1 1.714-.64l.395-.136.408-.15a11 11 0 0 1 .503-.204c.068-.054.204-.068.286-.041a131 131 0 0 1 2.544.939 215 215 0 0 1 2.912 1.061c.571.204.571.204.585.272a3.47 3.47 0 0 0 2.857 2.68l.068.027.014.218a30 30 0 0 1-.014 2.354c.027-.082.109-.136.218-.122.095.014.122 0 .163-.041.054-.095.136-.109.245-.068a.24.24 0 0 1 .109.122l.054.082c.054 0 .204.095.259.163.027.041.041.095.054.245 0 .19 0 .204.068.231.136.082.19.245.136.517 0 .082 0 .095.068.177a.6.6 0 0 1 .109.19.9.9 0 0 1-.054.395c-.027.027-.027.041 0 .054l.082.095a.4.4 0 0 1 0 .408c-.041.068-.041.095-.014.109.109.041.136.272.041.422l-.041.095.054.041a.18.18 0 0 1 .054.136c0 .082.014.109.068.136.054.041.082.041.109.014.136-.082.299 0 .299.163 0 .068.027.095.095.136l.109.109c.041.082.027.259-.041.381-.041.082-.041.095 0 .122.136.122.109.463-.054.612-.068.054-.068.068-.027.109.054.054.068.231.027.354 0 .054-.054.136-.109.177l-.095.095.054.095c.041.068.041.095 0 .177-.014.095-.082.19-.177.286-.054.068-.054.068-.027.136.054.109 0 .259-.122.367q-.095.095-.068.19c.041.15-.041.272-.272.435 0 0 0 .041.027.068a.2.2 0 0 1 .014.136l-.014.082.082-.014.109-.027c.041 0 .177.068.218.136.041.041.054.041.15.027.109 0 .122 0 .19.054.095.095.109.177.054.299-.027.095-.027.109.014.19.041.054.041.095.041.136a.65.65 0 0 1-.231.313c-.109.082-.109.082-.095.19 0 .095 0 .136-.054.231-.068.136-.136.204-.313.313-.109.054-.136.082-.136.136 0 .204-.122.354-.354.435-.082.027-.136.068-.136.082-.095.272-.19.395-.449.49-.177.068-.177.068-.19.163-.027.163-.218.313-.49.381-.109.041-.109.041-.177.177-.082.177-.163.231-.381.272-.109.027-.15.041-.15.068l-.068.136a.54.54 0 0 1-.408.218c-.136.027-.15.027-.163.082 0 .041-.054.109-.095.163-.082.095-.231.136-.408.136-.054 0-.068.014-.068.041l-.054.109-.041.082s.068 0 .136-.041c.136-.054.476-.095.585-.054.041 0 .109.041.163.082l.068.054.218-.054c.381-.082.571-.054.707.095l.082.082.163-.014c.245-.041.354-.014.463.095.054.054.095.109.095.136 0 .054 0 .068.054.068.082 0 .204.095.218.177.027.095-.014.231-.095.272-.054.014-.068.027-.054.068.082.19-.027.34-.313.435-.122.041-.136.054-.204.177-.109.204-.19.272-.435.34l-.259.041c-.041 0-.082.041-.163.136-.177.204-.381.286-.707.299-.15 0-.163 0-.204.068a.7.7 0 0 1-.163.15c-.095.068-.109.082-.34.068-.204 0-.245 0-.272.041-.082.177-.395.272-.68.19-.095-.014-.095-.014-.163.068a.5.5 0 0 1-.136.109c-.082.041-.408.054-.544.014-.082-.027-.082-.014-.136.041-.136.15-.354.19-.571.109-.109-.041-.122-.041-.15 0-.082.095-.177.136-.354.136l-.408.054c-.463.068-1.279.041-1.429-.068-.041-.027-.068-.027-.19.054-.49.286-1.361.408-2.449.327"
      }
    ),
    /* @__PURE__ */ jsx48(
      "path",
      {
        fill: "#ffd587",
        d: "M12.109 23.905a6 6 0 0 0 .68-.136h.082l-.109-.068c-.272-.15-.367-.449-.408-1.143a2.72 2.72 0 0 1 .367-1.728c.082-.109.082-.136 0-.068-.272.204-1.279.844-1.333.844s-.789-.463-1.265-.803c-.15-.109-.19-.122-.136-.041.027.014.095.136.163.259a3.13 3.13 0 0 1 .245 1.837c-.068.503-.204.789-.435.871-.054.014-.027.054.054.068l.231.041c.517.122 1.279.136 1.864.068m-2.068-.286a.6.6 0 0 0 .177-.231c.095-.177.095-.231 0-.082-.109.19-.163.218-.367.218a.5.5 0 0 1-.245-.041c-.068-.041-.136-.027-.136.041 0 .041.136.095.272.136.177.041.19.041.299-.041m2.993.041a.8.8 0 0 0 .272-.122l-.041-.054c-.041-.041-.041-.041-.109 0a1 1 0 0 1-.231.041c-.15.014-.163 0-.259-.082a.7.7 0 0 1-.136-.163c-.041-.095-.054-.082-.027.027.041.122.177.299.272.34.082.054.082.054.245.014Zm-3.782-.082a.7.7 0 0 0 .245-.177c.163-.15.272-.204.653-.327l.136-.054.041-.15a1 1 0 0 0 .027-.177l-.367.095c-.49.136-.844.218-1.129.272a13 13 0 0 0-1.279.299c-.027.027-.054.054-.054.095s.014.054.15.109c.218.068.463.082 1.007.082.395 0 .449-.014.571-.068m-1.225 0c-.231-.027-.299-.054-.286-.109.014-.109.68-.204 1.129-.15.286.027.381.054.381.109 0 .082-.272.136-.735.163l-.503-.014Zm.98-.082c.313-.082.19-.122-.435-.122-.49 0-.776.041-.776.095 0 .027.054.041.15.054l.218.014c.136.027.694 0 .844-.041m5.687.136c.259-.027.49-.095.544-.136.041-.041 0-.136-.068-.15-.054-.027-.272-.082-1.156-.259a17 17 0 0 1-1.592-.395c0 .014.041.286.068.313l.245.109c.327.109.435.163.544.286a.4.4 0 0 0 .231.177l.218.054zm-.735-.054c-.231-.027-.381-.068-.408-.136-.041-.054.027-.095.327-.122a2.45 2.45 0 0 1 1.129.109c.054.027.054.041 0 .082-.095.068-.612.109-1.048.068m.925-.068c.109-.027.095-.054-.027-.095-.122-.027-1.034-.054-1.197-.014-.109.027-.095.041.054.082.204.068.912.082 1.156.027Zm-7.403.027c-.054-.068-.054-.082 0-.163.068-.068.163-.095.844-.231.299-.068.313-.082.544-.218.327-.231.585-.435.544-.449l-.204-.027-.177-.014-.136.109a7 7 0 0 1-1.429.776c-.19.068-.272.109-.259.136 0 .041.19.136.272.136.027 0 .027 0 0-.054m7.891.014c.109-.041.177-.082.177-.109l-.272-.136a7 7 0 0 1-1.388-.748l-.19-.136-.177.027a.8.8 0 0 0-.204.027c-.014.027.367.327.599.463.204.136.19.136.939.299l.34.082c.082.041.109.136.068.204l-.027.054c0 .027.068.014.136-.027M10 23.471l.136-.122c.068-.082.136-.245.109-.245l-.259.082c-.218.082-.408.19-.408.231 0 .027.163.082.272.082a.4.4 0 0 0 .15-.027m3.089 0c.095-.041.109-.054.082-.082a2.3 2.3 0 0 0-.667-.272c-.027.014.109.245.19.313.095.082.218.095.395.027Zm-5.987-.068.354-.136a7 7 0 0 0 1.497-.844c0-.014-.231-.041-.354-.041l-.19.082a6.4 6.4 0 0 1-1.946.844c0 .027.068.082.15.136.095.041.313.027.476-.041Zm8.993.041c.095-.027.19-.109.19-.136 0 0-.027-.027-.068-.027a6.7 6.7 0 0 1-1.81-.762c-.163-.109-.218-.136-.299-.136-.136 0-.313.027-.313.041a8.3 8.3 0 0 0 1.578.871c.435.177.599.204.721.15m.844-.15c.082-.027.177-.136.163-.163l-.136-.041a7.6 7.6 0 0 1-2.068-.667l-.245-.109-.177.014-.177.041a6.3 6.3 0 0 0 2.313.952c.041.014.204 0 .327-.027M6.57 23.214c.612-.163 1.252-.435 1.701-.721.218-.136.218-.136-.041-.163-.15-.014-.163-.014-.34.068a7.9 7.9 0 0 1-2.245.735c0 .041.082.122.136.15.109.054.449.027.789-.068m-.952-.136.245-.054a8.3 8.3 0 0 0 2.095-.707l-.19-.041-.177-.027-.272.095a9 9 0 0 1-2.082.49c-.367.041-.435.054-.435.095s.163.163.245.19c.068 0 .476 0 .571-.041m12.068.027a.7.7 0 0 0 .15-.082c.041-.027.082-.054.095-.041v-.041c0-.041 0-.054-.027-.054l-.49-.068-.653-.095a10 10 0 0 1-1.361-.395l-.245-.082-.19.027-.204.027.136.082a7.7 7.7 0 0 0 2.422.721c.272.027.286.027.367 0m-8.544-.136c.204-.054.408-.109.435-.136l.19-.19.136-.136-.19-.014-.177-.027-.204.163a7 7 0 0 1-.558.422zm4.816.082-.177-.136-.381-.272-.19-.177-.163.027c-.095 0-.177.014-.177.027 0 .041.34.354.395.367l.354.082zm-9.291-.193.898-.136a8 8 0 0 0 1.742-.422c.163-.068.163-.068.095-.082a1.2 1.2 0 0 0-.585 0 14 14 0 0 1-2.789.408c-.027.027.136.177.272.231.136.041.136.041.367 0m13.796-.014c.136-.054.299-.204.259-.231l-.395-.041a14.4 14.4 0 0 1-2.667-.408l-.204.027c-.163.027-.177.041-.122.068a10 10 0 0 0 2.259.544l.544.068a.47.47 0 0 0 .327-.027m-8.517-.082c.218-.068.218-.068.259-.15s.027-.082-.136-.095h-.109l-.136.15c-.109.109-.136.163-.109.15zm3.089 0-.136-.15-.095-.109h-.136c-.163.014-.177.041-.109.136.054.054.381.177.49.177.041 0 .041 0-.014-.054m-2.668-.175c0-.027 0-.041-.027-.041s-.082.068-.095.109c0 .054.109 0 .122-.068m2.136.027c-.041-.068-.095-.082-.095-.027s.027.068.082.068c.041 0 .041 0 .014-.041m-8.055-.095a21 21 0 0 0 2.422-.367c.041-.027-.422-.109-.517-.095a17.4 17.4 0 0 1-2.585.177c-.735 0-.68-.014-.544.136.19.204.354.231 1.225.15m14.925-.014a.7.7 0 0 0 .272-.231c.027-.041.027-.041-.653-.041a17 17 0 0 1-2.585-.177c-.082 0-.49.054-.517.082s.735.177 1.238.259a19 19 0 0 0 1.456.136c.299.041.68.027.789-.027m-8.993-.204v-.163l-.109-.014-.503-.068-.952-.122a102 102 0 0 0-3.075-.299c-.068.027-.082.122-.027.163a20.4 20.4 0 0 0 4.626.68c.027 0 .041-.068.041-.163Zm2.776.136c1.361-.136 2.667-.327 3.537-.531.367-.082.476-.163.354-.272-.068-.054-.218-.041-1.197.082l-1.184.136a248 248 0 0 0-2.231.272c-.041 0-.041.027-.041.177v.177l.762-.054Zm-7.919-.299c.612-.054 1.034-.109 1.007-.136-.054-.054-.313-.068-1.116-.068a13.8 13.8 0 0 1-2.844-.218c-.068-.027-.068 0 0 .095.15.19.272.259.585.313.395.068.381.068 1.225.054a12 12 0 0 0 1.143-.041m14.667 0c.286-.068.449-.136.544-.286.082-.136.095-.15.027-.136l-.544.082-.585.068c-.408.054-.871.068-1.701.068-.789 0-1.048.014-1.116.068a9.7 9.7 0 0 0 2.367.177c.639 0 .816-.014 1.007-.054Zm-9.524-.177a4 4 0 0 0-.15-.653 3 3 0 0 0-.286-.544c-.068-.041-.15.027-.095.095a4.1 4.1 0 0 1 .503 1.211c.041 0 .041 0 .027-.109m2.068.082.068-.245a2.8 2.8 0 0 1 .408-.939c.027-.041.027-.041 0-.082-.054-.041-.095-.014-.19.136a2.7 2.7 0 0 0-.313.898c-.041.245-.041.272 0 .272 0 0 .027-.014.027-.041m.313 0c.027 0 .054-.068.095-.177.068-.218.259-.585.381-.762l.245-.408c-.136-.122-.34-.054-.49.15a3.4 3.4 0 0 0-.476 1.102l-.014.122.109-.014.15-.027Zm-2.503-.082c-.041-.245-.299-.871-.449-1.088-.095-.136-.245-.245-.327-.245a.3.3 0 0 0-.136.041l-.068.027.109.177a5.4 5.4 0 0 1 .558 1.075c.027.082.054.095.245.109h.095l-.027-.082Zm-.381-.068c-.163-.422-.544-1.075-.735-1.265-.082-.068-.095-.082-.231-.082l-.177.027c-.014.014 0 .068.082.15.19.245.327.463.517.816l.231.408c.014.027.068.041.177.054h.163zm3.32.068.177-.313c.177-.327.463-.776.599-.952.082-.082.082-.095.041-.122-.054-.041-.204-.041-.299 0a.35.35 0 0 0-.136.109 3.7 3.7 0 0 0-.707 1.333c0 .014.327-.027.327-.054m.49-.15c.163-.313.449-.735.68-1.007s.245-.299.204-.327a.3.3 0 0 0-.136-.027c-.19 0-.327.136-.626.571a5 5 0 0 0-.544.939h.201l.163-.027.068-.122Zm-4.177.136-.095-.163-.19-.34a4.8 4.8 0 0 0-.626-.884c-.109-.109-.313-.136-.408-.082-.041.041-.041.041.109.204.231.259.639.83.789 1.129.054.109.068.136.15.136zm-.449-.082a6.2 6.2 0 0 0-.857-1.211c-.245-.259-.313-.299-.435-.299-.095 0-.272.054-.231.082.544.544.925.993 1.116 1.306.082.136.082.136.19.15.259.027.245.027.218-.041Zm4.966 0 .041-.014a4.9 4.9 0 0 1 .898-1.143l.286-.286-.082-.041c-.163-.068-.354 0-.517.163a8 8 0 0 0-.952 1.361s.259 0 .327-.027Zm-8.272.014-.054-.041c-.041-.027-.177-.054-.367-.082a66 66 0 0 1-3.578-.544c-.054.082-.041.136.041.218.163.15.476.245 1.088.327l.49.054a14.3 14.3 0 0 0 2.381.068m13.334-.027c1.225-.136 1.592-.204 1.796-.354.109-.068.136-.122.136-.204 0-.109-.027-.136-.15-.095a36 36 0 0 1-3.442.571c-.299.027-.408.054-.408.109 0 .027 1.769 0 2.068-.027m-10.476-.068a6.4 6.4 0 0 0-.952-1.143c-.354-.34-.49-.408-.707-.34-.095.041-.095.068 0 .136a8 8 0 0 1 1.116 1.061c.245.313.272.327.395.34.218.027.204.041.15-.054m5.755.054c.054 0 .082-.014.204-.163a8 8 0 0 1 1.333-1.32l-.082-.041c-.259-.082-.381 0-.844.449a5.8 5.8 0 0 0-.816.993l-.054.109h.095a1 1 0 0 1 .163-.027m-6.123-.027c0-.041-.327-.408-.626-.707a6 6 0 0 0-.898-.776c-.15-.095-.163-.109-.313-.109-.136 0-.177.014-.204.041s-.041.041-.027.054l.136.095c.245.177.844.68 1.129.912.517.476.49.449.626.476.163.027.177.027.177 0Zm6.531-.027c.041 0 .177-.122.313-.245a15 15 0 0 1 1.524-1.238c0-.014-.041-.041-.095-.054-.109-.054-.272-.027-.408.041a5.6 5.6 0 0 0-.789.639 6.3 6.3 0 0 0-.789.871l.259-.014Zm-6.939-.027c0-.041-.707-.639-1.211-1.034a2.7 2.7 0 0 0-.884-.544c-.109-.014-.136-.014-.218.027-.054.014-.095.041-.095.054l.19.122a10 10 0 0 1 1.796 1.293c.041.041.109.068.218.068a3 3 0 0 1 .19.014Zm7.347-.014c.109-.014.136-.041.327-.204a11.6 11.6 0 0 1 1.823-1.279l-.082-.054c-.163-.082-.395 0-.748.245a15 15 0 0 0-1.551 1.293c0 .014.027.027.068.014l.177-.014Zm-9.538-.054v-.068a54 54 0 0 0-3.864-.898c-.082 0-.177.095-.177.204 0 .136.082.19.721.313a14 14 0 0 0 1.088.19l1.361.204.49.068c.381.054.367.054.381 0Zm11.946 0c1.497-.19 2.884-.422 3.333-.544.245-.082.327-.245.177-.367a.3.3 0 0 0-.136-.054 52 52 0 0 0-3.837.898v.068c.014.054.027.068.109.054zm-10.232.014a8 8 0 0 0-2.204-1.497c-.163-.054-.313-.082-.408-.041-.177.054-.15.068.218.272l.463.231.19.109c.327.19.952.599 1.252.816a.46.46 0 0 0 .272.095l.204.027s.014 0 0 0Zm8.286-.014c.136-.014.163-.027.299-.136a16 16 0 0 1 2.177-1.279c.068 0 .041-.041-.054-.082-.136-.068-.19-.068-.408 0a8.4 8.4 0 0 0-2.109 1.388c-.136.095-.163.163-.095.136zm-8.789-.041-.34-.259a19 19 0 0 0-1.565-.925c-.408-.204-.748-.313-.966-.313-.109 0-.19 0-.204.027l-.082.054c-.082.027-.068.041.163.136.571.19 1.905.816 2.354 1.088a.84.84 0 0 0 .367.163zm9.361-.027a.9.9 0 0 0 .272-.109 14.2 14.2 0 0 1 2.64-1.238c0-.041-.218-.136-.313-.136-.204 0-.789.204-1.116.395l-.245.136a15 15 0 0 0-1.497.952l-.054.041.082-.014zm-10.408-.054a16.3 16.3 0 0 0-3.537-1.17c-.163 0-.272.041-.34.15-.068.095-.054.136.041.136a51 51 0 0 1 3.755.884zm.463 0a7 7 0 0 0-1.116-.599l-.517-.231c-.898-.408-1.497-.585-1.782-.503-.109.027-.245.15-.19.177l.231.054a25 25 0 0 1 3.211 1.088l.136.027zm10.953-.204a26 26 0 0 1 2.857-.952c.068 0 .054-.054-.027-.122-.136-.122-.476-.095-.98.068a14 14 0 0 0-1.293.544 6.5 6.5 0 0 0-1.265.667c0 .041.272-.041.707-.204m.408.068a105 105 0 0 1 3.238-.762c.027-.027-.041-.163-.095-.204-.136-.095-.327-.095-.735 0a19 19 0 0 0-3.089 1.061c-.041.027.095.054.15.041zm-5.952-.207a21.6 21.6 0 0 0 6.626-6.327 11.9 11.9 0 0 0 1.66-4.653 30 30 0 0 0 .327-4.789l-.082.068c-.068.068-.19.095-.272.027l-.054-.027-.027.857a30 30 0 0 1-.272 3.606 11.9 11.9 0 0 1-1.088 3.687l-.259.449a15.4 15.4 0 0 1-2.735 3.51 22 22 0 0 1-3.891 3.129l-.231.15-.272-.163c-.626-.408-.844-.544-1.333-.925-1.238-.912-2.449-2.041-3.646-3.388a13 13 0 0 1-2.286-3.769c-.313-.816-.571-1.986-.721-3.238a35 35 0 0 1-.245-3.918l-.054.041c-.082.054-.19.041-.272-.041l-.082-.068.014 1.469c.041.912.068 1.293.163 2.191.136 1.17.286 2 .571 3.02a12.34 12.34 0 0 0 2.939 4.993 30 30 0 0 0 2.49 2.381 26 26 0 0 0 2.735 1.905l.311-.177Zm-1.837-.544c.027 0 .027-.027.027-.041-.027-.014-.163.014-.15.041s.082.027.136 0Zm1.973-.245a19 19 0 0 0 2.544-1.959l-.327-.054c-.367-.054-.49-.082-.639-.177-.163-.095-.095-.109.082-.014a6.4 6.4 0 0 0 .925.19c.041 0 .177-.109.136-.136l-.286-.027c-.408-.041-.68-.082-.83-.136-.136-.054-.34-.054-.381 0v.231c.027.122.054.354.054.517.027.367 0 .408-.245.667a3.3 3.3 0 0 1-1.674.884l-.163.054c0 .027.327.218.367.231l.422-.272Zm1.225.245c.027-.027-.109-.054-.136-.041-.014.027.041.068.095.068.014 0 .041 0 .054-.027Zm-3.81-.054-.095-.122c-.109-.095-.109-.095-.054-.122.15-.054.15-.054.231.068.041.068.095.122.122.122l.041-.014-.095-.15-.095-.136-.136.027c-.136.027-.218.054-.218.068 0 .041.054.095.122.136l.136.082c.027.054.054.054.054.041Zm.571-.054-.041-.027q-.061-.041-.082 0c-.027.014-.054 0-.122-.082-.082-.136-.177-.218-.19-.19-.014 0 .122.218.204.299.068.054.068.054.136.041zm3.374.027c.054-.054.245-.313.218-.327 0-.027-.136.095-.204.204-.054.068-.068.082-.109.068q-.041-.041-.082 0c-.027.027-.027.027.027.054.095.041.082.041.136 0Zm-3.878-.082c-.054-.095-.095-.122-.136-.109s-.027.027.041.095c.095.109.15.109.095.014m4.259 0c.054-.041.082-.082.068-.095-.027-.041-.095 0-.15.068-.082.136-.027.136.082.027m-.122-.068c.082-.122.095-.136.259-.068l.054.027-.082.068c-.041.027-.068.068-.054.068.041 0 .218-.136.218-.163s-.218-.095-.299-.095c-.054 0-.082.027-.163.136-.082.136-.095.136-.054.136s.082-.027.136-.109Zm-4.585.014c.054 0 .068-.027.041-.054s-.068-.014-.136.027c-.136.068-.136.136-.027.068zm5.265.054c0-.027-.054-.054-.109-.082-.082-.041-.109-.054-.136-.027-.014.027 0 .041.068.068.054 0 .095.041.109.041.041.041.068.027.068 0m-5.429-.34-.122-.204-.027-.014c-.041 0-.367.15-.408.19-.027.027.136.245.177.218.027 0 0-.041-.027-.082-.041-.041-.054-.082-.054-.109 0-.014.272-.163.272-.136l.095.122.095.136-.068.068c-.136.082-.068.109.095.041l.109-.068-.136-.177Zm5.51.272c.027-.027 0-.041-.041-.068l-.068-.068a1.1 1.1 0 0 1 .177-.272h.041l.136.068.109.068-.054.109-.054.095c.027 0 .204-.177.204-.218a2 2 0 0 0-.408-.204s-.082.082-.136.177l-.136.177c-.054 0 0 .041.082.095.122.068.122.068.15.041m-6.109-.041-.068-.054.027.054.054.041zm3.197-.054a3.16 3.16 0 0 0 1.742-1.129c.041-.068.027-.381 0-.748l-.027-.136-.082.136c-.122.204-.639.626-1.02.83a4.8 4.8 0 0 1-1.837.517l.218.163.435.299c.218.15.204.15.571.068m-3.075.027-.068-.109-.082-.082-.082.041q-.061.061-.041.082c0 .014.027.014.054 0 .041-.027.054-.027.109.027s.122.082.109.041m.34-.041.068-.054-.068-.095-.068-.095-.109.054-.109.041.054.082c.054.068.122.136.15.136zm5.85-.027.082-.109-.095-.068-.109-.041-.054.068c-.095.136-.095.136-.014.19l.095.054zm.272.027c.054-.054.068-.054.095-.027h.068s0-.041-.054-.068l-.068-.054-.082.082-.082.109c0 .041.054.014.122-.041m.789-.299.068.068c.054.068.163.136.163.082a1.2 1.2 0 0 0-.259-.272s-.027.014-.027.054l-.122.19c-.068.136-.082.15-.054.177.027 0 .054-.027.136-.136zm-8.095.177-.082-.095c-.027 0-.082.095-.068.109a1 1 0 0 0 .204.095zm.177.082a.3.3 0 0 0-.054-.095l-.109-.19-.068-.109-.136.136-.122.15c0 .041.136-.014.177-.082l.068-.082.095.15c.095.136.15.19.15.136Zm1.633-.054c.095 0 .109-.054.014-.136q-.143-.102-.082 0c.027.054 0 .068-.095.095a1 1 0 0 0-.109.027c-.027 0-.204-.218-.19-.245l.122-.027c.095 0 .136-.041.068-.068-.041 0-.286.041-.286.068 0 .014.027.068.163.245l.082.136.136-.054.19-.054Zm4.857-.109.122-.19c-.027-.014-.272-.054-.299-.041-.054.027-.014.054.082.054.054 0 .109 0 .109.027l-.082.136-.082.109-.122-.027c-.095-.027-.109-.027-.095-.082v-.068l-.082.054c-.095.082-.095.109.014.136l.177.054.109.027zm1.483.095c.041-.027.041-.027 0-.068-.054-.041-.054-.041-.109.054l-.068.109s.109-.041.177-.095m-8.64.041.082-.054-.082-.068c-.054-.027-.082-.041-.15-.027-.15.041-.15.041-.041.109l.109.068zm.789.014-.109-.19c-.054-.109-.109-.19-.095-.204l.15-.109.136-.082.095.204.095.218-.068.068-.068.068c0 .041.054.027.136-.054l.095-.068-.068-.136a3 3 0 0 1-.177-.381c-.014-.014-.313.163-.381.218l-.054.041.082.136c.136.272.204.327.231.272m7.538-.082.136-.204.054-.122-.068-.054c-.109-.082-.354-.218-.367-.204l-.027.122-.122.245-.068.136.082.082c.122.109.177.109.082 0l-.068-.095.15-.354.041-.054.109.082.136.082c.054 0 .027.068-.082.231l-.095.19c0 .041.054 0 .109-.082m.857.041c.109-.082.109-.082-.014-.109-.054-.014-.095 0-.163.027-.041.014-.068.041-.068.054 0 0 .109.082.136.082zm-9.878-.041a.3.3 0 0 1 .177-.054c.095 0 .408-.068.408-.095l-.027-.054a.3.3 0 0 1-.041-.15q0-.122-.231-.068a8.3 8.3 0 0 1-1.619.204c-.395 0-.408.014-.313.136.041.041.041.041.109 0 .095-.054.354-.054.544.027.136.068.177.068.218.041.204-.136.34-.122.68.068zm10.925-.095c.109 0 .136 0 .204.054l.082.054.204-.068c.245-.082.354-.095.476-.027l.109.041c.027 0 .095-.136.082-.15 0 0-.177-.027-.367-.027-.408 0-.748-.041-1.32-.136l-.449-.095c-.054 0-.068 0-.068.082l-.027.136-.041.082c0 .027.299.095.395.095.068 0 .231.054.245.082 0 .014.082 0 .177-.041a.5.5 0 0 1 .286-.082Zm-9.279.068.068-.068-.082-.163-.082-.163-.218.136c0 .027.19.313.218.313l.082-.054Zm7.32-.109.095-.163-.082-.054-.122-.054-.095.15-.068.163.068.068.095.054zm-1.197-.041-.095-.027c-.068 0-.095.014-.136.068-.027.054-.027.054.041.082.082.041.082.027.136-.027.041-.041.068-.082.054-.095m-6.925.122.136-.163.136-.136-.068-.163-.068-.245-.014-.068c-.041 0-.272.19-.34.272-.109.109-.054.354.095.476.068.041.136.054.136.027Zm-.109-.109a.4.4 0 0 1-.109-.218c0-.054 0-.082.136-.204.082-.082.136-.136.15-.109l.068.177.054.15-.136.136-.109.136zm.204-.313c-.041-.163-.054-.163-.163-.068-.109.109-.109.177-.041.299l.041.068.109-.095.095-.095zm1.932.408-.027-.068c-.027-.054-.041-.068-.136-.068l-.095.014.041.082c.041.068.054.068.136.068zm6.803-.014a.47.47 0 0 0 .163-.327c0-.068-.027-.109-.109-.19a1.3 1.3 0 0 0-.286-.231s-.041.068-.054.15l-.082.245-.027.082.136.15.163.163.082-.041Zm-.19-.15-.109-.136.054-.163c.027-.109.054-.177.068-.177l.136.136c.136.122.163.163.109.286a.4.4 0 0 1-.136.177l-.136-.136Zm.177 0c.027-.027.041-.082.054-.122 0-.054 0-.082-.095-.177-.054-.054-.109-.095-.122-.082l-.041.136-.027.109.068.095.109.095zm-7.347-.068c.014 0 0-.068-.054-.218l-.068-.204H8.26c-.109 0-.313.068-.381.095-.027.014-.014.054.041.177l.109.272.054.082.204-.095a5 5 0 0 1 .218-.109m-.476-.082c-.041-.095-.082-.177-.068-.19l.327-.082c.027 0 .15.231.15.286l-.163.095-.163.068zm.231.054.109-.054-.068-.204c-.027-.027-.272.027-.272.068s.109.245.122.245zm6.572-.027c.122-.272.136-.259-.054-.313a2 2 0 0 0-.259-.054h-.095l-.054.109-.082.218c-.027.068-.027.082 0 .095l.218.109c.218.109.204.122.327-.163m-.313.082a2 2 0 0 1-.163-.082l.041-.136c.054-.177.068-.177.272-.122l.136.014.014.014c.014.014 0 .082-.054.204l-.095.177zm.19-.109.041-.136c0-.014-.177-.082-.245-.082-.014 0-.082.136-.082.19 0 .027.163.136.218.136zm-9.116.068a7 7 0 0 0 .98-.19l-.179-.114-.19-.095-.367.054a12 12 0 0 1-1.905.109c-.027.041.068.177.136.218a5.1 5.1 0 0 0 1.537.027Zm13.102 0c.082-.054.177-.177.177-.231 0-.027-.109-.027-.381-.027-.503 0-1.088-.041-1.551-.095l-.367-.054-.19.109-.19.109a5.9 5.9 0 0 0 2.503.177Zm-9.891-.041-.014-.041c-.027-.027-.054-.041-.109-.027-.068.014-.082 0-.109-.095l-.082-.136c-.041-.027-.041-.027 0 .122.068.19.095.204.204.19zm5.415-.041c.068-.122.109-.259.082-.245-.027 0-.041.027-.095.136-.027.068-.041.082-.095.068l-.109.027c-.041.041-.041.041.054.068l.122.014.054-.068Zm-6.776-.054.204-.136c.15-.068.136-.054.109-.313-.027-.177-.027-.177-.095-.163-.082 0-.463.177-.463.204l.122.408c.027.082.027.082.122 0m-.095-.136-.041-.177-.014-.082.163-.068c.095-.041.177-.082.19-.068l.027.095.041.136c0 .041-.014.068-.163.136l-.163.109-.041-.095Zm.272-.218v-.109c-.014 0-.082 0-.15.041-.136.068-.136.068-.082.231l.027.068.109-.068c.109-.068.109-.068.109-.163Zm7.864.259c.095-.272.095-.327.027-.367l-.395-.163c-.054 0-.054 0-.082.163l-.041.218c0 .027.027.054.136.122a2 2 0 0 1 .299.177zm-.272-.054-.136-.095v-.095l.041-.15.027-.054.177.068c.122.054.177.082.177.109 0 .068-.082.299-.109.299a.5.5 0 0 1-.177-.082m.204-.082v-.122c0-.027-.231-.122-.245-.095l-.027.095c-.014.082-.014.095.095.15l.136.082zm-5.008.199c.653-.095 1.279-.299 1.701-.585.163-.095.531-.408.667-.531.19-.19.272-.476.136-.612a.7.7 0 0 0-.163-.136c-.218-.095-.381-.122-1.483-.218-.272-.027-.313-.054-.313-.218 0-.136.068-.231.204-.313.136-.068.163-.095.068-.054-.313.122-.449.299-.327.476.082.136.19.163.544.19.952.082 1.252.136 1.388.313.082.122.068.19-.054.408-.19.327-.367.449-1.007.748a4.8 4.8 0 0 1-1.728.381l-.272.027.109.095c.082.054.136.082.177.068zm-1.742-.014c-.041-.027-.054-.014-.027.014 0 .014.027.027.041.014zm5.497-.014c-.027-.027-.068 0-.054.041h.041V19.7Zm2-.027.422-.245c1.878-.993 3.333-1.905 3.333-2.068 0-.041-.082-.095-.136-.095-.068 0-.177.054-2.721 1.469l-.857.463c-.014.014-.027.082-.014.163 0 .109 0 .15-.041.231-.054.095-.041.136 0 .082Zm-9.524-.068c-.054-.068-.068-.272-.041-.354 0-.041-.503-.327-1.633-.939l-.19-.109a10 10 0 0 0-.776-.422c-1.007-.544-1.048-.571-1.116-.463-.041.068.027.15.245.313a25 25 0 0 0 2.816 1.66l.49.272.218.095-.027-.054Zm.381-.19.122-.095v-.15c0-.082-.027-.15-.041-.163-.082-.054-.34.054-.408.19-.068.095-.068.299 0 .408l.027.054.082-.068c.054-.041.136-.136.218-.177m-.313.041c-.027-.136.054-.286.19-.367.122-.054.163-.041.163.082q0 .109-.15.245l-.177.136c-.014 0-.027-.041-.027-.095m.19-.095c.082-.068.122-.109.122-.163 0-.082-.014-.095-.095-.068-.082.041-.19.19-.19.272s.041.068.163-.041m9.211.177a.36.36 0 0 0-.041-.367.45.45 0 0 0-.327-.177c-.082 0-.109.068-.109.231 0 .095 0 .109.109.177l.204.163c.054.041.095.095.109.082zm-.245-.122c-.082-.068-.15-.136-.136-.163v-.109c0-.082 0-.095.068-.082.15.041.272.19.272.34 0 .082-.014.136-.041.136zm.163 0a.3.3 0 0 0-.095-.218c-.082-.082-.15-.082-.163 0-.014.054 0 .054.109.177.122.095.15.109.15.041m-10.992.149c.476-.041 1.088-.109 1.088-.136 0 0-.463-.245-.476-.231a12.3 12.3 0 0 1-2.204.014h-.136v.054c.041.136.163.231.408.272.163.041.884.054 1.32.027m14.041 0c.163-.041.299-.109.381-.218.095-.136.082-.136-.095-.136a9 9 0 0 1-2.191-.014c-.014-.014-.476.218-.476.245a9 9 0 0 0 2.381.109Zm-10.939-.109c.136-.027.177-.054.15-.068-.014-.027-.054-.027-.204 0-.19.054-.177.054-.204-.136 0-.109 0-.109.054-.109H8l-.054-.054c-.041-.041-.054-.041-.095-.014-.054.014-.054.027-.041.19.027.218.041.272.095.245l.218-.054Zm2.408 0a3.3 3.3 0 0 0 1.279-.354c.585-.272.735-.367.898-.653.177-.272.15-.408-.068-.503-.163-.068-.571-.136-1.007-.163-.218 0-.449-.027-.517-.054-.136-.041-.272-.136-.299-.245-.041-.082 0-.231.082-.299.095-.095.327-.204.517-.259l.177-.041v-.218c-.014-.245-.027-.272-.136-.327h-.136c-.095.041-.109.082-.109.34 0 .204 0 .218.041.218.082 0 .054.041-.082.082-.204.068-.408.19-.49.272-.082.122-.095.272-.041.367.095.136.218.177.939.245.327.027.599.082.735.177.136.068.163.177.109.34-.027.109-.15.245-.19.218l-.014-.095c0-.122-.041-.068-.054.068 0 .109 0 .136-.082.177-.041.014-.082.041-.095.027l-.014-.109c0-.109 0-.122-.082-.095-.027 0-.041.041-.041.136v.136l-.082.041-.109.027-.014-.136v-.136l-.082.041c-.054.014-.054.027-.054.136 0 .136 0 .136-.163.163-.054 0-.054 0-.068-.109 0-.109-.014-.136-.054-.136-.095 0-.109.041-.109.163s-.027.15-.177.15c-.054 0-.054 0-.054-.109v-.136h-.163v.136l-.014.136-.109.027c-.136.027-.163 0-.163-.136 0-.109 0-.109-.068-.109s-.068 0-.068.136l-.014.136h-.259v-.272h-.177v.272h-.272v-.272h-.082l-.082.014v.136c0 .082-.014.095-.068.109-.041 0-.095 0-.136-.027-.041-.014-.054-.027-.054-.136v-.136h-.082c-.082 0-.082 0-.082.095s0 .095.272.299l.34.272c.054.041.082.041.272.041zm4.449-.122c.027-.218.027-.231-.027-.272l-.082.014c-.068.041-.068.068 0 .068.054 0 .068 0 .054.054l-.014.122c0 .122-.014.136-.204.082-.095-.027-.177-.041-.204-.027-.041.027 0 .054.19.095l.19.041c.054.041.068 0 .095-.177m-6.871 0c.095-.014.082-.027 0-.109-.068-.054-.095-.054-.136-.041-.054.014-.054.027-.054.109 0 .068.014.082.068.068l.136-.027Zm6.762-.054c0-.082 0-.095-.068-.095-.054 0-.19.082-.19.122l.204.068c.041 0 .041-.027.041-.095Zm-7.535-.096a2 2 0 0 1 .245-.095c.109-.027.109-.027.109-.122 0-.068 0-.095-.068-.122a.37.37 0 0 0-.408.068c-.054.041-.068.068-.068.19 0 .095.014.15.027.15zm-.109-.136c0-.054 0-.082.082-.122.122-.068.313-.054.313.041 0 .041-.027.054-.163.109-.218.082-.231.082-.231-.014Zm.272-.041c.082-.041.082-.041.027-.068-.068-.027-.245.027-.245.095-.014.041 0 .041.054.027a1 1 0 0 0 .15-.054Zm8.068.109c0-.177 0-.19-.136-.259-.15-.082-.367-.041-.408.082 0 .095 0 .136.136.163.082.014.177.068.245.095l.136.054zm-.313-.041c-.163-.068-.204-.136-.095-.177.15-.054.367.041.354.177 0 .082-.068.082-.259 0m.177-.068c-.041-.054-.15-.082-.218-.068-.082.027-.054.041.082.095.15.054.204.041.136-.027m-10.476.19.571-.054-.204-.136-.204-.095h-.49c-.735 0-1.769-.082-1.905-.136-.041-.014-.041 0-.027.041a.45.45 0 0 0 .231.272 18 18 0 0 0 1.401.136c.054 0 .34 0 .639-.027Zm14.272-.027a6 6 0 0 1 .381-.027.64.64 0 0 0 .34-.15c.068-.095.109-.231.054-.204l-.313.041c-.435.041-1.048.082-1.592.082h-.49l-.163.082c-.299.163-.299.163-.027.177a9.4 9.4 0 0 0 1.81 0m-12.476-.422c0-.136-.041-.395-.068-.544l-.054-.313-.19-.204c-.136-.163-.19-.204-.231-.19-.027 0-.027.027-.027.054a7 7 0 0 1 .272 1.497l.082.068.068.041.082-.082.082-.082zm9.456.367c.068-.041.068-.054.095-.327.041-.327.136-.884.218-1.116.082-.259.027-.259-.218 0l-.19.177-.054.286-.068.571-.014.272.068.095.068.082zm-6.422-.082c0-.041-.014-.068-.054-.068-.068-.027-.082-.027-.095.068-.014.054-.014.054.068.054.068 0 .082 0 .082-.054m.408.041c.054-.041.027-.109-.041-.122-.054 0-.068 0-.082.054l-.014.068c.014.027.109.027.136 0m-.898-.136c-.041 0-.095.027-.095.068 0 .014.027.041.054.041.068 0 .095-.068.041-.095Zm1.333.054c0-.054-.027-.068-.109-.054-.041.014-.054.027-.054.054 0 .054 0 .068.082.054.054 0 .082-.027.082-.054m-4.218-.041-.054-.299a4.4 4.4 0 0 0-.327-1.306.33.33 0 0 0-.136-.109c-.068-.014-.19 0-.19.041l.082.272c.136.435.272 1.02.272 1.225 0 .068.014.082.136.163.19.095.218.095.204.014Zm1.388.041-.027-.027-.027.027c0 .014 0 .027.027.027s.041 0 .027-.027m7.197 0-.027-.027-.027.027c0 .014 0 .027.027.027s.027 0 .027-.027m1.497-.041c.163-.095.177-.109.204-.408l.068-.34.068-.272a9 9 0 0 1 .177-.68c-.027-.027-.218 0-.245.027-.15.122-.34.816-.408 1.497l-.027.231c0 .027.041 0 .177-.054Zm-5.483 0v-.027c-.027-.068-.095-.041-.095.027q-.02.061.041.041l.054-.027Zm-4.014-.014.109-.014v-.136c0-.068 0-.204-.027-.299l-.014-.177-.177-.177a1 1 0 0 0-.19-.163l.041.218.054.503c.014.245.027.272.054.272l.136-.027Zm8.925-.136a6 6 0 0 1 .122-.844s-.095.068-.19.177c-.204.204-.218.231-.218.599v.19h.082l.136.027c.027 0 .041.014.054 0v-.163Zm-4.503.11c.027-.014.027-.027 0-.068-.068-.041-.109-.027-.109.041 0 .041.054.054.109.027m-1.619-.068c0-.109.027-.136.15-.136h.136v.109c0 .095 0 .095.068.082.068 0 .082 0 .082-.068v-.109c0-.014.054-.027.136-.027h.109v.095c0 .082 0 .095.068.095s.068 0 .068-.109v-.095l.136-.014c.122-.014.163 0 .163.109 0 .041.014.054.041.054.014 0 .027-.027.041-.095q0-.095.122-.122c.095-.014.109 0 .15.041l.041.082c0 .027.027.027.041.027.027 0 .041-.027.041-.095 0-.109 0-.109.095-.136.082 0 .109 0 .15.027l.054.082c0 .014 0 .027.027.027s.014-.041.027-.095c0-.082 0-.095.095-.136.082-.027.095-.027.136.041.082.068.082.068.082-.027 0-.082.054-.136.15-.136.068 0 .082-.041.027-.122s-.381-.136-1.034-.19c-.381-.027-.517-.082-.667-.231-.041-.041-.082-.082-.095-.068-.027.027 0 .599.014.639.027.027.177.082.286.109.041 0 .068.027.068.041 0 .041-.136 0-.272-.054-.136-.068-.218-.136-.381-.34-.204-.272-.395-.435-.639-.544-.122-.068-.19-.109-.177-.136.041-.014.408.19.558.313a4 4 0 0 1 .49.544v-.18c-.027-.367.041-.789.15-.912.027-.027.041-.136.041-.299v-.259h-.112a1.74 1.74 0 0 0-.748.286 4 4 0 0 0-.422.449 3 3 0 0 1-1.116.898l.109.136c.367.327.517.435.585.449.054.014.068 0 .068-.041 0-.027.014-.082.041-.109.027-.041.054-.041.15-.027l.122.014v.095c.014.136.054.136.109 0 .041-.082.041-.082.163-.082h.136v.109c0 .095 0 .095.068.095.054 0 .068 0 .068-.054m.095-.435c-.612-.408-1.007-.463-1.361-.163-.068.041-.122.082-.136.068-.027-.027.19-.19.327-.245.272-.095.49-.082.776.054.136.068.503.286.571.354.122.095 0 .054-.177-.068m.313-1.17a.8.8 0 0 0-.408-.163c-.095 0-.15-.027-.15-.041.027-.027.204-.014.313.027.109.027.354.19.354.218 0 .041-.041.027-.109-.041m-2.815 1.537c.054 0 .095-.027.095-.041s-.068-.095-.177-.19l-.177-.163.014.095.014.259v.15l.068-.041zm8.218-.408s-.327.327-.327.354c0 .014.041.041.095.054.041 0 .109.041.136.054l.068.054.027-.259v-.245Zm-10.586.503-.218-.136-.218-.109-.327-.014c-.694-.027-1.497-.136-1.959-.272-.272-.095-.272-.095-.231.014.054.163.272.313.544.367a10.8 10.8 0 0 0 2.408.136Zm13.946-.027a5 5 0 0 0 1.429-.204c.122-.068.272-.204.286-.272v-.095l-.259.068c-.503.136-1.265.245-1.946.272l-.327.014-.204.122c-.122.054-.204.109-.204.122l1.225-.014Zm-7.211-.041c0-.014 0-.041-.027-.041-.041 0-.041 0-.041.041s0 .054.041.041l.041-.041Zm-5.755-.109a7.6 7.6 0 0 0-.367-1.483c-.068-.136-.19-.245-.327-.245s-.136.027-.095.109l.245.639c.082.218.163.531.204.68l.068.286.136.068.136.082zm3.578.095c0-.027-.014-.027-.068-.027-.109 0-.136.041-.054.054.095 0 .109 0 .122-.027m.422.014s-.027-.027-.082-.027c-.041 0-.068.014-.068.027l.082.027zm.422-.027-.068-.014c-.068 0-.082.014-.054.041.014.027.136 0 .136-.027Zm6.449 0 .136-.095.095-.34a7 7 0 0 1 .463-1.361c-.027-.027-.218-.014-.286.027-.095.054-.15.163-.272.531a7 7 0 0 0-.286 1.252c-.014.054.014.054.136-.027Zm-5.442-.082v.082zm-2.259.068c0-.027-.122-.054-.15-.041v.041c.014.027.136.027.136 0Zm1.674 0c0-.027-.027-.027-.027-.027h-.082c-.041 0-.054 0-.054.027s.041.014.082.014c.054 0 .082 0 .082-.027Zm.367-.068v-.027c-.027-.014-.136.014-.136.041s.109.014.136 0Zm.871 0c.027-.027-.014-.082-.054-.068-.027.027-.027.082.014.082zm-6.477-.326a9 9 0 0 0-.463-1.32c-.109-.259-.245-.395-.395-.381-.136 0-.136.014 0 .259a8.7 8.7 0 0 1 .639 1.551c.082.068.245.163.259.136zm5.987.245-.068-.014-.054.014.054.027c.027 0 .068 0 .068-.027m5.674-.068c.109-.068.136-.095.15-.163a8.5 8.5 0 0 1 .68-1.701c-.082-.068-.259 0-.367.136a6.2 6.2 0 0 0-.626 1.769c-.027.068 0 .068.163-.041m-12.789.014-.19-.136-.204-.109-.408-.041a8 8 0 0 1-2.231-.558c-.014.014.082.231.136.272a4.4 4.4 0 0 0 1.565.463c.422.068 1.347.136 1.347.109Zm14.354-.027c.748-.054 1.252-.136 1.85-.327.34-.095.435-.136.517-.259.082-.095.136-.245.082-.245l-.136.054a8 8 0 0 1-2.054.517 3 3 0 0 0-.463.068l-.313.177-.082.054h.068l.517-.041Zm-6.925 0c.054-.041 0-.054-.054-.014-.054.027-.054.027-.014.027zm.449-.136c.041-.095.041-.136.027-.19-.027-.068-.054-.095-.15-.136a2.3 2.3 0 0 0-.816-.163c-.599-.054-.707-.082-.816-.245-.054-.082-.068-.109-.054-.204.014-.177.136-.299.34-.408.095-.027.163-.068.163-.082s-.136.027-.245.082c-.408.204-.463.639-.095.816.136.068.299.095.68.109.313.027.694.082.816.136q.143.082.082.245c-.054.19 0 .218.068.041M5.24 18.22a7.4 7.4 0 0 0-.639-1.469c-.19-.299-.367-.422-.49-.354-.027.027-.014.054.068.19a5.9 5.9 0 0 1 .789 1.633c.027.041.313.218.327.19l-.041-.19Zm12.408.136c.136-.082.136-.095.19-.231a8 8 0 0 1 .707-1.469c.163-.245.163-.272.027-.272q-.265 0-.735 1.061a9 9 0 0 0-.367.98l.177-.082Zm-2.98-.136s-.014-.027-.054-.027a3.7 3.7 0 0 1-1.143-.694c-.272-.231-.531-.286-.776-.19-.068.027-.204.041-.463.054h-.367l-.082.082c-.095.082-.082.177.014.19.163 0 .612.082.721.095.177.041.354.136.435.231l.068.095h.068c.095-.041.218-.027.408.041.109.041.327.068.639.109.517.054.517.054.544.027Zm-10.708 0a2.6 2.6 0 0 0-.435-.231c-.109 0-.871-.163-1.116-.245a9 9 0 0 1-1.457-.601c-.041 0-.014.136.027.204.068.109.231.218.558.327a9.2 9.2 0 0 0 2.422.544m4.286-.027c.34-.15.707-.463 1.116-.952l.299-.327c.204-.163.531-.299.816-.313.122 0 .163-.041.136-.122-.014-.027-.041-.041-.299-.027-.517.027-.762.136-1.102.544a3.7 3.7 0 0 1-1.279 1.048l.19.204.136-.068Zm10.993 0a7.6 7.6 0 0 0 2.463-.735.27.27 0 0 0 .095-.122c.041-.095.041-.19 0-.177l-.49.218a7 7 0 0 1-1.864.585c-.272.041-.259.041-.585.259-.068.027-.041.027.381-.027m-.803-.612c.272-.544.408-.762.653-1.143.19-.286.19-.313.054-.313-.15 0-.259.109-.517.503a6.2 6.2 0 0 0-.762 1.578l.163-.082.177-.095.231-.463Zm-13.537.584a6 6 0 0 0-.272-.653 5.3 5.3 0 0 0-.844-1.361c-.136-.095-.34-.027-.231.068s.435.667.748 1.279l.259.503.136.095c.15.082.204.095.204.068m10.3-.463c.503-.49.517-.503.286-.503-.082 0-.15.027-.286.095-.19.095-.354.15-.327.095l.095-.041.245-.109c.15-.095.34-.109.449-.054.041.027.054 0 .272-.204l.204-.259h-.109a.56.56 0 0 1-.299 0c-.068-.027-.136-.027-.177-.027l-.463.218-.408.204h-.272c-.272 0-.286 0-.449.095-.177.082-.354.136-.354.082l.082-.041a.8.8 0 0 0 .272-.095.6.6 0 0 1 .34-.082c.095 0 .163 0 .163-.027s-.19-.095-.367-.136c-.259-.068-.599-.027-.952.122-.136.054-.163.068-.163.109s0 .054.054.054a1.1 1.1 0 0 1 .436.219l.122.082.354-.041c.422-.054.503-.054.871.068l.299.082v.041c0 .014-.082 0-.367-.095s-.408-.109-.68-.054l-.34.027c-.054 0-.082.014-.082.027.027.041.218.19.408.299.163.095.612.299.653.299.014 0 .245-.204.49-.449m-7.157.218c.367-.19.626-.408.98-.816.327-.354.435-.463.639-.558.163-.095.177-.109 0-.054a1.2 1.2 0 0 0-.449.34l-.367.395a2.7 2.7 0 0 1-.776.599l-.231.109c-.014 0 0 .054.027.054l.177-.082Zm-3.592.014-.422-.871c-.449-.816-.83-1.265-1.034-1.225l-.068.041.231.354a8.3 8.3 0 0 1 .735 1.197l.136.299.204.109c.19.109.218.122.218.095m14.096-.095.19-.109.204-.408c.245-.49.49-.871.803-1.252.136-.19.136-.231 0-.231-.19 0-.544.408-.952 1.184-.163.272-.476.884-.476.912s.041 0 .231-.095m-15.13.041a1.3 1.3 0 0 0-.476-.245 12 12 0 0 1-2.422-1.197c-.082-.068-.122.027-.068.19a.68.68 0 0 0 .313.34c.476.272 1.279.599 1.687.721a3 3 0 0 0 .952.19ZM8 17.811c.177-.082.435-.259.517-.34l.095-.082.34-.367a2.3 2.3 0 0 1 .544-.49c.136-.095.095-.095-.095 0-.095.054-.272.19-.558.49a2.8 2.8 0 0 1-1.088.762c-.068.027-.068.027-.027.068l.054.054zm11.823 0c.517-.109.966-.272 1.66-.585.612-.272.68-.327.816-.544.041-.068.068-.204.041-.245-.014-.014-.136.054-.34.163a9.7 9.7 0 0 1-2.408 1.116l-.136.095-.136.095.122-.014zm-11.66-.287a7 7 0 0 0 1.088-.993c-.027-.027-.204.136-.49.408a2.75 2.75 0 0 1-1.006.748c-.15.054-.136.054-.136.082.027.027.327-.095.544-.231Zm-.34.054c.245-.109.367-.19.571-.354l.177-.15h-.095c-.082-.014-.136 0-.313.095l-.204.109h-.204c-.204-.014-.218-.014-.327.054-.068.027-.122.082-.122.095s.041.082.109.136c.136.136.15.136.408.014m-4-.162a8 8 0 0 0-.49-.844c-.476-.707-.844-1.048-1.061-1.007-.109.027-.122.054-.054.122a12.3 12.3 0 0 1 1.306 1.701.7.7 0 0 0 .231.204l.177.082zm15.429-.027.15-.245a10.5 10.5 0 0 1 .98-1.265c.204-.231.218-.259.177-.272-.109-.095-.272 0-.544.231a7.1 7.1 0 0 0-1.184 1.823s.082-.014.177-.068a.54.54 0 0 0 .245-.204m-16.354.109a2.6 2.6 0 0 0-.476-.313 23 23 0 0 1-2.205-1.401c-.041 0-.095.082-.095.163s.136.272.299.381a11.4 11.4 0 0 0 2.571 1.265l-.109-.109Zm8.653-.136-.041-.272c-.027-.054-.041-.054-.109-.027-.259.068-.408.204-.408.367 0 .136.041.136.517.177h.054zm.122.19c0-.068.095-.19.19-.218l.082-.041-.082-.136c-.054-.068-.095-.095-.136-.109-.054 0-.082-.027-.082-.041 0-.041.136 0 .19.041l.095.136c.054.095.095.136.245.136h.109l-.014-.19-.041-.626-.041-.435-.653.014c-.735.027-.816.027-.844.054l-.054.952s.041 0 .068-.027a.7.7 0 0 1 .34-.136l.095-.027v-.449l.068-.082c.095-.095.177-.109.299-.054.095.054.109.136.122.395v.245h-.054c-.068 0-.068.014-.027.082.014.041.041.163.041.327.014.19.027.259.054.259l.027-.054Zm8.245.014a14 14 0 0 0 1.02-.408c.884-.435 1.674-.952 1.701-1.143.014-.082-.014-.19-.068-.204l-.313.19c-.408.313-1.197.789-1.932 1.197a2 2 0 0 0-.463.299l-.082.109zm-13.728-.163-.068-.068c-.054-.027-.054-.027-.014.027l.054.082.027.014c.014 0 .014-.027 0-.054m10.476-.041c.054-.095.095-.136.136-.136.095-.014.136-.054.054-.054-.068 0-.313.231-.286.272s.027.041.095-.082m-13.198.041a8 8 0 0 0-.517-.762c-.721-.952-1.129-1.333-1.456-1.333-.068 0-.19.041-.19.068l.122.095c.15.095.857.803 1.374 1.388.313.34.435.449.544.503l.136.082zm15.973-.041a1.9 1.9 0 0 0 .408-.395 22 22 0 0 1 1.605-1.605c0-.041-.136-.068-.272-.041-.245.041-.49.259-1.048.912a9 9 0 0 0-.816 1.184zm-12.082-.027c.109-.095.218-.122.422-.095.177 0 .177 0 .381-.109.163-.082.218-.109.34-.109s.15-.027.231-.095l.095-.095c0-.027-.259 0-.381.054a1.8 1.8 0 0 1-.408.068c-.272.027-.299.041-.571.19-.109.054-.163.082-.272.082h-.12l.095.082.095.095zm-4.517-.054c.041-.054.041-.054-.354-.354l-1.034-.816c-.925-.721-1.048-.816-1.211-.748-.041.027-.109.136-.109.19 0 .082.109.204.272.327a19 19 0 0 0 2.316 1.399c.082.054.082.054.136-.014Zm17.293-.041 1.034-.599c.707-.408 1.265-.803 1.401-.952.054-.068.068-.095.054-.163-.014-.122-.095-.177-.218-.163-.136 0-.34.15-.857.558a164 164 0 0 1-.98.776c-.748.585-.694.544-.667.558l.027.041c0 .054.027.041.204-.054m-7.51.027.218-.054.068-.027-.027-.245c-.027-.435 0-.395-.327-.626l-.299-.204.068 1.17c.014.041.136.041.299-.014m-6.599-.041-.109-.054c-.054 0-.041.041.014.041l.082.041c.082.054.082.041 0-.027Zm-3.184-.272A13 13 0 0 0 1.37 15.5c-.408-.299-.721-.381-.816-.204l-.014.068.15.109.639.476c1.347 1.061 1.605 1.265 1.674 1.265s.054-.014-.163-.259m14.245.122c0-.041-.19-.027-.231.014-.027.027-.014.041.054.027.068 0 .082 0 .068.054v.054l.054-.068zm3.17-.204.707-.544a93 93 0 0 0 1.265-.993c0-.014-.027-.054-.068-.082-.177-.136-.517 0-.98.408-.136.136-.816.816-1.17 1.225l-.231.245-.082.082h.054c.054 0 .177-.082.503-.34m-14.477.272c0-.041 0-.041.068-.027.068 0 .068 0 .041-.027-.014-.027-.068-.041-.122-.041-.095 0-.095 0-.054.082.027.068.082.082.068.014m1.674-.054c.272-.136.299-.15.612-.19a2 2 0 0 0 .435-.082c.095-.041.163-.041.272-.041.163 0 .177-.014.054-.122-.068-.054-.095-.068-.218-.068a1 1 0 0 1-.245-.027.27.27 0 0 0-.204 0l-.177.027-.218.054c-.177.082-.204.095-.313.068a.5.5 0 0 0-.435.041.6.6 0 0 1-.204.082l-.082.027.136.163.163.163h.136a.6.6 0 0 0 .272-.095Zm7.306-.054.095-.054-.014-.19c-.014-.327 0-.299-.299-.299h-.272v.313c-.027.095-.014.095.041.136.095.027.109.027.109-.068 0-.136.095-.204.204-.136.041.027.041.068.041.163s0 .136-.027.136-.041-.041-.041-.136 0-.136-.027-.136c-.068-.027-.109.027-.109.136 0 .082 0 .109.054.136.068.054.122.054.245 0m-1.646-.041a1.9 1.9 0 0 1 1.088-.109v-.082c.014-.082 0-.082-.068-.122a1.2 1.2 0 0 0-.952.136c-.218.095-.231.109-.231.163v.068zm-7.333-.041c-.014-.027-.054-.041-.082-.041s-.054-.041-.095-.122a.5.5 0 0 0-.082-.136c-.027-.027-.027-.027-.014.027 0 .041.041.136.068.19.054.136.054.136.15.136s.095 0 .054-.054m11.429-.082.054-.19c.014-.054.014-.054-.027-.014l-.082.136c-.027.068-.054.095-.095.109a.14.14 0 0 0-.082.054c-.027.041-.014.041.068.041.095 0 .095 0 .15-.136Zm-11.647.109-.041-.109-.082-.19c-.014-.082-.027-.095-.109-.109-.109-.014-.299 0-.299.041 0 .027.19.299.204.299.041 0 .027-.014-.041-.136-.041-.054-.068-.122-.054-.136h.109c.095 0 .095 0 .136.136.027.082.068.15.095.177.041.027.082.041.082.014Zm11.715-.027.041-.054.054-.136c.054-.136.054-.136.15-.136l.109.027-.068.109c-.054.095-.068.163-.027.136l.109-.163c.095-.136.095-.136.041-.15a.5.5 0 0 0-.286 0c-.027 0-.054.027-.068.068l-.068.19-.054.136zm-2.177-.218c0-.095-.014-.109-.109-.177l-.095-.068v.34l.027.109.082-.041c.095-.041.095-.054.095-.136Zm-9.742.027q-.041-.082-.082-.082c-.068 0-.068 0 0 .109.082.136.136.095.082-.027m12.136.027c.082-.109.082-.136 0-.122-.054.014-.136.218-.068.218zm-4.293-.059c.286-.136.49-.177.762-.136.204.027.259.014.15-.027-.041-.027-.177-.027-.327-.027-.299 0-.286 0-.653.177-.136.068-.218.136-.177.136zm2 .068s0-.027-.027-.027l-.014.014.014.041c.014 0 .027 0 .027-.027m-8.231-.095.15-.082.027-.19.027-.163h-.15c-.177 0-.245.027-.34.163l-.082.095a.14.14 0 0 0-.068.014c-.041.041.095.204.177.218l.095.014zm10.939-.095-.027-.014-.054-.027c-.109.163-.109.19-.014.109zm-12.857.082c0-.041-.095-.122-.136-.109-.027.014-.014.027.041.068.095.068.095.068.095.041m2.558-.177c0-.122 0-.136-.054-.136-.095-.027-.109 0-.109.122 0 .136 0 .136.095.136.068 0 .068 0 .068-.122m-2.803.054.122-.041c0-.041-.163-.435-.177-.435-.109 0-.327.041-.381.068-.068.041-.068.041-.041.136.041.068.15.218.177.19l-.054-.136c-.068-.109-.068-.136 0-.136a4 4 0 0 0 .272-.054c.027.014.109.299.109.313l-.136.041-.109.082c-.014.027 0 .027.218-.027m2.585-.082c0-.109.014-.136.068-.163.054-.041.068-.041.122 0 .054.027.068.054.068.163l.027.136.136-.054.095-.054-.014-.245-.027-.272h-.327l-.299.014-.014.082-.027.286-.014.231h.218v-.122Zm10.83.109-.109-.068-.136-.054c-.014-.014.054-.286.082-.313l.136.014.163.027c.054.014.054.027-.027.177l-.027.109c.041-.027.136-.15.177-.218.027-.068.027-.068-.054-.109-.095-.041-.381-.082-.408-.068l-.027.054-.068.19c-.041.095-.068.177-.054.19l.327.082zm-12.803-.095-.054-.082c-.041-.054-.054-.068-.068-.027 0 .014-.027.041-.068.041-.163.041-.177.027-.245-.109l-.054-.15h.122l.109-.014c0-.041-.014-.054-.177-.068l-.15-.014.014.068c0 .054.041.136.082.231l.068.136h.175l.218-.014Zm2.721 0c.068-.027.082-.041.068-.095l-.014-.136c0-.054-.027-.082-.122-.15a.3.3 0 0 0-.136-.082v.327c.027.177.041.19.204.136m9.714-.136a.54.54 0 0 0 .082-.218l.014-.068h-.136c-.136.027-.163.041-.163.068 0 .014.041.027.095.027h.109l-.054.15c-.068.136-.068.136-.231.109-.068 0-.082-.014-.082-.041.027-.054 0-.041-.054.014-.068.095-.054.109.163.109h.204l.054-.136Zm-13.17.109c.082-.027.095-.054.027-.19-.014-.068-.027-.068-.122-.054l-.109.027c-.014.014.095.245.109.245 0 0 .054 0 .095-.027m13.606-.095.041-.122-.136-.027-.109-.014-.027.109a1 1 0 0 0-.041.122c.163.082.204.068.272-.068m-13.062-.068c-.027-.095-.027-.095-.136-.082h-.082l.027.082c.027.068.041.068.122.068q.095 0 .068-.068m12.517 0c.054-.095.054-.095-.054-.095s-.109 0-.136.109c0 .054 0 .054.082.054.068 0 .082 0 .109-.068m-13.647.027.095-.027c.082 0 .095 0 .068-.082-.014-.027-.027-.027-.136.014-.122.054-.122.054-.095.095a.04.04 0 0 0 .068 0m8.708-.054a8 8 0 0 1-.544-.395c-.027.027.027.068.354.299.122.095.218.15.231.136 0 0 0-.027-.027-.041Zm2.027.054c.014 0 .041-.027.041-.054 0-.054-.041-.054-.068 0-.014.041-.068.041-.095 0-.027-.054-.027-.054-.027 0 0 .041-.082.041-.109 0 0-.041-.014-.041-.027-.014-.054.068-.027.095.109.095l.177-.014Zm3.918-.014c0-.027-.054-.054-.109-.082l-.095-.041-.014.054c-.027.041-.014.041.068.054l.109.027c.027.041.054.027.041-.014m-14.64-.122.109-.068-.027-.136a2 2 0 0 1-.054-.272c0-.095-.014-.163-.027-.163-.041 0-.422.136-.449.163s.041.272.095.34c.068.068.082.041.014-.136-.041-.109-.041-.163-.027-.163l.313-.095.082.408-.095.068c-.095.054-.109.068-.082.109.027.014.027.014.15-.054m14.735.027-.095-.068-.109-.054.041-.136a1 1 0 0 0 .027-.19c0-.109.027-.122.19-.068.095.027.163.068.163.082l-.082.272c-.014.041-.014.041.027.014.054-.027.163-.313.136-.354a2.3 2.3 0 0 0-.408-.136l-.068-.014-.041.231-.041.286c-.014.054 0 .068.095.109.109.068.136.068.163.027m-6-.136c0-.082 0-.136-.014-.109l-.027.068c0 .027-.014.027-.054 0-.027-.041-.041-.068-.027-.136l-.014-.095c-.014 0-.027.027-.027.068 0 .068-.041.095-.095.041-.027-.027-.041-.068-.041-.136 0-.082-.014-.109-.041-.109s-.041.027-.041.068c0 .082 0 .095-.095.014-.054-.041-.068-.068-.054-.136.014-.095-.041-.15-.163-.177l-.095-.014v.109c0 .095 0 .095-.082.095s-.082 0-.082-.082c0-.068 0-.082-.082-.082h-.108v.163l-.095.014h-.095v-.082c0-.095 0-.095-.068-.095-.122 0-.136.014-.136.109s0 .095-.095.095h-.095v-.095c0-.082 0-.095-.068-.095s-.068 0-.068.095c0 .054-.014.095-.027.095-.136.027-.177 0-.163-.095.014-.054 0-.068-.041-.068h-.068v.299c.027.014.735 0 1.238-.027h.272l.299.218.313.231v-.136Zm-8.844.014c.054-.014.082-.041.068-.068l-.027-.163-.027-.136c-.014 0-.204.041-.218.068-.014 0 .095.34.122.34zm14.913-.058.054-.177c.014-.068 0-.082-.054-.095-.136-.054-.15-.054-.177.109l-.041.177.15.082zm-14.354 0c.177-.027.19-.027.177-.082l-.027-.218-.014-.177-.15-.014c-.204-.027-.313-.027-.354 0-.027.014-.027.054 0 .204 0 .109.027.231.041.272.027.082.041.095.082.082l.245-.054Zm-.272-.15-.041-.204-.014-.054h.395l.014.122c.027.19.014.204-.136.231l-.177.041zm.218.054c.095-.027.109-.041.095-.163l-.027-.109H4.3v.136c.027.136.041.177.082.163zm14.041 0 .041-.286q.027-.095-.068-.122c-.082 0-.408 0-.449.027l-.027.136-.014.218-.027.095.19.027.218.054c.082.041.095.014.136-.163Zm-.299.041a1 1 0 0 1-.136-.041v-.312h.408l-.014.136c-.027.272-.027.272-.259.218m.177-.054.027-.136.014-.122h-.299v.109l-.014.122.245.068s.027-.014.027-.041m-14.912.136c.041-.027 0-.109-.027-.109-.054 0-.082.041-.054.095.027.041.041.041.082.014m15.81 0c.027-.041.027-.054 0-.082-.041-.041-.082-.027-.082.041s.041.082.082.027Zm-15.674-.041-.041-.15-.041-.136-.122.082c-.068.041-.122.095-.122.109 0 .041.041.041.109-.014.082-.068.095-.054.136.054.027.068.082.095.082.054m1.401 0c0-.041-.054-.068-.136-.082-.054 0-.068 0-.068-.109a.26.26 0 0 0-.054-.163l-.041-.054v.136c.041.272.041.272.15.272l.136.014v-.014Zm12.912-.027.027-.19v-.177l-.041.068a.27.27 0 0 0-.041.15c0 .095 0 .109-.068.109s-.122.027-.122.068a.54.54 0 0 0 .245-.027m1.238-.041c.027-.095.041-.109.109-.054s.136.068.136.027l-.136-.109-.109-.068-.027.054a1 1 0 0 0-.041.136c-.014.068 0 .082.027.082.014 0 .041-.027.041-.068m-11.157-.027a.4.4 0 0 0-.082-.068c-.027 0-.054-.041-.068-.082 0-.068-.068-.095-.068-.027l-.014.041h-.041c-.027.014-.041 0-.054-.027l-.014-.054-.027.054c-.027.054-.082.068-.109 0-.014-.027-.041-.041-.054-.041l-.014.041c0 .027-.014.041-.054.041s-.041 0-.041-.041q0-.041-.041-.041c-.041 0-.027.014-.027.041s-.014.041-.054.041-.041 0-.041-.041c0-.027 0-.041-.027-.041s0 .027 0 .068v.068h.68l.095.054c.109.082.15.095.068.014Zm3.796-.014c.299-.014.34-.027.34-.054s-.027-.041-.041-.041l-1.252.054c-.15 0-.204.014-.204.041 0 .041.068.041 1.156 0m-6.912-.082c-.027-.014-.041.014-.027.054.014.014.027.014.027 0zm-1.497-.054c.136-.095.15-.095.136-.177l-.014-.259-.014-.177-.136.054c-.177.082-.354.204-.354.245l.082.313c.014.041.082.041.068 0l-.041-.136-.027-.136c-.014-.027.027-.068.15-.136l.177-.082.014.19v.177l-.136.095c-.068.041-.122.095-.109.109.014.027.054.014.218-.095Zm16.096.082c0-.014-.054-.068-.136-.122-.122-.082-.136-.095-.122-.163l.027-.19.014-.109c.041 0 .299.177.313.204 0 0 0 .095-.027.177-.041.177-.041.177 0 .15.041 0 .054-.068.082-.204.027-.177.027-.177-.027-.218a2 2 0 0 0-.408-.204c-.041 0-.068.49 0 .517l.136.109c.109.082.136.082.136.054Zm-6.912-.041-.014-.041-.027.041c0 .014 0 .041.027.041s.014-.027.014-.041m-9.714-.014.027-.054c0-.027-.027 0-.054.041-.041.041-.014.054.027.014m17.007-.014-.068-.041c-.014 0-.014.027 0 .054.082.041.109.027.054-.014Zm-17.007-.136c.027-.054.082 0 .082.054 0 .027 0 .054.041.054.027 0 .027-.014.014-.109-.027-.19-.041-.19-.177-.054-.095.095-.109.136-.082.163.014.027.027.014.082-.027l.054-.095Zm17.007-.054-.136-.122-.041.095-.027.136c0 .041 0 .054.041.054s.054-.014.054-.068 0-.068.027-.068.041 0 .041.027.027.041.054.082.054.041.082.027c.027-.027 0-.054-.095-.15Zm-.354.014.027-.122a.7.7 0 0 0-.231-.136s-.027.054-.014.136c0 .136 0 .136.082.204l.095.041zm-16.191.068c.082-.068.082-.068.068-.19l-.027-.122a.4.4 0 0 0-.109.054c-.095.054-.109.068-.095.122l.027.136.027.054c0 .054.054-.027.109-.054m9.048-.027-.014-.054c-.027 0-.054.068-.041.095.027.041.054.014.054-.041m-9.565-.109c.15-.136.15-.136.136-.259 0-.095-.014-.109-.041-.082-.027.014-.027.054-.027.109s-.014.095-.122.19c-.109.109-.136.177-.109.177zm17.13-.041c-.122-.109-.136-.136-.136-.19.027-.068 0-.136-.041-.136-.014 0-.027.054-.027.136l.027.122c.027 0 .068.054.136.136l.136.095c.027-.014-.014-.068-.095-.163m-16.191.095a.7.7 0 0 1 .218-.068l.109-.027.014-.218c0-.109.014-.218 0-.218a2.3 2.3 0 0 0-.476.068c-.041.014-.041.041-.041.245s0 .272.041.272zm-.109-.204v-.19c0-.014.041-.027.095-.027.041 0 .122 0 .177-.027h.095v.286l-.109.041-.177.054-.082.027zm.177.054c.136-.041.15-.054.15-.163v-.095l-.095.027c-.19.027-.19.027-.19.136 0 .068 0 .136.027.136zm15.293.122.014-.245c0-.163 0-.177-.054-.204a1.5 1.5 0 0 0-.476-.041v.218l.027.204.122.027a.7.7 0 0 1 .218.068c.136.054.136.054.15-.027m-.245-.068-.163-.068-.027-.163c-.014-.136-.014-.136.041-.136l.19.027.15.041c.027.027 0 .34-.027.34a1 1 0 0 1-.163-.041m.136-.136c0-.136 0-.136-.163-.163h-.109v.204l.109.027c.177.054.177.054.177-.068Zm-16.286.136c.109-.136.15-.231.054-.136-.068.054-.204.259-.177.245l.122-.122Zm8.191.095-.027-.054c-.027-.014-.041 0-.054.014v.041c.027.027.082.027.082 0m.327 0c0-.027-.068-.082-.082-.068-.027.027 0 .082.054.082zm8.871 0c0-.041-.231-.313-.245-.272 0 0 .041.082.109.15.136.136.136.163.136.122m-8.476-.027-.041-.041c-.041-.027-.054-.027-.054.014s.027.054.054.054.041 0 .041-.027m.354 0c0-.054-.068-.109-.082-.068-.027.041 0 .095.041.095q.041 0 .041-.041Zm-9.374-.082a2.2 2.2 0 0 1 .449-.476c.218-.177.34-.245.639-.367.163-.068.204-.095.136-.082-.122.014-.517.177-.667.272a2.1 2.1 0 0 0-.639.558c-.082.109-.095.109-.054.136.054.054.068.054.136-.041m17.619.054c.041-.027.041-.027-.027-.136a2.53 2.53 0 0 0-1.333-.844l-.095-.014.095.041.19.068c.313.109.707.408.98.762l.136.15zm-18.085-.028c.041-.027.095-.041.136-.027.068 0 .095 0 .122-.041l.177-.218a2.38 2.38 0 0 1 1.401-.748 13 13 0 0 1-.463-.952c-.014-.068-.054-.068-.354.027a4 4 0 0 0-.816.395 3.24 3.24 0 0 0-1.116 1.306l.068-.014c.068-.041.299-.014.422.041l.218.15.122.109.082-.041Zm18.613-.095c.245-.19.463-.245.626-.163l.082.041-.068-.122-.068-.136-.082-.136a3.36 3.36 0 0 0-2.041-1.429 36 36 0 0 0-.517.993s.082.041.19.054a2.45 2.45 0 0 1 1.347.871c.068.095.082.109.163.095.041 0 .095 0 .136.027l.054.027zm-16.136.041c-.014-.014-.054-.027-.122-.027l-.204-.014c-.095-.014-.109-.027-.109-.095l.014-.122c.014-.054.027-.054.122-.041s.109.014.082-.027c-.014-.041-.054-.054-.095-.054h-.095c-.041-.027-.054.014-.082.245l-.014.163h.259c.204 0 .259 0 .245-.027m13.932-.014-.041-.381h-.109a.26.26 0 0 0-.136.068c-.014.041 0 .041.082.027.109-.014.109-.014.136.054v.136c0 .054 0 .054-.354.082q-.061 0-.082.041c0 .014.054.027.245.014.204 0 .259-.014.259-.041m-14.014-.095c.027-.041-.095-.136-.177-.15-.068 0-.082 0-.095.041-.027.095-.027.095.109.109l.136.014zm13.837 0c.068 0 .082 0 .082-.054 0-.095-.027-.109-.136-.095-.15.041-.245.19-.095.163zm-15.238-.082.259-.136c.122-.041.136-.054.136-.136a6 6 0 0 1 .054-.272c-.027-.027-.082.041-.095.109l-.027.136c0 .054-.041.082-.19.15l-.19.082v-.082c0-.068 0-.068-.027-.068-.054.027-.068.082-.054.19l.027.109.122-.082Zm16.556-.056c0-.082-.014-.122-.041-.136-.014 0-.027.014-.014.054v.082c-.041.014-.367-.136-.381-.19l-.041-.136c0-.095-.054-.177-.082-.15l.054.354a6 6 0 0 0 .408.218c.082.068.109.041.095-.095m-18.449-.041.054-.109-.15-.082c-.15-.082-.163-.082-.204-.041s-.041.122.014.19c.027.027.177.136.204.136zm20.381.054c.136-.082.177-.136.177-.204 0-.136-.041-.136-.218-.041-.095.041-.163.082-.15.095.095.218.095.204.19.15M3.33 15.116c.109-.054.122-.068.136-.163v-.095s-.082.027-.15.082c-.109.068-.136.095-.136.163v.068l.15-.068Zm16.286 0c0-.068-.027-.095-.136-.177-.163-.122-.19-.122-.163 0 0 .068.027.109.041.109l.122.068c.136.068.136.068.136 0m-15.755-.054.231-.027c.068 0 .082 0 .109-.082.041-.19 0-.272-.054-.109-.014.054-.041.109-.068.122-.041.027-.34.054-.367.041v-.15c.041-.136.041-.177 0-.136-.027.027-.095.34-.082.367h.054zm15.293-.014c0-.136-.095-.381-.136-.34l.027.136c.054.177.054.177-.136.15-.204-.014-.245-.027-.272-.136l-.041-.095c-.054 0-.054.054-.014.163s.041.109.136.109l.245.041.177.027v-.054Zm-14.8-.014c0-.014 0-.027-.027-.041-.027 0-.041-.027-.041-.054 0-.041-.027-.082-.054-.054l-.014.082c-.014.054-.014.068.027.068.095.027.109.027.109 0m14.164 0-.014-.095-.027-.082-.027.068c0 .027-.027.068-.041.068-.054.041-.027.068.041.054l.068-.027Zm-17.116-.109.068-.109-.19-.109a8 8 0 0 1-.544-.313c-.027.027-.041.109-.041.19s.163.204.395.34l.231.109zm20.245 0 .272-.177c.109-.095.136-.231.095-.313-.027-.041-.041-.041-.272.095a11 11 0 0 1-.476.299l.136.204.245-.122ZM4 14.926c.041 0 .054-.041.095-.136.054-.19.027-.204-.163-.136-.136.027-.15.041-.163.122l-.027.136c-.014.054 0 .054.095.041zm14.98 0-.027-.136c-.027-.109-.027-.109-.163-.15-.177-.054-.204-.027-.136.15.041.136.027.136.245.163h.068l.027-.014Zm-17.388-.272.068-.095-.299-.177a10 10 0 0 1-.816-.503l-.054.041c-.041.082.041.231.163.327.272.204.776.517.83.517.014 0 .068-.041.109-.095Zm19.932-.041c.354-.204.558-.354.653-.449.054-.082.068-.109.068-.19-.014-.122-.068-.136-.19-.027a7 7 0 0 1-.966.612.7.7 0 0 0 .163.19zm-8.163-.082v.082zm-5.442.068h-.136zm.259 0h-.136zm6.531 0h-.151.177Zm.272 0h-.068l.027.014h.041Zm-5.401-.34.571-.272c.136-.054.136-.095.095-.136-.027-.014-.204.068-.694.299l-.68.313.041.054.041.054.095-.054.544-.259Zm1.905.259c0-.068.068-.136.095-.122h.082c.054-.027.136 0 .136.054s.054.054.136.014c.082-.027.095-.041.082-.109-.014-.082 0-.095.095-.177.095-.068.095-.068.163 0l.054.054.082-.082.082-.082-.054-.054c-.054-.082-.041-.136.041-.218.054-.054.082-.068.136-.054h.082c0-.027-.041-.041-.109-.054l-.218-.054-.109-.041-.109.136c-.354.408-.816.476-1.279.231a1 1 0 0 1-.327-.272l-.068-.095-.109.041a.6.6 0 0 1-.218.054c-.136.027-.136.068-.014.054h.095l.068.095c.054.082.041.136-.027.19-.027.027-.027.041.054.122.095.082.095.082.136.027.027-.041.068-.041.177.014.082.041.082.054.082.136-.014.082 0 .095.082.136l.082.041.068-.068.095-.068.082.027c.082.014.136.054.136.122 0 .054 0 .054.095.041.095 0 .122 0 .122-.054Zm1.279-.068-.014.041v.054Zm1.075.014c-.041-.041-1.293-.612-1.32-.612s-.041.027-.054.041c0 .041.027.054.544.299l.544.272c.204.095.204.095.245.054.027-.014.041-.041.041-.054m-12.014-.095s-.177-.136-.408-.272a6 6 0 0 1-.857-.68c-.204-.177-.218-.177-.245-.136-.041.054-.041.136.014.259.068.122.136.177.327.327.231.177.408.272.748.49l.286.163.068-.054zm19.592-.068c.776-.463 1.088-.748 1.034-.939-.041-.136-.054-.136-.327.109a8 8 0 0 1-.912.68l-.327.218.082.082.082.068zm-12.381.027a138 138 0 0 0 1.129-.544h-.136c-.095 0-.177.041-.435.163l-.558.272c-.204.095-.218.109-.204.136l.041.054.177-.082Zm4.857.041c0-.014.014-.041 0-.054l-.34-.163-.816-.367c-.027.014-.068.014-.109 0a32 32 0 0 0 1.211.612zm-12.027-.068-.041-.068a1.5 1.5 0 0 0-.476-.544 9.4 9.4 0 0 1-1.143-1.088c-.027 0-.041.041-.054.095-.054.177 0 .272.218.49a6.5 6.5 0 0 0 1.497 1.116m19.157-.068.367-.259c.503-.34 1.088-.857 1.184-1.048.054-.109.041-.272-.014-.313-.027-.027-.054 0-.163.122a9.5 9.5 0 0 1-.993.939c-.286.231-.327.272-.435.449l-.095.19.136-.082Zm-18.847-.179s-.095-.19-.259-.408c-.381-.517-.422-.571-.517-.517-.109.054-.054.204.34.871l.177.286.122-.109zm6.871.095.531-.245.286-.136h-.122c-.095-.014-.163.014-.517.177-.367.177-.435.231-.435.299q0 .027.259-.095m4.884.054c0-.041-.014-.068-.054-.082l-.408-.19c-.272-.122-.408-.177-.49-.177h-.109l.231.122a44 44 0 0 1 .816.395v-.068Zm7.007-.136c.204-.354.422-.748.435-.816 0-.054 0-.082-.027-.109-.109-.095-.19 0-.626.626l-.177.272.122.109.136.122zm-11.769-.15q.34-.163.272-.19c-.082-.014-.109 0-.327.095l-.272.122-.027.027c0 .041-.014.109 0 .109zm4.735.136V14c0-.027-.095-.082-.272-.163-.245-.122-.272-.136-.354-.109l-.082.014.299.136.34.177c.041.027.082.027.068 0m-2.177-.068a.8.8 0 0 0 .299-.218l.15-.163c0-.027-.204-.136-.245-.136l-.082.095-.177.136c-.095.054-.136.068-.299.068-.231 0-.313-.027-.476-.19l-.109-.109-.109.054-.136.068c0 .041.163.218.245.272.095.054.163.095.395.177.082.027.408 0 .544-.054m-9.402-.027c.054-.041.082-.082.109-.231.122-.544.163-1.088.095-1.265-.041-.095-.095-.136-.163-.109-.054 0-.054.027-.054.245 0 .231-.041.68-.109 1.088-.027.19-.027.245 0 .272.027.068.027.068.122 0m18.232-.095a10 10 0 0 1-.136-1.265c-.027-.272-.054-.299-.15-.218-.082.054-.095.136-.095.381 0 .231.014.435.095.857.054.272.054.272.136.34l.082.054.041-.054c.027-.027.041-.068.027-.095m-11.51-.068c.109-.054.204-.095.19-.109-.027-.041-.15-.027-.272.041-.109.041-.136.068-.136.109v.054zm4.857.041c0-.041-.027-.068-.136-.109-.136-.082-.272-.095-.272-.027 0 .014 0 .027.027.027l.19.082c.19.095.19.095.19.027m-11.674-.762c.041-.327.041-.68.014-.871-.014-.136-.109-.245-.231-.245-.082 0-.082 0-.068.068.027.136.041 1.197.027 1.388l-.027.177.095.136.095.136.027-.231.068-.544Zm.327.735.122-.068c.027 0 .054-.027.068-.041.082-.095.15-.735.095-.857-.027-.095-.122-.136-.177-.122-.041.027-.041.054-.054.177a5 5 0 0 1-.109.748c-.041.231-.041.231.054.163m17.715.027-.054-.231-.082-.544-.041-.34h-.082c-.177.027-.204.231-.109.762l.041.19.299.163zm.435-.136.068-.095-.027-.463v-.816c.027-.19.027-.354.014-.367-.027-.027-.177.027-.218.095-.095.122-.109.286-.054.762a5.3 5.3 0 0 0 .136 1.007l.082-.109Zm-19.21-.028-.082-.136a10 10 0 0 1-1.279-1.674.6.6 0 0 0-.095.231c0 .163.272.531.762 1.02.245.245.735.653.776.653l-.054-.109Zm19.728.095.245-.204c.327-.259.599-.544.898-.884.354-.395.34-.395.34-.544 0-.109 0-.136-.054-.204l-.068-.054-.177.272a11 11 0 0 1-.857 1.088 2.2 2.2 0 0 0-.367.544c-.014.014.027.014.054 0Zm-9.66-.068c.109-.027.313-.19.313-.245 0 0 0-.027-.041-.027a1 1 0 0 1-.095-.068l-.068-.041-.054.054c-.054.041-.082.041-.259.041-.15 0-.218 0-.259-.041-.054-.041-.054-.041-.15.014l-.095.082a1.2 1.2 0 0 0 .231.204.58.58 0 0 0 .476.041Zm-8.436-.231q.061-.367-.122-.367h-.082l-.027.177c0 .095-.027.218-.041.272l-.014.122.136-.054c.136-.054.136-.068.15-.15m16.735.041-.054-.272c-.014-.163-.068-.204-.163-.109-.054.041-.054.068-.054.177 0 .204.027.259.136.299.163.068.163.068.136-.095m-17.906-.586c0-.435-.054-1.061-.109-1.184l-.082-.122c-.068-.041-.163-.041-.177 0l.054.395c.095.476.122.667.136 1.048 0 .313 0 .327.082.408l.054.082.014-.136zm1.361.585c.068-.014.082-.027.054-.054-.041-.041-.15-.041-.163 0-.041.095-.027.095.109.054m16.259 0-.014-.068h-.082c-.109 0-.136.054-.027.082.122.027.136.014.122-.014m1.347-.068c.054-.068.054-.109.054-.272 0-.299.054-.694.136-1.129l.068-.435c-.027-.041-.136-.027-.19.027-.095.068-.136.204-.163.667a6.4 6.4 0 0 0 0 1.225c.014.027.027.027.095-.082m-17.415 0-.095-.19c-.054-.027-.095-.014-.068.054.027.109.177.231.177.136Zm15.851-.027c.027-.027.068-.082.068-.136.027-.054.014-.068-.027-.041-.054.014-.163.177-.15.218.014.027.054.014.109-.041m-16.068-.054-.014-.109c-.041-.095-.014-.122.054-.082l.054.014c.027-.027-.041-.082-.136-.095l-.068-.027.014.109.027.15c0 .054.041.082.068.041m16.259-.041c0-.027 0-.095.027-.15v-.11l-.082.027c-.095.014-.136.041-.136.082 0 .027.027.014.122-.014.041-.014.041 0 .027.054l-.027.136c-.014.014 0 .027.027.027s.041 0 .041-.054m-18.366-.395c-.231-.34-.544-.884-.735-1.293-.136-.245-.19-.354-.218-.354-.068 0-.15.095-.163.163-.027.136.027.272.245.585a8.6 8.6 0 0 0 1.007 1.225c0-.068-.027-.136-.136-.327m20.449.178c.272-.313.544-.653.762-.98.272-.408.313-.49.327-.599 0-.082-.014-.109-.068-.177-.041-.041-.082-.068-.109-.068s-.095.122-.231.381c-.218.435-.517.952-.721 1.265-.109.163-.136.231-.136.299v.082zm-19.919-.177a4.5 4.5 0 0 0-.122-.912c-.109-.585-.136-.68-.245-.735-.068-.041-.19-.041-.218 0l.027.136a6 6 0 0 1 .259.816 7 7 0 0 1 .177.789c.014.109.095.272.136.272v-.366Zm19.388.272.068-.204a13 13 0 0 1 .476-1.755l-.095-.014c-.19 0-.272.122-.34.49l-.082.463c-.068.408-.136 1.061-.082 1.061 0 0 .041-.014.054-.054Zm-12.925-.014a1 1 0 0 0-.068-.082q-.041-.082 0 0l.082.136zm.367-.027c-.095-.109-.095-.109-.082-.068.027.041.109.136.136.136zm-.585.041-.054-.068-.068-.054.054.068zm6.708-.095c.041-.068.014-.054-.041.027-.041.054-.041.068-.014.054zm-.98-.014.068-.095-.095.095-.082.082zm-12.245-.054-.49-1.102a5 5 0 0 0-.435-.898c-.095-.109-.259-.041-.259.095s.585 1.211.939 1.769c.136.204.136.218.19.19.027 0 .041-.027.027-.041Zm20.123-.15c.245-.381.721-1.252.871-1.605.082-.177.027-.313-.109-.313-.095 0-.177.122-.381.599l-.177.449-.163.395-.19.449c-.068.136-.082.19-.054.218.027.041.054.027.204-.204Zm-20.014.095a7.4 7.4 0 0 0-.286-1.088c-.15-.531-.272-.816-.381-.884-.082-.054-.231-.054-.245 0a1.1 1.1 0 0 0 .122.327l.476 1.088.26.64c.027.068.068.041.041-.068Zm19.742.014a155 155 0 0 0 .762-1.769c.109-.218.095-.272-.041-.272-.204 0-.367.34-.612 1.279a2.8 2.8 0 0 0-.177.857c.027 0 .054-.041.082-.095Zm-17.96 0-.068-.054c-.054-.014-.054-.027-.054-.177 0-.109 0-.177-.027-.204-.041-.041-.041-.027-.041.136 0 .245.027.299.095.327.095.027.109.014.095-.027m16.245 0c.041-.027.068-.463.027-.463-.027 0-.041.068-.054.245 0 .122 0 .136-.068.163-.095.041-.082.109.014.082zm-16.449-.069-.014-.231v-.177l-.109-.027c-.15-.027-.354-.054-.367-.027v.136c0 .068.027.109.041.109.027 0 .041-.027.027-.095l-.014-.095h.136c.218.041.204.027.204.218 0 .163 0 .177-.041.177-.068 0-.041.054.027.068.109.041.122.027.109-.068Zm7.279.054.014-.082.082-.204a.993.993 0 0 1 1.864.19l.027.122h.163l.15.014-.014-.068-.027-.109c0-.041 0-.082.054-.122l.068-.068-.041-.095c-.041-.109-.054-.109-.109-.082-.068.027-.109.014-.163-.068-.041-.068-.041-.122 0-.204.027-.041.014-.054-.041-.122l-.082-.068-.068.054c-.068.041-.068.041-.136 0-.095-.068-.136-.109-.109-.177 0-.068 0-.082-.095-.136-.082-.027-.109-.041-.109 0 0 .054-.082.136-.136.109l-.082-.027c-.054 0-.109-.054-.109-.095 0-.054-.041-.095-.109-.095q-.122 0-.122.082c0 .068-.027.095-.136.122-.095.027-.109.014-.163-.041l-.054-.082-.095.041c-.082.041-.082.054-.082.136s0 .109-.082.15c-.082.054-.136.054-.19 0-.027-.041-.041-.041-.122.041s-.082.082-.041.136c.054.041.054.082 0 .177-.041.082-.109.109-.177.068-.041-.014-.054 0-.095.095-.041.082-.041.109-.014.109l.068.054q.061.082 0 .245c-.027.027 0 .041.136.041s.163 0 .177-.041m9.388.014.041-.027-.041-.041c-.027 0-.041-.041-.041-.177 0-.19 0-.19.231-.204h.109v.082c0 .068 0 .095.014.082.041 0 .082-.19.054-.231 0-.027-.245 0-.381.027l-.095.027v.408c-.027.082-.014.082.014.068h.082Zm-9.864-.027c.027-.014-.027-.041-.218-.122l-.272-.082v.068c0 .068.027.082.163.109.177.041.259.054.327.027m.762 0c.027 0 .068-.068.095-.136a.68.68 0 0 1 .368-.313c.286-.136.68.014.816.327.068.136.095.15.245.15h.109l-.014-.068a1.2 1.2 0 0 0-.286-.49.952.952 0 0 0-1.497.286.8.8 0 0 0-.054.203c0 .054 0 .054.095.054h.136Zm2.449-.027c.136-.041.163-.054.177-.109l.014-.068a2.5 2.5 0 0 0-.517.204c.068.027.15.014.327-.027m-2.041-.054c.095-.082.449-.082.544 0 .027.027.082.041.177.041l.136-.014c0-.027-.122-.218-.163-.272-.15-.122-.463-.177-.639-.095a.72.72 0 0 0-.34.327c0 .041 0 .054.122.054.095 0 .136-.014.177-.041Zm-1.048-.041c0-.027-.245-.136-.612-.245-.027-.014-.041 0-.041.027l.027.068c.054.027.599.218.612.204zm3.02-.054c.19-.068.272-.109.272-.136.027-.082 0-.082-.163-.014l-.299.109c-.19.054-.19.054-.177.122 0 .027.027.041.054.027l.3-.109Zm6.436.068-.014-.014c-.014 0-.027.014-.027.041s0 .027.027.014zm-10.123-.096-.054-.408-.041-.272-.095-.041-.122-.082c-.014-.014-.027-.014-.027 0-.014.068.109.816.136.844l.204.082zm4.177.068c.027 0 .054-.082.082-.204l.095-.68-.136.068c-.095.068-.109.095-.109.163l-.054.367c-.027.177-.054.313-.041.327zm-10.572-.095c0-.109 0-.136-.054-.136l-.122-.027c-.054 0-.054 0-.054.054 0 .041.014.068.054.082a.2.2 0 0 1 .082.095c.054.109.095.082.095-.068m16.871.054c.027-.027.068-.082.109-.082.041-.027.054-.041.054-.082 0-.054 0-.054-.082-.054-.15.027-.15.027-.15.163l.014.136zm-10.817-.122a19 19 0 0 0-.109-.585c-.027-.177-.068-.272-.109-.272l-.082-.041c-.082-.068-.095-.054-.082.041l.136.816.218.122c.027 0 .027-.027.027-.082m4.789.027a.23.23 0 0 0 .122-.095l.027-.177a6 6 0 0 0 .109-.707s-.041 0-.068.027l-.122.095c-.041.027-.054.095-.109.367l-.068.544.122-.054Zm-3.89-.04c0-.041-.027-.054-.204-.122l-.272-.095-.082-.027c-.014.014-.014.095 0 .109l.517.19q.041 0 .041-.041Zm3.184-.041c.245-.082.259-.095.259-.15v-.081l-.272.109c-.245.082-.272.109-.299.15 0 .082 0 .082.313-.041Zm-4.408-.136c0-.082-.027-.122-.068-.136-.054-.027-.272 0-.272.027.014.041.218.177.245.177l.054.041q.061.082.041-.122Zm5.347.136c0-.027.027-.054.068-.068.272-.136.286-.19.136-.218-.15-.014-.218.027-.231.136-.027.136-.027.163 0 .163l.027-.027Zm-4.082-.068.014-.054c0-.014-.027-.041-.136-.082a2.4 2.4 0 0 1-.463-.19c-.054-.027-.068 0-.054.054 0 .041.041.068.109.095a15 15 0 0 1 .544.177Zm3.157-.109c.218-.082.272-.109.272-.15v-.068l-.272.095-.177.068c-.19.068-.218.082-.19.136.014.041.027.041.367-.082m-10.027 0c0-.068-.041-.245-.068-.218l-.027.082v.068l-.163-.014c-.095 0-.177-.027-.177-.027l.082-.408.122.041c.109.054.122.054.109.014 0-.041-.272-.136-.286-.122a1.5 1.5 0 0 0-.082.435v.109l.218.041c.245.041.272.041.272 0m16.966-.027c.054 0 .054 0 .054-.109s-.054-.408-.068-.449c-.027-.014-.286.082-.299.136 0 .027 0 .027.122-.014l.122-.054.054.408-.163.027-.15.014-.014-.095c-.027-.122-.054-.109-.082.027-.027.177 0 .177.19.136a2 2 0 0 1 .231-.027m-17.495-.149c0-.082 0-.204.027-.272.027-.109.027-.15 0-.163a.9.9 0 0 0-.327-.014c-.136 0-.136 0-.136.082l.014.068.027-.054c0-.041 0-.041.177-.041.19 0 .19-.027.136.272-.014.163-.014.19 0 .218.068.041.082.027.082-.109Zm17.674.082-.014-.218c-.027-.109-.027-.204-.027-.231s.054-.027.177-.027c.15 0 .163 0 .163.041q0 .041.041.041c.014 0 .027-.014.027-.068s0-.068-.054-.068h-.449l.027.19c.027.082.041.204.041.272 0 .095.014.122.068.068m-5.456-.299.041-.082c0-.014-.177.041-.177.068l-.136.122c-.15.095-.15.082-.109.15.014.041.027.041.163-.068zm-6.449.259c.041-.054.041-.068-.095-.136l-.177-.136c-.068-.054-.163-.082-.163-.054a1.6 1.6 0 0 0 .395.354zm-5.361-.069c.027-.177.014-.19-.136-.245-.068-.014-.068-.014-.095.204l-.027.082h.109l.109.027s.027-.027.027-.068ZM20 12.259v-.15c-.027-.122-.027-.136-.082-.122-.136.054-.15.054-.15.163l.014.136c.014.014.204 0 .231-.027Zm-17.551-.054.027-.177.014-.136h-.122c-.136 0-.163.054-.109.163l.054.136c.014.068.027.082.068.082.027 0 .054-.027.068-.068m6.027.054-.054-.068c-.027-.027-.041-.054-.027-.109a.47.47 0 0 0-.136-.313l-.15-.082c-.095-.041-.109-.041-.082 0l.027.136a.45.45 0 0 0 .231.286l.122.109c.027.054.068.082.068.041m.204 0-.054-.054c-.041 0-.095-.054-.136-.082-.041-.041-.068-.054-.068-.027 0 .054.068.122.15.15.095.041.109.041.109 0Zm5.51-.014c.054 0 .136-.082.136-.136 0-.014-.014-.014-.054.027l-.136.068c-.082.027-.109.082-.027.054zm.327-.15c.095-.068.177-.177.177-.272l.041-.109c.041-.054.027-.082-.027-.054a.15.15 0 0 1-.095.041c-.122.027-.245.231-.245.381 0 .041 0 .095-.027.122l-.041.068.068-.054.136-.136Zm5.959.027c.054-.19.041-.218-.082-.218l-.122.014c0 .014.027.272.054.327l.054.027c.041 0 .054-.041.095-.15m-11.823-.095c-.027-.109-.041-.136-.095-.163l-.109-.054q-.102-.061-.041.082c.041.109.218.313.245.272zm5.606.041c.041-.041.136-.245.122-.272l-.068.014-.109.041c-.082 0-.082.027-.109.204l-.014.136.068-.041.109-.068Zm-7.293-.218.136-.327a27 27 0 0 0 .367-.925l.054-.095-.082-.109a.5.5 0 0 0-.082-.122l-.136.272-.313.789c-.109.286-.218.544-.218.585-.014.041 0 .082.054.136l.082.082.136-.272Zm9.048.218.082-.109-.299-.748-.231-.544c-.136-.327-.19-.463-.19-.367l-.068.122c-.041.068-.054.095-.041.136l.272.639.163.422.136.327.095.19.082-.082Zm-8.055-.163c.027.014.054.027.068.014s-.041-.136-.082-.136l-.082-.122c-.054-.082-.082-.109-.15-.109h-.092v.109c.027.082.041.122.122.204s.095.082.136.054c.027-.027.041-.041.082-.014m7.17-.245v-.095c.041-.027.027-.027-.054-.014a.2.2 0 0 0-.136.054c0 .027-.054.095-.095.136l-.095.136c0 .054 0 .054.068.027.041-.027.054-.027.082 0 .041.041.041.041.136-.054s.109-.136.095-.19m-13.034.19c0-.027 0-.041-.041-.027h-.068c-.054 0-.041.082.027.082.068.014.082 0 .082-.054m18.721.014c0-.014 0-.027-.027-.027l-.068-.014c-.027 0-.041 0-.041.027v.054c.041.027.136 0 .136-.041M2.953 11.81c0-.027-.027-.054-.068-.068-.068-.027-.082-.054-.027-.136l.027-.109c0-.027 0-.041-.027 0-.041.014-.136.272-.136.272l.122.054.109.027zm3.81-.367.354-.844c.163-.408.177-.449.15-.517 0-.041-.041-.109-.068-.136l-.041-.054-.041.082a154 154 0 0 1-.68 1.701c.041.054.136.177.163.177l.177-.408Zm9.497.34.068-.109-.109-.299a9 9 0 0 1-.354-.857 20 20 0 0 1-.272-.639l-.068.136-.068.136.082.177a82 82 0 0 1 .381.925l.136.34.122.272zm3.701.027c.054 0 .095-.027.095-.041l-.136-.313-.027.027c-.014.014 0 .068.027.136.041.068.041.082.014.095a.1.1 0 0 1-.041.027c-.027 0-.095.068-.095.095h.041c.014 0 .068 0 .122-.027m-17.864-.054.054-.218.082-.245c0-.041 0-.041-.15-.027-.299.027-.517.136-.517.231 0 .054.054.041.082-.014.014-.041.054-.068.19-.095.095 0 .19-.041.218-.041.054-.041.068 0 .027.163s-.068.204-.136.204c-.041 0-.054.027-.014.054 0 .027.136 0 .163-.014m6.531.014-.231-.19a5.7 5.7 0 0 1-.762-.803c-.095-.122-.136-.15-.136-.109a5 5 0 0 0 1.116 1.102Zm5.701-.095a5.4 5.4 0 0 0 .952-1.007c0-.054-.054 0-.136.109a5.7 5.7 0 0 1-.993 1.007.6.6 0 0 0 .177-.109m6.517.082-.054-.054c-.054-.014-.095-.109-.136-.272 0-.082 0-.095.068-.082l.218.041c.136.027.163.041.19.095s.082.068.082.014c0-.068-.068-.136-.218-.177s-.449-.082-.449-.054l.054.204.054.231c0 .041.014.068.054.068h.136Zm-18.151-.053.095-.19c.041-.054.041-.122.041-.136a1.3 1.3 0 0 0-.408-.082h-.136l-.054.19c-.095.272-.095.272.136.272l.245.014c.054 0 .068 0 .082-.068m-.463-.027c0-.082.109-.327.136-.327l.177.041.177.027c.082.014-.014.068-.054.136l-.054.136h-.19zm.381-.122.041-.082-.259-.068c-.027 0-.054.068-.082.177-.014.054 0 .068.136.068s.136 0 .163-.095m5.85.204-.136-.109-.109-.082.014.068c.027.095.068.136.163.136zm6.027-.027.054-.109c0-.054 0-.054-.082.027-.095.082-.109.095-.068.122.054.014.054 0 .095-.041m6.123.014c0-.014-.095-.381-.136-.422-.014-.027-.054-.041-.136-.027-.136 0-.381.068-.408.095l.068.163.082.19a2.6 2.6 0 0 0 .531 0m-.531-.19-.054-.136.381-.054.068.136.054.163c0 .014-.041.027-.19.027h-.19zm.381.082-.027-.122c-.041-.109-.054-.122-.218-.082q-.109.027-.068.136c.027.068.027.068.177.068zm-12.49.054c-.014-.054.054-.095.095-.054l.082.027h.054l-.054-.082-.082-.136c-.014-.041-.041-.054-.068-.068a.17.17 0 0 1-.095-.068c-.054-.082-.054-.082-.054-.014l-.014.136c-.014.068 0 .095.041.19.068.109.109.136.095.068m6.939-.122c.041-.068.041-.095.014-.136l-.027-.122c0-.041 0-.041-.054.014-.027.041-.068.068-.082.068-.027 0-.19.245-.177.272l.095-.014c.095-.041.136-.014.122.041 0 .054 0 .054.027 0 .027 0 .068-.068.082-.122m-11.973.136c0-.041-.027-.054-.054-.041-.027 0 0 .054.027.054l.027-.027Zm4.626-.109c-.027-.082 0-.122.054-.109.054.027.054 0-.027-.095-.068-.082-.231-.204-.245-.19l-.027.068c-.054.095-.014.204.136.367.109.095.163.082.109-.041m7.782-.014c.136-.136.163-.218.122-.286l-.027-.082c0-.041 0-.041-.041 0l-.068.027c-.027 0-.218.218-.218.245h.027c.054-.014.082.054.054.109-.027.041-.027.122 0 .122l.136-.136Zm-13.374.095a.54.54 0 0 0 .069-.244c0-.041-.354.041-.367.082 0 0 .014.027.041.027s.082.027.109.068c.068.068.095.082.136.054Zm18.939-.027c0-.027.054-.068.109-.082.082-.041.082-.082 0-.082l-.177-.041-.136-.027.027.068v.095c0 .041.082.109.122.109zm-4.177-.68a5.1 5.1 0 0 0 .571-1.374c.027-.041.095-.408.082-.422-.027-.027-.041 0-.122.313a5.6 5.6 0 0 1-.816 1.823c-.095.136-.136.204-.109.231a2.5 2.5 0 0 0 .395-.571m-10.3.544s-.027-.082-.082-.136a6.8 6.8 0 0 1-.98-2.177 3 3 0 0 0 .163.626l.068.204c.014.054.068.15.082.231a5 5 0 0 0 .612 1.129c.095.136.109.163.136.136Zm1.361-.15c.014-.163 0-.272-.095-.327l-.109-.054-.041-.041c-.054-.054-.068-.014-.054.136a.47.47 0 0 0 .136.272l.122.122zm7.32.027c.109-.136.163-.259.163-.381 0-.109 0-.109-.041-.068l-.068.041-.109.068c-.068.054-.082.082-.095.177-.014.109.014.245.054.245zm-8.667-.041-.054-.053c-.027.027.054.109.082.095.014 0 0-.041-.027-.068Zm9.932-.027.068-.095-.082.068-.095.095c0 .054.041.027.109-.068m-14.83.068-.326-.366-.354-.354-.068.054c-.068.082-.054.177.054.218.054.014.122.082.163.136.082.109.082.122.19.109.109 0 .245.068.286.15.027.054.068.082.068.054Zm19.756-.082.041-.082-.068.068c-.054.027-.082.068-.068.082.014.027.041.014.095-.068M1.66 11.196c0-.136 0-.15-.19-.354a8 8 0 0 1-.544-.653c-.027-.068-.082-.068-.136 0-.041.068-.027.19.027.313.068.136.748.816.816.816.027 0 .027-.027.027-.136Zm19.592.054a6 6 0 0 0 .707-.762.4.4 0 0 0 .041-.177c0-.068-.054-.177-.109-.177l-.218.245-.381.476c-.19.204-.19.218-.19.327 0 .163.027.177.15.068m-18.395.029c0-.027-.068-.054-.231-.095l-.177-.041.054-.109c.068-.095.15-.15.218-.15q.041 0 .041-.041c0-.027-.014-.027-.082-.014-.109.027-.163.068-.259.218l-.082.136.177.041.231.054c.068.027.109.027.109 0m3.714-.082c.027-.068.027-.082 0-.122a1.1 1.1 0 0 0-.34-.163l-.082-.041c-.095-.082-.027.014.095.136.068.082.136.136.136.163s.095.136.122.136c.014 0 .054-.054.068-.109m9.81.027.109-.15c.014-.027.054-.082.095-.095.027 0 .068-.054.082-.095.054-.082.027-.095-.041-.027a.3.3 0 0 1-.109.068 1.1 1.1 0 0 0-.327.163c-.014.027.054.218.095.218zm3.85.014.218-.027c.027 0-.136-.272-.204-.327-.082-.054-.204-.082-.204-.041q0 .041.041.041c.068 0 .163.068.218.163l.041.095-.15.041-.204.054c-.054.027-.054.068 0 .054l.245-.041Zm-18.232 0 .19-.027c.095 0 .095 0 .177-.15l.082-.163-.054-.041a.41.41 0 0 0-.585.095c-.054.082-.082.136-.082.218v.122l.082-.027.177-.027Zm-.204-.054c-.027-.041.041-.19.136-.272a.26.26 0 0 1 .19-.068c.109 0 .218.027.218.068s-.095.204-.122.218c-.041.027-.408.082-.422.054m.367-.095c.027 0 .068-.054.082-.095.027-.054.027-.068 0-.095-.095-.054-.272 0-.354.109-.068.136-.054.136.095.122zm12.517.15c.027-.027-.082-.027-.925-.027a2441 2441 0 0 1-5.66 0c0 .068.082.068 3.306.068 2.857 0 3.265 0 3.279-.041m6.395-.054c0-.19-.163-.367-.34-.408a.54.54 0 0 0-.327.082l-.068.054.068.095.068.136c.027.054.041.068.218.082l.231.027c.122.054.136.041.136-.068Zm-.272 0-.218-.054c-.041-.014-.136-.177-.136-.218 0-.027.122-.068.218-.068s.218.054.272.136c.041.068.082.204.054.218l-.204-.027Zm.136-.095c-.054-.15-.272-.272-.395-.177-.027.027-.027.041 0 .109.041.054.082.082.136.082l.122.027h.082c.054 0 .068 0 .054-.041m.803.041c.054-.095.136-.163.204-.19s.082-.041.068-.122c0-.054-.027-.095-.054-.109-.041-.027-.068-.014-.299.231l-.272.272.163-.014c.136 0 .163-.014.19-.068m-18.953-.095c0-.095-.014-.109-.068-.109s-.19.136-.19.163l.054.041.136.027c.082.027.095 0 .068-.136Zm4.667 0c-.014-.177.027-.231.095-.15l.068.041c0-.014-.109-.177-.136-.177l-.136.327.109.109v-.136Zm7.946.109.054-.041-.054-.136c-.095-.245-.095-.245-.177-.136-.082.095-.068.136 0 .054.041-.041.054-.041.082-.027.027.027.027.068.027.177v.136s.041 0 .068-.027m4.721 0c.15-.027.136-.027.122-.095-.027-.054-.136-.122-.19-.122-.014 0-.041.027-.041.068l-.041.136c0 .054 0 .054.041.041zm-11.547-.015c0-.027-.041-.041-.299-.041-.272 0-.327.014-.286.054l.299.014c.245 0 .286 0 .286-.027m.177.014h-.068c-.027 0-.014.014.027.014h.041Zm1.156-.014c0-.068-.204-.082-.259-.027-.041.041-.027.054.122.054.095 0 .136 0 .136-.027m.367 0c0-.027-.027-.041-.122-.041-.122 0-.177.027-.136.054.027.027.245 0 .259-.027Zm.367 0c.014-.027-.054-.068-.163-.054-.068 0-.095.014-.109.041 0 .041.014.041.136.041l.136-.014Zm.299.014a.3.3 0 0 0-.082 0c-.027 0-.014.014.041.014h.054Zm.639 0c0-.054-.082-.082-.231-.068-.136 0-.177 0-.177.041-.014.041 0 .041.204.041zm.34 0h-.177Zm.449-.014c0-.041-.054-.054-.136-.054s-.136.014-.136.054c0 .027.027.041.136.027.095 0 .136 0 .136-.027m.354 0c0-.027-.027-.041-.109-.041-.122 0-.163.027-.136.054s.231 0 .245-.027Zm.395.014c0-.041-.068-.082-.15-.082s-.177.054-.136.082c.027.027.286.027.286 0m.272 0h-.052l.041.014h.041Zm.204 0h-.068c-.027 0-.014.014.027.014h.041Zm.286 0h-.177Zm.204 0h-.068c-.027 0-.014.014.027.014h.041Zm.68-.027c0-.014-.054-.027-.286-.027-.272 0-.354.014-.313.054.027.027.585 0 .599-.027m-5.143-.068.027-.109c0-.054.068-.15.122-.15s.109.095.109.163.068.136.095.095l.054-.027c.027-.014.041-.054.041-.177 0-.15 0-.163-.082-.231-.041-.027-.082-.068-.082-.095s-.136-.027-1.048-.027H7.805l-.027.095-.041.177c-.027.068-.014.082.054.177l.095.109h.367l.381.014c0 .014.19.027.476.027.408 0 .476 0 .503-.041m1.524 0c.027-.014.041-.068.041-.095 0-.095.054-.204.109-.218.136-.054.245.027.245.177s.054.177.299.177.272-.014.272-.136c0-.054.027-.095.041-.122.082-.095.177-.027.218.136.027.109.054.163.054.095 0-.027.014-.041.054-.041.054 0 .054 0 .054-.177 0-.136 0-.177-.041-.19-.082-.027-.109-.041-.095-.109v-.054h-2.041v.054c.041.041 0 .095-.068.109-.054 0-.054.027-.054.177 0 .136 0 .177.027.19l.054.027c.027.041.068 0 .068-.082s.082-.177.136-.177c.068 0 .136.082.136.163 0 .122.014.136.245.136.163 0 .231 0 .272-.041Zm1.714-.109c0-.054.014-.095.054-.109.095-.068.136-.041.204.177l.014.068h.98c0-.014.163-.027.367-.027h.354l.095-.109.095-.095-.041-.15-.054-.177c0-.027-.381-.027-1.048-.027h-1.034l-.041.082c-.027.041-.068.082-.095.082s-.027.027-.027.177c0 .177 0 .19.041.19.027 0 .054.014.054.041 0 .041 0 .041.041 0 .027-.027.041-.082.041-.136Zm-6.218.014c.027-.082.027-.109-.095-.299-.027-.041-.027-.054 0-.082s.014-.068-.068-.231l-.068-.136c.068.231.082.327.068.381l-.014.204c0 .136 0 .15.054.204l.082.054zm3.524-.122v-.204h.068c.082-.027.095-.082.014-.068a.14.14 0 0 1-.082 0c-.014-.027-.041-.014-.068 0 0 0-.041.014-.054 0l-.027.014.054.041c.041.027.041.054.041.231 0 .122 0 .204.027.204s.027-.095.027-.218m2.463 0c0-.163 0-.204.041-.218l.027-.041h-.027l-.041-.014c0-.027-.027-.027-.041-.014h-.095c-.095 0-.082.027 0 .068l.095.027v.204c0 .109 0 .19.027.19s.014-.082.014-.204m3.592.163c.054-.041.068-.068.068-.15l-.027-.204c-.027-.109-.014-.204.054-.367.068-.15.027-.095-.068.068a.6.6 0 0 0-.068.231c.014.027 0 .095-.054.177-.068.136-.068.136-.041.218l.054.082zm-14.443-.189c0-.041-.041-.109-.095-.177a7 7 0 0 1-.586-.843l-.136-.259-.068.068c-.082.068-.109.177-.082.286.027.095.327.517.612.816a8 8 0 0 1 .218.272l.041.054.054-.082a.22.22 0 0 0 .054-.136Zm8.068.15c0-.095-.054-.136-.109-.082l-.027.095c0 .041 0 .054.068.054.054 0 .068 0 .068-.068m.748.014c0-.068-.054-.136-.095-.122-.041.027-.082.136-.054.15l.082.027c.054 0 .068 0 .068-.054m.898-.027c0-.109-.041-.177-.122-.177-.068 0-.136.095-.136.204 0 .054 0 .054.136.054h.136v-.082Zm.816.014c0-.082-.054-.136-.109-.095l-.027.095c0 .054 0 .068.068.068s.068 0 .068-.068m.748 0c0-.014-.014-.068-.041-.082-.041-.054-.095 0-.095.082 0 .054 0 .068.068.068s.068 0 .068-.054Zm8.204-.136c.231-.272.517-.639.612-.803.109-.177.095-.354-.027-.463a8 8 0 0 1-.748 1.06c-.068.082-.095.136-.095.19s.068.19.095.19l.19-.19Zm-14.844.014c0-.068-.027-.082-.136-.136-.109-.041-.136-.054-.163-.163-.095-.204-.19-.408-.204-.395 0 .014.054.19.15.408l.054.177c0 .068.041.109.163.15.136.041.136.041.136-.041m10.123.014c.054-.027.082-.041.082-.082s.054-.204.136-.381l.054-.136.041-.136.041-.122-.054.095a6 6 0 0 1-.272.571l-.136.068c-.082.027-.095.041-.095.109s0 .082.068.068zm-13.946-.125.109-.109-.027-.163-.041-.15-.095.122a2 2 0 0 1-.177.204.4.4 0 0 0-.082.109l.177.095zm17.81.068c.041-.014.068-.041.068-.054l-.109-.163-.163-.218-.054-.054-.041.15-.027.163.109.109.136.109zm-18.449-.027a.4.4 0 0 1 .163-.041h.082l-.014-.109c-.041-.272-.19-.925-.218-.993q-.082-.163-.163-.082c-.068.054-.068.272 0 .816l.041.435c0 .027 0 .027.109-.027m4.748-.068c-.027-.054-.109-.136-.109-.109l.068.122c.054.122.095.109.041 0Zm14.259-.122c.068-.544.082-.912.041-.993-.068-.15-.204-.041-.245.218l-.177.884c-.014.027 0 .041.068.041.054 0 .136.014.177.041l.095.041zm-18.273.205c.041-.014.054-.082.014-.082l-.054.041q-.061.082.041.041m13.429-.082c.068-.136.041-.136-.027-.014l-.041.109zm4.027.068-.041-.054c-.041-.041-.041-.041-.041 0 0 .054.014.068.068.082zm-13.701-.15c.014-.068 0-.095-.027-.136l-.054-.095-.095-.272c-.136-.34-.163-.395-.19-.395 0 0-.014 0 0 .014l.136.354c.109.272.136.367.136.463 0 .109.014.136.068.136 0 0 .027-.027.027-.068m9.959.068c.027 0 .041-.041.027-.109 0-.054 0-.136.041-.204a13 13 0 0 1 .231-.653c-.027.014-.163.313-.245.571l-.095.19c-.027.041-.054.095-.041.109l.027.068c0 .041 0 .041.054.027m-14.014-.15c.231-.299.245-.313.218-.503l-.027-.19c0-.014-.068.054-.136.163a1.3 1.3 0 0 1-.177.272l-.082.095.027.15.054.15a.7.7 0 0 0 .136-.136Zm18.164.041.027-.136c0-.041-.014-.095-.095-.19l-.177-.272c-.027-.082-.068-.136-.082-.136l-.041.19-.027.177.109.177c.136.177.231.286.259.286 0 0 .027-.041.027-.095m-14.259 0c0-.054-.068-.177-.095-.177s0 .19.027.231c.027.027.054 0 .068-.054m.544-.054.068-.136-.054-.041c-.054-.041-.122-.054-.177-.041l-.054-.041c-.027-.014-.054-.027-.054 0v.027l.027.082c0 .054.136.272.19.272l.068-.122Zm9.252.054c.054-.082.136-.272.136-.327l-.054.014c-.027.027-.054.041-.068.027-.027-.014-.177.041-.204.082v.095c.027.027.041.082.054.122.027.082.054.082.136-.014m.49-.054.014-.109.027-.068-.082.082c-.068.082-.095.177-.054.218.027.014.109-.068.095-.122m-14.803.013-.027-.218c-.014-.136-.027-.19-.177-.408a7.3 7.3 0 0 1-.517-1.061c-.041-.027-.136.122-.163.218-.014.095.027.34.068.395a6 6 0 0 0 .531.816l.231.299c.027.054.054.027.041-.041Zm19.456-.163c.177-.231.367-.544.531-.803.163-.272.19-.476.082-.626l-.082-.082c-.014 0-.068.082-.109.177-.19.435-.381.816-.544 1.034-.041.068-.109.544-.068.544zm-4.327.068c.068-.136.122-.272.095-.272l-.027.041-.054.136c-.082.177-.082.19-.068.19zm-11.007-.068c0-.041-.027-.068-.041-.068s0 .095.041.136c.027.054.027 0 0-.068m4.218.027c0-.027-.204-.027-1.116-.027-1.048 0-1.116 0-1.129.027 0 .041.054.041 1.116.041.925 0 1.129-.014 1.129-.041m2.449.027c.027-.014.027-.027.027-.041a67 67 0 0 0-2.367 0v.027c.027.041 2.299.041 2.34 0Zm2.381 0c0-.082 0-.082-1.143-.068-.599 0-1.102.014-1.116.027-.041.054.095.054 1.143.054zm-8.762-.327c-.109-.259-.177-.408-.15-.299a3 3 0 0 0 .231.571zm10.708.19.082-.19.027-.136-.068.136c0 .054-.041.136-.068.19-.041.109-.027.109.027 0m-.041-.299.041-.136-.027.027v.109Zm-10.762.245L6 10.027c-.027-.068-.054-.122-.068-.109-.014 0 .082.245.136.34.041.082.054.068 0-.027Zm.912-.054.054-.136-.054-.082c-.041-.068-.177-.15-.231-.15-.014 0 0 .354.041.408.027.054.082.109.109.109l.082-.136Zm8.925.122c.054-.027.095-.163.095-.313l.014-.136c.014-.014.027-.027.014-.041-.014-.027-.19.068-.245.136s-.054.109 0 .259c.068.136.054.136.122.095m-13.497-.34.136-.218-.027-.272c-.027-.136-.041-.272-.054-.245l-.054.15-.163.408-.136.272.027.122.041.136.041-.068.19-.272Zm3.428.177-.109-.272c-.041-.109-.041-.136-.027-.163.027-.027.027-.041-.014-.054l-.095-.095c-.068-.068-.068-.054-.014.109.014.068.054.136.068.136.027 0 .054.054.068.109l.054.136.027.068c.027.109.068.19.082.177zm7.402.136-.054-.014c-.054 0-.054 0-.054-.136 0-.082 0-.122-.027-.122s-.041.014-.041.122v.122h-.287v-.122c0-.109 0-.136-.027-.136s-.027.041-.027.136v.122h-.299v-.122c.014-.109 0-.136-.027-.136s-.027.027-.027.136v.122h-.299v-.095l.014-.136-.027-.014c-.054 0-.054 0-.054.122v.136l-.136-.014h-.15v-.136c0-.082 0-.109-.041-.109-.027 0-.027.014-.027.122l.014.136h-.612v-.136c0-.122 0-.136-.027-.136s-.054.014-.041.136v.136h-.272v-.136c0-.109-.014-.136-.041-.136-.041 0-.041.027-.041.136v.136l-.136-.014h-.15v-.136c0-.095 0-.109-.041-.109s-.027.014-.027.122l.014.136h-.313v-.136c.027-.109.014-.136-.014-.136s-.041.027-.027.136v.122H9.66l.014-.136c0-.095 0-.109-.027-.109-.041 0-.041.014-.041.122 0 .122 0 .136-.068.136l-.054.014c0 .014.653.027 1.905.027s1.891 0 1.891-.027Zm7.361-.095c.027-.136.027-.136-.095-.381l-.177-.422c-.068-.19-.095-.218-.095-.095l-.027.259-.027.177.082.136c.136.218.272.449.299.449l.041-.136Zm-14.858-.109c-.041-.15-.095-.259-.095-.204l.136.381c.014 0 0-.082-.041-.177m.952.068c-.027-.15-.136-.299-.231-.299l-.081-.041c-.041-.041-.041-.041-.041.041 0 .136.136.395.19.354h.054c.027.027.068.041.095.041s.027-.014.014-.095m9.51.068c.068 0 .15-.163.177-.299.014-.136 0-.177-.041-.109-.014.014-.041.041-.068.041-.068 0-.19.136-.231.245-.054.136-.041.15.041.136zm-4.788-.028.054-.014c.136 0 .163 0 .163-.054 0-.082-.068-.109-.272-.109s-.245.027-.245.109c0 .054.027.068.136.054l.068.014c0 .041.095.041.095 0m5.279-.082c.027-.082 0-.068-.041.041v.054zm-6.803 0c0-.068-.068-.109-.136-.068-.082.027-.082.136 0 .136.095.014.136 0 .136-.054Zm.367 0c0-.027-.027-.054-.068-.082s-.054-.014-.095.014c-.068.054-.068.136 0 .136.095.014.163 0 .163-.054Zm.34 0c0-.027-.014-.054-.054-.082-.054-.027-.068-.014-.109.014-.054.054-.054.109 0 .136.095.027.163 0 .163-.068m.354 0c0-.082-.095-.122-.163-.068-.054.054-.041.136.014.136.095.014.136 0 .136-.068Zm1.02 0c0-.068-.095-.122-.136-.082-.054.041-.054.136 0 .15.082.014.136 0 .136-.054Zm.327.068c.041 0 .027-.109 0-.136-.041-.027-.054-.027-.095 0-.109.041-.068.177.054.136zm.354 0c.041 0 .027-.109-.014-.136-.027-.027-.041-.027-.095 0-.095.054-.054.177.054.136zm.395-.041-.041-.082c-.041-.054-.054-.054-.109-.027-.082.041-.082.136 0 .15.068 0 .136 0 .136-.041Zm4-.136c.041-.095.027-.163 0-.054l-.054.136c-.027.082.027.027.054-.068ZM5.877 9.959l-.054-.095.027.122.054.095zM1.7 9.837a.7.7 0 0 0-.068-.286 7 7 0 0 1-.327-1.034c-.082-.367-.068-.34-.136-.313l-.054.054-.041.054c-.027.027-.041.082-.041.19A4.2 4.2 0 0 0 1.7 9.999v-.15Zm15.143-.082c.027-.027.027-.068.014-.068s-.109.218-.136.327l.136-.259Zm4.299.136a6.3 6.3 0 0 0 .585-1.32c.014-.136.014-.177-.027-.245-.054-.082-.15-.163-.177-.136l-.027.15c-.136.544-.231.884-.367 1.197-.041.095-.082.463-.054.463l.068-.095Zm-4.912-.19-.027-.082c0-.014-.027 0-.027.027l-.054.15c-.082.163-.068.177.027.068.054-.068.082-.109.082-.163m.735.082-.027.054c-.041.109-.041.136 0 .054zM2.217 9.729l.218-.585c.027-.109.027-.177 0-.354l-.027-.476c-.027-.272-.041-.286-.068-.027a9 9 0 0 1-.218 1.088 1.1 1.1 0 0 0-.068.408c.027.19.041.19.15-.054Zm3.755.082-.054-.109.027.109.054.095s0-.054-.027-.095m.68.014c-.041-.054-.068-.136-.068-.177s0-.068-.027-.054l-.014.109c0 .068 0 .095.068.15l.082.068-.054-.095Zm.381-.082-.082-.204a6 6 0 0 1-.299-1.633c-.054.041 0 .735.122 1.197a7 7 0 0 0 .299.816s0-.082-.041-.177m8.735.014a3.9 3.9 0 0 0 .34-1.837l-.027.082v.136l-.027.259c-.027.422-.204 1.129-.354 1.415-.027.082-.041.122 0 .122l.082-.177Zm4.925.068c.027-.095.014-.15-.054-.408a9 9 0 0 1-.136-.721c-.122-.612-.109-.599-.163-.177-.041.49-.041.503.027.748a3.4 3.4 0 0 0 .286.667zm-4.163-.041c0-.041-.041 0-.054.068l-.014.068.041-.068zm.571 0c.027 0 .122-.272.095-.286l-.027.027c0 .027-.041.068-.095.095-.054.041-.068.068-.054.095.027.014.027.041 0 .095-.027.109-.027.122.014.041.014-.041.054-.068.068-.068M5.89 9.796c-.041-.082-.054-.068-.027.014l.041.068zm7.415.027c0-.027 0-.041-.041-.041s-.068 0-.068-.027-.218-.041-1.796-.027c-1.714 0-1.796 0-1.864.041l-.054.068c0 .014.816.027 1.905.027 1.674 0 1.905 0 1.918-.041M6.91 9.741a.4.4 0 0 0-.041-.163c-.027-.082-.136-.231-.163-.231s-.082.177-.068.272c0 .136.027.177.082.136l.109.027.109.054-.014-.095Zm9.143 0c.041.027.095-.082.068-.177-.027-.177-.041-.218-.068-.218-.041 0-.136.163-.177.299-.068.19-.054.19.054.136.041-.027.109-.041.122-.027Zm-9.524-.204c.136-.136.136-.299 0-.476l-.041-.054-.041.082a.7.7 0 0 0-.027.408.34.34 0 0 1 .041.163c0 .15.014.163.027.027 0-.054.027-.122.054-.136Zm-.463.109.054.041c.041.027.054.027.068 0 .027 0 .014-.054-.014-.15l-.082-.299-.054-.245-.041-.082.014.095.027.19c.014.068 0 .122-.054.245-.068.15-.068.163-.027.218.027.041.041.041.068.014zm.354.041-.027-.136a.5.5 0 0 1-.041-.204c0-.095 0-.122-.068-.163l-.068-.041-.027.082c-.027.082-.027.109 0 .218.054.136.136.272.204.272.014 0 .027 0 .027-.027m10.055-.054c.095-.122.136-.272.095-.408l-.027-.082-.068.041c-.041.041-.054.068-.054.136l-.041.19c-.068.204-.027.272.095.136Zm.136.068c0-.041.095-.054.136-.014.027.027.041.027.068-.041.027-.054.014-.082-.041-.204a.65.65 0 0 1-.041-.395v-.095l-.014.041c0 .068-.095.435-.136.544s-.027.177.014.177l.027-.014ZM5.876 9.566c.014-.068 0-.109-.068-.204a1 1 0 0 0-.19-.204l-.109-.095c0-.014 0-.014-.027 0-.041.027-.041.041 0 .068a.4.4 0 0 1 .082.15c0 .068.027.15.041.19.027.068.204.204.245.19zm11.17 0c.095-.082.109-.109.136-.245.027-.082.054-.163.082-.177.041-.027.041-.082 0-.082-.054 0-.299.245-.354.367-.041.068-.041.109-.027.163l.041.082.136-.109Zm-.707-.082a.6.6 0 0 0 0-.381l-.068-.082-.068.082c-.095.136-.095.272 0 .435.068.082.082.109.095.068l.041-.136Zm-3.184.095c.041-.027.041-.027-.014-.082-.054-.041-.068-.054-.082-.041 0 .027-.027.027-.054.027h-.068c-.054.027-.082-.041-.082-.177V9.17l-1.483.014H9.905v.286H9.81l-.122-.014s-.027 0-.041.027c-.027.027-.054.054-.082.054s-.014 0 .027.027.327.041 1.782.041c1.129 0 1.755 0 1.769-.027ZM2.041 9.47l.082-.272c.177-.721.259-1.524.136-1.646-.054-.068-.136-.095-.19-.068-.054.014-.054.027-.054.327 0 .272-.041 1.361-.068 1.578 0 .068.027.19.054.19zm18.776.054c.027-.041.027-.082.027-.136a18 18 0 0 1-.082-1.469c0-.395 0-.408-.054-.435-.054-.041-.204.027-.231.109v.408c0 .272.027.408.109.83a4 4 0 0 0 .177.748zM1.755 9.51l.014-.109a18 18 0 0 1-.204-1.823l-.109.027a.35.35 0 0 0-.19.327 7.4 7.4 0 0 0 .435 1.633zm19.361 0 .122-.354c.122-.34.272-.939.272-1.184.027-.136-.054-.299-.163-.354l-.109-.041-.041.272c-.014.327-.068.721-.136 1.265-.041.299-.054.367-.027.408.041.041.068.041.082-.027ZM1.905 9.306c.054-.517.068-.912.068-1.333 0-.517 0-.599-.136-.626-.054-.027-.136 0-.177.054-.027.041-.027.422 0 .68a105 105 0 0 1 .122 1.048 10 10 0 0 1 .082.313c.014 0 .027-.041.041-.136m19.089-.082.068-.544c.054-.408.109-1.02.095-1.129-.014-.136-.027-.163-.082-.19-.068-.041-.122-.041-.19.027-.068.054-.068.054-.068.34l.068 1.687.054.027c.014 0 .041-.054.054-.218m-14.98.054c0-.041 0-.136-.027-.218-.027-.136-.027-.15 0-.177.041-.027.041-.095.014-.231-.014-.136-.041-.109-.027.027 0 .095 0 .136-.068.218l-.095.204c-.027.082-.027.095.054.204.068.109.068.122.095.082zm10.925.027.068-.109-.027-.122-.095-.177a.4.4 0 0 1-.054-.204l-.014-.136-.027.136.014.177c.027.054.027.095 0 .218s-.027.163 0 .245l.041.095zm-7.075-.122c-.014-.041-.014 0-.014.082v.068Zm3.089.082-.014-.136c-.014 0-.027.054-.027.136l.027.136c.027 0 .027-.068.027-.136Zm-6.191 0-.068-.218c-.041 0-.027.082 0 .177.027.054.068.082.068.041m9.306 0c.041-.027.068-.19.041-.204q-.041-.02-.082.163-.02.082.041.041M6.176 9.17l-.014-.041c-.014 0-.027 0-.027.027s0 .041.027.041.014-.014.014-.027M5.4 9.088c.027-.054.054-.082.435-.463.204-.231.68-.667.816-.789.095-.068.109-.082.122-.231.014-.177 0-.218-.041-.163l-.324.313c-.286.272-.626.599-.939.952-.15.163-.19.218-.19.272 0 .109.027.19.054.19l.054-.054Zm.367 0c.027-.082-.014-.245-.068-.245l-.082.082-.068.082.082.068c.095.082.109.082.136 0Zm.612.027-.014-.054-.027-.204c0-.082-.014-.15-.027-.15l-.027-.054c-.014-.054-.014-.054-.041 0l-.082.122c-.054.082-.068.15-.027.245.027.041.041.054.068.041.027 0 .054 0 .082.041.054.054.068.054.095.014m10.136-.014c.014-.027.054-.041.068-.041.054.014.082-.027.082-.136s-.027-.136-.095-.231c-.054-.068-.054-.068-.082-.027-.027.027-.041.109-.041.204l-.014.163c-.041.027-.041.109 0 .109l.082-.054Zm.639-.041.095-.068-.082-.095-.082-.082-.041.054-.041.082c0 .054.027.19.054.19zm.327.068.014-.122.027-.095-.231-.245a16 16 0 0 0-1.225-1.211l-.068-.041.014.163c0 .095.027.177.027.177a14 14 0 0 1 1.211 1.17c.177.204.231.245.231.204m-4.572-.054c.054-.054.068-.068 0-.068l-.041-.054c-.027-.054-.027-.041-.027.027v.068H9.932v-.054c.041-.054 0-.054-.054 0l-.054.041.054.054c.054.041.095.041 1.497.041s1.469 0 1.524-.041ZM6.436 8.98c0-.082.082-.082.109-.014.041.136.095.041.095-.163 0-.095-.014-.136-.054-.163l-.041-.082c0-.041-.136.109-.163.19a.36.36 0 0 0-.014.177c.014.109.054.136.068.054m9.796 0c.027-.082.082-.082.109 0l.027.054.014-.068c.027-.109 0-.272-.068-.327l-.054-.095-.027-.027c-.014 0-.027.014-.027.041l-.027.095c-.068.082-.068.367 0 .367.014 0 .041-.014.054-.054ZM5.878 8.843c.041-.068.054-.218.014-.218l-.082.082c-.082.068-.082.068-.041.136.041.082.054.082.109 0m11.129 0c.027-.068.014-.082-.068-.163l-.082-.082v.082c0 .095.054.231.095.231l.041-.068ZM5.755 8.231c.204-.204.49-.503.667-.653l.34-.299.054-.136.054-.204v-.082c-.082.041-.952.884-1.361 1.333-.313.327-.327.354-.272.531 0 .054 0 .054.095-.041l.422-.463Zm11.783.449v-.136c.027-.041-.231-.327-.68-.803a17 17 0 0 0-.952-.871l.027.177.027.19.327.299a19 19 0 0 1 1.225 1.225zm-11.388 0c.027-.014.041-.054.041-.082s.014-.041.041-.041.041-.027.027-.136v-.136l-.136.082c-.095.109-.122.177-.068.299.027.068.041.068.095.014m10.558 0q.041-.204-.068-.313c-.054-.054-.109-.095-.122-.082l-.027.136c0 .109 0 .136.027.136.014 0 .054.041.068.082.054.095.109.109.122.027ZM6.34 8.612c-.014-.027-.041 0-.014.041 0 .027.014.027.027 0v-.041Zm.122-.082c.014-.041.054-.068.082-.068.041 0 .041 0 .041-.109 0-.054 0-.136-.027-.15a.2.2 0 0 1-.041-.109c0-.068-.027-.054-.068.014l-.068.136c-.041.082-.054.122-.041.204.027.177.054.204.122.095Zm9.959-.109a.36.36 0 0 0-.054-.204l-.082-.136c-.014-.041-.014-.041-.041.027a.15.15 0 0 1-.041.095l-.027.136c0 .109 0 .136.041.122.027 0 .054 0 .068.041.054.109.068.109.109.068a.3.3 0 0 0 .027-.15M5.306 7.946a5.77 5.77 0 0 1 .789-2.993c.082-.136.095-.177.041-.163a3.5 3.5 0 0 0-.531 1.075 6.7 6.7 0 0 0-.34 1.565c-.027.231-.041.844-.014.898.041.095.054 0 .054-.381m12.218.231a6.2 6.2 0 0 0-.313-2.177l-.082-.204c-.136-.354-.408-.952-.49-1.007-.068-.041-.054 0 .027.15a6.46 6.46 0 0 1 .803 3.034c0 .408 0 .395.014.395zm-11.157.014h-.041l-.041.054h.041l.027-.054Zm10.082.027c0-.027-.014-.041-.027-.041-.027 0-.027.014 0 .054.027.054.054.041.027-.014M5.482 8.15c.027-.027.027-.041 0-.068-.054-.041-.082-.109-.109-.19-.014-.068-.014-.068-.014.041 0 .068 0 .136.027.163s.027.068.027.082c-.027.041.027.027.068-.027m11.932-.245c0-.109 0-.122-.027 0 0 .027-.041.095-.082.136-.054.068-.054.068-.014.109s.041.041.082-.041a.5.5 0 0 0 .041-.204m-10.83.095c-.027-.027-.041 0-.027.082l.014.082.014-.082zm9.633.054v-.068c-.027 0-.027.041-.027.082 0 .082 0 .082.027-.014M5.617 7.987c.054-.054.054-.054.014-.177a1.2 1.2 0 0 0-.136-.272.5.5 0 0 1-.095-.19c0-.054-.014-.041-.027.041l.014.136c.027.027.041.109.041.204 0 .136 0 .19.041.259.054.082.095.095.15 0m11.674 0c.041-.068.054-.109.054-.272 0-.136 0-.19.027-.204.041 0 .027-.19 0-.272-.027-.041-.027-.041-.014.014.014.109-.014.204-.109.327a1 1 0 0 0-.136.218c-.027.122-.027.122.027.19l.068.068.082-.082Zm-6.708-.381.014-.177.122-.027a5 5 0 0 1 .34-.109l-.204-.095c-.109-.041-.204-.095-.204-.109-.027-.027-.014-.367 0-.435.027-.068-.027-.041-.109.068l-.15.19-.068.068-.19-.068c-.299-.136-.299-.136-.19.027l.136.218.054.068-.163.177-.177.216.204-.041.259-.054c.027 0 .068.068.163.204.136.231.136.218.163-.095Zm1.769.095.136-.19.231.041.245.054-.15-.177c-.082-.109-.15-.19-.15-.218l.041-.082.19-.327h-.041l-.177.082c-.272.109-.231.122-.395-.082a1 1 0 0 0-.163-.19c-.027 0-.027.041-.014.109l.027.245.014.136-.163.068-.245.095c-.082.027-.054.054.068.082a1 1 0 0 1 .245.054l.136.027v.109c0 .163.014.381.041.367l.136-.19Zm-6.558.109c.054-.054.068-.095.082-.218 0-.109.027-.177.054-.204.041-.041.095-.245.068-.272l-.041.082c-.014.068-.068.136-.15.231-.177.19-.19.204-.136.34l.054.109zm11.293-.054c.041-.136.041-.136-.15-.354-.082-.082-.136-.15-.136-.19l-.014-.082c-.014-.027-.027 0 0 .082 0 .054.027.136.054.177s.041.122.054.204c0 .122.027.163.068.218l.082.054zM5.96 7.553c0-.082 0-.095-.027-.082-.027.054-.027.19 0 .19zm10.885 0c-.014-.136-.027-.136-.027 0l.014.109v-.095ZM5.661 7.526c.041-.068.041-.068-.027-.15-.082-.109-.082-.15-.041-.381.054-.204.054-.313 0-.163l-.068.272a.35.35 0 0 1-.054.19l-.027.068c0 .041.136.231.163.231zm11.578-.027c.082-.095.082-.095 0-.408a11 11 0 0 1-.095-.327l.041.245c.041.218.027.272-.054.381-.054.068-.068.068-.014.136.014.041.041.068.054.068l.082-.095ZM6.136 7.483l.095-.082-.095-.082-.082-.082-.027.082c-.027.109-.027.272 0 .272zm10.612.027-.014-.177-.014-.095-.082.054-.082.095c0 .027.163.19.19.19zM5.85 7.265l.082-.422c.082-.354.109-.503.068-.408a2.7 2.7 0 0 0-.122.476.86.86 0 0 1-.122.367c-.054.068-.054.095-.041.122.027.027.041.027.082-.027.041-.027.054-.068.054-.109m11.225.122c.027-.041.014-.054-.014-.095-.082-.054-.095-.109-.136-.299a2.5 2.5 0 0 0-.136-.585c-.027-.027 0 .054.068.395l.068.422c0 .068.014.109.054.136.054.082.068.082.095.027M6.326 7.292c.054-.054.027-.313-.054-.408-.027-.054-.054-.068-.068-.054l-.054.109c-.082.122-.082.218.027.313.095.095.109.095.15.041m10.3-.054c.041-.041.082-.109.082-.136a.5.5 0 0 0-.109-.231l-.041-.054-.054.082a.4.4 0 0 0-.054.177l-.014.122c-.014.027-.014.054.027.082l.068.054zm-10.898 0c.027-.014.027-.054.014-.136l-.014-.082-.054.109c-.068.136-.041.218.054.122Zm11.442 0c0-.027 0-.068-.027-.082a.7.7 0 0 1-.068-.19c-.041-.163-.082-.231-.054-.082l.027.204c0 .136.041.218.095.19zM6.559 7.076c.109-.109.136-.136.109-.204l-.054-.109-.041-.068c0-.054-.136.122-.177.204-.027.109-.027.299.014.299a.5.5 0 0 0 .15-.136Zm9.823.027a.46.46 0 0 0-.109-.367l-.068-.068-.054.095c-.082.136-.082.19.068.313l.136.122zM5.443 6.967v-.054l-.014.054-.027.109v.068l.027-.068zm11.891-.027c0-.054-.014-.082-.027-.082v.109l.027.082zM5.796 6.722l.027-.15c-.027 0-.095.299-.095.367 0 .027 0 .027.014 0zm-.136-.313c.027-.19.068-.231.136-.136.041.054.054-.027 0-.136l-.041-.204-.014-.122-.068.204a1 1 0 0 0-.054.259c0 .027 0 .163-.041.299s-.054.272-.054.286c0 .068.068-.204.122-.449Zm.762.34c.041-.054.014-.15-.068-.286-.068-.082-.082-.095-.082-.068l-.054.095a.4.4 0 0 0-.068.177c0 .109 0 .122.027.095.041-.041.082-.027.082.027l.041.068c.041.041.041.041.068-.014zm.49-.245a4.67 4.67 0 0 1 1.823-2.449l.19-.122a5.4 5.4 0 0 1 1.687-.627 5.1 5.1 0 0 1 2.45.231 4.94 4.94 0 0 1 2.952 3.361 5.1 5.1 0 0 0-.966-2.014 4.67 4.67 0 0 0-4.435-1.633 4.88 4.88 0 0 0-3.129 2 5.6 5.6 0 0 0-.721 1.578c-.027.163.041.027.15-.327m9.578.313c.027-.068.054-.082.095-.068.027 0 .041 0 .041-.041a.4.4 0 0 0-.095-.259l-.054-.054-.054.068c-.095.109-.109.204-.054.327l.068.109zm.762.014-.068-.272a1 1 0 0 1-.027-.286 1 1 0 0 0-.054-.245c-.068-.231-.109-.299-.082-.163 0 .068 0 .136-.041.231l-.041.163c.014.041.014.041.041 0 .027-.054.082-.041.109.027l.041.163.041.204.082.245zM5.756 6.584l.027-.218-.041.136-.054.313zm11.334.163c-.041-.136-.068-.259-.082-.245 0 0 0 .095.054.272.014.082.041.054.027-.027m-10.34-.136c.041-.095.054-.15.041-.204l-.014-.136-.027-.054c-.041 0-.19.163-.231.245-.054.122-.054.19 0 .15.041-.027.095 0 .095.041s.041.109.068.109l.068-.136Zm9.388.054c.041-.054.068-.082.095-.068.109.027 0-.218-.136-.313-.082-.082-.095-.082-.095 0 0 .041 0 .082-.027.109 0 .027 0 .095.027.177.068.218.082.231.136.095m.857.027-.041-.177-.041-.136.054.327c.014.041.041.027.027-.014M5.877 6.365v-.054l-.041.136v.054zm-.136 0v-.027a.2.2 0 0 0-.041.109c-.014.041 0 .054 0 .027zm.476-.136.15-.408c.095-.177.095-.19.068-.177l-.095.163c-.068.136-.095.163-.204.218-.177.095-.259.19-.218.231v.082c0 .027 0 .041.068.041.041 0 .054 0 .068.054 0 .041 0 .054.041.041q.041 0 .122-.245m.272.177c.054-.109.027-.136-.027-.027l-.027.122zm9.838-.011-.054-.082c-.041 0-.027.027.027.109.054.109.082.082.027-.027m.408.068c0-.095 0-.109.054-.095.054 0 .054 0 .068-.068.014-.109-.014-.136-.163-.231-.163-.095-.204-.136-.272-.299l-.068-.136a6 6 0 0 1 .231.599c.041.15.082.245.109.259h.041zm.327-.136c-.027-.041-.027-.041-.014 0l.014.109.014-.027c.014-.027 0-.068-.014-.082m-8.218-.041.19-.15.109.054.218.136.109.068-.082-.218-.109-.231c-.014-.014.041-.082.177-.19l.204-.177s-.231 0-.408.027c-.095 0-.109 0-.136-.027a8 8 0 0 0-.136-.395c-.027-.041-.041-.027-.054.054a4 4 0 0 0-.068.245c-.027.163-.054.177-.327.177-.109 0-.204 0-.204.027l.218.136.204.136-.109.435c-.014.068.027.041.204-.109m5.265-.082c-.027-.122-.054-.231-.041-.245 0-.014.095-.082.204-.136l.204-.136c0-.014-.082-.027-.177-.027h-.285c-.068-.027-.068 0-.15-.395l-.041-.136-.054.136-.082.218c-.041.136-.054.136-.313.109l-.245-.014.177.163.19.177-.082.218-.082.218.204-.109.218-.109.19.136.177.163s0-.109-.041-.231Zm-7.66.136c.027-.054.054-.068.109-.068.068 0 .218-.122.272-.218l.027-.19v-.136l-.109.068c-.136.068-.272.272-.272.367a.4.4 0 0 1-.041.163c-.041.041-.054.082-.041.082zm.503-.163.054-.204c-.014-.027-.122.068-.136.136-.054.136-.068.259-.014.259zm-.544.082.041-.15c0-.041.041-.122.068-.15.041-.054.054-.15.027-.15-.014 0-.054.014-.082.054-.095.082-.163.34-.136.435.027.054.054.027.082-.041m9.551-.014c0-.136-.054-.218-.136-.259h-.041a1.4 1.4 0 0 0 .163.354zm.381 0-.095-.231a.43.43 0 0 0-.177-.204l-.109-.082-.014.136c0 .136 0 .163.041.231.068.082.19.177.245.177.027 0 .068 0 .082.027.041.054.054.041.027-.054m.109-.041c0-.177-.041-.272-.136-.354-.054-.041-.054-.041-.068 0l.054.163.082.231c.041.136.068.122.068-.041M5.973 6.09c.054-.054.054-.068.054-.259 0-.109 0-.204-.027-.245l-.027-.136v-.095c-.041 0-.082.136-.068.177l-.055.182q-.102.204 0 .367l.027.082.082-.054Zm10.98-.041c.054-.136.054-.136-.014-.34-.041-.095-.054-.177-.041-.19 0-.027 0-.082-.041-.136l-.054-.109.014.122c.014.082 0 .136-.014.218a.7.7 0 0 0-.041.259c0 .136 0 .163.054.218l.082.054zm-10.64-.272c.054-.109.109-.177.136-.19.027 0 .082-.095.15-.218l.054-.136c-.027 0-.054.068-.068.109-.054.109-.095.136-.245.231-.218.095-.245.136-.245.299v.136l.068-.041a.46.46 0 0 0 .15-.204Zm10.395.095c0-.136 0-.136-.068-.204a1 1 0 0 0-.19-.109c-.122-.041-.177-.109-.245-.245-.054-.095-.095-.136-.095-.109l.041.095.095.163a.23.23 0 0 0 .095.122c.041 0 .068.054.122.15.054.136.177.272.231.272zm-9.633-.049c.082-.095.15-.272.122-.313-.014-.014-.231.054-.272.095-.027.027-.027.054-.027.068v.136c0 .109 0 .136.041.136l.136-.136Zm3.674.014.408-.272.245-.19.19.136a16 16 0 0 1 .599.408l-.136-.381c-.163-.544-.163-.517-.027-.626a12 12 0 0 0 .571-.408l.095-.068h-.993l-.041-.109a9 9 0 0 1-.259-.789c-.014-.054-.014-.068-.231.599l-.095.272-.503.027h-.476l.244.19a35 35 0 0 0 .544.408 7 7 0 0 1-.299.925l.164-.109Zm5.143-.068v-.163l-.095-.041q-.224-.102-.204 0c.014.136.204.381.272.381.027 0 .027-.041.027-.177m-9.17-.014c.095-.041.163-.177.163-.313 0-.095 0-.109-.041-.082l-.136.054c-.068.041-.136.136-.19.272-.027.068-.027.068.027.054.054 0 .054 0 .054.027l.027.027zm9.483 0c0-.014 0-.027.041-.014.041 0 .054 0 .054-.027 0-.054-.136-.272-.19-.286l-.204-.095v.095c0 .136.054.245.15.313.109.068.136.068.136.027Zm-10.041-.15c.054-.054.068-.095.082-.204v-.245c-.041-.136-.041-.218 0-.299.054-.109.027-.095-.041.014l-.082.163-.054.19a.5.5 0 0 0-.041.367c.041.082.041.082.136 0Zm10.599-.054c.027-.109 0-.231-.082-.381-.014-.041-.041-.095-.027-.122l-.041-.163c-.068-.136-.109-.136-.054 0 .041.068.041.109.014.218a1 1 0 0 0-.014.286c0 .136.014.163.068.218l.082.054zM2.844 5.483c.122-.109.041-.286-.122-.286q-.163 0-.163.163c0 .163.177.245.286.136Zm3.687-.177.136-.163c.068-.027.272-.327.259-.34l-.15.177c-.054.068-.095.109-.231.15-.218.095-.245.122-.272.272l-.014.136.095-.041a.35.35 0 0 0 .177-.19m.571.163c.177-.068.327-.218.327-.327l.014-.109c.014-.027 0-.027-.027-.014a.4.4 0 0 1-.109.027c-.136 0-.259.136-.272.286-.014.082-.041.136-.068.136-.041.027-.068.082-.027.068l.163-.054Zm9.388-.068c-.027-.163-.041-.19-.231-.259l-.163-.068a1.2 1.2 0 0 1-.204-.245c-.014-.027-.027-.041-.041-.027-.027.027.204.34.245.34.027 0 .095.082.136.163.068.109.204.231.259.231zm3.687.095c.068-.054.082-.163.027-.245-.027-.041-.054-.054-.136-.054-.136 0-.177.054-.177.177 0 .082.082.163.177.163zm-4.381-.041a.24.24 0 0 1-.054-.136c0-.122-.136-.272-.272-.272l-.082-.014c-.054-.082-.068.109-.014.204.041.082.177.19.286.231.163.068.19.068.136 0ZM3.183 5.374l-.068-.082c-.082-.068-.095-.082-.082-.163l.027-.136c.014-.027 0-.027-.163.027a3 3 0 0 1-.408.095v.082c-.027.068 0 .095.041.027.014-.041.163-.109.231-.082.109.014.177.122.177.231v.095l.109-.041a1 1 0 0 1 .136-.041Zm16.681-.149.095-.068c.054-.027.082-.041.15-.014a.3.3 0 0 1 .136.082c.027.041.027.041.027-.041s0-.082-.109-.095c-.068 0-.19-.041-.299-.068-.136-.041-.177-.054-.177-.027l.027.041c.068.041-.027.299-.109.299-.068 0-.014.054.095.095l.122.041v-.109zM6.952 5.32a.26.26 0 0 1 .068-.163c.068-.068.082-.272.027-.204l-.109.041c-.027 0-.095.054-.136.095-.054.082-.136.245-.122.272l.082-.041c.122-.054.136-.041.136.041 0 .122.041.082.054-.041m8.885.041c-.014-.068.041-.095.136-.041.109.054.122.027.041-.095-.082-.15-.136-.218-.218-.231l-.082-.041c-.041-.054-.082-.054-.068 0l.027.082a.2.2 0 0 0 .054.122.3.3 0 0 1 .054.136c0 .082.014.136.054.136zM3.361 5.266c.068-.068.068-.218 0-.272-.082-.054-.19-.041-.245.027-.068.082-.068.163 0 .231.082.068.19.068.245 0Zm16.259 0c.068-.054.068-.19.014-.259a.193.193 0 0 0-.272.014c-.054.082-.054.163.014.231s.177.082.245.014m-16-.068.177-.082-.068-.027c-.109-.041-.163-.109-.163-.231v-.109l-.122.054-.136.068c-.054 0-.041.027.041.054.095.041.136.177.109.272-.041.109-.041.109.163 0m15.687.041c-.041-.109-.027-.218.041-.272l.095-.054c.014 0 .041 0 .041-.027s-.014-.014-.041-.014l-.163-.068c-.15-.082-.163-.082-.136-.027.054.082.041.177-.041.259l-.095.068c-.082 0-.041.041.122.109.19.095.19.095.177.027M6.37 5.144c.068-.041.122-.177.122-.327 0-.068 0-.068-.082-.054-.095.027-.109.027-.136.109-.041.054-.041.109-.041.19l.041.136zm10.136-.068c.027-.095.014-.122-.027-.204l-.068-.095-.095-.014c-.054-.014-.068 0-.068.041 0 .122.068.313.136.354.082.041.082.054.122-.082m-9.905-.014.177-.177c.054-.095.109-.136.136-.136.041 0 .327-.327.299-.34l-.136.122c-.095.109-.136.136-.259.163-.204.054-.272.109-.286.218l-.027.136c-.027.054 0 .054.095 0Zm9.633-.068a.4.4 0 0 1-.041-.136c0-.054-.095-.122-.231-.15a.54.54 0 0 1-.315-.218l-.095-.095.068.109c.109.15.15.204.218.218.041 0 .082.054.136.122.068.122.136.177.204.204.095.041.109.027.068-.068Zm-12.34.027c.095-.068.095-.231 0-.299-.054-.041-.19-.014-.231.027-.136.15.068.381.231.272m3.347-.082a.3.3 0 0 0 .027-.204c0-.136-.014-.177-.041-.136-.014.027-.027.027-.041.027-.041-.027-.259.204-.259.272 0 .054.054.041.109 0 .054-.054.054-.054.095-.027.027.027.027.041 0 .082-.027.068 0 .109.041.082zm8.381.054-.027-.095c0-.054.068-.068.122 0 .041.041.109.054.109.014 0-.054-.15-.231-.231-.272l-.109-.054v.136c0 .19.054.327.136.327zm3.442.014c.136-.095.054-.299-.109-.299-.245 0-.231.34 0 .34.041 0 .082 0 .109-.041m-3.796-.041c0-.027.014-.027.041-.027l.054-.014c0-.014 0-.041-.027-.041s-.068-.041-.136-.109c-.136-.109-.245-.177-.272-.15-.027 0 .109.204.218.313.082.095.122.095.122.027M4.327 4.762h-.041c-.122 0-.231-.163-.19-.272 0-.054 0-.054-.136.041-.15.095-.177.136-.095.136l.109.054c.054.068.054.082.054.177l-.027.109.163-.109a.8.8 0 0 0 .163-.136m3.034.163a.37.37 0 0 1 .136-.15c.095-.068.19-.204.19-.286 0-.027 0-.095.027-.122.014-.054 0-.082-.041-.041l-.068.027c-.082 0-.19.082-.231.177-.027.041-.041.136-.054.218a1 1 0 0 1-.014.204c-.027.082 0 .068.054-.027m.272 0 .218-.299c-.027-.027-.177.041-.218.095l-.122.095-.109.095c-.014.041-.014.054.027.041.027-.014.054 0 .068.014.014.054.068.041.136-.041m7.837 0c-.027-.027-.027-.095-.027-.177a.4.4 0 0 0-.041-.204c-.041-.095-.163-.19-.231-.19-.027 0-.054 0-.068-.027-.041-.054-.054 0-.041.095a.52.52 0 0 0 .231.367c.054.041.109.095.109.136.027.082.041.095.068.068zm3.265-.027c-.014-.082 0-.109.054-.163.027-.041.082-.082.109-.082.095 0 .082-.027-.054-.122-.163-.095-.177-.095-.163-.041 0 .136-.082.272-.177.272h-.054c0 .027.272.218.286.218zM6.176 4.721c.014 0 .014 0 0-.014-.027-.027-.095 0-.095.027h.095Zm.463-.014c.109-.068.163-.204.163-.422l.027-.259.041-.082-.068.082c-.041.041-.068.095-.068.136s-.041.095-.095.163c-.082.122-.095.136-.095.272l.014.15.095-.041Zm9.578-.122c0-.109 0-.136-.095-.272l-.095-.19c0-.027-.041-.082-.095-.136l-.082-.082.054.082a.54.54 0 0 1 .041.231c0 .095.027.218.054.299.041.136.054.163.122.19l.082.027v-.136Zm.449.136a.07.07 0 0 0-.068-.027c-.054.014-.054.014 0 .041l.068.014c.041 0 .041 0 0-.027M4.449 4.626a.2.2 0 0 0 .041-.109c0-.082-.082-.177-.163-.177-.15 0-.245.136-.177.259.041.082.068.095.177.095.054 0 .082-.014.122-.068m1.959.014a1 1 0 0 0-.122-.068c-.054-.041-.068-.041-.109 0-.027.041-.027.054 0 .054l.095.041.136.027h.054zm10.082.027c.136-.041.136-.054.095-.095s-.054-.041-.177.041c-.095.068-.109.082-.068.082zm2.082-.027c.068-.068.082-.19 0-.245-.095-.109-.286-.027-.286.122s.177.231.286.136ZM6.436 4.45l-.068-.136-.054.054-.054.041.109.122c.136.136.163.109.068-.082m.544.122.136-.136c.027-.068.068-.095.109-.095s.136-.082.299-.245c.136-.136.19-.218.136-.163l-.122.109-.136.122c-.095.082-.136.109-.245.122a1 1 0 0 0-.204.054c-.082.027-.095.054-.136.136l-.014.136c0 .041.122 0 .177-.041m8.993.054c0-.014 0-.054-.027-.082l-.027-.109c-.014-.068-.082-.109-.272-.136-.177-.027-.19-.054-.435-.272-.136-.136-.122-.095.095.136l.218.177.177.136.177.15.082.014zm.408-.082c.068-.054.109-.122.109-.136s-.068-.095-.082-.082a.7.7 0 0 0-.136.259c-.027.082 0 .082.122-.041ZM4.817 4.324l-.082-.014a.21.21 0 0 1-.204-.204v-.068c-.027 0-.245.218-.245.245h.054c.095 0 .204.136.204.231v.095l.136-.136zm13.47.027c.054-.041.095-.054.136-.054s.068-.014.068-.027l-.245-.231v.068c0 .095-.109.19-.218.204h-.095l.136.136.15.136v-.082c.014-.054.041-.109.082-.136Zm-10.396.207c.109 0 .177-.068.204-.231v-.15c0-.014-.122.068-.231.163-.095.082-.122.122-.122.177s0 .068.041.054h.109Zm7.143-.054c0-.054-.027-.109-.109-.177l-.163-.136-.068-.014v.136c.027.163.109.272.204.245h.082c.027.068.068.027.054-.054m-7.782.041.041-.041a.7.7 0 0 0 .259-.272v-.068l-.082.095c-.177.15-.286.313-.245.313zm8.34 0-.177-.204c-.163-.177-.163-.177-.15-.109 0 .082.136.231.231.272.027 0 .054.027.054.041l.014.027zm-9.021-.177.041-.068-.054.041-.054.068c0 .027.027.027.068-.041m9.701 0-.041-.027c-.014.014.014.068.041.068v-.055Zm-1.633-.095-.014-.082c-.027-.041.027-.082.082-.068.054 0 .054 0 .014-.041a.63.63 0 0 0-.286-.177c-.082 0-.082 0-.054.027l.027.109a.33.33 0 0 0 .054.163c.109.15.204.19.19.068Zm-7.919-.191a6.2 6.2 0 0 1 5.606-2.136A6.2 6.2 0 0 1 16.3 4.327c.054 0 0-.095-.299-.408a5 5 0 0 0-1.306-1.143l-.177-.109-.408-.218-.272-.136-.299-.109-.272-.095-.34-.109a6.25 6.25 0 0 0-4.694.68 6.7 6.7 0 0 0-1.742 1.633c0 .054-.014.068.231-.231m.299.122c0-.136.054-.218.245-.408.163-.19.109-.163-.095.041a.8.8 0 0 1-.19.15c-.095.068-.095.082-.095.231v.136l.068-.041c.054-.014.068-.027.068-.109m.912-.027c.068-.136.068-.354 0-.245l-.068.014c-.068 0-.204.136-.245.245-.054.109-.027.163.054.095.054-.041.122-.027.122.027 0 .041 0 .027.054 0zm.354.082c.068-.082.082-.122.082-.19l.027-.109c.054-.027.014-.054-.054-.027a.54.54 0 0 0-.259.163l-.041.041h.054c.054 0 .054 0 .054.095-.014.136.027.15.136.027m6.721.054c0-.054.068-.068.122-.027.068.068.095.014.054-.095s-.177-.245-.259-.245l-.068-.014c-.027-.054-.054-.014-.041.082a.5.5 0 0 0 .109.272c.054.068.082.082.082.027m.884-.272a5 5 0 0 1-.354-.286l-.163-.136.19.204.19.204v.136c0 .136 0 .136.068.15l.082.027v-.136l-.014-.15ZM4.83 4.272c.054 0 .122-.095.122-.163 0-.136-.177-.231-.286-.136-.109.082-.082.272.054.313h.109Zm13.334-.054c.082-.122 0-.272-.136-.272s-.231.15-.136.272c.054.095.218.095.272 0m-10.939.041.054-.054c.014-.041.109-.136.19-.204l.408-.395-.245.19c-.313.299-.408.367-.476.367-.027 0-.068 0-.082.027-.014.054.014.095.068.082zm8.476-.041c0-.027-.027-.054-.082-.054-.082-.027-.177-.095-.476-.381a.9.9 0 0 0-.218-.177s.068.095.163.177a12 12 0 0 1 .517.476c.095.027.109.014.095-.041M8.436 4.15c.027-.041 0-.054-.027-.014-.027.014-.027.027 0 .027zm5.918-.014c-.014-.041-.054-.054-.054-.014 0 .014.014.027.068.041v-.027Zm1.061.014-.095-.095-.095-.082.082.095c.109.109.109.109.109.082M5.061 4.082l.109-.163.068-.095H5.17c-.082.027-.109.014-.177-.041-.041-.041-.068-.095-.068-.136 0-.027 0-.054-.027-.054l-.204.272h.082c.054 0 .082.014.136.068s.082.109.082.136c0 .095.027.095.082.014Zm12.803-.15a.22.22 0 0 1 .15-.068h.095l-.054-.054-.095-.136c-.068-.095-.095-.109-.095-.041 0 .122-.136.231-.272.204h-.054l.122.163.122.15v-.068c0-.054.027-.095.082-.136Zm-10.612.054.082-.109-.136.082c-.136.082-.15.136-.068.136.041 0 .082-.027.136-.109Zm8.436.095c0-.027-.054-.095-.095-.095l-.082-.054-.054-.054.041.068.041.095c0 .027 0 .041.027.041h.136Zm-7.075-.082c.109-.068.136-.109.136-.163 0-.014.027-.054.054-.054.068-.054 0-.068-.177-.041-.19.027-.272.068-.19.109.041.014.041.027 0 .082-.014.041-.027.082-.014.095.027.041.136.027.204-.027Zm5.728 0s0-.041-.027-.054V3.85c.027-.027.027-.054.027-.068-.027-.014-.367-.068-.381-.054-.027.027.095.218.177.272.095.068.204.068.204 0m-6.163-.095c.109-.095.136-.136.163-.231.041-.095.027-.136-.014-.082l-.095.014c-.054 0-.095.027-.163.095-.095.068-.109.082-.068.122.027.027.027.068.027.122v.082zm6.572.027c0-.068 0-.095.027-.122.041-.027.027-.041-.068-.109-.068-.054-.136-.095-.177-.095l-.082-.014c0-.014-.027-.027-.041-.014l.027.122c.014.068.068.136.163.218l.136.109s.027-.041.014-.095m-7.13-.19c.272-.259.259-.259.299-.177l-.014.068c-.027.041-.027.041 0 .054.041.014.095 0 .19-.082a10 10 0 0 1 .408-.327c-.054.027-.109.027-.231 0-.218-.014-.245 0-.327.109a.7.7 0 0 1-.177.163c-.163.136-.449.408-.449.435s.082-.054.299-.245m7.823.231a5 5 0 0 0-.49-.449c-.041-.041-.109-.095-.136-.15-.054-.095-.109-.109-.327-.082l-.231-.014c-.122-.054-.122-.027 0 .041l.327.218c.163.136.231.163.272.15.041 0 .041-.014 0-.054-.027-.041-.027-.109.027-.109l.299.245.272.245v-.041ZM7.576 3.59c.136-.136.272-.231.299-.231.041 0 .109-.163.109-.245 0-.041.027-.095.068-.136l.068-.095c-.027-.027-.463.313-.463.354a.5.5 0 0 1-.163.177l-.283.26c-.163.177-.054.095.218-.15.19-.163.299-.259.326-.259.082.014.041.082-.109.218l-.068.122Zm7.891.19-.313-.272c-.109-.109-.177-.177-.177-.204 0-.054.068-.054.136.014l.122.054c-.068-.054-.136-.109-.136-.136a2 2 0 0 0-.449-.354s.014.041.054.068a.4.4 0 0 1 .068.163c.027.109.095.272.136.245.014 0 .068.041.408.354l.259.204s-.041-.068-.122-.136Zm-6.476 0 .204-.095.041-.027c.014-.027-.231-.014-.286.014-.027.014-.054.041-.054.068s-.027.041-.041.054c-.041.027-.068.095-.041.095zm4.925.014c-.027-.014-.041-.054-.041-.068 0-.041-.109-.082-.231-.095h-.136l.15.082.218.122c.068.054.095.027.041-.041m1.429 0c-.095-.109-.122-.136-.122-.109l.218.204-.095-.109Zm-7.714-.177c.122-.122.122-.122-.041.014l-.176.179zm-.408-.027c0-.014-.027 0-.122.109l-.109.109.122-.109zm8.463.109-.109-.082.082.082.109.095zm-10.422.027c.068-.068.054-.177-.014-.245s-.15-.068-.231 0c-.068.041-.082.177-.027.245s.204.054.272 0m12.504 0c.068-.068.054-.177 0-.245q-.122-.102-.245 0c-.068.041-.082.163-.027.245.054.068.204.068.272 0m-9.252-.014c.068-.014.068-.054 0-.041-.122.027-.136.027-.136.054 0 .014.014.027.041.014zm5.878.014c0-.027-.027-.041-.136-.054h-.082s.041.041.095.054c.122.027.122.027.122 0m-5.442-.109c.068-.054.177-.163.177-.19l-.095-.041c-.136-.014-.299.054-.408.136-.054.068-.054.082-.014.122.054.054.231.054.327-.027Zm5.197.027.054-.041-.054-.054c-.027-.041-.109-.082-.177-.122-.095-.041-.136-.054-.231-.041l-.122.014.054.082c.136.177.34.245.476.163m-5.633-.027h-.041l-.041.014h.082Zm8.98-.177c.027-.041.068-.054.15-.054h.122l-.095-.15-.082-.136a.27.27 0 0 1-.286.204h-.068l.082.177.082.163.027-.082c0-.041.027-.095.054-.136Zm-12.027 0 .068-.136h-.095c-.136 0-.204-.054-.231-.163l-.014-.082-.082.15-.095.177h.082c.122-.014.245.054.272.15 0 .095.014.082.109-.095Zm3.864.136c.082-.027.245-.136.218-.163-.136-.068-.177-.082-.272-.082-.068 0-.136 0-.136.027s.027.014.027.014c.041 0 .027.068 0 .095a.3.3 0 0 0-.068.082c-.014.027 0 .041.054.041l.177-.027Zm4.34-.027-.082-.082c-.041-.041-.041-.041 0-.068.054-.054.041-.068-.082-.068a.44.44 0 0 0-.218.054l-.082.041.068.068c.068.054.177.082.327.095.082 0 .095 0 .068-.041m1.769-.082-.259-.204c0 .027.354.327.367.327zm-7.958-.106c.068-.054.095-.095.068-.082a1.6 1.6 0 0 0-.245.245zm.163.054c.068-.054.109-.109.095-.109l-.163.136-.095.109zm.966.068.109-.082c.054-.014.136-.177.122-.204-.014 0-.313.15-.381.218s-.082.082-.054.122c.041.041.136.027.204-.054m5.742.041c.027-.054-.109-.177-.286-.272l-.15-.054.027.054.027.095c0 .014.027.041.068.054l.122.082c.095.082.177.109.19.041m.136 0-.054-.014.027.027.041.014zm.816.027a8 8 0 0 1-.272-.231c-.014 0 .054.082.19.177zm-5.442-.204.122-.095c0-.041-.136-.109-.218-.109a.7.7 0 0 0-.313.122c-.027 0-.027.027.027.068a.15.15 0 0 0 .095.041l.054.027c.027.041.122.027.231-.054m3.361.014.136-.054-.082-.054c-.109-.095-.367-.136-.422-.068l-.068.027c-.054 0 0 .068.136.15s.15.082.299 0m-3.152-.029c.027 0 .041-.014.041-.027 0-.027-.068-.027-.122 0s-.054.082 0 .054zm-.898-.041c.082 0 .109-.027.136-.068l.082-.095c.095-.082-.19-.109-.34-.027a.3.3 0 0 0-.177.204c-.027.041-.014.041.095.027zm3.619.027a.12.12 0 0 0-.082-.027c-.054 0-.054 0 0 .027.054.054.122.054.082 0m1.143.014c0-.041-.136-.218-.218-.245-.068-.041-.272-.054-.327-.014-.027.014-.014.041.041.109s.095.095.177.109l.19.041c.136.027.136.027.136 0m-4.449-.136.136-.082c.041 0 .259-.177.231-.19-.163-.095-.204-.095-.408 0-.109.041-.136.082-.041.095.082.014.109.068.054.109l-.082.095c-.054.082-.041.068.109-.041Zm3.932.068-.068-.109c-.068-.082-.068-.136.027-.136.027 0 .041 0 .041-.027 0-.041-.095-.095-.231-.136-.082-.014-.109 0-.15.014a.2.2 0 0 1-.095.041c-.054 0-.041 0 .027.095l.218.136c.082.041.163.082.177.109.041.041.054.041.054 0ZM5.55 3.183c.095-.109.014-.272-.136-.272-.136 0-.218.136-.136.259.041.095.19.109.272.014m3.075-.014c.082-.041.15-.068.177-.054l.245-.082c.204-.109.218-.136 0-.041a.34.34 0 0 1-.245.041l-.231-.027h-.136l-.082.095-.082.122c0 .014.095.027.163.014a1 1 0 0 0 .19-.068m1.864-.014.082-.109c0-.027-.136 0-.204.041a.44.44 0 0 1-.218.041h-.15l.054.082c.054.041.082.054.204.041.122 0 .136-.014.231-.095m2.231.041.054-.054h-.163c-.082 0-.177-.027-.204-.054a.7.7 0 0 0-.163-.054h-.082l.095.082c.109.122.163.136.272.136a.27.27 0 0 0 .19-.054m1.769.027-.082-.109-.068-.122-.136.014-.245.027c-.082.014-.136 0-.231-.041l-.15-.054.15.082q.184.102.245.082c.027 0 .095.014.163.054l.177.082.163-.014Zm2.939 0c.136-.054.136-.231.014-.299-.136-.068-.259 0-.259.15 0 .095.054.15.163.19zm-9.153-.098a1 1 0 0 0 .15-.245 1 1 0 0 1 .109-.231l.054-.054-.054.041c-.041 0-.095.068-.136.109l-.19.15a.33.33 0 0 0-.163.272c0 .054 0 .068.068.054.068 0 .109-.027.163-.095m2.939.027c.367-.014.599 0 .98.054h.095l-.082-.082c-.109-.095-.109-.122-.027-.136.095-.014.068-.054-.027-.054-.082 0-.313-.109-.313-.136l-.068-.095c-.054-.068-.054-.068-.014-.082.136-.041.136-.054.041-.054-.122 0-.204-.068-.136-.109.027-.027.014-.027-.041-.054-.068-.027-.095-.095-.041-.095l.027-.027-.054-.027a.1.1 0 0 1-.068-.027c-.041-.054.027-.095.136-.082h.095s-.027-.027-.068-.027c-.095 0-.136-.014-.136-.054 0-.068.054-.082.313-.041a7 7 0 0 0 .299 0 1.5 1.5 0 0 0-.272-.027c-.136-.014-.245-.027-.272-.054-.041-.041-.354-.041-.408 0 0 .027-.095.041-.245.054l-.272.027c-.027.014 0 .027.068.014.422-.041.49-.041.517-.014.082.054 0 .082-.313.122-.299.027-.503.054-.408.068l.408-.041c.245-.027.327-.027.354 0 .027.014-.014.082-.068.082-.041 0-.041.027 0 .068.027.027-.041.095-.095.095-.041 0-.041 0 0 .027.054.041 0 .109-.136.122l-.054.014.095.027c.041 0 .027.054-.068.15a.43.43 0 0 1-.34.177c-.041 0-.082 0-.082.027s.014.027.041.027c.095 0 .095.054.014.136l-.082.095.163-.014c.082-.027.327-.041.544-.054m3.537.041c0-.095-.068-.204-.163-.272l-.163-.15a.9.9 0 0 0-.327-.218c-.054-.014-.054-.014 0 .027.122.054.204.136.231.231.082.231.19.395.299.408s.122.014.122-.027m-2.014-.163-.109-.109a.4.4 0 0 0-.34-.095l-.082.027.109.095c.095.109.109.109.272.136h.205zm-2.381 0c.068-.014.204-.15.204-.19 0-.014-.082-.027-.177-.027s-.245.082-.272.163l-.068.082h.095l.218-.014Zm-.367 0 .054-.054.082-.095c.068-.082.082-.082.041-.095a.9.9 0 0 0-.313.027c-.054 0-.054.054 0 .054.082 0 .095.068.027.122-.027.014-.041.041-.041.054l.136-.014Zm2.912-.041c-.054-.054-.054-.082-.041-.095l.082-.027c.027 0 .041-.014.041-.027 0-.027-.259-.082-.354-.054h-.082l.095.068.082.082c0 .054.095.109.163.109h.082zm-7.184-.136.027-.109c.027-.041 0-.041-.095-.027-.136.014-.204-.014-.245-.122q-.02-.061-.041-.041l-.068.177-.027.136h.054c.095-.054.299.027.299.136 0 .054.068-.041.082-.136Zm11.415.136c0-.082.204-.177.299-.136.027.027.054.027.068.027l-.068-.204-.054-.19-.027.082c-.041.122-.122.163-.259.136-.068 0-.095 0-.095.027l.054.163c.041.122.082.177.082.095m-8.082-.054c.109-.041.163-.054.19-.041.014.027.054.014.299-.082.136-.041.082-.041-.095 0-.095.027-.136.027-.272 0-.218-.068-.272-.054-.381.041-.095.095-.109.122-.054.136.095.027.15 0 .313-.054m5.007.027-.082-.095c-.109-.109-.163-.122-.408-.054-.163.041-.19.027-.395-.041-.027 0-.027 0 0 .014.041.054.299.136.34.109.027-.014.082 0 .19.041.122.054.177.068.245.054l.109-.014Zm-5.306-.109c.054-.068.136-.177.163-.245a.7.7 0 0 1 .136-.19c.136-.068.136-.082.027-.041-.15.068-.19.082-.19.109.014.014-.054.082-.19.136-.136.068-.163.109-.19.204l-.041.109c0 .027 0 .041.082.041s.109-.014.204-.122m5.578.109-.041-.122c-.054-.095-.136-.177-.299-.272l-.109-.082c0-.027-.082-.082-.204-.136-.068-.014-.054 0 .041.068.054.027.095.095.136.19l.19.245c.095.095.122.122.19.122zm-3.537-.109.095-.068.041-.068c.027-.027.054-.054.041-.068-.041-.027-.299 0-.381.041-.109.054-.122.109-.027.109.041 0 .054 0 .054.054.014.054.041.054.163 0Zm1.374 0c0-.041.027-.054.054-.054.082 0 .082-.041 0-.109-.095-.054-.19-.068-.381-.041-.041 0-.027 0 .027.095a.54.54 0 0 0 .272.15s.027-.014.027-.041m-2.626-.095c.109-.041.136-.054.177-.027s.068.027.122 0l.19-.054c.122-.027.109-.027-.136 0a.4.4 0 0 1-.218-.027 1 1 0 0 0-.204-.068c-.095 0-.109 0-.19.082-.109.095-.122.109-.054.136a.6.6 0 0 0 .313-.041m.925-.054.082-.082-.259.054-.245.041.109.027.109.041c.027.027.122 0 .204-.082m3.129.068c.027-.027-.177-.19-.231-.204l-.218.068c-.19.068-.245.068-.381.027-.068-.027-.109-.027-.109-.014l.122.041.177.054h.109c.041-.041.068-.027.177 0 .109.054.272.068.34.027Zm-.966-.014.095-.041-.19-.041-.259-.054c-.054 0-.054 0 .027.082.082.095.15.095.327.054m-3.401-.122c.068-.054.136-.163.19-.245.068-.109.109-.136.177-.163.109-.041.082-.054-.041-.027-.054.014-.122.054-.15.082s-.109.082-.19.109c-.19.095-.218.122-.272.286-.014.054-.014.054.082.054s.122 0 .204-.095m4.626.095-.054-.136a.3.3 0 0 0-.163-.177l-.15-.054-.082-.054c-.054-.054-.204-.136-.286-.136-.027 0-.027 0 0 .027.136.041.177.082.245.19a1 1 0 0 0 .177.231c.095.109.122.109.218.109h.109Zm-8.109-.095c.122-.095.041-.299-.122-.299-.095 0-.163.068-.163.177 0 .163.177.231.286.136Zm11.538 0c.054-.054.041-.204-.014-.259-.136-.095-.327 0-.299.163l.054.109c.054.054.19.054.259 0ZM5.987 2.585l.136-.054-.068-.041c-.095-.054-.136-.231-.082-.299.054-.054 0-.054-.136 0l-.177.068-.027.014c0 .014.014.027.041.027s.068.027.109.068c.054.068.054.095.054.177v.095L6 2.586Zm4.027.027c.095-.027.136-.027.163 0 .027.014.109.014.299-.027l.136-.027h-.136c-.163.027-.19.014-.313-.041-.218-.109-.272-.122-.354-.054l-.109.082c-.041.027-.041.027.014.068.095.041.15.041.327 0Zm3.02 0c.041 0 .068-.027.068-.027l-.109-.095c-.095-.068-.109-.068-.204-.054l-.19.095c-.095.041-.122.054-.299.041l-.19-.014.204.041c.15.027.218.027.259 0l.163.014c.163.041.204.041.299 0m3.864-.068c0-.095 0-.109.068-.177.041-.041.095-.068.122-.068l.041-.027c0-.027-.014-.014-.041-.014l-.177-.068c-.136-.054-.19-.054-.136 0l.027.109c0 .054-.014.095-.082.163l-.068.082.136.054.122.054v-.109Zm-8.191.014c.027-.027.014-.027-.054 0l-.068.054c0 .027.095-.014.122-.054m.925-.041a1 1 0 0 0 .272-.272c.041-.054.095-.122.136-.136l.041-.041-.068.014a.3.3 0 0 0-.109.054.3.3 0 0 1-.095.054c-.231.082-.286.109-.354.218l-.054.109.136.041a.15.15 0 0 0 .095-.041m3.714 0c.014 0-.095-.177-.136-.204l-.177-.082c-.082-.027-.177-.068-.19-.095s-.068-.041-.122-.054c-.068-.014-.068 0-.027.014.054.041.136.136.204.231a.6.6 0 0 0 .163.15c.095.068.136.082.204.068zm-2.762-.069c.34-.041.544-.068.571-.095.014-.014-.327 0-.599.054-.218.027-.231.027-.299-.014-.095-.054-.095-.054-.136 0 0 .041 0 .054.054.082.027.014.082.027.109.014zm2.014.027c.068-.027.068-.041.041-.082l-.027-.041s-.054 0-.095.041l-.136.041a9 9 0 0 0-.735-.068l.612.082c.095 0 .19.027.204.041.054.027.068.027.136-.014m4.15-.122c.054-.136-.068-.272-.218-.231-.082.027-.136.15-.109.231a.17.17 0 0 0 .327 0m-10.436.068c.027-.014.041-.054.041-.109 0-.177-.163-.272-.286-.136-.163.15.054.381.245.245m10.068-.054a.216.216 0 0 1 .095-.272l.068-.027-.095-.041-.163-.068c-.082-.041-.136-.027-.082.014.068.082 0 .272-.109.313-.054.027-.068.054 0 .068.014 0 .095.014.163.054l.136.041-.027-.082Zm-9.837.027.15-.054c.041-.014.041-.027-.027-.068-.109-.068-.15-.19-.095-.299.027-.041.027-.054-.014-.041-.299.095-.367.136-.272.163.041 0 .082.054.109.109.041.068.041.109 0 .19-.027.054 0 .054.136 0Zm3.565-.054c.095-.136.109-.136.612-.204l.027-.027a21 21 0 0 1-.68.054l-.095.095-.068.109.068.027c.082.027.082.027.136-.054m2.776.027-.164-.191-.163-.027a15 15 0 0 1-.952-.082c-.082 0 .082.041.204.041l.435.054.299.041.095.109c.082.095.082.095.163.082zm4.476 0c-.041-.027-.068 0-.041.027h.041zm-6.953-.055c.041 0 .082-.027.082-.041 0-.027-.204-.041-.245-.027-.054.014-.054.054 0 .082.082.027.068.027.163 0Zm2.122 0c.082-.054 0-.095-.136-.068-.109 0-.122.027-.027.068.082.041.095.041.163 0m-1.755 0a.3.3 0 0 0-.082 0zm1.361 0a.3.3 0 0 0-.095 0zm-5.238-.136c.027-.027.041-.068.041-.136a.157.157 0 0 0-.163-.163.177.177 0 0 0-.136.299.19.19 0 0 0 .259 0m.408-.095-.027-.014c-.027 0-.054-.027-.095-.068a.27.27 0 0 1-.027-.272c.027-.041 0-.041-.136 0a.4.4 0 0 1-.163.068c-.041.014-.041.014.014.054l.095.068c.027.041.041.231 0 .259l-.027.027c0 .014.34-.095.367-.122m3.701.136h-.082zm.844 0h-.082zm4.286-.054.054-.109a.18.18 0 0 0-.177-.177c-.109 0-.177.068-.177.19 0 .068.014.095.054.136.082.041.19.041.245-.041m-3.918.014-.463-.027.449.054h.109zm3.592-.027a.14.14 0 0 1-.041-.095c0-.068.068-.177.136-.204.041-.027.054-.041.027-.054l-.177-.054c-.136-.054-.177-.054-.136 0 .054.054.041.19-.027.259l-.095.068-.027.014c.027.027.272.122.327.122.041 0 .041 0 0-.054Zm-8.329-.164.027-.122c0-.068 0-.095-.054-.136l-.122-.041c-.082 0-.163.082-.163.163 0 .095 0 .122.095.163.068.041.136.027.218-.027m8.055-.014c.068-.082.068-.163 0-.231-.109-.122-.299-.041-.299.136 0 .163.177.231.299.095m-4.871 0c.245-.014.34-.041.204-.041s-.571.068-.571.082a3 3 0 0 1 .367-.027Zm1.769.041c0-.027-.435-.082-.585-.068l.177.027a5 5 0 0 1 .408.041m-4.708-.068c.163-.054.163-.054.095-.082l-.095-.068c-.054-.054-.068-.204-.027-.245q.082-.082-.163 0c-.136.054-.163.068-.136.095.122.054.163.109.163.204l-.027.136c-.054.041 0 .027.19-.041m7.483.054-.014-.068a.25.25 0 0 1 .095-.272l.068-.041-.163-.054c-.204-.082-.19-.082-.163-.027a.244.244 0 0 1-.095.313l-.068.041.122.041zm-7.225-.19c.027 0 .054-.041.068-.082.068-.136 0-.259-.163-.259-.136 0-.204.136-.136.259.041.095.136.122.231.082m.408-.109c.068 0 .054-.041 0-.054-.109-.027-.177-.231-.109-.313.054-.054 0-.041-.163 0-.177.082-.19.082-.136.109.041 0 .082.041.109.068.041.068.054.204.027.231l-.027.041c0 .027.027.027.136-.014l.177-.068Zm6.558.068c.122-.109.041-.299-.122-.299-.095 0-.163.068-.163.177 0 .163.177.231.286.136Zm-.313 0c-.068-.082-.014-.272.095-.327.041-.027.041-.041.014-.041l-.286-.109v.082c.041.109 0 .19-.082.245l-.068.068s.272.109.327.109c.014 0 .014 0 0-.027m-6.027-.19c.054-.068.068-.136.027-.218-.054-.109-.19-.136-.272-.041-.082.068-.082.15-.014.231.054.082.204.082.259.027m5.442-.041c-.041-.054-.027-.177.054-.245l.095-.082s.014 0 0 0a1.6 1.6 0 0 0-.327-.136l.014.068c.054.082.027.163-.054.259l-.082.082.136.041.136.068c.054.027.068-.014.027-.054m.34.041c.054-.082.054-.204 0-.272-.082-.068-.19-.054-.259.014s-.068.15 0 .231c.054.082.19.082.245.027Zm-5.524-.04.136-.068-.027-.014-.082-.068c-.068-.068-.082-.204-.027-.272.054-.041 0-.041-.136 0l-.15.054c-.068 0-.054.041.014.082.041.014.082.068.095.109.027.068.027.095 0 .19-.027.054-.027.054.177-.014m.327-.177c.054-.041.054-.19 0-.245-.136-.136-.367 0-.286.19.041.122.19.136.272.054Zm4.599 0c.054-.027.082-.122.054-.19-.054-.136-.204-.136-.299-.041-.15.15.082.381.245.245Zm-4.354-.041.136-.041c.027-.014.041-.027 0-.027l-.095-.082c-.068-.054-.082-.177-.041-.259.041-.054.027-.054-.177.014l-.163.068.068.041c.136.095.15.177.095.313 0 .027 0 .041.041.027zm4.027.014c-.054-.095 0-.245.109-.299.082-.041.068-.054-.136-.122-.136-.041-.19-.041-.136 0 .054.054.027.177-.027.259l-.081.055c-.068 0-.014.027.136.082.163.068.19.068.163.014Zm-3.673-.189c.109-.095.027-.299-.136-.299-.082 0-.163.095-.163.177 0 .136.204.231.299.136Zm3.469-.014c.136-.163-.082-.381-.245-.245-.041.027-.054.068-.054.136 0 .163.204.245.299.109m-3.197-.013c.122-.041.177-.082.095-.082-.041 0-.136-.095-.136-.177l.014-.136c.041-.082.041-.082-.163 0l-.177.054.068.041c.109.054.163.177.109.313l.014.041zm2.857.014c-.054-.136 0-.272.109-.313l.082-.041-.177-.054c-.177-.068-.245-.068-.19-.014s.041.19-.027.259l-.082.068c-.041.014-.027.027.122.082.163.068.19.068.163 0ZM10.368.925c.041-.054.054-.082.041-.136-.041-.163-.204-.204-.313-.082-.068.082-.068.136-.014.204.068.109.19.109.272 0Zm2.299 0c.068-.054.068-.163 0-.231-.082-.068-.163-.082-.245 0-.095.082-.068.245.054.286.054.027.136 0 .19-.054M10.734.872c.041 0 .027-.041-.014-.054-.109-.041-.19-.245-.122-.313s0-.054-.177 0l-.177.082.068.027c.136.054.177.177.109.327 0 .041 0 .041.136-.014zm1.592.041c-.027-.109-.014-.19.068-.259.041-.027.082-.068.109-.068l-.136-.068c-.109-.041-.19-.068-.204-.054l.014.068c.041.082 0 .218-.082.272l-.068.041.299.122c.014 0 .014-.027 0-.054M10.925.735l.068-.109c0-.068 0-.095-.054-.136-.122-.122-.299-.054-.299.109 0 .15.163.231.272.136Zm.327-.136C11.157.517 11.13.381 11.198.3l.027-.068s-.068 0-.136.041a.8.8 0 0 1-.19.054c-.054 0-.054.041 0 .068.109.027.15.163.109.313l-.014.068.163-.068.163-.054-.068-.068Zm.517.109c-.068-.109-.027-.231.095-.299.054-.041.054-.054.041-.068l-.163-.054-.19-.027c.095.095.082.272-.041.34l-.054.041.163.068.163.054zm.299.041.068-.095c.054-.177-.15-.313-.299-.163-.068.068-.068.136 0 .231a.18.18 0 0 0 .231.027m-.599-.19c.068-.027.082-.054.082-.163 0-.163-.19-.218-.299-.095-.068.082-.068.163 0 .231s.136.068.218.027"
      }
    ),
    /* @__PURE__ */ jsx48(
      "path",
      {
        fill: "#ee1c25",
        d: "m12.925 16.721-.041-.435-.014-.34-.109-.095-.15-.095c-.014 0-.041 0-.041-.027 0-.041-.095-.109-.15-.109-.041 0-.054-.014-.054-.041 0-.054-.15-.15-.259-.15-.068 0-.095 0-.095.041s-.041.041-.054 0l-.136-.014c-.122 0-.136 0-.136.041 0 .068-.014.068-.082 0-.041-.027-.068-.041-.19-.027-.109 0-.136.027-.136.041 0 .041-.027.041-.068 0-.054-.054-.231-.041-.272 0-.014.041-.014.041-.054 0-.041-.014-.068-.027-.136-.014l-.095.014-.014.422c0 .231-.014.435-.027.435h-.231c-.544-.082-1.075.027-1.347.272l-.068.082-.095-.095c-.095-.082-.109-.082-.272-.082-.15 0-.313-.041-.354-.082l-.041-.272-.014-.272-.15-.095-.163-.122-.272.014-.354.014h-.082v.218a1 1 0 0 1-.027.245c0 .027-.068.041-.136.041-.163 0-.299.068-.367.177s-.163.15-.204.109l-.313-.354a10.9 10.9 0 0 1-2.422-4.49c0-.082-.041-.204-.054-.272a20.4 20.4 0 0 1-.503-3.483 22 22 0 0 1-.068-1.714v-.599l.19-.068a4.33 4.33 0 0 0 2.218-1.782 5 5 0 0 0 .449-.952l.571-.231 1.088-.395.558-.19a27 27 0 0 1 .694-.259l.476-.177.531-.19.952-.354c.082-.014.231-.068.354-.122l.231-.082.381.136a24 24 0 0 0 .776.283c.136.054.408.136.612.231l.912.327.571.218.218.068.476.177a42 42 0 0 1 1.17.422c.354.136.34.109.422.34a4.22 4.22 0 0 0 2.64 2.57l.136.041v.748a32 32 0 0 1-.218 3.061 14.2 14.2 0 0 1-1.225 4.327 13.5 13.5 0 0 1-1.742 2.585c-.313.367-.299.367-.49.381a.7.7 0 0 1-.299 0c-.122-.041-.136-.041-.299 0a.7.7 0 0 1-.231.054c-.068-.014-.068-.014-.082-.177l-.014-.177-.136-.095-.136-.095h-.204l-.299.027h-.095v.177c0 .163 0 .177-.041.163a1.2 1.2 0 0 0-.721-.041c-.136.027-.34.136-.49.231-.054.027-.054.027-.068-.054ZM8.87 15.02l.027-.122c0-.041.027-.068.136-.109l.136-.082c.014 0 .027.041.027.095v.095h.136l.19.014a3.4 3.4 0 0 0 .762.122 7 7 0 0 0 1.116 0 7.3 7.3 0 0 0 2.014-.136c.136 0 .177-.027.163-.122v-.068l.163.068c.136.082.136.082.136.177 0 .054 0 .109.027.109l.83-.041c.109-.014.136-.027.136-.068.014-.054.054-.068.218-.122l.218-.068v-.163l.204-.068.218-.068v-.095c.014-.122.014-.122.272-.136.19-.014.177 0 .136-.286a33 33 0 0 1-.245-1.714c.068 0 .517-.544.49-.585l.177-.299a6.3 6.3 0 0 0 .816-1.85.7.7 0 0 1 .082-.204c.027-.027.054-.122.082-.231l.027-.231c.041-.245.041-.34.014-.367a8 8 0 0 0-.095-1.537 6.2 6.2 0 0 0-.626-1.85 1 1 0 0 1-.109-.272c0-.082-.136-.286-.19-.313l-.027-.041c0-.068-.122-.218-.177-.245-.027 0-.136-.109-.231-.231a6.04 6.04 0 0 0-4.354-2.191 6.08 6.08 0 0 0-5.102 2.161l-.272.245c-.068.014-.177.177-.177.231 0 .027-.027.054-.068.082-.027.014-.054.041-.054.068s-.027.041-.041.068c-.041.027-.054.068-.054.136s-.027.136-.095.231a6.33 6.33 0 0 0-.748 3.456c-.054.054.068.735.136.83l.054.109a5.7 5.7 0 0 0 .911 2.027c.082.136.122.204.109.231 0 .027.014.068.082.136l.231.272a.6.6 0 0 0 .19.177c.041 0 .041.014.027.082l-.286 1.891.15.027c.245.027.245.027.245.136v.082l.218.068.231.082v.177l.19.054c.177.041.218.054.245.109.014.041.041.068.068.068l.857.068c.027 0 .041-.027.054-.054Zm-.571-.054-.272-.027c-.041-.041.095-.054.354-.054.272 0 .286 0 .34.054l.054.054H8.68c-.068 0-.231 0-.381-.027m2.136 0c-.095 0-.109-.041-.014-.041.15 0 .422.027.422.054h-.408Zm.544 0-.054-.068a.12.12 0 0 1-.041-.054l.381.027.027.068c.014.054.014.054-.136.054-.109 0-.15 0-.177-.027m.517-.041c.027-.068.041-.068.204-.082h.19l-.041.082c-.054.068-.068.068-.218.068h-.163zm.435.054c0-.027.49-.068.517-.041s-.027.027-.272.054zm2.136-.041c.054-.054.082-.054.34-.054s.381.014.34.054l-.707.054c-.041 0-.041 0 .027-.054m-5.306-.041c-.041-.054-.041-.082-.041-.19l.014-.136c.014 0 .136.259.136.313 0 .082-.027.095-.095.014Zm2.612-.082v-.136c.027.014.041.286.027.286 0 0-.027-.068-.027-.15m2.571.082c0-.041.014-.136.054-.19l.054-.122.014.136c.014.109.014.122-.054.19l-.068.068zm-4.109 0c-.136-.014-.204-.041-.19-.054s.068 0 .15 0l.231.041c.136.027.177.068.082.054a4 4 0 0 1-.272-.027Zm.422.027-.054-.054c-.027-.068-.027-.068.054-.068.054 0 .095.014.095.027 0 .041-.068.109-.095.095m2.204-.041-.041-.082h.095c.095 0 .095 0 .082.054s-.054.095-.082.095zm.177.041.136-.041.218-.027c.122-.027.177-.027.177 0l-.245.054c-.299.041-.286.041-.286.014m-4.694-.041c-.014-.014.041-.095.054-.095s.027 0 .027.027c0 .041-.054.095-.082.068m6.83-.014c-.041-.054 0-.095.041-.068.041.041.041.095 0 .095 0 0-.027 0-.041-.027m-4.218-.027c.014-.014.027-.122.027-.34v-.313l.054.041c.054.027.054.054.054.34v.299h-.078c-.068 0-.068 0-.054-.027m1.565-.136c0-.082 0-.218-.027-.272-.014-.109-.014-.136.027-.177l.068-.041c.014 0 .027.136.027.299a1.2 1.2 0 0 0 .027.327c.014.027 0 .041-.054.041h-.082v-.163Zm-4.272.109c0-.014-.068-.041-.15-.054l-.136-.041s0-.027.041-.041a1.5 1.5 0 0 1 .694 0 .05.05 0 0 1 .027.041h-.164c-.136-.027-.15-.014-.218.041-.041.041-.082.054-.095.054m.231 0c-.041-.041 0-.054.136-.041h.163l.014-.095c.027-.095.122-1.061.122-1.129 0-.041 0-.041.122 0l.136.068-.027.218-.095.98c0 .027-.544.027-.571 0m1.225 0 .041-.068c.054-.054.136-.068.231-.041q.054.014-.014.068c-.068.054-.272.082-.259.041m.599 0c-.027 0-.041-.027-.027-.054l.014-.313c.014-.19.027-.272.054-.299l.041-.014c.014.014-.014.694-.027.68zm1.401-.082c0-.041 0-.095.027-.095s0 .041 0 .095c-.014.122-.027.122-.027 0m1.497-.259c0-.34 0-.34.041-.327.041.027.041.054.054.259l.014.313c.014.068.014.082-.027.095l-.068.014v-.354Zm.408.299-.041-.054.109-.014c.082-.014.109-.014.163.027.068.068.054.095-.068.095-.068 0-.109-.014-.15-.054Zm.912-.109c-.027-.204-.095-1.048-.082-1.061.082-.041.218-.095.231-.082l.014.19.122 1.061h.136c.136 0 .163 0 .163.027s-.041.027-.272.027h-.272l-.027-.163Zm.707.095c-.041-.054-.082-.068-.122-.054l-.231.014v-.041c.027-.027.068-.041.34-.041.299 0 .408.027.408.082l-.041.014-.163.041-.122.041zm-4.082.014v-.286l.082.041c.095.054.136.041.163-.041.027-.041.054-.054.095-.054.095 0 .136.068.163.218l.014.136h-.259l-.272-.014Zm.803-.136c.014-.218.136-.272.245-.136l.068.082.082-.041.095-.041.014.136v.136h-.531zm.721-.014v-.408c.027 0 .041.027.041.027 0 .095.218-.082.231-.163v-.068l.082.041c.082.041.095.054.109.177v.313l.014.19h-.068l-.231.027h-.163v-.136Zm-3.32.068c.027-.054.068-.095.19-.15l.177-.082-.041.082a.7.7 0 0 1-.204.136l-.136.082zm1.184.054-.122-.014.014-.15.027-.313v-.163l.082-.041c.095-.054.095-.054.095 0 0 .041.163.204.218.204l.054-.027c.027-.082.027.014.014.259v.259h-.136zm3.565-.068a.6.6 0 0 1-.19-.15l-.041-.068.136.068a.43.43 0 0 1 .204.136l.027.082zm-4.898-.095c-.054-.136-.068-.163-.041-.313l.027-.177v.136c0 .095 0 .163.027.177l.068.095c.041.082.041.109.014.163l-.027.082zm.476.095.082-.177c.027 0-.014.15-.054.204-.041.041-.041.041-.027-.027m4.191 0a.3.3 0 0 1-.041-.109v-.082l.041.082c.027.041.054.095.041.136v.041l-.041-.054Zm.408-.014c-.027-.068-.027-.082.014-.136.082-.109.095-.19.095-.381q0-.19.027-.068c.041.272.027.408-.041.544l-.068.109zm-4.286 0-.177-.027v-.215l.218-.109.218-.095v.245c0 .204-.014.231-.054.231zm3.361-.204v-.231c0-.014.299.122.354.163.027.014.054.068.054.136v.109h-.109l-.204.041-.082.014v-.231Zm2.259.163a.14.14 0 0 1-.041-.082c0-.041 0-.041.041 0 .027 0 .054.054.054.082 0 .054 0 .054-.054 0m-7.674-.027c0-.014.014-.054.041-.068.027-.027.027-.027.027.041-.014.068-.068.109-.068.041Zm6.898-.109c0-.163 0-.15.027 0v.136c-.027 0-.027-.068-.027-.136m.082.068-.014-.204-.095-.871s.014-.027.041-.027l.068-.027h.041l.054.476.068.517c.014.082.027.082.286.054l.163-.014v.054l-.014.068h-.299c-.245 0-.299 0-.299-.027m-6.871-.041v-.054l.177.014c.272.027.272.027.286-.054a15 15 0 0 1 .109-.857l.027-.15.054.027c.041 0 .068.027.082.041l-.014.286a10 10 0 0 0-.082.707v.095h-.667v-.054Zm-.354-.054c-.163-.054-.177-.054-.136-.095.027-.041.068-.041.422-.027.272 0 .408.014.422.041.054.054.014.054-.177.041-.163-.027-.19-.014-.231 0q-.109.109-.299.041m7.932 0c-.068-.068-.068-.068-.245-.041h-.19v-.041c.014-.027.095-.027.408-.041.354-.014.463 0 .463.041a10 10 0 0 0-.354.136l-.068-.054Zm-6.857-.15.027-.313v.095c0 .109 0 .259-.027.313zm-.327.027v-.054a55 55 0 0 0 .122-.912s.014.054 0 .109q-.102.939-.122.857m6.68 0-.041-.408-.054-.449c0-.095 0-.095.014-.041a9 9 0 0 1 .082.898m-7.648-.051.041-.082c.027-.027.027-.027.027.014 0 .054-.041.136-.082.136v-.068Zm8.572.027c-.027-.041-.041-.136-.014-.136s.068.068.054.122c0 .041 0 .041-.027.014Zm-1.252-.068c0-.041 0-.054.014-.041v.082Zm-6.939.027h-.245v-.068c-.014-.082-.027-.082.204-.027l.19.027c.027-.027.068-.327.122-.707l.041-.367.014-.068.136.136.163.163-.041.313a9 9 0 0 1-.082.612h-.503Zm7.333 0-.095-.816-.027-.095.163-.15.163-.163v.109a10 10 0 0 0 .163 1.034.8.8 0 0 0 .34-.054c.054 0 .054 0 .054.068v.068h-.15a7 7 0 0 0-.612 0m-7.932-.095a1 1 0 0 1-.177-.027l.068-.082.068-.068h.707l.014.068c.041.082.027.082-.19.027l-.177-.041-.068.068c-.082.068-.082.068-.245.054m8.817-.041c-.068-.082-.082-.082-.286-.027l-.163.027V14h.721l.068.068.054.068-.177.041c-.177.014-.177.014-.231-.041Zm-1.306-.109c0-.054 0-.068.014-.041v.095Zm-7.701 0a11 11 0 0 0 .177-1.007l.122-.735c0-.014 0-.014.027 0 .027.041.027.095-.014.408l-.19 1.184c-.014.054-.041.109-.082.136-.054.054-.054.054-.041.014m9.361-.041a1 1 0 0 1-.082-.299 5 5 0 0 0-.109-.721l-.082-.449c-.027-.163-.014-.177.014-.218.041-.041.041-.027.041.027l.041.327a38 38 0 0 1 .231 1.361c.014.068 0 .068-.054-.027m-8.449-.054.041-.381c.041-.327.082-.517.082-.408a6 6 0 0 1-.136.803Zm7.565-.136c-.027-.204-.041-.34-.014-.299.014.054.068.476.054.49zm-8.299.109.068-.395.163-1.02v-.095l.122.095a.9.9 0 0 1 .204.245l.177.204c.041.027.068.068.068.082l-.136.898a6 6 0 0 1-.68-.014Zm8.368-.231-.054-.463-.041-.204.095-.095c.054-.041.136-.136.177-.204s.122-.163.19-.218l.109-.109v.095a55 55 0 0 1 .245 1.429s-.163.027-.354.027h-.34zm-.871.177-.014-.204v-.163c.014 0 .041.381.027.395v-.027Zm-5.932-.054c0-.041 0-.054.014-.027v.068Zm.463-.095c-.041-.027-.027-.054.041-.054.027 0 .054 0 .068.027v.027h-.136Zm.626 0a1.63 1.63 0 0 1-1.279-1.238v-.136s.027 0 .068.041l.272.163c.163.109.218.136.272.245.109.204.286.408.435.49a1.63 1.63 0 0 0 1.211.136c.218-.041.558-.163.558-.204q0-.041-.204.041c-.15.068-.476.136-.707.163-.136.014-.218 0-.408-.027a1.1 1.1 0 0 1-.599-.315c-.122-.136-.245-.299-.231-.327l.177.082.204.082c.027 0 .095.041.15.109a.97.97 0 0 0 .639.245c.327.027.844-.068.871-.15.014-.027 0-.027-.299.041-.163.054-.245.054-.503.054-.272-.014-.299-.014-.435-.095-.136-.068-.218-.136-.218-.136a3.1 3.1 0 0 0 1.32.041c.272-.054.272-.054.272.136v.136l-.095.068c-.163.109-.245.136-.531.245-.34.136-.585.15-.925.109Zm3.265 0c-.204-.027-.585-.163-.816-.286-.245-.136-.259-.136-.259-.313 0-.122 0-.136.054-.136h.177l.463.068c.15 0 .667-.027.816-.068l.136-.041-.054.054-.204.122c-.122.054-.177.068-.408.082-.272 0-.544-.027-.707-.095-.082-.027-.109-.027-.095 0 0 .041.231.109.449.136.435.068.789-.014 1.048-.231a.44.44 0 0 1 .15-.109l.218-.082.163-.082-.082.15c-.095.15-.231.272-.395.367-.109.068-.544.177-.694.177s-.571-.095-.762-.163c-.177-.068-.218-.082-.218-.054s.272.136.463.19l.435.068c.231 0 .272 0 .503-.054a1.1 1.1 0 0 0 .313-.109c.136-.082.354-.299.435-.435.068-.136.136-.231.177-.231.014 0 .136-.068.259-.163a2 2 0 0 1 .245-.136l-.15.531a1.77 1.77 0 0 1-.952.803 2.5 2.5 0 0 1-.707.027Zm1.061 0c-.068-.014-.041-.054.027-.054.054 0 .068 0 .054.041 0 .027 0 .027-.082 0Zm-5.388-.136v-.082s.027.027.027.068-.014.068-.027.068v-.068Zm.449.027c-.163-.041-.408-.15-.517-.245a1.2 1.2 0 0 1-.327-.408c-.109-.19-.177-.476-.231-.844v-.109l.068.068.163.136c.095.054.095.068.109.204a1.63 1.63 0 0 0 .735 1.129l.136.082-.014.014-.136-.027Zm4.898 0 .136-.109a1.6 1.6 0 0 0 .463-.476 1.3 1.3 0 0 0 .218-.571c.027-.177.041-.19.19-.313l.095-.082.068-.054v.177c-.027.299-.163.707-.327.939a1.17 1.17 0 0 1-.653.463c-.136.041-.245.054-.204.014Zm1.32-.231v-.029.095Zm-6.911-.029a1.2 1.2 0 0 1-.463-.517 2.2 2.2 0 0 1-.259-.966v-.136l.136.109c.136.109.136.136.136.231.014.286.163.803.299 1.007l.177.218.109.136zm6.299 0c.272-.218.476-.707.517-1.252.014-.136.014-.15.15-.272l.136-.136v.136a2.04 2.04 0 0 1-.49 1.347 1.5 1.5 0 0 1-.381.259l.068-.068Zm-3.293 0-.082-.027v-.177c0-.245 0-.272.272-.272.163 0 .204.014.231.054.041.068.041.367 0 .408-.054.041-.313.054-.408.014Zm.272-.218c0-.082-.041-.163-.082-.163v.286l-.027.068.041-.054c.041-.027.054-.082.054-.136Zm3.592.041v-.136a.5.5 0 0 1 .027.204c0 .014-.027-.014-.027-.068m-7.456-.272c-.095-.082-.286-.381-.354-.544a3 3 0 0 1-.136-.558.45.45 0 0 1 .027-.231c.014-.068.041-.122.054-.122l.109.109.095.095.014.231c.014.34.109.748.231.925.041.068.068.163.041.163zm7.442.041.082-.15c.136-.259.204-.531.218-.857l.014-.299.095-.095.109-.095.041.082c.068.095.068.286 0 .49l-.054.231c-.054.245-.381.721-.49.721 0 0-.014-.014 0-.027Zm-4.939-.517-.176-.028c-.259-.068-.599-.231-.612-.272s-.095-.095-.177-.15a6 6 0 0 1-.544-.299c-.041 0-.408-.272-.408-.313l3.197-.014h3.197c0 .054-.381.34-.408.327a.6.6 0 0 0-.204.095l-.313.19c-.163.095-.218.136-.218.177 0 .014-.027.041-.068.054l-.245.095-.367.136-.19.054-.041-.054c-.054-.068-.054-.109-.014-.163s.027-.109-.068-.204q-.082-.082-.15-.041c-.095.054-.122.054-.19 0-.041-.041-.041-.068-.027-.136 0-.068 0-.082-.109-.136l-.136-.054-.054.068c-.054.068-.082.082-.122.068-.082-.014-.109-.041-.109-.109s-.027-.082-.163-.082-.136 0-.177.095c0 .054-.041.082-.082.095-.054.014-.082 0-.15-.068s-.082-.082-.122-.041l-.109.054c-.068.027-.068.027-.068.122 0 .082 0 .095-.054.136-.054.027-.054.027-.136 0l-.082-.054-.082.082c-.109.082-.136.163-.068.204.054.041.041.109-.014.163l-.068.054-.068-.027Zm-3.061-.136-.136-.15.068-.19.068-.15.041.204.082.313.027.109-.136-.136Zm8.504.136c0-.027.068-.095.15-.177l.163-.136c0 .041-.041.082-.204.218l-.109.082Zm.054-.163.027-.109c.027-.041.041-.136.054-.218.014-.19.027-.177.109.068a.35.35 0 0 1-.082.163zm-.558-1.551-.081-.219-.041-.136-.816-.014h-.775v-.082c-.014-.068-.027-.068-.068-.054-.054 0-.068 0-.068-.082l.027-.109c.014 0 .014-.014 0-.027l.068-.068c.082-.068.095-.095.027-.109l-.082-.068c-.027-.054-.041-.054-.082-.041-.068.041-.054 0 .027-.068.068-.068.082-.068.041-.095l-.041-.068c0-.027-.082-.041-.15-.041-.054 0-.054 0-.054-.218 0-.177-.014-.231-.041-.231s-.041 0-.041-.027-.014-.014-.054 0c-.027 0-.054 0-.054.054v.054H9.973V8.98c.014-.054 0-.068-.041-.068a.14.14 0 0 0-.095.041c-.054.041-.054.082-.054.259v.204h-.082c-.068-.027-.082-.014-.095.027 0 .027-.041.054-.068.068-.041.014-.041.014 0 .054l.082.082.041.041H9.62c-.041-.041-.122 0-.122.054 0 0-.014.027-.041.027-.068 0-.068.068 0 .109s.095.095.095.218c0 .054 0 .068-.054.068s-.041.014-.041.068v.068H7.851l-.027.054-.068.231-.068.19-.082-.109c-.054-.068-.068-.109-.054-.136s-.014-.082-.109-.231l-.19-.354c-.027-.095-.082-.163-.109-.163-.068-.027-.136-.231-.272-.68a3.4 3.4 0 0 1-.109-1.293c.027-.014.041-.109.054-.259a2 2 0 0 1 .095-.599.5.5 0 0 0 .014-.204c-.014-.177.204-.748.435-1.143a4.63 4.63 0 0 1 3.878-2.313 4.585 4.585 0 0 1 4.612 3.456c0 .054 0 .177.027.313l.068.327c.027.299.041.395.068.449a4.2 4.2 0 0 1-.19 1.497c-.068.272-.136.408-.19.449a.8.8 0 0 0-.136.218l-.19.34a.54.54 0 0 0-.095.218.3.3 0 0 1-.068.15l-.068.095-.027-.095Zm-4.462-2.804v-.177c0-.245 0-.245.272-.313.136-.027.245-.068.245-.082l-.068-.041c-.136-.041-.354-.136-.367-.163v-.503c0-.014-.041 0-.068.054l-.122.136-.109.136c-.041.041-.068.054-.082.027l-.109-.041L10 6.842c-.095-.041-.15-.054-.15-.014l.109.204.122.218-.15.19c-.136.177-.177.218-.136.218l.231-.054.231-.054.15.204.136.218zm1.701 0 .122-.218c.082-.136.082-.136.163-.109l.177.041c.136.054.245.068.245.041l-.054-.082a3 3 0 0 1-.259-.286c-.014-.014.041-.136.095-.19.054-.068.15-.272.136-.272l-.109.014-.231.095-.136.054-.163-.19-.177-.19v.272c.014.122.027.231 0 .245l-.354.163c-.041 0-.082.027-.082.041l.245.082.245.054v.163l.027.245c0 .122.041.136.095.027ZM8.83 6.313l.177-.15.231.122c.19.122.272.136.218.082l-.054-.136-.082-.204c-.054-.082-.054-.095 0-.136l.19-.177c.163-.136.19-.177.082-.15l-.259.027h-.19l-.068-.163-.095-.19-.014-.054-.027-.054c-.027 0-.041.068-.068.163l-.054.245c-.027.082-.027.082-.163.095l-.245.027c-.136 0-.136.041-.041.109l.19.109.122.068c.014.014.014.068-.014.231l-.068.245c-.027.082.054.041.218-.109Zm5.333.095-.054-.231c-.068-.218-.082-.19.19-.354l.177-.136-.163-.041-.259-.014-.095-.014-.041-.231c-.027-.136-.068-.245-.082-.245s-.109.19-.177.381l-.027.082-.231-.014a7 7 0 0 1-.272 0s.082.095.19.177c.177.163.19.163.15.231-.082.136-.163.381-.136.395.014 0 .136-.054.299-.163l.136-.082.177.15.19.163zm-3.469-.49.272-.204a17 17 0 0 0 .408-.299c.014 0 .408.272.707.503.109.082.163.082.122 0l-.15-.422-.136-.435a23 23 0 0 0 .803-.626c0-.014-.19-.027-.517-.027h-.502l-.027-.082c-.027-.054-.027-.109-.027-.136l-.041-.095-.054-.163-.068-.177-.054-.177c0-.054-.027-.095-.041-.095-.027 0-.068.136-.19.517l-.136.367c0 .041-.014.041-.503.041-.272 0-.503.014-.503.027l.136.109.19.136.259.19c.109.068.19.136.204.163 0 .027-.19.68-.272.844-.054.136-.041.15.109.041Z"
      }
    ),
    /* @__PURE__ */ jsx48(
      "path",
      {
        fill: "#152584",
        d: "m12.925 16.721-.041-.435-.014-.34-.109-.095-.15-.095c-.014 0-.041 0-.041-.027 0-.041-.095-.109-.15-.109-.027 0-.054-.014-.054-.041s-.041-.054-.082-.095c-.082-.068-.272-.082-.272-.014 0 .027-.041.041-.054 0l-.136-.014c-.122 0-.136 0-.136.041 0 .054-.014.054-.082 0-.041-.041-.068-.041-.19-.027-.109 0-.136.027-.136.041 0 .027-.014.027-.068 0-.068-.054-.231-.041-.272 0-.014.041-.014.041-.054 0-.041-.014-.068-.027-.136-.014l-.095.014-.014.422c0 .231-.014.435-.027.435h-.231c-.544-.082-1.075.027-1.347.272l-.068.082-.095-.095c-.095-.082-.095-.082-.272-.082-.15 0-.313-.041-.354-.082l-.041-.272-.014-.272-.15-.109-.15-.109-.286.014-.354.014h-.082v.422c-.027.054-.027.068-.163.068-.163.014-.299.082-.367.19s-.15.15-.204.109c-.136-.095-.816-.98-1.17-1.497a11.16 11.16 0 0 1-1.863-4.844 25 25 0 0 1-.313-3.959v-.599l.19-.068A4.3 4.3 0 0 0 5.945 2.83c.041-.041.408-.177 1.605-.612a70 70 0 0 0 1.306-.476l.476-.177.531-.19.952-.354.354-.122.231-.082.367.136.449.163 1.85.68.585.204.218.082.476.177a42 42 0 0 1 1.156.408c.367.136.354.136.435.354a4.22 4.22 0 0 0 2.643 2.557l.136.041v.748a32 32 0 0 1-.231 3.061 14.2 14.2 0 0 1-1.211 4.327 13.5 13.5 0 0 1-1.742 2.585c-.313.367-.299.354-.49.381a.7.7 0 0 1-.299 0c-.136-.041-.136-.041-.299 0-.095.027-.204.054-.245.041-.068 0-.068 0-.068-.163l-.014-.177-.136-.109-.177-.095-.299.027-.272.014v.177c0 .163 0 .177-.041.163a1.2 1.2 0 0 0-.707-.054 2 2 0 0 0-.49.231c-.054.041-.054.041-.068-.041ZM8.87 15.02l.027-.122c0-.041.027-.068.136-.109l.136-.082c.014 0 .027.041.027.095v.095h.136l.19.014a3.4 3.4 0 0 0 .762.122 7 7 0 0 0 1.116 0 7.3 7.3 0 0 0 2.014-.136c.136 0 .177-.027.163-.122v-.068l.15.068c.136.068.136.082.15.177.014.109.014.109.082.109l.476-.014.408-.027.027-.054c.027-.054.068-.082.163-.109.272-.082.259-.068.272-.177 0-.054 0-.095.027-.095l.218-.054.19-.054v-.095l.027-.109.204-.041c.218-.027.218 0 .163-.286a33 33 0 0 1-.245-1.714c.068 0 .531-.531.49-.585l.177-.299a6.2 6.2 0 0 0 .816-1.864l.095-.19c.027-.027.054-.122.068-.231l.041-.231c.027-.245.041-.34 0-.367a6.23 6.23 0 0 0-.68-3.306 2 2 0 0 1-.15-.367c0-.068-.136-.272-.177-.299-.027 0-.041-.027-.041-.041 0-.054-.109-.218-.163-.245-.027 0-.136-.109-.245-.231a6.19 6.19 0 0 0-9.538.082c-.068.082-.136.136-.163.136-.041 0-.177.19-.177.245 0 .027-.027.054-.054.082-.041.014-.068.054-.068.068l-.041.068c-.027.027-.054.082-.054.136s-.027.136-.082.231A6.3 6.3 0 0 0 5.17 8.49c-.014.041.014.34.068.612.014.082.041.177.082.218l.054.095a5.7 5.7 0 0 0 .885 2.014l.109.231c-.014.027 0 .068.068.136l.231.272c.095.109.177.19.204.19s.041 0 .027.068l-.299 1.891.15.027c.245.027.245.027.259.136v.095l.218.068.218.068v.177l.204.054c.163.041.204.068.231.122l.068.068.857.054c.027 0 .041-.014.054-.054Z"
      }
    )
  ] });
}

// src/footer.module.scss
var footer_module_default = {
  "footer": "rgft_563c562a",
  "main-container-grid": "rgft_45aa1f39",
  "content-grid": "rgft_11eb7627",
  "primary-button": "rgft_d0491a70",
  "language-selector-col": "rgft_fc2c8cd2",
  "content": "rgft_d212d948",
  "nav-item-col": "rgft_114d6be0",
  "nav-links-list": "rgft_290ac8b1",
  "item-expander-col": "rgft_1a4673cc",
  "back-to-top-col": "rgft_29322bb5",
  "back-to-top-button": "rgft_a69dc288",
  "eoe-col": "rgft_6bf4d00d",
  "social-links": "rgft_5570117e",
  "legal-links-col": "rgft_caf08481",
  "legal-links": "rgft_fbe69ca6",
  "legal-text-wrapper": "rgft_7a36e004",
  "china-links": "rgft_40fd0c7f",
  "china": "rgft_8503a4bd",
  "footer-link": "rgft_27323f5c",
  "cookie-link": "rgft_88b4811b",
  "bold": "rgft_25381ce6"
};

// src/FooterLink.tsx
import { useCallback as useCallback15 } from "react";

// src/ccba.tsx
import { jsx as jsx49, jsxs as jsxs23 } from "react/jsx-runtime";
function CCBAIcon() {
  return /* @__PURE__ */ jsxs23(
    "svg",
    {
      role: "img",
      className: "",
      style: { height: 18, verticalAlign: "middle", marginTop: -2, marginLeft: 4 },
      enableBackground: "new 0 0 30 14",
      version: "1.1",
      viewBox: "0 0 30 14",
      xmlSpace: "preserve",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx49("title", { children: "California Consumer Privacy Act (CCPA) Opt-Out Icon" }),
        /* @__PURE__ */ jsx49(
          "style",
          {
            type: "text/css",
            dangerouslySetInnerHTML: {
              __html: ".st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#0066FF;}.st2{fill:#FFFFFF;}.st3{fill:#0066FF;}"
            }
          }
        ),
        /* @__PURE__ */ jsx49("g", { transform: "translate(-1275 -200)", children: /* @__PURE__ */ jsx49("g", { transform: "translate(1275 200)", children: /* @__PURE__ */ jsx49("path", { className: "st0", d: "m7.4 12.8h6.8l3.1-11.6h-9.9c-3.2 0-5.8 2.6-5.8 5.8s2.6 5.8 5.8 5.8z" }) }) }),
        /* @__PURE__ */ jsx49("g", { transform: "translate(-1275 -200)", children: /* @__PURE__ */ jsxs23("g", { transform: "translate(1275 200)", children: [
          /* @__PURE__ */ jsx49(
            "path",
            {
              className: "st1",
              d: "m22.6 0h-15.2c-3.9 0-7 3.1-7 7s3.1 7 7 7h15.2c3.9 0 7-3.1 7-7s-3.2-7-7-7zm-21 7c0-3.2 2.6-5.8 5.8-5.8h9.9l-3.1 11.6h-6.8c-3.2 0-5.8-2.6-5.8-5.8z"
            }
          ),
          /* @__PURE__ */ jsx49(
            "path",
            {
              className: "st2",
              d: "m24.6 4c0.2 0.2 0.2 0.6 0 0.8l-2.1 2.2 2.2 2.2c0.2 0.2 0.2 0.6 0 0.8s-0.6 0.2-0.8 0l-2.2-2.2-2.2 2.2c-0.2 0.2-0.6 0.2-0.8 0s-0.2-0.6 0-0.8l2.1-2.2-2.2-2.2c-0.2-0.2-0.2-0.6 0-0.8s0.6-0.2 0.8 0l2.2 2.2 2.2-2.2c0.2-0.2 0.6-0.2 0.8 0z"
            }
          ),
          /* @__PURE__ */ jsx49(
            "path",
            {
              className: "st3",
              d: "m12.7 4.1c0.2 0.2 0.3 0.6 0.1 0.8l-4.2 4.9c-0.1 0.1-0.2 0.2-0.3 0.2-0.2 0.1-0.5 0.1-0.7-0.1l-2.2-2.2c-0.2-0.2-0.2-0.6 0-0.8s0.6-0.2 0.8 0l1.8 1.7 3.8-4.5c0.2-0.2 0.6-0.2 0.9 0z"
            }
          )
        ] }) })
      ]
    }
  );
}

// src/i18n.ts
var FOOTER_I18N_STRINGS = {
  "footer-action-cookie-preferences": {
    "ar-SA": "\u062A\u0641\u0636\u064A\u0644\u0627\u062A \u0645\u0644\u0641\u0627\u062A \u062A\u0639\u0631\u064A\u0641 \u0627\u0644\u0627\u0631\u062A\u0628\u0627\u0637",
    "de-DE": "Cookie-Einstellungen",
    "en-GB": "Cookie Preferences",
    "en-US": "Cookie Preferences",
    "es-ES": "Preferencias de cookies",
    "fr-FR": "Pr\xE9f\xE9rences en mati\xE8re de cookies",
    "id-ID": "Preferensi Cookie",
    "it-IT": "Preferenze cookie",
    "ja-JP": "Cookie \u306E\u8A73\u7D30\u8A2D\u5B9A",
    "ko-KR": "\uCFE0\uD0A4 \uAE30\uBCF8 \uC124\uC815",
    "pt-BR": "Prefer\xEAncias de cookies",
    "ru-RU": "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0444\u0430\u0439\u043B\u043E\u0432 cookie",
    "th-TH": "\u0E04\u0E48\u0E32\u0E01\u0E33\u0E2B\u0E19\u0E14\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E01\u0E01\u0E35\u0E49",
    "tr-TR": "\xC7erez Tercihleri",
    "vi-VN": "T\xF9y ch\u1ECDn cookie",
    "zh-CN": "Cookie \u9996\u9009\u9879",
    "zh-TW": "Cookie \u504F\u597D\u8A2D\u5B9A"
  },
  "footer-action-privacy-preferences": {
    "ar-SA": "\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643",
    "de-DE": "Ihre Datenschutzoptionen",
    "en-GB": "Your Privacy Choices",
    "en-US": "Your Privacy Choices",
    "es-ES": "Sus opciones de privacidad",
    "fr-FR": "Vos choix en mati\xE8re de confidentialit\xE9",
    "id-ID": "Pilihan Privasi Anda",
    "it-IT": "Le tue scelte sulla privacy",
    "ja-JP": "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u306E\u9078\u629E\u80A2",
    "ko-KR": "\uAC1C\uC778 \uC815\uBCF4 \uBCF4\uD638 \uC120\uD0DD",
    "pt-BR": "Suas op\xE7\xF5es de privacidade",
    "ru-RU": "\u0412\u0430\u0448 \u0432\u044B\u0431\u043E\u0440 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438",
    "th-TH": "\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E04\u0E27\u0E32\u0E21\u0E40\u0E1B\u0E47\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E15\u0E31\u0E27\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    "tr-TR": "Gizlilik Se\xE7enekleriniz",
    "vi-VN": "C\xE1c L\u1EF1a Ch\u1ECDn V\u1EC1 Quy\u1EC1n Ri\xEAng T\u01B0",
    "zh-CN": "\u60A8\u7684\u9690\u79C1\u9009\u62E9",
    "zh-TW": "\u60A8\u7684\u96B1\u79C1\u6B0A\u9078\u64C7"
  },
  "footer-china-legal-text": {
    "ar-SA": "",
    "de-DE": "",
    "en-GB": "Amazon Web Services in China: We're committed to providing Chinese software developers and enterprises with secure, flexible, reliable, and low-cost IT infrastructure resources to innovate and rapidly scale their businesses. 'AWS' is an abbreviation of 'Amazon Web Services', and is not displayed herein as a trademark. ",
    "en-US": "Amazon Web Services in China: We're committed to providing Chinese software developers and enterprises with secure, flexible, reliable, and low-cost IT infrastructure resources to innovate and rapidly scale their businesses. 'AWS' is an abbreviation of 'Amazon Web Services', and is not displayed herein as a trademark. ",
    "es-ES": "",
    "fr-FR": "",
    "id-ID": "",
    "it-IT": "",
    "ja-JP": "",
    "ko-KR": "",
    "pt-BR": "",
    "ru-RU": "",
    "th-TH": "",
    "tr-TR": "",
    "vi-VN": "",
    "zh-CN": '\u6211\u4EEC\u81F4\u529B\u4E8E\u4E3A\u4E2D\u56FD\u7684\u8F6F\u4EF6\u5F00\u53D1\u4EBA\u5458\u548C\u4F01\u4E1A\u63D0\u4F9B\u5B89\u5168\u3001\u7075\u6D3B\u3001\u53EF\u9760\u4E14\u4F4E\u6210\u672C\u7684 IT \u57FA\u7840\u8BBE\u65BD\u8D44\u6E90\uFF0C\u5E2E\u52A9\u4ED6\u4EEC\u5B9E\u73B0\u521B\u65B0\u548C\u5FEB\u901F\u6269\u5927\u4F01\u4E1A\u89C4\u6A21\u3002"AWS" \u662F"Amazon Web Services"\u7684\u7F29\u5199\uFF0C\u5728\u6B64\u7F51\u7AD9\u4E0D\u4F5C\u4E3A\u5546\u6807\u5C55\u793A\u3002',
    "zh-TW": ""
  },
  "footer-china-legal-link-text": {
    "ar-SA": "",
    "de-DE": "",
    "en-GB": "Explore China customer stories",
    "en-US": "Explore China customer stories",
    "es-ES": "",
    "fr-FR": "",
    "id-ID": "",
    "it-IT": "",
    "ja-JP": "",
    "ko-KR": "",
    "pt-BR": "",
    "ru-RU": "",
    "th-TH": "",
    "tr-TR": "",
    "vi-VN": "",
    "zh-CN": "\u4E86\u89E3\u5BA2\u6237\u600E\u6837\u5728\u4E2D\u56FD\u4F7F\u7528\u4E9A\u9A6C\u900A\u4E91\u79D1\u6280\u670D\u52A1",
    "zh-TW": ""
  }
};

// src/FooterLink.tsx
import { jsx as jsx50, jsxs as jsxs24 } from "react/jsx-runtime";
function FooterLink({ heading, small, ...rest }) {
  if ("action" in rest) {
    return /* @__PURE__ */ jsx50(FooterActionLink, { heading, action: rest.action, actions: rest.actions });
  }
  const linkClasses = clsx_default(footer_module_default["footer-link"], {
    [footer_module_default.bold]: "bold" in rest && rest.bold
  });
  return /* @__PURE__ */ jsx50(Link, { size: small ? 2 : 1, href: rest.linkURL, className: linkClasses, injectAnalyticsMetadata: true, children: heading });
}
function FooterActionLink({ heading, action, actions }) {
  const { T } = useTranslate(FOOTER_I18N_STRINGS);
  if (!actions) {
    throw new Error("Action link must include the `actions` prop.");
  }
  const displayLabel = heading || T(`footer-action-${action}`);
  const handleClick = useCallback15(
    (e2) => {
      e2.preventDefault();
      if (action === "cookie-preferences") {
        actions.cookiePreferences();
      } else {
        actions.privacyPreferences();
      }
    },
    [action, actions]
  );
  return /* @__PURE__ */ jsxs24(Link, { size: 2, onClick: handleClick, className: footer_module_default["footer-link"], href: "#", injectAnalyticsMetadata: true, children: [
    displayLabel,
    action === "privacy-preferences" ? /* @__PURE__ */ jsx50(CCBAIcon, {}) : null
  ] });
}

// ../../hooks/dist/esm/useTransitionState.js
import { useEffect as useEffect23, useRef as useRef12, useState as useState19 } from "react";
var TRANSITION_ATTRIBUTE = "data-transition-state";
var useTransitionState = (opts) => {
  const { in: active = false, duration = 300 } = opts;
  const [element, setElement] = useState19(null);
  const previousActiveRef = useRef12(active);
  const [transitionState, setTransitionState] = useState19(active ? "entered" : "exited");
  useEffect23(() => {
    let timeout = 0;
    if (active === previousActiveRef.current) {
      return;
    }
    if (active) {
      setTransitionState("entering");
      timeout = window.setTimeout(() => {
        setTransitionState("entered");
      }, duration);
    } else {
      setTransitionState("exiting");
      timeout = window.setTimeout(() => {
        setTransitionState("exited");
      }, duration);
    }
    previousActiveRef.current = active;
    return () => window.clearTimeout(timeout);
  }, [active, duration]);
  useEffect23(() => {
    element?.setAttribute(TRANSITION_ATTRIBUTE, transitionState);
  }, [element, transitionState]);
  useEffect23(() => {
    if (element instanceof HTMLElement) {
      element.style.setProperty("transition-duration", `${duration}ms`);
    }
  }, [element, duration]);
  return {
    transitioning: transitionState !== "entered" && transitionState !== "exited",
    transitionState,
    ref: setElement
  };
};

// ../../components/dist/esm/AlertBanner/AlertBanner.js
import { forwardRef as forwardRef30 } from "react";

// ../../components/dist/esm/AlertBanner/alert-banner.module.css
var alert_banner_default = {
  "alert-banner": "rgft_e2a14e2b",
  "alert-banner--positive": "rgft_6ddc2911",
  "icon": "rgft_a1bb4875",
  "alert-banner--neutral": "rgft_5bbed488",
  "alert-banner--notice": "rgft_d85f2d1c",
  "alert-banner--negative": "rgft_dd2ea975",
  "banner-enter": "rgft_663bee7c",
  "banner-opacity-enter": "rgft_73875065",
  "banner-exit": "rgft_1416c90d",
  "banner-opacity-exit": "rgft_669572c2",
  "inner": "rgft_dc93dc62",
  "content": "rgft_7b208d8e",
  "title": "rgft_da68aaba",
  "text": "rgft_a53dc04a",
  "message": "rgft_aa8b943e",
  "interactions": "rgft_f436461f",
  "close": "rgft_227600ee"
};

// ../../components/dist/esm/AlertBanner/AlertBanner.js
import { jsx as jsx51, jsxs as jsxs25 } from "react/jsx-runtime";
var iconNames = {
  positive: "verify",
  neutral: "info",
  notice: "alert",
  negative: "cancel"
};
var AlertBanner = forwardRef30(
  ({
    className,
    variant,
    title,
    message,
    action,
    dismissible = true,
    icon = true,
    visible = true,
    onDismiss = () => null
  }, ref) => {
    const { ref: transitionRef } = useTransitionState({ in: visible });
    const refs = useMergeRefs(ref, transitionRef);
    const classes = clsx_default(className, alert_banner_default["alert-banner"], alert_banner_default[`alert-banner--${variant}`]);
    return /* @__PURE__ */ jsx51(Box, { ref: refs, className: classes, bg: variant, children: /* @__PURE__ */ jsx51("div", { className: alert_banner_default.inner, children: /* @__PURE__ */ jsxs25("div", { className: alert_banner_default.content, children: [
      /* @__PURE__ */ jsxs25("div", { className: alert_banner_default.title, children: [
        /* @__PURE__ */ jsx51(When, { condition: icon, children: /* @__PURE__ */ jsx51(Icon, { name: iconNames[variant], className: alert_banner_default.icon }) }),
        /* @__PURE__ */ jsx51(TitleText, { className: alert_banner_default.text, size: 3, children: title })
      ] }),
      /* @__PURE__ */ jsx51("div", { className: alert_banner_default.message, children: /* @__PURE__ */ jsx51(When, { condition: message, children: /* @__PURE__ */ jsx51(BodyText, { size: 2, children: message }) }) }),
      action && /* @__PURE__ */ jsx51("div", { className: alert_banner_default.interactions, children: action }),
      /* @__PURE__ */ jsx51(When, { condition: dismissible, children: /* @__PURE__ */ jsx51("div", { className: alert_banner_default.close, children: /* @__PURE__ */ jsx51(CloseButton, { size: "m", onClick: onDismiss }) }) })
    ] }) }) });
  }
);

// src/Footer.tsx
import { Fragment as Fragment9, jsx as jsx52, jsxs as jsxs26 } from "react/jsx-runtime";
var primaryCtaColSpan = {
  xl: 6,
  l: 6,
  m: 6,
  s: 12,
  xs: 12
};
var languageSelectorColSpan = {
  xl: 6,
  l: 6,
  m: 6,
  s: 12,
  xs: 12
};
var eoeColSpan = {
  xl: 9,
  l: 8,
  m: 8,
  s: 12,
  xs: 12
};
var socialColSpan = {
  xl: 3,
  l: 4,
  m: 4,
  s: 12,
  xs: 12
};
function Footer({
  dark,
  locale,
  createAccountButtonLabel,
  createAccountButtonURL,
  backToTopText,
  items,
  eoeText,
  disclosureItems,
  copyrightText,
  socialItems,
  availableLanguages,
  isChinaSite,
  alertBannerItems,
  findPortalRoot,
  onShowCookiePreferences,
  onShowPrivacyPreferences = () => null,
  onLanguageSelect
}) {
  const [expandedItems, setExpandedItems] = useState20(/* @__PURE__ */ new Set());
  const filteredLanguageOptions = useMemo15(() => filterLanguageOptions(availableLanguages), [availableLanguages]);
  const { T } = useTranslate(FOOTER_I18N_STRINGS, { locale });
  const classes = clsx_default(footer_module_default["legal-links-col"], {
    [footer_module_default.china]: isChinaSite
  });
  const isMobileStyles = useIsBreakpoint("smallphone", "phone", "tablet");
  const footerLegalLinks = useMemo15(() => {
    if (!disclosureItems.find((item) => "action" in item)) {
      return [...disclosureItems, { action: "cookie-preferences" }];
    }
    return disclosureItems;
  }, [disclosureItems]);
  const footerLinkActions = useMemo15(
    () => ({
      cookiePreferences: onShowCookiePreferences,
      privacyPreferences: onShowPrivacyPreferences
    }),
    [onShowCookiePreferences, onShowPrivacyPreferences]
  );
  const toggleItem = (itemId) => {
    const newExpandedItems = new Set(expandedItems);
    if (newExpandedItems.has(itemId)) {
      newExpandedItems.delete(itemId);
    } else {
      newExpandedItems.add(itemId);
    }
    setExpandedItems(newExpandedItems);
  };
  const backToTop = (e2) => {
    e2.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
  };
  const titles = items.map((navItem) => navItem.name);
  const links = items.map((navItem, index3) => {
    return /* @__PURE__ */ jsx52("ul", { className: footer_module_default["nav-links-list"], children: navItem.items.map((linkItem, i2) => {
      return /* @__PURE__ */ jsx52("li", { className: footer_module_default["list-item"], children: /* @__PURE__ */ jsx52(FooterLink, { heading: linkItem.heading, linkURL: linkItem.linkURL }) }, i2);
    }) }, index3);
  });
  const linkContent = /* @__PURE__ */ jsxs26(Fragment9, { children: [
    /* @__PURE__ */ jsx52(When, { condition: isMobileStyles, children: /* @__PURE__ */ jsx52(Col, { span: 12, className: footer_module_default["item-expander-col"], children: titles.map((title, i2) => /* @__PURE__ */ jsx52(
      ItemExpander,
      {
        id: i2.toString(),
        title: /* @__PURE__ */ jsx52(TitleText, { as: "span", size: 3, children: title }),
        content: links[i2],
        expanded: expandedItems.has(i2.toString()),
        onToggle: toggleItem,
        injectAnalyticsMetadata: true
      },
      i2
    )) }) }),
    /* @__PURE__ */ jsx52(When, { condition: !isMobileStyles, children: items.map((navItem, i2) => /* @__PURE__ */ jsxs26(Col, { span: Math.floor(12 / items.length), className: footer_module_default["nav-item-col"], children: [
      /* @__PURE__ */ jsx52(TitleText, { size: 3, as: "h2", children: navItem.name }),
      links[i2]
    ] }, i2)) })
  ] });
  const content = /* @__PURE__ */ jsx52("footer", { role: "contentinfo", children: /* @__PURE__ */ jsx52(LoggingProvider, { namespace: "Footer", children: /* @__PURE__ */ jsxs26(I18NProvider, { locale, children: [
    /* @__PURE__ */ jsx52(ColorThemeProvider, { dark: !dark, children: /* @__PURE__ */ jsx52("div", { children: /* @__PURE__ */ jsx52(TemplateContainer, { className: footer_module_default["footer"], children: /* @__PURE__ */ jsx52(Grid, { className: footer_module_default["main-container-grid"], children: /* @__PURE__ */ jsx52(Col, { span: 12, children: /* @__PURE__ */ jsxs26(Grid, { className: footer_module_default["content-grid"], children: [
      /* @__PURE__ */ jsx52(Col, { span: primaryCtaColSpan, children: /* @__PURE__ */ jsx52(
        Button,
        {
          href: createAccountButtonURL,
          className: footer_module_default["primary-button"],
          "data-testid": "footer-create-account-button",
          injectAnalyticsMetadata: true,
          children: createAccountButtonLabel
        }
      ) }),
      linkContent,
      /* @__PURE__ */ jsx52(Col, { span: languageSelectorColSpan, className: footer_module_default["language-selector-col"], children: /* @__PURE__ */ jsx52(When, { condition: !availableLanguages || availableLanguages.length > 0, children: /* @__PURE__ */ jsx52(
        LanguageSelector,
        {
          languages: filteredLanguageOptions,
          onSelect: onLanguageSelect,
          value: locale
        }
      ) }) }),
      /* @__PURE__ */ jsx52(Col, { span: 12, className: footer_module_default["back-to-top-col"], children: /* @__PURE__ */ jsxs26(Button, { size: "s", variant: "link", onClick: backToTop, className: footer_module_default["back-to-top-button"], children: [
        backToTopText,
        /* @__PURE__ */ jsx52(Icon, { name: "arrow-up" })
      ] }) }),
      /* @__PURE__ */ jsxs26(Col, { span: eoeColSpan, className: footer_module_default["eoe-col"], children: [
        isChinaSite && /* @__PURE__ */ jsxs26(BodyText, { size: 2, as: "p", children: [
          T("footer-china-legal-text"),
          " ",
          /* @__PURE__ */ jsx52(Link, { size: 2, href: "https://www.amazonaws.cn/customer-stories/", injectAnalyticsMetadata: true, children: T("footer-china-legal-link-text") })
        ] }),
        /* @__PURE__ */ jsx52(BodyText, { size: 2, as: "span", children: eoeText })
      ] }),
      /* @__PURE__ */ jsx52(Col, { span: socialColSpan, className: footer_module_default["social-col"], children: /* @__PURE__ */ jsx52("div", { className: footer_module_default["social-links"], children: socialItems.map((socialItem, i2) => /* @__PURE__ */ jsx52(Tooltip, { placement: "top", arrow: true, title: (0, import_capitalize.default)(socialItem.socialIconType), children: /* @__PURE__ */ jsx52(
        "a",
        {
          href: socialItem.linkURL,
          "aria-label": socialItem.socialIconType,
          ...{
            [ANALYTICS_METADATA_ATTRIBUTE]: JSON.stringify({
              name: "Footer_SocialMediaLink"
            })
          },
          children: /* @__PURE__ */ jsx52(Icon, { name: socialItem.socialIconType, title: socialItem.socialIconType })
        }
      ) }, i2)) }) }),
      /* @__PURE__ */ jsxs26(Col, { className: classes, children: [
        /* @__PURE__ */ jsx52("ul", { className: footer_module_default["legal-links"], children: footerLegalLinks.map((legalLink, i2) => /* @__PURE__ */ jsx52("li", { children: /* @__PURE__ */ jsx52(FooterLink, { small: true, ...legalLink, actions: footerLinkActions }) }, i2)) }),
        /* @__PURE__ */ jsxs26("div", { className: footer_module_default["legal-text-wrapper"], children: [
          /* @__PURE__ */ jsx52("div", { className: footer_module_default["legal-copyright"], children: /* @__PURE__ */ jsx52(BodyText, { size: 2, as: "span", children: copyrightText }) }),
          isChinaSite && /* @__PURE__ */ jsxs26("div", { className: footer_module_default["china-links"], children: [
            /* @__PURE__ */ jsx52(chinaIcon, {}),
            /* @__PURE__ */ jsx52(
              FooterLink,
              {
                heading: "\u5B81\u516C\u7F51\u5B89\u5907 64050202000147\u53F7",
                linkURL: "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=64050202000147",
                small: true
              }
            ),
            /* @__PURE__ */ jsx52("span", { className: footer_module_default["china-link-pipe"], children: "|" }),
            /* @__PURE__ */ jsx52(
              FooterLink,
              {
                heading: "\u5B81ICP\u590717000743\u53F7",
                linkURL: "https://beian.miit.gov.cn/#/Integrated/index",
                small: true
              }
            )
          ] })
        ] })
      ] })
    ] }) }) }) }) }) }),
    alertBannerItems && /* @__PURE__ */ jsx52(AlertBanner, { ...alertBannerItems, dismissible: false })
  ] }) }) });
  if (findPortalRoot) {
    return /* @__PURE__ */ jsx52(PortalProvider, { findRoot: findPortalRoot, children: content });
  }
  return content;
}
export {
  Footer as default
};
